import React, { useEffect, useRef, useState, Suspense, useCallback, useMemo, Fragment, useContext } from 'react';
import cx from 'classnames';
import _$1, { isEqual } from 'lodash';
import { useMotionValue, animate, motion, AnimatePresence } from 'framer-motion';
import { useMediaQuery } from 'react-responsive';
import { isDesktop } from 'react-device-detect';
import { useGesture } from '@use-gesture/react';
import { useInView as useInView$1 } from 'react-intersection-observer';
import { IKImage } from 'imagekitio-react';
import Mark from 'mark.js';
import { Modal, Button, Dropdown, OverlayTrigger, Tooltip as Tooltip$1, Form, InputGroup, Popover } from 'react-bootstrap';
import { Frame } from 'scenejs';
import { GlobalHotKeys, HotKeys } from 'react-hotkeys';
import { ReactSVG } from 'react-svg';
import Lottie from 'react-lottie';
import { Parallax, ParallaxProvider } from 'react-scroll-parallax';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { createAction } from 'redux-actions';
import { Helmet } from 'react-helmet';
import { Fade, Reveal } from 'react-awesome-reveal';
import { keyframes } from '@emotion/react';
import LinesEllipsis from 'react-lines-ellipsis';
import ReactDOM from 'react-dom';
import { Fonts as Fonts$1 } from '@paperflite-marketing/cleverstory-commons';
import OtpInput from 'react-otp-input';
import Truncate from 'react-truncate';
import Modal$1 from 'react-modal';
import Typewriter from 'typewriter-effect/dist/core';
import { Transition } from 'react-transition-group';
import ScrollToBottom, { useScrollToBottom } from 'react-scroll-to-bottom';
import Slider from 'react-slick';
import { Waypoint } from 'react-waypoint';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _taggedTemplateLiteralLoose(e, t) {
  return t || (t = e.slice(0)), e.raw = t, e;
}

var PAGE = "cleverstory.v2.widgets.page";
var BASIC_TEXT = "cleverstory.v2.widgets.text.basic";
var TEXT = "cleverstory.v2.widgets.text";
var ANCHOR = "cleverstory.v2.widgets.anchor";
var BUTTON = "cleverstory.v2.widgets.button";
var IFRAME = "cleverstory.v2.widgets.iframe";
var HTML = 'cleverstory.v2.widgets.html';
var IMAGE = "cleverstory.v2.widgets.image";
var VIDEO = "cleverstory.v2.widgets.video";
var SHAPE = "cleverstory.v2.widgets.shape";
var LINE = "cleverstory.v2.widgets.line";
var RECTANGLE = "cleverstory.v2.widgets.rectangle";
var FORM = "cleverstory.v2.widgets.form";
var FORM_STEP = "cleverstory.v2.widgets.form.step";
var FORM_FIELD = "cleverstory.v2.widgets.form.input";
var FORM_TEXTAREA = "cleverstory.v2.widgets.form.textarea";
var FORM_DROPDOWN_LIST = "cleverstory.v2.widgets.form.dropdown";
var FORM_CHECK_LIST = "cleverstory.v2.widgets.form.checkbox";
var FORM_NUMBER = "cleverstory.v2.widgets.form.number";
var FORM_CHECK_BOX = "cleverstory.v2.widgets.form.boolean";
var FORM_SUBMIT = "cleverstory.v2.widgets.form.submit";
var OTP_INPUT = "cleverstory.v2.widgets.otp.input";
var OTP_FORM_SUBMIT = "cleverstory.v2.widgets.otp.submit";
var OTP_RESEND = "cleverstory.v2.widgets.otp.resend";
var LIVE_ELEMENT = "cleverstory.v2.widgets.liveElement";
var LIVE_ELEMENT_CONTAINER = "cleverstory.v2.widgets.liveElement.container";
var SECTION = "cleverstory.v2.widgets.section";
var SECTION_COLUMN = "cleverstory.v2.widgets.section.column";
var MENU = "cleverstory.v2.widgets.menu";
var MENU_CONTAINER = "cleverstory.v2.widgets.menu.container";
var CAROUSEL = 'cleverstory.v2.widgets.carousel';
var CAROUSEL_CARD = 'cleverstory.v2.widgets.carousel.card';
var CONTENT = "cleverstory.v2.widgets.content";
var CONTENT_FILTER = "cleverstory.v2.widgets.content.filter";
var CONTENT_SEARCH = "cleverstory.v2.widgets.content.filter.search";
var CONTENT_FILTER_CONTAINER = "cleverstory.v2.widgets.content.filter.container";
var CONTENT_EMPTY_MESSAGE = "cleverstory.v2.widgets.content.empty";
var CONTENT_LOADING_MESSAGE = "cleverstory.v2.widgets.content.loading";
var CONTENT_PAGINATION_BUTTON = "cleverstory.v2.widgets.content.pagination.button";
var CONTENT_CARD = "cleverstory.v2.widgets.content.card";
var CONTENT_CARD_TEMPLATE = "cleverstory.v2.widgets.content.card.template";
var GROUP = "cleverstory.v2.widgets.group";
var MODAL = "cleverstory.v2.widgets.modal";
var SEEK = "cleverstory.v2.widgets.seek";
var EXTERNAL_FORM = 'cleverstory.v2.widgets.form.external';
var HOTSPOT = 'cleverstory.v2.widgets.hotspot';
var ASSET = 'cleverstory.v2.widgets.asset';
var SLIDE = 'cleverstory.v2.widgets.slide';

function getStylesForLayout(layout, breakpoint, container, parentContainer) {
  var widgetStyle = new Frame(layout).toCSSObject();
  if (container) {
    var minWidth = _$1.get(container, "properties." + breakpoint + ".container.minWidth");
    var alignment = _$1.get(container, "properties." + breakpoint + ".container.alignment.position") || _$1.get(container, "properties." + breakpoint + ".container.alignment", 'center');
    var multiplier = 0.5;
    switch (alignment) {
      case 'left':
        multiplier = 0;
        break;
      case 'right':
        multiplier = 1;
        break;
      case 'center':
      default:
        multiplier = 0.5;
        break;
    }
    widgetStyle = _extends({}, widgetStyle, {
      marginLeft: !minWidth ? '0px' : "calc((100% - " + minWidth + "px) * " + multiplier + ")"
    });
    if ((container === null || container === void 0 ? void 0 : container.type) === CAROUSEL_CARD) {
      var parentWidget = parentContainer;
      var isFreeSize = _$1.get(parentWidget, "properties.desktop.free", false);
      var stretched = _$1.get(parentWidget, "properties.desktop.stretched", false);
      if (isFreeSize || stretched) {
        widgetStyle = _extends({}, widgetStyle, {
          marginLeft: '0px'
        });
      }
    }
  }
  return widgetStyle;
}
function colorToString(color) {
  if (!color) {
    return "inherit";
  }
  return "rgba(" + color.r + ", " + color.g + ", " + color.b + ", " + color.a + ")";
}

var styles = {"background":"_1KXjp","overlay":"_2v5Uf","image":"_1XEDj","video":"_3tAEx","videoPlayer":"_1FZOe","poster":"_ajjBY","hidden":"_12Yr3","conditonalHide":"_oboPM","showVideoPlayer":"_107wz"};

var POSITION = {
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  TOP_RIGHT: 'top-right',
  CENTER_LEFT: 'center-left',
  CENTER: 'center',
  CENTER_RIGHT: 'center-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_RIGHT: 'bottom-right'
};
var SCALE = {
  SCALE_TO_FILL: 'scale-to-fit',
  TILED: 'tiled'
};

var getColorsConfig = function getColorsConfig(colorConfig) {
  if (!colorConfig) {
    return "inherit";
  }
  if (colorConfig.type == 'solid') {
    var colorRgb = colorConfig;
    return "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  if (colorConfig.type == 'gradient') {
    var gradientType = _$1.get(colorConfig, 'gradientType', 'Linear');
    var degree = _$1.get(colorConfig, 'degree');
    var colorStrings = _$1.map(_$1.get(colorConfig, 'gradientColors'), function (color) {
      var rgb = "rgb(" + color.r + ", " + color.g + ", " + color.b + ", " + color.a + ")";
      var position = color.position + "%";
      return rgb + " " + position;
    });
    var gradientColor = colorStrings.join(', ');
    switch (gradientType) {
      case 'Linear':
        gradientColor = "linear-gradient(" + degree + "deg, " + gradientColor + " )";
        break;
      case 'Radial':
        gradientColor = "radial-gradient(circle at 50% 50%, " + gradientColor + " )";
        break;
      case 'Angular':
        gradientColor = "conic-gradient(from " + degree + "deg at 50% 50%, " + gradientColor + " )";
        break;
      default:
        gradientColor = "linear-gradient(" + degree + "deg, " + gradientColor + " )";
        break;
    }
    return gradientColor;
  }
  if (colorConfig && _$1.has(colorConfig, 'rbg') && _$1.isNull(colorConfig.rbg)) {
    return "rgba(0,0,0,0)";
  }
  var colorRgb = colorConfig.color || colorConfig;
  return colorRgb ? "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")" : "rgba(255, 255, 255, 1)";
};

var _require = require("react-intersection-observer"),
  useInView = _require.useInView;
var useDelayedInView = function useDelayedInView(_ref) {
  var root = _ref.root,
    rootMargin = _ref.rootMargin,
    threshold = _ref.threshold,
    skip = _ref.skip,
    onChange = _ref.onChange;
  var timeoutId = React.useRef(null);
  var _useInView = useInView({
      root: root,
      rootMargin: rootMargin,
      threshold: threshold,
      skip: skip
    }),
    ref = _useInView[0],
    visible = _useInView[1],
    entry = _useInView[2];
  var intersectionRatio = _$1.get(entry, 'intersectionRatio');
  useEffect(function () {
    var isIntersecting = _$1.get(entry, 'isIntersecting');
    var intersectionRatio = _$1.get(entry, 'intersectionRatio');
    if (isIntersecting || intersectionRatio > 0) {
      _delayElementEnteredCheck();
    } else {
      _handleElementExited();
    }
    return function () {
      _clearTimeout();
    };
  }, [entry, intersectionRatio]);
  var _delayElementEnteredCheck = function _delayElementEnteredCheck() {
    if (timeoutId.current) {
      return;
    }
    timeoutId.current = setTimeout(function () {
      _handleElementEntered();
    }, 500);
  };
  var _handleElementEntered = function _handleElementEntered() {
    onChange(true);
    _clearTimeout();
  };
  var _handleElementExited = function _handleElementExited() {
    _clearTimeout();
    onChange(false);
  };
  var _clearTimeout = function _clearTimeout() {
    if (!timeoutId.current) {
      return;
    }
    clearTimeout(timeoutId.current);
    timeoutId.current = null;
  };
  return [ref, visible];
};

var BackgroundViewComponent = function BackgroundViewComponent(_ref) {
  var className = _ref.className,
    background = _ref.background,
    style = _ref.style,
    breakpoint = _ref.breakpoint;
  if (background == null) {
    return false;
  }
  var type = _$1.get(background, 'type');
  var color = _$1.get(background, 'color');
  var blur = _$1.get(background, 'blur', 0);
  var colorOverlay = getColorsConfig(color);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.background, className),
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.overlay, styles.color),
    style: {
      background: colorOverlay,
      WebkitBackdropFilter: "blur(" + blur + "px)",
      backdropFilter: type === 'glass' ? "blur(" + blur + "px)" : 'none'
    }
  }), type === 'image' && /*#__PURE__*/React.createElement(ImageView, {
    background: background
  }), type === 'video' && /*#__PURE__*/React.createElement(VideoView, {
    background: background,
    breakpoint: breakpoint
  }));
};
var backgroundViewEquals = function backgroundViewEquals(prevProps, nextProps) {
  var paths = ['className', 'background', 'style'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var BackgroundView = React.memo(BackgroundViewComponent, backgroundViewEquals);
var ImageViewComponent = function ImageViewComponent(_ref2) {
  var background = _ref2.background,
    imageCDN = _ref2.imageCDN;
  var context = React.useContext(Widgets.Context);
  var media = _$1.get(background, 'media');
  if (!media) {
    return null;
  }
  var finalImageCDN = context.imageCDN || imageCDN;
  var backgroundStyles = getImageBackgroundStyles(finalImageCDN, background);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.overlay, styles.image),
    style: backgroundStyles
  });
};
var imageViewEquals = function imageViewEquals(prevProps, nextProps) {
  var paths = ['background'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var ImageView = React.memo(ImageViewComponent, imageViewEquals);
var VideoViewComponent = function VideoViewComponent(_ref3) {
  var _cx, _cx2;
  var background = _ref3.background,
    breakpoint = _ref3.breakpoint,
    imageCDN = _ref3.imageCDN;
  var context = React.useContext(Widgets.Context);
  var media = _$1.get(background, 'media');
  var _React$useState = React.useState(false),
    show = _React$useState[0],
    setShow = _React$useState[1];
  var _React$useState2 = React.useState(false),
    videoLoaded = _React$useState2[0],
    setVideoLoaded = _React$useState2[1];
  if (!media) {
    return null;
  }
  var videoRef = useRef(null);
  var videoContainerRef = useRef(null);
  var _useDelayedInView = useDelayedInView({
      rootMargin: '0px',
      root: null,
      onChange: function onChange(visible) {
        setShow(visible);
      }
    }),
    ref = _useDelayedInView[0];
  var setVideoRefs = React.useCallback(function (node) {
    videoContainerRef.current = node;
    ref(node);
  }, [ref]);
  var url = media.url;
  var backgroundStyles = getVideoBackgroundStyles(background);
  var finalImageCDN = context.imageCDN || imageCDN;
  var posterStyles = getVideoPosterStyles(background, finalImageCDN + "/" + url + "/ik-thumbnail.jpg");
  var calculateSource = function calculateSource(breakpoint) {
    if (!videoContainerRef.current) {
      return "";
    }
    var videoUrl = finalImageCDN + "/" + url;
    if (breakpoint === 'mobile') {
      var height = videoContainerRef.current.offsetHeight;
      var maxHeight = _$1.get(background, 'media.height') || 1080;
      if (height <= 360) {
        height = 360;
      } else if (height <= 480) {
        height = 480;
      } else if (height <= 720) {
        height = 720;
      } else {
        height = 1080;
      }
      height = Math.min(height, maxHeight);
      if (height >= 360) {
        videoUrl = videoUrl + "?tr=h-" + height;
      }
    }
    return videoUrl;
  };
  useEffect(function () {
    if (!videoRef.current) {
      return;
    }
    var url = calculateSource(breakpoint);
    videoRef.current.src = url;
  }, [videoContainerRef.current, breakpoint]);
  var handleVideoLoaded = function handleVideoLoaded() {
    setVideoLoaded(true);
  };
  var opacityConditon = (posterStyles === null || posterStyles === void 0 ? void 0 : posterStyles.opacity) != 1;
  var isVideoLoaded = show && videoLoaded;
  return /*#__PURE__*/React.createElement("div", {
    ref: setVideoRefs,
    className: cx(styles.overlay, styles.video)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.poster, (_cx = {}, _cx[styles.hidden] = isVideoLoaded && opacityConditon, _cx[styles.conditonalHide] = isVideoLoaded && !opacityConditon, _cx)),
    style: _extends({}, posterStyles, {
      opacity: opacityConditon ? Math.max(0, ((posterStyles === null || posterStyles === void 0 ? void 0 : posterStyles.opacity) || 0) - 0.10) : posterStyles === null || posterStyles === void 0 ? void 0 : posterStyles.opacity,
      transition: opacityConditon ? 'opacity 0.5s ease-in-out' : 'none'
    })
  }, "\xA0"), show && /*#__PURE__*/React.createElement("video", {
    key: breakpoint + "-" + url,
    style: backgroundStyles,
    ref: videoRef,
    playsInline: true,
    preload: breakpoint == 'mobile' ? 'auto' : 'auto',
    className: cx(styles.videoPlayer, (_cx2 = {}, _cx2[styles.showVideoPlayer] = show && videoLoaded, _cx2)),
    muted: true,
    autoPlay: true,
    loop: true,
    crossOrigin: "anonymous",
    onLoadedData: handleVideoLoaded,
    src: calculateSource(breakpoint)
  }));
};
var videoViewEquals = function videoViewEquals(prevProps, nextProps) {
  var paths = ['background'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var VideoView = React.memo(VideoViewComponent, videoViewEquals);
function getImageBackgroundStyles(imageCDN, background) {
  var backgroundStyles = {};
  var media = _$1.get(background, 'media');
  var url = imageCDN + "/" + media.url;
  var scale = _$1.get(background, 'scale', SCALE.SCALE_TO_FILL);
  var opacity = _$1.get(background, 'opacity', 100) / 100;
  backgroundStyles = _extends({}, backgroundStyles, {
    backgroundImage: "url('" + url + "')",
    opacity: opacity
  });
  switch (scale) {
    case SCALE.TILED:
      backgroundStyles = _extends({}, backgroundStyles, {
        backgroundRepeat: 'repeat',
        backgroundSize: 'auto'
      });
      break;
    case SCALE.SCALE_TO_FILL:
    default:
      backgroundStyles = _extends({}, backgroundStyles, {
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      });
      break;
  }
  var backgroundPosition = getBackgroundPosition(background);
  backgroundStyles = _extends({}, backgroundStyles, {
    backgroundPosition: backgroundPosition,
    height: '100%'
  });
  return backgroundStyles;
}
function getVideoBackgroundStyles(background) {
  var backgroundStyles = {};
  var opacity = _$1.get(background, 'opacity', 100) / 100;
  backgroundStyles = _extends({}, backgroundStyles, {
    opacity: opacity
  });
  var backgroundPosition = getBackgroundPosition(background);
  backgroundStyles = _extends({}, backgroundStyles, {
    objectPosition: backgroundPosition
  });
  return backgroundStyles;
}
function getVideoPosterStyles(background, url) {
  var backgroundStyles = {};
  var backgroundPosition = getBackgroundPosition(background);
  var opacity = _$1.get(background, 'opacity', 100) / 100;
  backgroundStyles = _extends({}, backgroundStyles, {
    backgroundImage: "url('" + url + "')",
    backgroundPosition: backgroundPosition,
    opacity: opacity
  });
  return backgroundStyles;
}
function getBackgroundPosition(background) {
  var position = _$1.get(background, 'position', POSITION.CENTER);
  var backgroundPosition = 'center center';
  switch (position) {
    case POSITION.TOP_LEFT:
      backgroundPosition = 'left top';
      break;
    case POSITION.TOP_CENTER:
      backgroundPosition = 'center top';
      break;
    case POSITION.TOP_RIGHT:
      backgroundPosition = 'right top';
      break;
    case POSITION.CENTER_LEFT:
      backgroundPosition = 'left center';
      break;
    case POSITION.CENTER:
      backgroundPosition = 'center center';
      break;
    case POSITION.CENTER_RIGHT:
      backgroundPosition = 'right center';
      break;
    case POSITION.BOTTOM_LEFT:
      backgroundPosition = 'left bottom';
      break;
    case POSITION.BOTTOM_CENTER:
      backgroundPosition = 'center bottom';
      break;
    case POSITION.BOTTOM_RIGHT:
      backgroundPosition = 'right bottom';
      break;
  }
  return backgroundPosition;
}

var _excluded = ["url", "width", "iconColor", "height", "play", "loop", "eventListeners"];
function AfterEffect(_ref) {
  var url = _ref.url,
    width = _ref.width,
    iconColor = _ref.iconColor,
    height = _ref.height,
    play = _ref.play,
    loop = _ref.loop,
    eventListeners = _ref.eventListeners,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = useState(true),
    setLoading = _useState[1];
  var _useState2 = useState(null),
    data = _useState2[0],
    setData = _useState2[1];
  useEffect(function () {
    setLoading(true);
    setData(null);
    if (url) {
      fetch(url).then(function (response) {
        return response.json();
      }).then(function (data) {
        setData(data);
        setLoading(false);
      });
    }
  }, [url]);
  var options = _extends({
    loop: loop,
    autoplay: false,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  }, rest, {
    animationData: data
  });
  return /*#__PURE__*/React.createElement(Lottie, {
    options: options,
    height: parseInt(height),
    width: parseInt(width),
    style: {
      margin: "0px",
      color: iconColor
    },
    isStopped: !play,
    eventListeners: eventListeners
  });
}

var DESKTOP = 'desktop';
var MOBILE = 'mobile';

var INSTALL_FONTS = 'INSTALL_FONTS';
var AUTO_GROW_LAYOUT_REQUEST = 'AUTO_GROW_LAYOUT_REQUEST';

var installFonts = createAction(INSTALL_FONTS, function (fonts) {
  return fonts;
});

function FontManager(props) {
  var dispatch = useDispatch();
  var availableFonts = useSelector(function (state) {
    var fonts = _$1.get(state, 'fonts.items') || [];
    var installed = _$1.get(state, 'fonts.installed');
    return fonts.filter(function (font) {
      return installed.some(function (item) {
        return item === font.id;
      });
    }).filter(function (font) {
      return font.styleSheet != null;
    });
  });
  return /*#__PURE__*/React.createElement(Helmet, null, availableFonts.map(function (font) {
    return /*#__PURE__*/React.createElement("link", {
      key: font.id,
      rel: "stylesheet",
      type: "text/css",
      href: font.styleSheet
    });
  }));
}
var useFont = function useFont(fonts) {
  var dispatch = useDispatch();
  var fontToBeInstalled = useSelector(function (state) {
    var installed = _$1.get(state, 'fonts.installed');
    var availableFonts = _$1.get(state, 'fonts.items') || [];
    var filtered = (fonts || []).map(function (font) {
      if (typeof font === 'string') {
        return availableFonts.find(function (item) {
          return item.id === font;
        });
      }
      return font;
    }).filter(function (font) {
      return font != null;
    }).filter(function (font) {
      return !installed.some(function (item) {
        return item === font.id;
      });
    });
    return filtered;
  }, shallowEqual);
  useEffect(function () {
    if (_$1.size(fontToBeInstalled) > 0) {
      dispatch(installFonts(fontToBeInstalled));
    }
  }, [fontToBeInstalled]);
};
var Fonts = {
  Manager: FontManager,
  useFont: useFont
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var _excluded$1 = ["type", "disabled", "children", "fraction"];
var AnimationComponentView = function AnimationComponentView(_ref) {
  var type = _ref.type,
    disabled = _ref.disabled,
    children = _ref.children,
    _ref$fraction = _ref.fraction,
    fraction = _ref$fraction === void 0 ? 0.1 : _ref$fraction,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  if (disabled) {
    return children;
  }
  var context = React.useContext(WidgetsContext);
  var style = {
    height: "100%"
  };
  switch (type) {
    case 'fade':
      {
        var delay = rest.delay,
          triggerOnce = rest.triggerOnce,
          duration = rest.duration;
        return /*#__PURE__*/React.createElement(FadeAnimation, {
          delay: delay,
          fraction: fraction,
          triggerOnce: triggerOnce,
          duration: duration,
          style: style
        }, children);
      }
    case 'slide':
      {
        var _duration = rest.duration,
          _delay = rest.delay,
          direction = rest.direction,
          distance = rest.distance,
          _triggerOnce = rest.triggerOnce;
        return /*#__PURE__*/React.createElement(SlideAnimation, {
          delay: _delay,
          direction: direction,
          fraction: fraction,
          distance: distance,
          triggerOnce: _triggerOnce,
          duration: _duration,
          style: style
        }, children);
      }
    case 'spin':
      {
        var _duration2 = rest.duration,
          _delay2 = rest.delay,
          _direction = rest.direction,
          count = rest.count,
          _triggerOnce2 = rest.triggerOnce;
        return /*#__PURE__*/React.createElement(SpinAnimation, {
          delay: _delay2,
          direction: _direction,
          fraction: fraction,
          count: count,
          triggerOnce: _triggerOnce2,
          duration: _duration2,
          style: style
        }, children);
      }
    case 'bounce':
      {
        var _delay3 = rest.delay,
          _triggerOnce3 = rest.triggerOnce,
          _duration3 = rest.duration;
        return /*#__PURE__*/React.createElement(BounceAnimation, {
          delay: _delay3,
          fraction: fraction,
          triggerOnce: _triggerOnce3,
          duration: _duration3,
          style: style
        }, children);
      }
    case 'arc':
      {
        var _delay4 = rest.delay,
          _triggerOnce4 = rest.triggerOnce,
          _direction3 = rest.direction,
          _duration4 = rest.duration;
        return /*#__PURE__*/React.createElement(ArcAnimation, {
          delay: _delay4,
          direction: _direction3,
          fraction: fraction,
          triggerOnce: _triggerOnce4,
          duration: _duration4,
          style: style
        }, children);
      }
    case 'flip':
      {
        var _delay5 = rest.delay,
          _triggerOnce5 = rest.triggerOnce,
          _direction4 = rest.direction,
          _duration5 = rest.duration;
        return /*#__PURE__*/React.createElement(FlipAnimation, {
          delay: _delay5,
          fraction: fraction,
          direction: _direction4,
          triggerOnce: _triggerOnce5,
          duration: _duration5,
          style: style
        }, children);
      }
    case 'expand':
      {
        var _delay6 = rest.delay,
          _triggerOnce6 = rest.triggerOnce,
          _duration6 = rest.duration;
        return /*#__PURE__*/React.createElement(ExpandAnimation, {
          delay: _delay6,
          triggerOnce: _triggerOnce6,
          fraction: fraction,
          duration: _duration6,
          style: style
        }, children);
      }
    case 'puffin':
      {
        var _delay7 = rest.delay,
          _triggerOnce7 = rest.triggerOnce,
          _duration7 = rest.duration;
        return /*#__PURE__*/React.createElement(PuffAnimation, {
          delay: _delay7,
          triggerOnce: _triggerOnce7,
          fraction: fraction,
          duration: _duration7,
          style: style
        }, children);
      }
    case 'turn':
      {
        var _delay8 = rest.delay,
          _triggerOnce8 = rest.triggerOnce,
          _direction5 = rest.direction,
          _duration8 = rest.duration;
        return /*#__PURE__*/React.createElement(TurnInAnimation, {
          delay: _delay8,
          triggerOnce: _triggerOnce8,
          fraction: fraction,
          direction: _direction5,
          duration: _duration8,
          style: style
        }, children);
      }
    case 'reveal':
      {
        var _delay9 = rest.delay,
          _triggerOnce9 = rest.triggerOnce,
          _direction6 = rest.direction,
          _duration9 = rest.duration;
        return /*#__PURE__*/React.createElement(RevealAnimation, {
          delay: _delay9,
          triggerOnce: _triggerOnce9,
          fraction: fraction,
          direction: _direction6,
          duration: _duration9,
          style: style
        }, children);
      }
    case 'parallax':
      {
        var _direction7 = rest.direction,
          speed = rest.speed,
          angle = rest.angle,
          reverse = rest.reverse;
        return /*#__PURE__*/React.createElement(ParallaxAnimation, {
          type: type,
          direction: _direction7,
          speed: speed,
          angle: angle,
          reverse: reverse,
          style: style
        }, children);
      }
  }
  return children;
};
var FadeAnimation = function FadeAnimation(_ref2) {
  var duration = _ref2.duration,
    delay = _ref2.delay,
    fraction = _ref2.fraction,
    children = _ref2.children,
    triggerOnce = _ref2.triggerOnce,
    style = _ref2.style;
  return /*#__PURE__*/React.createElement(Fade, {
    fraction: fraction,
    triggerOnce: triggerOnce,
    duration: duration * 1000,
    delay: delay * 1000,
    style: style
  }, children);
};
var SlideAnimation = function SlideAnimation(_ref3) {
  var duration = _ref3.duration,
    triggerOnce = _ref3.triggerOnce,
    delay = _ref3.delay,
    direction = _ref3.direction,
    fraction = _ref3.fraction,
    distance = _ref3.distance,
    children = _ref3.children,
    style = _ref3.style;
  var _useInView = useInView$1({
      threshold: fraction,
      triggerOnce: triggerOnce
    }),
    ref = _useInView.ref,
    inView = _useInView.inView;
  var animationVlaue = generateKeyFrameForSlide(direction, distance);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      transform: inView ? animationVlaue.to.transform : animationVlaue.from.transform,
      transition: "transform " + (inView ? duration : 0) + "s  ease-out " + (inView ? delay : 0) + "s",
      height: "100%"
    }
  }, children));
};
var SpinAnimation = function SpinAnimation(_ref4) {
  var duration = _ref4.duration,
    delay = _ref4.delay,
    triggerOnce = _ref4.triggerOnce,
    fraction = _ref4.fraction,
    direction = _ref4.direction,
    count = _ref4.count,
    children = _ref4.children,
    style = _ref4.style;
  var _useInView2 = useInView$1({
      threshold: fraction,
      triggerOnce: triggerOnce
    }),
    ref = _useInView2.ref,
    inView = _useInView2.inView;
  var animationValue = generateKeyFrameForSpin(direction, count);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      opacity: inView ? animationValue.to.opacity : animationValue.from.opacity,
      transform: inView ? animationValue.to.transform : animationValue.from.transform,
      transition: "transform " + (inView ? duration : 0) + "s ease-out " + (inView ? delay : 0) + "s",
      height: "100%"
    }
  }, children));
};
var BounceAnimation = function BounceAnimation(_ref5) {
  var duration = _ref5.duration,
    delay = _ref5.delay,
    triggerOnce = _ref5.triggerOnce,
    fraction = _ref5.fraction,
    children = _ref5.children,
    style = _ref5.style;
  var _useInView3 = useInView$1({
      threshold: fraction,
      triggerOnce: triggerOnce
    }),
    ref = _useInView3.ref,
    inView = _useInView3.inView;
  var animationValue = generateKeyFrameForBounce();
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: style
  }, /*#__PURE__*/React.createElement("style", null, animationValue), /*#__PURE__*/React.createElement("div", {
    style: {
      animation: inView ? "bounceAnimation " + duration + "s ease-out " + delay + "s" : 'none',
      height: "100%"
    }
  }, children));
};
var ArcAnimation = function ArcAnimation(_ref6) {
  var duration = _ref6.duration,
    delay = _ref6.delay,
    triggerOnce = _ref6.triggerOnce,
    fraction = _ref6.fraction,
    direction = _ref6.direction,
    children = _ref6.children,
    style = _ref6.style;
  var _useInView4 = useInView$1({
      threshold: fraction,
      triggerOnce: triggerOnce
    }),
    ref = _useInView4.ref,
    inView = _useInView4.inView;
  var animationValue = generateKeyFrameForArc(direction);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      transform: inView ? animationValue.to.transform : animationValue.from.transform,
      scale: inView ? animationValue.to.scale : animationValue.from.scale,
      opacity: inView ? animationValue.to.opacity : animationValue.from.opacity,
      transition: "all " + (inView ? duration : 0) + "s  ease-out " + (inView ? delay : 0) + "s",
      height: "100%"
    }
  }, children));
};
var FlipAnimation = function FlipAnimation(_ref7) {
  var duration = _ref7.duration,
    delay = _ref7.delay,
    triggerOnce = _ref7.triggerOnce,
    fraction = _ref7.fraction,
    direction = _ref7.direction,
    children = _ref7.children,
    style = _ref7.style;
  return /*#__PURE__*/React.createElement(Reveal, {
    fraction: fraction,
    style: _extends({
      animationTimingFunction: "ease"
    }, style),
    triggerOnce: triggerOnce,
    keyframes: generateKeyFrameForFlip(direction),
    duration: duration * 1000,
    delay: delay * 1000
  }, children);
};
var ExpandAnimation = function ExpandAnimation(_ref8) {
  var duration = _ref8.duration,
    delay = _ref8.delay,
    triggerOnce = _ref8.triggerOnce,
    fraction = _ref8.fraction,
    children = _ref8.children,
    style = _ref8.style;
  var _useInView5 = useInView$1({
      threshold: fraction,
      triggerOnce: triggerOnce
    }),
    ref = _useInView5.ref,
    inView = _useInView5.inView;
  var animationValue = generateKeyFrameForExpand();
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      transform: inView ? animationValue.to.transform : animationValue.from.transform,
      opacity: inView ? animationValue.to.opacity : animationValue.from.opacity,
      transition: "all " + (inView ? duration : 0) + "s ease-out " + (inView ? delay : 0) + "s",
      height: '100%'
    }
  }, children));
};
var PuffAnimation = function PuffAnimation(_ref9) {
  var duration = _ref9.duration,
    delay = _ref9.delay,
    triggerOnce = _ref9.triggerOnce,
    children = _ref9.children,
    fraction = _ref9.fraction,
    style = _ref9.style;
  var _useInView6 = useInView$1({
      threshold: fraction,
      triggerOnce: triggerOnce
    }),
    ref = _useInView6.ref,
    inView = _useInView6.inView;
  var animationVlaue = generateKeyFrameForPuff();
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      transform: inView ? animationVlaue.to.transform : animationVlaue.from.transform,
      transition: "transform " + (inView ? duration : 0) + "s  ease-out " + (inView ? delay : 0) + "s",
      height: "100%"
    }
  }, children));
};
var TurnInAnimation = function TurnInAnimation(_ref10) {
  var duration = _ref10.duration,
    delay = _ref10.delay,
    triggerOnce = _ref10.triggerOnce,
    fraction = _ref10.fraction,
    direction = _ref10.direction,
    children = _ref10.children,
    style = _ref10.style;
  return /*#__PURE__*/React.createElement(Reveal, {
    fraction: fraction,
    style: _extends({
      animationTimingFunction: "ease"
    }, style),
    triggerOnce: triggerOnce,
    keyframes: generateKeyFrameForTurnIn(direction),
    duration: duration * 1000,
    delay: delay * 1000
  }, children);
};
var RevealAnimation = function RevealAnimation(_ref11) {
  var duration = _ref11.duration,
    delay = _ref11.delay,
    fraction = _ref11.fraction,
    triggerOnce = _ref11.triggerOnce,
    direction = _ref11.direction,
    children = _ref11.children,
    style = _ref11.style;
  var _useInView7 = useInView$1({
      threshold: fraction,
      triggerOnce: triggerOnce
    }),
    ref = _useInView7.ref,
    inView = _useInView7.inView;
  var animationVlaue = generateKeyFrameForReveal(direction);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      clipPath: inView ? animationVlaue.to : animationVlaue.from,
      transition: "clip-path " + (inView ? duration : 0) + "s  ease-out " + (inView ? delay : 0) + "s",
      height: "100%"
    }
  }, children));
};
var ParallaxAnimation = function ParallaxAnimation(_ref12) {
  var direction = _ref12.direction,
    speed = _ref12.speed,
    angle = _ref12.angle,
    reverse = _ref12.reverse,
    children = _ref12.children;
  return /*#__PURE__*/React.createElement(Parallax, {
    shouldAlwaysCompleteAnimation: false,
    translateX: getTranslateX(direction, speed, angle, reverse),
    translateY: getTranslateY(direction, speed, angle, reverse),
    style: {
      height: "100%"
    }
  }, children);
};
var generateKeyFrameForSlide = function generateKeyFrameForSlide(direction, distance, count) {
  var animationKeyframe = null;
  switch (direction) {
    case 'right':
      animationKeyframe = {
        from: {
          transform: "translateX(-" + distance + "px)"
        },
        to: {
          transform: 'translateX(0)'
        }
      };
      break;
    case 'left':
      animationKeyframe = {
        from: {
          transform: "translateX(" + distance + "px)"
        },
        to: {
          transform: 'translateX(0)'
        }
      };
      break;
    case 'top':
      animationKeyframe = {
        from: {
          opacity: 1,
          transform: "translateY(" + distance + "px)"
        },
        to: {
          opacity: 1,
          transform: 'translateY(0)'
        }
      };
      break;
    case 'bottom':
      animationKeyframe = {
        from: {
          transform: "translateY(-" + distance + "px)"
        },
        to: {
          transform: 'translateY(0)'
        }
      };
      break;
  }
  return animationKeyframe;
};
var getTranslateX = function getTranslateX(direction, speed, angle, reverse) {
  var translate = null;
  var end = 100;
  var degree = 0;
  switch (direction) {
    case 'vertical':
      degree = 0;
      end = 0;
      break;
    case 'horizontal':
      degree = 360;
      break;
    case 'angle':
      degree = angle - 90;
      break;
  }
  var x = Number.parseFloat(Math.cos(Math.PI * 2 * degree / 360)).toFixed(2);
  var delta = end * x * speed;
  translate = reverse ? [delta + "px", -delta + "px"] : [-delta + "px", delta + "px"];
  return translate;
};
var getTranslateY = function getTranslateY(direction, speed, angle, reverse) {
  var translate = null;
  var end = 100;
  var degree = 0;
  switch (direction) {
    case 'vertical':
      degree = 270;
      break;
    case 'horizontal':
      degree = 0;
      end = 0;
      break;
    case 'angle':
      degree = angle - 90;
      break;
  }
  var y = Number.parseFloat(Math.sin(Math.PI * 2 * degree / 360)).toFixed(2);
  var delta = end * y * speed;
  translate = reverse ? [delta + "px", -delta + "px"] : [-delta + "px", delta + "px"];
  return translate;
};
var generateKeyFrameForSpin = function generateKeyFrameForSpin(direction, count) {
  var animationKeyframe = null;
  switch (direction) {
    case 'right':
      animationKeyframe = {
        from: {
          opacity: 0,
          transform: 'scale(0) rotate(0deg)'
        },
        to: {
          opacity: 1,
          transform: "scale(1) rotate(" + 360 * count + "deg)"
        }
      };
      break;
    case 'left':
      animationKeyframe = {
        from: {
          opacity: 0,
          transform: "scale(0) rotate(" + 360 * count + "deg)"
        },
        to: {
          opacity: 1,
          transform: 'scale(1) rotate(0deg)'
        }
      };
      break;
  }
  return animationKeyframe;
};
var generateKeyFrameForBounce = function generateKeyFrameForBounce() {
  return "\n    @keyframes bounceAnimation {\n      from {\n        opacity: 0;\n        transform: scale(0.1);\n      }\n      60% {\n        opacity: 1;\n        transform: scale(1.2);\n      }\n      80% {\n        transform: scale(0.9);\n      }\n      to {\n        transform: scale(1);\n      }\n    }";
};
var generateKeyFrameForArc = function generateKeyFrameForArc(direction) {
  var animationValue = null;
  switch (direction) {
    case 'right':
      animationValue = {
        from: {
          opacity: 0,
          scale: 0.5,
          transform: 'perspective(1500px) rotateY(180deg) translateZ(300px)'
        },
        to: {
          opacity: 1,
          scale: 1,
          transform: 'perspective(1500px) rotateY(0deg) translateZ(0px)'
        }
      };
      break;
    case 'left':
      animationValue = {
        from: {
          opacity: 0,
          scale: 0.5,
          transform: 'perspective(1500px) rotateY(-180deg) translateZ(300px)'
        },
        to: {
          opacity: 1,
          scale: 1,
          transform: 'perspective(1500px) rotateY(0deg) translateZ(0px)'
        }
      };
      break;
  }
  return animationValue;
};
var generateKeyFrameForFlip = function generateKeyFrameForFlip(direction) {
  var animationKeyframe = null;
  switch (direction) {
    case 'right':
      animationKeyframe = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      from {\n        transform-origin: left;\n        transform: rotateY(90deg);\n      }\n      to {\n        transform: rotateY(0deg);\n      }"])));
      break;
    case 'left':
      animationKeyframe = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      from {\n        transform-origin: right;\n        transform: rotateY(-90deg);\n      }\n      to {\n        transform: rotateY(0deg);\n      }\n      "])));
      break;
    case 'top':
      animationKeyframe = keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      from {\n        transform-origin: bottom;\n        transform: rotateX(90deg);\n      }\n      to {\n        transform: rotateX(0deg);\n      }"])));
      break;
    case 'bottom':
      animationKeyframe = keyframes(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n        from {\n          transform-origin: top;\n          transform: rotateX(-90deg);\n        }\n        to {\n          transform: rotateX(0deg);\n        }\n        "])));
      break;
  }
  return animationKeyframe;
};
var generateKeyFrameForExpand = function generateKeyFrameForExpand() {
  return {
    from: {
      opacity: 0,
      transform: 'scale(0)'
    },
    to: {
      opacity: 1,
      transform: 'scale(1)'
    }
  };
};
var generateKeyFrameForPuff = function generateKeyFrameForPuff() {
  var animationKeyframe = {
    from: {
      transform: 'scale(2.5)'
    },
    to: {
      opacity: 1,
      transform: 'scale(1)'
    }
  };
  return animationKeyframe;
};
var generateKeyFrameForTurnIn = function generateKeyFrameForTurnIn(direction) {
  var animationKeyframe = null;
  switch (direction) {
    case 'right':
      animationKeyframe = keyframes(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      0% {\n        opacity: 0;\n        transform: translate(200%, -200%) rotate(45deg);\n      }\n      100% {\n        opacity: 1;\n        transform: translate(0, 0) rotate(0deg);\n      }"])));
      break;
    case 'left':
      animationKeyframe = keyframes(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      from {\n        opacity: 0;\n        transform: translate(-200%, -200%) rotate(-45deg);\n      }\n      to {\n        opacity: 1;\n        transform: translate(0, 0) rotate(0deg);\n      }"])));
      break;
  }
  return animationKeyframe;
};
var generateKeyFrameForReveal = function generateKeyFrameForReveal(direction) {
  var animationKeyframe = null;
  switch (direction) {
    case 'right':
      animationKeyframe = {
        from: 'polygon(0 0, 0 0, 0% 100%, 0% 100%)',
        to: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'
      };
      break;
    case 'left':
      animationKeyframe = {
        from: 'polygon(100% 0, 100% 0, 100% 100%, 100% 100%)',
        to: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)'
      };
      break;
    case 'top':
      animationKeyframe = {
        from: 'polygon(0 100%, 100% 100%, 100% 100%, 0 100%)',
        to: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)'
      };
      break;
    case 'bottom':
      animationKeyframe = {
        from: 'polygon(0 0, 100% 0, 100% 0, 0 0)',
        to: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)'
      };
      break;
  }
  return animationKeyframe;
};
var animationEquals = function animationEquals(prevProps, nextProps) {
  var paths = ['preview'];
  var next = _$1.omit(nextProps, paths);
  var previous = _$1.omit(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var AnimationComponent = React.memo(AnimationComponentView, animationEquals);
var ParallaxContainer = function ParallaxContainer(_ref13) {
  var scrollRef = _ref13.scrollRef,
    children = _ref13.children;
  if (children) {
    return /*#__PURE__*/React.createElement(ParallaxProvider, {
      scrollContainer: scrollRef
    }, children);
  }
  return children;
};

var styles$1 = {"basicText":"_5ar31","inner":"_3mjF-"};

var BasicTextWidgetComponent = function BasicTextWidgetComponent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var elementRef = React.useRef(null);
  var id = _$1.get(widgetProps, 'uid');
  var content = _$1.get(widgetProps, 'content') || "";
  var animation = _$1.get(widgetProps, "properties." + breakpoint + ".animation") || {};
  var lines = getLinesToRender(widgetProps, breakpoint);
  Fonts.useFont(_$1.get(widgetProps, 'fonts') || []);
  var widgetStyle = _extends({}, getStyles(widgetProps, breakpoint));
  var removeHtmlTags = function removeHtmlTags(htmlString) {
    if (!htmlString) {
      return '';
    }
    var doc = new DOMParser().parseFromString(htmlString, 'text/html');
    return _$1.get(doc, 'body.textContent', '');
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    ref: elementRef,
    className: cx(className, styles$1.basicText, 'cs_basic_text_widget'),
    style: style,
    "data-widget-id": id
  }, /*#__PURE__*/React.createElement(AnimationComponent, animation, /*#__PURE__*/React.createElement(LinesEllipsis, {
    maxLine: lines,
    text: removeHtmlTags(content),
    className: styles$1.inner,
    style: widgetStyle
  })));
};
var getLinesToRender = function getLinesToRender(widgetProps, breakpoint) {
  var lineHeight = _$1.get(widgetProps, "properties." + breakpoint + ".lineSpacing", 1.2);
  var fontSize = _$1.get(widgetProps, "properties." + breakpoint + ".fontSize", 16);
  var height = _$1.get(widgetProps, "properties." + breakpoint + ".layout.height");
  height = parseInt(height);
  var textHeight = lineHeight * fontSize;
  height = Math.max(height, textHeight);
  var lines = Math.floor(height / textHeight);
  return lines;
};
function getStyles(widget, breakpoint) {
  var styles = {};
  var defaultProperties = _$1.get(widget, "properties.desktop");
  var properties = _$1.get(widget, "properties." + breakpoint);
  if (!properties) {
    return styles;
  }
  var width = _$1.get(properties, 'layout.width');
  var height = _$1.get(properties, 'layout.height');
  styles = _extends({}, styles, {
    width: width,
    height: height
  });
  var colorRgb = _$1.get(defaultProperties, "font.color", null);
  var color = getColorStyles(colorRgb);
  styles = _extends({}, styles, color);
  var backgroundRgb = _$1.get(defaultProperties, "background", null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = "rgba(" + backgroundRgb.r + ", " + backgroundRgb.g + ", " + backgroundRgb.b + ", " + backgroundRgb.a + ")";
  }
  styles['backgroundColor'] = background;
  var defaultFont = _$1.get(defaultProperties, 'font', {});
  var font = _$1.get(properties, 'font', {});
  var fontFamily = _$1.get(defaultFont, 'fontFamily');
  if (fontFamily) {
    styles = _extends({}, styles, {
      fontFamily: fontFamily
    });
  }
  var fontSizeString = _$1.get(font, 'fontSize', null);
  var fontSize = 'inherit';
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }
  styles['fontSize'] = fontSize;
  var lineSpacingString = _$1.get(font, 'lineSpacing', null);
  if (lineSpacingString) {
    var lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }
  var letterSpacingString = _$1.get(font, 'letterSpacing', null);
  if (letterSpacingString) {
    var letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }
  var bold = _$1.get(defaultFont, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }
  var italic = _$1.get(defaultFont, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }
  var underline = _$1.get(defaultFont, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }
  var alignment = _$1.get(properties, 'alignment', 'left');
  styles['textAlign'] = alignment;
  return styles;
}
function getColorStyles(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  var styles = {
    color: color
  };
  return styles;
}
var textWidgetEquals = function textWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var BasicTextWidget = React.memo(BasicTextWidgetComponent, textWidgetEquals);

var styles$2 = {"indicator":"_2wlhB","vertical":"_3GaPD","horizontal":"_1O5xm"};

var InfiniteScroll = function InfiniteScroll(_ref) {
  var _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
    children = _ref.children,
    loading = _ref.loading,
    loadData = _ref.loadData;
  var _useInView = useInView$1({
      root: null,
      threshold: 0
    }),
    inViewRef = _useInView[0],
    inView = _useInView[1];
  useEffect(function () {
    if (inView) {
      loadData();
    }
  }, [inView]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children, !loading && /*#__PURE__*/React.createElement("div", {
    ref: inViewRef,
    className: cx(styles$2.indicator, styles$2[direction])
  }, "\xA0"));
};

var FileService = /*#__PURE__*/function () {
  function FileService() {}
  FileService.formatSize = function formatSize(bytes) {
    if (bytes >= 1000000000) {
      return (bytes / 1000000000).toFixed(2) + " GB";
    }
    if (bytes >= 1000000) {
      return (bytes / 1000000).toFixed(2) + " MB";
    }
    return (bytes / 1000).toFixed(2) + " KB";
  };
  FileService.formatDuration = function formatDuration(timeSpent) {
    var timeSpentValue = FileService.padNumber(timeSpent, 1) + " Seconds";
    if (timeSpent >= 60) {
      var minutes = Math.round(timeSpent / 60);
      timeSpentValue = FileService.padNumber(minutes, 1) + " Minute" + (minutes == 1 ? "" : "s");
    }
    return timeSpentValue;
  };
  FileService.videoFormatDuration = function videoFormatDuration(metadata) {
    var videoSeconds = metadata.video_duration;
    var videoFormatTime = function videoFormatTime(seconds) {
      return [seconds / 60, seconds % 60].map(function (v) {
        return ("0" + Math.floor(v)).slice(-2);
      }).join(":");
    };
    return videoFormatTime(videoSeconds);
  };
  FileService.metaData = function metaData(metadata) {
    switch (metadata === null || metadata === void 0 ? void 0 : metadata.content_type) {
      case "video/mp4":
        if (!(metadata !== null && metadata !== void 0 && metadata.video_duration)) {
          return '';
        }
        return this.videoFormatDuration(metadata);
      case "image/gif":
      case "image/tiff":
      case "image/png":
      case "image/bmp":
      case "image/jpeg":
      case "image/svg+xml":
        return "";
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      case "application/vnd.openxmlformats-officedocument.presentationml.template":
      case "application/vnd.openxmlformats-officedocument.presentationml.slideshow":
      case "application/vnd.ms-powerpoint.addin.macroEnabled.12":
      case "application/vnd.ms-powerpoint.presentation.macroEnabled.12":
      case "application/vnd.ms-powerpoint.template.macroEnabled.12":
      case "application/vnd.ms-powerpoint.slideshow.macroEnabled.12":
      case "application/pdf":
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.template":
      case "application/vnd.ms-word.template.macroEnabled.12":
        return metadata.pages + " PAGES";
      case "application/vnd.ms-excel":
        return "";
      case "application/vnd.ms-powerpoint":
        return "";
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.template":
      case "application/vnd.ms-excel.sheet.macroEnabled.12":
      case "application/vnd.ms-excel.template.macroEnabled.12":
      case "application/vnd.ms-excel.addin.macroEnabled.12":
      case "application/vnd.ms-excel.sheet.binary.macroEnabled.12":
        return "";
      case "application/url":
        if (metadata.external_video_provider) {
          if (metadata.external_video_provider == "youtube") {
            return this.videoFormatDuration(metadata);
          } else if (metadata.external_video_provider == "vimeo") {
            return this.videoFormatDuration(metadata);
          } else if (metadata.external_video_provider == "wistia") {
            return this.videoFormatDuration(metadata);
          } else if (metadata.external_video_provider == "vidyard") {
            return this.videoFormatDuration(metadata);
          }
        }
        return "";
      case 'audio/mp3':
      case 'audio/mpeg':
      case 'audio/aiff':
      case 'audio/flac':
      case 'audio/x-aiff':
        var audioSeconds = metadata.audio_duration;
        var audioFormatTime = function audioFormatTime(seconds) {
          return [seconds / 60, seconds % 60].map(function (v) {
            return ("0" + Math.floor(v)).slice(-2);
          }).join(":");
        };
        return audioFormatTime(audioSeconds);
      default:
        return "";
    }
  };
  FileService.padNumber = function padNumber(number, pad) {
    if (number === void 0) {
      number = 0;
    }
    number = Math.ceil(number);
    var length = pad - String(number).length + 1;
    var padding = "";
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join("0");
    }
    return padding + number;
  };
  FileService.fileType = function fileType(metadata) {
    switch (metadata === null || metadata === void 0 ? void 0 : metadata.content_type) {
      case "application/pdf":
        return "PDF";
      case "video/mp4":
        return "VIDEO";
      case "image/gif":
      case "image/tiff":
      case "image/png":
      case "image/bmp":
      case "image/jpeg":
      case "image/svg+xml":
        return "IMAGE";
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      case "application/vnd.openxmlformats-officedocument.presentationml.template":
      case "application/vnd.openxmlformats-officedocument.presentationml.slideshow":
      case "application/vnd.ms-powerpoint.addin.macroEnabled.12":
      case "application/vnd.ms-powerpoint.presentation.macroEnabled.12":
      case "application/vnd.ms-powerpoint.template.macroEnabled.12":
      case "application/vnd.ms-powerpoint.slideshow.macroEnabled.12":
        return "PPTX";
      case "application/vnd.ms-powerpoint":
      case "application/vnd.google-apps.presentation":
        return "PPT";
      case "application/msword":
        return "DOC";
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.template":
      case "application/vnd.ms-word.template.macroEnabled.12":
        return "DOCX";
      case "application/vnd.ms-excel":
        return "XLS";
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.template":
      case "application/vnd.ms-excel.sheet.macroEnabled.12":
      case "application/vnd.ms-excel.template.macroEnabled.12":
      case "application/vnd.ms-excel.addin.macroEnabled.12":
      case "application/vnd.ms-excel.sheet.binary.macroEnabled.12":
        return "XLSX";
      case "application/url":
        if (metadata.external_video_provider) {
          if (metadata.external_video_provider == "youtube") {
            return "YOUTUBE";
          } else if (metadata.external_video_provider == "vimeo") {
            return "VIMEO";
          } else if (metadata.external_video_provider == "wistia") {
            return "WISTIA";
          } else if (metadata.external_video_provider == "vidyard") {
            return "VIDYARD";
          }
        }
        return "LINK";
      case 'audio/mp3':
      case 'audio/mpeg':
      case 'audio/aiff':
      case 'audio/flac':
      case 'audio/x-aiff':
        return 'AUDIO';
      default:
        return (_$1.get(metadata, 'extension') || "").toUpperCase();
    }
  };
  return FileService;
}();

var styles$3 = {"analytics":"_LRaKt","action":"_2wKmr","dialog":"_2S6Ln","body":"_3A_Na","empty":"_2-aGW","name":"_3CLAB"};

var analyticsType = function analyticsType(asset) {
  var type = FileService.fileType(asset.metadata);
  switch (type) {
    case "PDF":
    case "PPTX":
    case "PPT":
    case "DOCX":
    case "DOC":
      return "PAGE";
    case "VIDEO":
    case "YOUTUBE":
      return "RANGE";
    default:
      return "DEFAULT";
  }
};
var AnalyticsDebug = function AnalyticsDebug(_ref) {
  var asset = _ref.asset,
    analytics = _ref.analytics;
  var desktop = useMediaQuery({
    query: '(min-width: 1024px)'
  });
  var _useState = useState(false),
    show = _useState[0],
    setShow = _useState[1];
  var type = analyticsType(asset);
  return /*#__PURE__*/React.createElement("div", {
    className: styles$3.analytics
  }, /*#__PURE__*/React.createElement("button", {
    className: styles$3.action,
    onClick: function onClick() {
      setShow(!show);
    }
  }, show ? 'Close' : 'Debug'), show && /*#__PURE__*/React.createElement("div", {
    className: styles$3.dialog
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$3.body
  }, type === 'PAGE' && /*#__PURE__*/React.createElement(PageAnalytics, {
    analytics: analytics
  }), type === 'RANGE' && /*#__PURE__*/React.createElement(RangeAnalytics, {
    analytics: analytics
  }), type === "DEFAULT" && /*#__PURE__*/React.createElement(DefaultAnalytics, {
    analytics: analytics
  }))));
};
var PageAnalytics = function PageAnalytics(_ref2) {
  var analytics = _ref2.analytics;
  var desktop = useMediaQuery({
    query: '(min-width: 1024px)'
  });
  var pages = _$1.get(analytics, 'datapoints') || [];
  return /*#__PURE__*/React.createElement("table", {
    width: desktop ? 200 : 300
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    className: styles$3.name
  }, "Page"), /*#__PURE__*/React.createElement("th", null, "Views"), /*#__PURE__*/React.createElement("th", null, "Duration"))), /*#__PURE__*/React.createElement("tbody", null, pages.map(function (page, index) {
    return /*#__PURE__*/React.createElement("tr", {
      key: page.index
    }, /*#__PURE__*/React.createElement("td", {
      className: styles$3.name,
      width: "50"
    }, "Page " + page.index), /*#__PURE__*/React.createElement("td", {
      width: "50"
    }, page.views), /*#__PURE__*/React.createElement("td", {
      width: "50"
    }, _$1.round(page.duration, 2).toFixed(2)));
  })));
};
var RangeAnalytics = function RangeAnalytics(_ref3) {
  var analytics = _ref3.analytics;
  var desktop = useMediaQuery({
    query: '(min-width: 1024px)'
  });
  var formatDuration = function formatDuration(timeSpent) {
    var value = Math.floor(timeSpent);
    if (timeSpent > 60) {
      var minutes = Math.floor(value / 60);
      var seconds = value % 60;
      return FileService.padNumber(minutes, 2) + ":" + FileService.padNumber(seconds, 2);
    } else {
      return "00:" + FileService.padNumber(value, 2);
    }
  };
  return /*#__PURE__*/React.createElement("table", {
    width: desktop ? 200 : 300
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    className: styles$3.name
  }, "Range"))), /*#__PURE__*/React.createElement("tbody", null, (analytics || []).map(function (range, index) {
    return /*#__PURE__*/React.createElement("tr", {
      key: range.id
    }, /*#__PURE__*/React.createElement("td", {
      className: styles$3.name,
      width: "50"
    }, "Start " + formatDuration(range.start) + " - End " + formatDuration(range.end)));
  })));
};
var DefaultAnalytics = function DefaultAnalytics(_ref4) {
  var analytics = _ref4.analytics;
  var desktop = useMediaQuery({
    query: '(min-width: 1024px)'
  });
  var formatDuration = function formatDuration(timeSpent) {
    var value = Math.floor(timeSpent);
    if (timeSpent > 60) {
      var minutes = Math.floor(value / 60);
      var seconds = value % 60;
      return FileService.padNumber(minutes, 2) + ":" + FileService.padNumber(seconds, 2);
    } else {
      return "00:" + FileService.padNumber(value, 2);
    }
  };
  if (!analytics) {
    return /*#__PURE__*/React.createElement("p", {
      className: styles$3.empty
    }, "No Analytics");
  }
  return /*#__PURE__*/React.createElement("table", {
    width: desktop ? 200 : 300
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    className: styles$3.name
  }, "Timespent"))), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: styles$3.name,
    width: "50"
  }, "" + formatDuration(analytics.duration)))));
};

var getFieldSelector = function getFieldSelector(mapping, key) {
  var fields = _$1.get(mapping, 'fields') || [];
  var field = fields.find(function (item) {
    return item.name === key;
  });
  return field;
};
var getContentForFieldSelector = function getContentForFieldSelector(mapping, key) {
  var field = getFieldSelector(mapping, key);
  if (!field) {
    return null;
  }
  return _$1.get(field, "content");
};

var styles$4 = {"backdropWrapper":"_m5OdF","assetViewerModal":"_15BvO","assetViewerDialog":"_2LIRm","fullscreen":"_2h4fI","assetViewerContent":"_3WpWD","assetToast":"_V6R7E","icon":"_1sd_s","borders":"_7LmAz","details":"_O99VJ","tag":"_3qM0Y","name":"_2tZVt","additionalData":"_1PFXE","metadata":"_3WEHi","showToast":"_3MObr","assetViewerBody":"_1v-ZU","journeyViewerBody":"_39T0T","body":"_Xl1JO","documentViewer":"_3rZq0","htmlViewer":"_2vakF","imageViewer":"_3w6m8","videoViewer":"_F3UF8","defaultViewer":"_2PVZt","header":"_3yybp","contentList":"_9Cz0c","arrows":"_1icwv","leftArrow":"_UkRRp","rightArrow":"_3KXo8","showLeftArrow":"_a9n7-","showRightArrow":"_3mr6e","cardsContainer":"_3pibo","contentCard":"_2qFbe","selected":"_1GM_G","contentMetadata":"_T3Ps9","placeholder":"_3KB4t","placeholder-glow":"_2TA0W","assetMetadata":"_1g66z","assetsContainer":"_KPt88","asset":"_2Zy7n","actions":"_3t1Lc","action":"_10u7M","debug":"_8F1ra","download":"_3Rspj","share":"_2Wiz0","close":"_39Pxd","column1":"_1WFWp","shareDropdown":"_1of1S","arrow":"_1ZSgu","column2":"_2_8fT","initialised":"_2wJFO","loader":"_2cCXo","videoWrapper":"_28YJF","message":"_YvW6A","headerVisible":"_vviyy","inner":"_3loml","downloadButton":"_3lBIC","inline":"_2l1H0","singleAssetViwerBody":"_1YAGw"};

var DefaultViewer = React.lazy(function () {
  return import('@paperflite-marketing/asset-viewer').then(function (module) {
    return {
      "default": module.DefaultViewer
    };
  });
});
var DefaultAssetViewer = function DefaultAssetViewer(_ref) {
  var asset = _ref.asset,
    active = _ref.active,
    onAnalyticsChange = _ref.onAnalyticsChange,
    onDebugAnalytics = _ref.onDebugAnalytics;
  var contentContext = React.useContext(Content.Context);
  var icon = getContentForFieldSelector(asset, 'icon');
  var iconUrl = _.get(icon, 'url') || '/public/cleverstory/v2/static/default_card.jpg';
  var downloadUrl = _.get(asset, 'content.asset.downloadUrl');
  var handleDownload = function handleDownload(asset) {
    window.open(downloadUrl, "_blank");
    contentContext.onDownload(asset);
  };
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", {
      className: styles$4.defaultViewer
    })
  }, /*#__PURE__*/React.createElement(DefaultViewer, {
    className: styles$4.defaultViewer,
    active: active,
    onAnalyticsChange: onAnalyticsChange,
    onDebugAnalytics: onDebugAnalytics
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.inner
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.icon
  }, /*#__PURE__*/React.createElement(IKImage, {
    path: iconUrl,
    width: 400,
    height: 226.75
  })), downloadUrl && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles$4.message
  }, "Click below to download the file"), /*#__PURE__*/React.createElement("a", {
    onClick: handleDownload,
    className: styles$4.downloadButton,
    target: "_blank"
  }, "Download")), !downloadUrl && /*#__PURE__*/React.createElement("div", {
    className: styles$4.message
  }, "Unable to preview the asset"))));
};

var DocumentViewer = React.lazy(function () {
  return import('@paperflite-marketing/asset-viewer').then(function (module) {
    return {
      "default": module.DocumentViewer
    };
  });
});
var DocumentContentViewer = function DocumentContentViewer(_ref) {
  var asset = _ref.asset,
    width = _ref.width,
    active = _ref.active,
    onLoad = _ref.onLoad,
    loaded = _ref.loaded,
    onAnalyticsChange = _ref.onAnalyticsChange,
    onDebugAnalytics = _ref.onDebugAnalytics,
    scrollParent = _ref.scrollParent,
    inline = _ref.inline,
    widgetId = _ref.widgetId;
  var contentContext = React.useContext(Content.Context);
  var id = _$1.get(asset, 'content.id');
  var type = _$1.get(asset, 'content.asset.viewer.type');
  var previewData = useSelector(function (state) {
    return _$1.get(state, "content.previews." + id + ".item");
  });
  var loading = useSelector(function (state) {
    return _$1.get(state, "content.previews." + id + ".loading");
  });
  var sourceUrl = _$1.get(asset, 'content.asset.viewer.url');
  var _useState = useState(width),
    preferredWidth = _useState[0],
    setPreferredWidth = _useState[1];
  var _useState2 = useState(205),
    offset = _useState2[0],
    setOffset = _useState2[1];
  var desktop = useDesktop$1();
  useEffect(function () {
    var offset = desktop ? 50 : 10;
    var widthValue = width - 2 * offset;
    widthValue = Math.min(widthValue, 1024);
    setPreferredWidth(widthValue);
  }, [width, desktop]);
  useEffect(function () {
    if (inline && loaded) {
      if (scrollParent === 'body') {
        var widgetElement = document.getElementById(widgetId);
        var widgetRect = widgetElement.getBoundingClientRect();
        setOffset(widgetRect.top * -1);
      } else {
        setOffset(0);
      }
    }
  }, [inline, loaded]);
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", {
      className: styles$4.documentViewer
    })
  }, /*#__PURE__*/React.createElement(DocumentViewer, {
    id: (inline ? 'inline_' : '') + "asset_viewer_" + (widgetId ? widgetId : id),
    inline: inline,
    sourceUrl: sourceUrl,
    previewData: previewData,
    fetchPreviewData: function fetchPreviewData() {
      if (type === 'enhanced_viewer') {
        contentContext.fetchPreviewDataForAsset(_$1.get(asset, 'content.id'));
      }
    },
    loading: loading,
    loadingComponent: function loadingComponent() {
      return /*#__PURE__*/React.createElement("div", {
        className: cx(styles$4.loader)
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$4.videoWrapper
      }, /*#__PURE__*/React.createElement("video", {
        loop: true,
        autoPlay: true,
        playsInline: true,
        muted: true
      }, /*#__PURE__*/React.createElement("source", {
        src: "/images/Workspaceloader.webm",
        type: "video/webm"
      }), /*#__PURE__*/React.createElement("source", {
        src: "/images/Workspaceloader.mp4",
        type: "video/mp4"
      })), /*#__PURE__*/React.createElement("label", {
        className: styles$4.message
      }, "Generating Preview....")));
    },
    scrollParent: scrollParent ? scrollParent : "." + styles$4.assetViewerContent,
    offset: offset,
    preferredWidth: preferredWidth,
    disabled: !active,
    workerUrl: "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.min.js",
    onPageChange: function onPageChange(page) {},
    onAnalyticsChange: onAnalyticsChange,
    onDebugAnalytics: onDebugAnalytics,
    onViewerRendered: function onViewerRendered() {
      if (onLoad) {
        onLoad();
      }
    }
  }));
};

var HTMLViewer = React.lazy(function () {
  return import('@paperflite-marketing/asset-viewer').then(function (module) {
    return {
      "default": module.HTMLViewer
    };
  });
});
var ScormViewer = React.lazy(function () {
  return import('@paperflite-marketing/asset-viewer').then(function (module) {
    return {
      "default": module.ScormViewer
    };
  });
});
var ImageViewer = React.lazy(function () {
  return import('@paperflite-marketing/asset-viewer').then(function (module) {
    return {
      "default": module.ImageViewer
    };
  });
});
var VideoViewer = React.lazy(function () {
  return import('@paperflite-marketing/asset-viewer').then(function (module) {
    return {
      "default": module.VideoViewer
    };
  });
});
var AudioViewer = React.lazy(function () {
  return import('@paperflite-marketing/asset-viewer').then(function (module) {
    return {
      "default": module.AudioViewer
    };
  });
});
var AssetContentViewer = function AssetContentViewer(_ref) {
  var asset = _ref.asset,
    active = _ref.active,
    onLoad = _ref.onLoad,
    loaded = _ref.loaded,
    onAnalyticsChange = _ref.onAnalyticsChange,
    onDebugAnalytics = _ref.onDebugAnalytics,
    scrollParent = _ref.scrollParent,
    inline = _ref.inline,
    widgetId = _ref.widgetId,
    poster = _ref.poster;
  var id = _$1.get(asset, 'content.asset.id');
  var type = _$1.get(asset, 'content.asset.viewer.type');
  var _useState = useState(1200),
    width = _useState[0],
    setWidth = _useState[1];
  var _React$useState = React.useState(!inline),
    render = _React$useState[0],
    setRender = _React$useState[1];
  var context = React.useContext(WidgetsContext);
  var embedContext = React.useContext(EmbedContext);
  var storyboard = _$1.get(context, 'storyboard');
  React.useEffect(function () {
    window.addEventListener('resize', handleWidowResize);
    calculatePreferredWidth();
    handleViewerLoaded();
    if (embedContext.embedded) {
      var script = _$1.get(storyboard, 'customScript', null);
      if (script !== null) {
        injectCustomScript(script);
      }
    }
    return function () {
      window.removeEventListener('resize', handleWidowResize);
    };
  }, []);
  React.useEffect(function () {
    if (!render) {
      setRender(true);
    }
  }, []);
  var handleWidowResize = function handleWidowResize() {
    calculatePreferredWidth();
  };
  var calculatePreferredWidth = function calculatePreferredWidth() {
    var viewerContainer = document.querySelector("[data-asset=\"" + _$1.get(asset, 'uid', null) + "\"]");
    if (viewerContainer) {
      var _width = viewerContainer.offsetWidth;
      setWidth(_width);
    }
  };
  var handleViewerLoaded = function handleViewerLoaded() {
    if (!_$1.includes(['enhanced_viewer', 'pdf_viewer'], type)) {
      onLoad();
    }
  };
  var injectCustomScript = function injectCustomScript(scriptText) {
    var script = document.createElement("script");
    if (scriptText) {
      script.appendChild(document.createTextNode(scriptText));
    }
    try {
      document.head.appendChild(script);
    } catch (e) {
      script.text = scriptText;
      document.head.appendChild(script);
    }
  };
  if (!render) {
    return null;
  }
  switch (type) {
    case 'enhanced_viewer':
    case 'pdf_viewer':
      {
        return /*#__PURE__*/React.createElement(DocumentContentViewer, {
          asset: asset,
          width: width,
          active: active,
          widgetId: widgetId,
          inline: inline,
          onLoad: onLoad,
          loaded: loaded,
          scrollParent: scrollParent,
          onAnalyticsChange: onAnalyticsChange,
          onDebugAnalytics: onDebugAnalytics
        });
      }
    case 'html_viewer':
      {
        var _id = _$1.get(asset, 'content.asset.id');
        var mode = _$1.get(asset, 'content.asset.viewer.mode');
        var url = _$1.get(asset, 'content.asset.metadata.url');
        var optimizedUrl = _$1.get(asset, 'content.asset.viewer.url');
        var canPreview = _$1.get(asset, 'content.asset.viewer.preview');
        var name = getContentForFieldSelector(asset, 'name') || "";
        var icon = getContentForFieldSelector(asset, 'icon');
        var iconUrl = _$1.get(icon, 'url') || '/public/cleverstory/v2/static/default_card.jpg';
        return /*#__PURE__*/React.createElement(Suspense, {
          fallback: /*#__PURE__*/React.createElement("div", {
            className: styles$4.htmlViewer
          })
        }, /*#__PURE__*/React.createElement(HTMLViewer, {
          id: widgetId ? widgetId : _id,
          className: styles$4.htmlViewer,
          name: name,
          icon: iconUrl,
          mode: mode,
          url: url,
          optimizedUrl: optimizedUrl,
          canPreview: canPreview,
          active: active,
          onAnalyticsChange: onAnalyticsChange,
          onDebugAnalytics: onDebugAnalytics
        }));
      }
    case 'scorm_viewer':
      {
        var _id2 = _$1.get(asset, 'content.asset.id');
        var _url = _$1.get(asset, 'content.asset.viewer.url');
        var _name = getContentForFieldSelector(asset, 'name') || "";
        var _icon = getContentForFieldSelector(asset, 'icon');
        var _iconUrl = _$1.get(_icon, 'url') || '/public/cleverstory/v2/static/default_card.jpg';
        return /*#__PURE__*/React.createElement(Suspense, {
          fallback: /*#__PURE__*/React.createElement("div", {
            className: styles$4.htmlViewer
          })
        }, /*#__PURE__*/React.createElement(ScormViewer, {
          id: widgetId ? widgetId : _id2,
          className: styles$4.htmlViewer,
          name: _name,
          icon: _iconUrl,
          url: _url,
          active: active,
          onAnalyticsChange: onAnalyticsChange,
          onDebugAnalytics: onDebugAnalytics
        }));
      }
    case 'image_viewer':
      {
        var _id3 = _$1.get(asset, 'content.asset.id');
        var sourceUrl = _$1.get(asset, 'content.asset.viewer.url');
        return /*#__PURE__*/React.createElement(Suspense, {
          fallback: /*#__PURE__*/React.createElement("div", {
            className: styles$4.imageViewer
          })
        }, /*#__PURE__*/React.createElement(ImageViewer, {
          id: "asset_viewer_" + (widgetId ? widgetId : _id3),
          className: styles$4.imageViewer,
          src: sourceUrl,
          scrollParent: "." + styles$4.assetViewerContent,
          loadingComponent: function loadingComponent() {
            return /*#__PURE__*/React.createElement("div", {
              className: cx(styles$4.loader)
            }, /*#__PURE__*/React.createElement("div", {
              className: styles$4.videoWrapper
            }, /*#__PURE__*/React.createElement("video", {
              loop: true,
              autoPlay: true,
              playsInline: true,
              muted: true
            }, /*#__PURE__*/React.createElement("source", {
              src: "/images/Workspaceloader.webm",
              type: "video/webm"
            }), /*#__PURE__*/React.createElement("source", {
              src: "/images/Workspaceloader.mp4",
              type: "video/mp4"
            })), /*#__PURE__*/React.createElement("label", {
              className: styles$4.message
            }, "Loading Image....")));
          },
          active: active,
          onAnalyticsChange: onAnalyticsChange,
          onDebugAnalytics: onDebugAnalytics
        }));
      }
    case 'video_viewer':
      {
        var _id4 = _$1.get(asset, 'content.asset.id');
        var metadata = _$1.get(asset, 'content.asset.metadata');
        var _sourceUrl = _$1.get(asset, 'content.asset.viewer.url');
        var videoProvider = _$1.get(metadata, 'external_video_provider');
        var _icon2 = getContentForFieldSelector(asset, 'icon');
        var _iconUrl2 = _$1.get(_icon2, 'url') || '/public/cleverstory/v2/static/default_card.jpg';
        if (videoProvider == null || videoProvider == 'youtube' || videoProvider == 'vimeo' || videoProvider == 'wistia') {
          var _cx, _cx2;
          return /*#__PURE__*/React.createElement(Suspense, {
            fallback: /*#__PURE__*/React.createElement("div", {
              className: cx(styles$4.videoViewer, (_cx = {}, _cx[styles$4.inline] = inline, _cx))
            })
          }, /*#__PURE__*/React.createElement(VideoViewer, {
            id: "asset_viewer_" + (widgetId ? widgetId : _id4),
            className: cx(styles$4.videoViewer, (_cx2 = {}, _cx2[styles$4.inline] = inline, _cx2)),
            src: _sourceUrl,
            metadata: metadata,
            active: active,
            icon: _iconUrl2,
            imageCDN: context.imageCDN,
            poster: poster,
            onPlay: function onPlay() {},
            onAnalyticsChange: onAnalyticsChange,
            onDebugAnalytics: onDebugAnalytics
          }));
        }
      }
    case 'audio_viewer':
      {
        var _cx3;
        var _id5 = _$1.get(asset, 'content.asset.id');
        var _metadata = _$1.get(asset, 'content.asset.metadata');
        var _sourceUrl2 = _$1.get(asset, 'content.asset.viewer.url');
        var supportedFormats = ['mp3', 'wav', 'aiff', 'flac', 'wma', 'aac'];
        var _icon3 = getContentForFieldSelector(asset, 'icon');
        var _iconUrl3 = _$1.get(_icon3, 'url') || '/public/cleverstory/v2/static/default_card.jpg';
        return /*#__PURE__*/React.createElement(Suspense, {
          fallback: /*#__PURE__*/React.createElement("div", {
            className: styles$4.defaultViewer
          })
        }, _$1.includes(supportedFormats, _$1.get(_metadata, 'extension')) && /*#__PURE__*/React.createElement(AudioViewer, {
          id: "asset_viewer_" + (widgetId ? widgetId : _id5),
          className: cx(styles$4.videoViewer, (_cx3 = {}, _cx3[styles$4.inline] = inline, _cx3)),
          src: _sourceUrl2,
          metadata: _metadata,
          active: active,
          icon: _iconUrl3,
          imageCDN: context.imageCDN,
          poster: poster,
          onPlay: function onPlay() {},
          onAnalyticsChange: onAnalyticsChange,
          onDebugAnalytics: onDebugAnalytics
        }), !_$1.includes(supportedFormats, _$1.get(_metadata, 'extension')) && /*#__PURE__*/React.createElement(DefaultAssetViewer, {
          asset: asset,
          active: active,
          onAnalyticsChange: onAnalyticsChange,
          onDebugAnalytics: onDebugAnalytics
        }));
      }
    default:
      return /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement("div", {
          className: styles$4.defaultViewer
        })
      }, /*#__PURE__*/React.createElement(DefaultAssetViewer, {
        asset: asset,
        active: active,
        onAnalyticsChange: onAnalyticsChange,
        onDebugAnalytics: onDebugAnalytics
      }));
  }
};

var journeyRecommendationAsset = function journeyRecommendationAsset(analytics, journeyConfigurations, nextJourneyAsset, setNextJourneyAsset, hasConditionRun, setHasConditionRun, setJourneyTrigger, setShowRecommendSlide, setIsJourneyEnd) {
  var _nextJourneyAsset$ste, _nextJourneyAsset$ste2, _nextJourneyAsset$ste3;
  if (!analytics || !journeyConfigurations) return;
  var filters = journeyConfigurations.filters,
    defaultStep = journeyConfigurations.defaultStep,
    conditionalStep = journeyConfigurations.conditionalStep,
    journeyExecution = journeyConfigurations.journeyExecution,
    asset = journeyConfigurations.asset,
    id = journeyConfigurations.id;
  var duration = analytics.duration,
    percentageRead = analytics.percentageRead;
  var _ref = Array.isArray(filters) && filters[0] ? filters[0] : {},
    property = _ref.property,
    value = _ref.value;
  var analyticsValue = (property === null || property === void 0 ? void 0 : property.type) === 'PERCENTAGE' ? percentageRead : duration;
  var filterValue = Array.isArray(value) && value[0] && parseFloat(value[0]);
  var isJourneyEnd = (journeyExecution === null || journeyExecution === void 0 ? void 0 : journeyExecution.status) == "COMPLETED";
  setJourneyTrigger(true);
  if (isJourneyEnd) {
    setShowRecommendSlide(false);
    setIsJourneyEnd(true);
    return;
  }
  if (asset != null && (nextJourneyAsset === null || nextJourneyAsset === void 0 ? void 0 : (_nextJourneyAsset$ste = nextJourneyAsset.step) === null || _nextJourneyAsset$ste === void 0 ? void 0 : _nextJourneyAsset$ste.id) != id) {
    setShowRecommendSlide(false);
    setTimeout(function () {
      setNextJourneyAsset(function (state) {
        return _extends({}, state, {
          step: {
            id: id,
            asset: asset
          },
          journeyExecution: journeyExecution
        });
      });
      setShowRecommendSlide(true);
    }, 500);
    return {
      id: id,
      asset: asset
    };
  }
  if (asset == null && conditionalStep != null && analyticsValue >= filterValue && ((nextJourneyAsset === null || nextJourneyAsset === void 0 ? void 0 : (_nextJourneyAsset$ste2 = nextJourneyAsset.step) === null || _nextJourneyAsset$ste2 === void 0 ? void 0 : _nextJourneyAsset$ste2.id) != (conditionalStep === null || conditionalStep === void 0 ? void 0 : conditionalStep.id) || (nextJourneyAsset === null || nextJourneyAsset === void 0 ? void 0 : nextJourneyAsset.step) == null)) {
    if (!hasConditionRun) {
      setShowRecommendSlide(false);
      if ((conditionalStep === null || conditionalStep === void 0 ? void 0 : conditionalStep.asset) != null) {
        setHasConditionRun(true);
        setTimeout(function () {
          setNextJourneyAsset(function (state) {
            return _extends({}, state, {
              step: conditionalStep,
              journeyExecution: journeyExecution
            });
          });
          setShowRecommendSlide(true);
        }, 500);
        return conditionalStep;
      } else {
        setNextJourneyAsset(function (state) {
          return _extends({}, state, {
            step: conditionalStep,
            journeyExecution: journeyExecution
          });
        });
        setShowRecommendSlide(false);
        return conditionalStep;
      }
    }
  }
  if (asset == null && defaultStep != null && (nextJourneyAsset === null || nextJourneyAsset === void 0 ? void 0 : (_nextJourneyAsset$ste3 = nextJourneyAsset.step) === null || _nextJourneyAsset$ste3 === void 0 ? void 0 : _nextJourneyAsset$ste3.id) != (defaultStep === null || defaultStep === void 0 ? void 0 : defaultStep.id)) {
    if ((defaultStep === null || defaultStep === void 0 ? void 0 : defaultStep.asset) != null) {
      setNextJourneyAsset(function (state) {
        return _extends({}, state, {
          step: defaultStep,
          journeyExecution: journeyExecution
        });
      });
      setShowRecommendSlide(true);
      return defaultStep;
    } else {
      setNextJourneyAsset(function (state) {
        return _extends({}, state, {
          step: defaultStep,
          journeyExecution: journeyExecution
        });
      });
      setShowRecommendSlide(false);
      return defaultStep;
    }
  }
  return;
};

function AssetViewer(_ref) {
  var _nextJourneyAsset$ste, _nextJourneyAsset$ste2, _cx, _cx2, _cx3;
  var show = _ref.show,
    initialContent = _ref.initialContent,
    redirect = _ref.redirect,
    asset = _ref.asset,
    contentGrid = _ref.contentGrid,
    onClose = _ref.onClose;
  var scrollContainerRef = React.useRef(null);
  var scrollPosition = React.useRef(0);
  var touchPosition = React.useRef(0);
  var context = React.useContext(WidgetsContext);
  var contentContext = React.useContext(Content.Context);
  var _React$useState = React.useState(),
    activeAsset = _React$useState[0],
    setActiveAsset = _React$useState[1];
  var _React$useState2 = React.useState(false),
    fullscreen = _React$useState2[0],
    setFullscreen = _React$useState2[1];
  var widgetContext = React.useContext(WidgetsContext);
  var gatingContext = React.useContext(GatingContext);
  var isPreview = widgetContext === null || widgetContext === void 0 ? void 0 : widgetContext.preview;
  var _useState = useState({
      position: 0,
      visible: true,
      fixed: false,
      scrollDisabled: false,
      selected: {},
      preloadedAssets: []
    }),
    state = _useState[0],
    setState = _useState[1];
  var _useState2 = useState([]),
    assetMappings = _useState2[0],
    setAssetMappings = _useState2[1];
  var _useState3 = useState(null),
    snapAsset = _useState3[0],
    setSnapAsset = _useState3[1];
  var _useState4 = useState(false),
    showRecommendSlide = _useState4[0],
    setShowRecommendSlide = _useState4[1];
  var _useState5 = useState({
      paused: false,
      assetId: null
    }),
    journeyPaused = _useState5[0],
    setJourneyPaused = _useState5[1];
  var _useState6 = useState({
      step: null,
      journeyExecution: null
    }),
    nextJourneyAsset = _useState6[0],
    setNextJourneyAsset = _useState6[1];
  var _useState7 = useState(false),
    journeyTriggered = _useState7[0],
    setJourneyTrigger = _useState7[1];
  var _useState8 = useState(false),
    hasConditionRun = _useState8[0],
    setHasConditionRun = _useState8[1];
  var _useState9 = useState(false),
    isJourneyEnd = _useState9[0],
    setIsJourneyEnd = _useState9[1];
  var _useState10 = useState({
      asset: null,
      journey: null
    }),
    journeyConfig = _useState10[0],
    setJourneyConfig = _useState10[1];
  var contentPage = useSelector(function (state) {
    var mappings = [];
    if (initialContent) {
      mappings = [initialContent];
    }
    if (!contentGrid) {
      return {
        items: mappings,
        loading: false,
        currentPage: 0,
        totalPages: 0,
        itemsPerPage: 0
      };
    }
    var widgets = _$1.get(state, context.selector + ".widgets") || [];
    var contentGridWidget = widgets.find(function (item) {
      return item.uid === contentGrid;
    });
    var items = _$1.get(contentGridWidget, 'content.mappings.items') || [];
    mappings = [].concat(mappings, items);
    mappings = _$1.uniqBy(mappings, 'uid');
    var loading = _$1.get(contentGridWidget, 'content.mappings.loading', false);
    var currentPage = _$1.get(contentGridWidget, 'content.mappings.pagination.current', 0);
    var totalPages = _$1.get(contentGridWidget, 'content.mappings.pagination.totalPages', 1);
    var itemsPerPage = _$1.get(contentGridWidget, 'properties.desktop.layoutStyle.itemsPerPage', 2);
    var pagination = _$1.get(contentGridWidget, 'properties.desktop.layoutStyle.pagination', 'infinite_scroll');
    return {
      items: mappings,
      loading: loading,
      currentPage: currentPage,
      totalPages: totalPages,
      itemsPerPage: itemsPerPage,
      pagination: pagination
    };
  });
  var isJourneyAsset = (assetMappings || []).length != _$1.get(contentPage, "items", []).length < 2;
  var alias = useSelector(function (state) {
    return _$1.get(state, "pages.item.canonical");
  });
  var pageSession = useSelector(function (state) {
    return _$1.get(state, "pages.analytics[" + alias + "].id", null);
  });
  var _useState11 = useState(pageSession),
    pageSessionState = _useState11[0],
    setPageSessionState = _useState11[1];
  var name = getContentForFieldSelector(nextJourneyAsset === null || nextJourneyAsset === void 0 ? void 0 : (_nextJourneyAsset$ste = nextJourneyAsset.step) === null || _nextJourneyAsset$ste === void 0 ? void 0 : _nextJourneyAsset$ste.asset, 'name') || "";
  var icon = getContentForFieldSelector(nextJourneyAsset === null || nextJourneyAsset === void 0 ? void 0 : (_nextJourneyAsset$ste2 = nextJourneyAsset.step) === null || _nextJourneyAsset$ste2 === void 0 ? void 0 : _nextJourneyAsset$ste2.asset, 'icon');
  var iconUrl = _$1.get(icon, 'url') || '/public/cleverstory/v2/static/default_card.jpg';
  var handleWheelEvent = _$1.throttle(function (wheelEvent) {
    var scrollContainer = scrollContainerRef.current.dialog.querySelector("." + styles$4.assetViewerContent);
    var previousPosition = scrollPosition.current;
    var currentPosition = scrollContainer.scrollTop;
    if (wheelEvent.deltaX) {
      scrollPosition.current = scrollContainer.scrollTop;
      return;
    }
    if (previousPosition > currentPosition) {
      scrollContainer.classList.add(styles$4.headerVisible);
    } else {
      scrollContainer.classList.remove(styles$4.headerVisible);
    }
    scrollPosition.current = scrollContainer.scrollTop;
  }, 100);
  var handleTouchStart = function handleTouchStart(e) {
    touchPosition.current = e.touches[0].clientY;
  };
  var handleTouchEnd = function handleTouchEnd(e) {
    var scrollContainer = scrollContainerRef.current.dialog.querySelector("." + styles$4.assetViewerContent);
    var currentPosition = e.changedTouches[0].clientY;
    var previousPosition = touchPosition.current;
    var diff = currentPosition - previousPosition;
    if (diff > 0) {
      scrollContainer.classList.add(styles$4.headerVisible);
    } else {
      scrollContainer.classList.remove(styles$4.headerVisible);
    }
  };
  useEffect(function () {
    if (pageSession) {
      setPageSessionState(pageSession);
    }
  }, [pageSession]);
  useEffect(function () {
    var newItems = contentPage.items.filter(function (item) {
      return !assetMappings.includes(item);
    });
    if (newItems.length > 0) {
      setAssetMappings(function (prevMappings) {
        return [].concat(prevMappings, newItems);
      });
    }
  }, [contentPage.items]);
  useEffect(function () {
    if (widgetContext.onTriggerMixpanelEvent) {
      widgetContext.onTriggerMixpanelEvent(widgetContext.session, 'Page Viewed', {
        screen_name: 'Asset Viewer'
      });
    }
  }, []);
  useEffect(function () {
    if (show) {
      setState(function (state) {
        return _extends({}, state, {
          selected: asset
        });
      });
      var scrollContent = document.getElementsByClassName('modal-content');
      scrollContent = _$1.head(scrollContent);
      scrollContent.addEventListener('wheel', handleWheelEvent);
      scrollContent.addEventListener('touchstart', handleTouchStart);
      scrollContent.addEventListener('touchend', handleTouchEnd);
      return function () {
        scrollContent.removeEventListener('wheel', handleWheelEvent);
        scrollContent.removeEventListener('touchstart', handleTouchStart);
        scrollContent.removeEventListener('touchend', handleTouchEnd);
      };
    }
  }, [show, asset]);
  useEffect(function () {
    var _nextJourneyAsset$ste3;
    if (!activeAsset) return;
    if (activeAsset.uid != (snapAsset === null || snapAsset === void 0 ? void 0 : snapAsset.uid) && (nextJourneyAsset === null || nextJourneyAsset === void 0 ? void 0 : nextJourneyAsset.step) != null && !isJourneyEnd && !isPreview) {
      setShowRecommendSlide(false);
      setHasConditionRun(false);
      var stepId = nextJourneyAsset.step.id;
      var journeyExecutionId = nextJourneyAsset.journeyExecution.id;
      contentContext.fetchAssetJourney(asset, stepId, journeyExecutionId, pageSessionState);
    }
    if ((nextJourneyAsset === null || nextJourneyAsset === void 0 ? void 0 : (_nextJourneyAsset$ste3 = nextJourneyAsset.step) === null || _nextJourneyAsset$ste3 === void 0 ? void 0 : _nextJourneyAsset$ste3.asset) != null) {
      var selectedAssetUid = snapAsset === null || snapAsset === void 0 ? void 0 : snapAsset.uid;
      var pausedAssetUid = journeyPaused === null || journeyPaused === void 0 ? void 0 : journeyPaused.assetId;
      if (selectedAssetUid == pausedAssetUid) {
        setJourneyPaused({
          paused: false,
          assetId: null
        });
        contentContext.updateAssetJourneyExecution(snapAsset, false);
      }
    }
    contentContext.onContentChange(contentGrid, activeAsset, contentPage, redirect);
  }, [activeAsset]);
  var fetchAdditionalContent = function fetchAdditionalContent() {
    var nextPage = contentPage.currentPage + 1;
    if (nextPage >= contentPage.totalPages || contentPage.pagination === 'none') {
      return;
    }
    contentContext.fetchMappingsForContentGrid(contentGrid, nextPage, contentPage.itemsPerPage);
  };
  var handleAssetSelection = function handleAssetSelection(content) {
    var _nextJourneyAsset$ste4;
    if ((nextJourneyAsset === null || nextJourneyAsset === void 0 ? void 0 : (_nextJourneyAsset$ste4 = nextJourneyAsset.step) === null || _nextJourneyAsset$ste4 === void 0 ? void 0 : _nextJourneyAsset$ste4.asset) != null && !isJourneyEnd) {
      var selectedAssetUid = content.uid;
      var nextAssetUid = nextJourneyAsset.step.asset.uid;
      if (selectedAssetUid != nextAssetUid) {
        setJourneyPaused({
          paused: true,
          assetId: snapAsset === null || snapAsset === void 0 ? void 0 : snapAsset.uid
        });
        contentContext.updateAssetJourneyExecution(snapAsset, true);
        setTimeout(function () {
          setNextJourneyAsset({
            step: null,
            journeyExecution: null
          });
        }, 300);
      }
      if (selectedAssetUid == nextAssetUid && !isPreview) {
        var stepId = nextJourneyAsset.step.id;
        var journeyExecutionId = nextJourneyAsset.journeyExecution.id;
        contentContext.fetchAssetJourney(content, stepId, journeyExecutionId, pageSessionState);
      }
    }
    setShowRecommendSlide(false);
    setState(function (state) {
      return _extends({}, state, {
        selected: content
      });
    });
    switch (content.type) {
      case 'INTERACTIVE_CONTENT':
      case 'LANDING_PAGE':
      case 'RESOURCE_CENTER':
        {
          if (!content.url) {
            return;
          }
          var pageUrl = "" + content.content.domain + content.url;
          window.open(pageUrl);
          break;
        }
      case 'ASSET':
        {
          scrollToAsset(content.uid);
          break;
        }
    }
  };
  var scrollToAsset = function scrollToAsset(id) {
    var scrollContainer = scrollContainerRef.current.dialog.querySelector("." + styles$4.assetViewerContent);
    var assetContainer = scrollContainer.querySelector("[data-asset='" + id + "']");
    if (!assetContainer) {
      return;
    }
    var scrollTop = scrollContainer.scrollTop;
    var assetOffset = assetContainer.offsetTop;
    var scrollDown = assetOffset > scrollTop;
    var offset = scrollDown ? 7 : 7;
    scrollContainer.scrollTo({
      top: assetContainer.offsetTop + offset,
      behavior: "smooth"
    });
  };
  var handleAssetVisibilityChange = function handleAssetVisibilityChange(asset, visible, analytics) {
    var prevId = _$1.get(activeAsset, 'asset.id');
    var nextId = _$1.get(asset, 'id');
    if (prevId == nextId && !visible) {
      setActiveAsset(null);
      return;
    }
    if (visible) {
      setActiveAsset(asset);
    }
  };
  var handleJourneyPath = function handleJourneyPath(nextAsset) {
    setAssetMappings(function (prevAssets) {
      var assetIndex = prevAssets.findIndex(function (a) {
        return a.uid === (activeAsset === null || activeAsset === void 0 ? void 0 : activeAsset.uid);
      });
      if (assetIndex >= 0) {
        var newAssets = [].concat(prevAssets);
        if ((snapAsset === null || snapAsset === void 0 ? void 0 : snapAsset.uid) === (activeAsset === null || activeAsset === void 0 ? void 0 : activeAsset.uid)) {
          newAssets.splice(assetIndex + 1, 1, nextAsset);
        } else {
          newAssets.splice(assetIndex + 1, 0, nextAsset);
        }
        setSnapAsset(activeAsset);
        return newAssets;
      }
      return prevAssets;
    });
  };
  var handleAssetLoaded = function handleAssetLoaded(asset, journeyConfigurations) {
    setState(function (state) {
      var assets = (assetMappings.items || []).filter(function (item) {
        return item.type === 'ASSET';
      }).map(function (item) {
        return item.uid;
      });
      var activeIndex = assets.indexOf(asset);
      var nextIndex = activeIndex + 1;
      var nextAsset = assets[nextIndex];
      var preloadedAssets = _$1.get(state, 'preloadedAssets') || [];
      preloadedAssets = [].concat(preloadedAssets, [asset]);
      if (nextAsset) {
        preloadedAssets = [].concat(preloadedAssets, [nextAsset]);
      }
      preloadedAssets = _$1.uniq(preloadedAssets);
      return _extends({}, state, {
        preloadedAssets: preloadedAssets
      });
    });
    if ((asset === null || asset === void 0 ? void 0 : asset.uid) != (snapAsset === null || snapAsset === void 0 ? void 0 : snapAsset.uid)) {
      setHasConditionRun(false);
    }
    if ((nextJourneyAsset === null || nextJourneyAsset === void 0 ? void 0 : nextJourneyAsset.step) != null && !isJourneyEnd && !journeyConfigurations && !isPreview) {
      var stepId = nextJourneyAsset.step.id;
      var journeyExecutionId = nextJourneyAsset.journeyExecution.id;
      contentContext.fetchAssetJourney(asset, stepId, journeyExecutionId, pageSessionState);
    }
  };
  var toggleFullScreen = function toggleFullScreen() {
    setFullscreen(function (state) {
      return !state;
    });
  };
  var handleClose = function handleClose() {
    if (!onClose) return;
    setShowRecommendSlide(false);
    setNextJourneyAsset({
      step: null,
      journeyExecution: null
    });
    setHasConditionRun(false);
    setAssetMappings([]);
    setJourneyTrigger(false);
    setIsJourneyEnd(false);
    setJourneyConfig({
      asset: null,
      journey: null
    });
    onClose();
  };
  return /*#__PURE__*/React.createElement(Modal, {
    ref: scrollContainerRef,
    backdrop: true,
    className: styles$4.assetViewerModal,
    contentClassName: cx(styles$4.assetViewerContent, styles$4.headerVisible, (_cx = {}, _cx[styles$4.fullscreen] = fullscreen, _cx)),
    dialogClassName: cx(styles$4.assetViewerDialog, (_cx2 = {}, _cx2[styles$4.fullscreen] = fullscreen, _cx2)),
    fullscreen: fullscreen,
    backdropClassName: styles$4.backdropWrapper,
    show: show,
    onHide: handleClose,
    centered: true,
    size: "lg",
    enforceFocus: false
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles$4.assetToast, (_cx3 = {}, _cx3[styles$4.showToast] = showRecommendSlide, _cx3)),
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick() {
      var _nextJourneyAsset$ste5, _nextJourneyAsset$ste6;
      return (nextJourneyAsset === null || nextJourneyAsset === void 0 ? void 0 : (_nextJourneyAsset$ste5 = nextJourneyAsset.step) === null || _nextJourneyAsset$ste5 === void 0 ? void 0 : _nextJourneyAsset$ste5.asset) && handleAssetSelection(nextJourneyAsset === null || nextJourneyAsset === void 0 ? void 0 : (_nextJourneyAsset$ste6 = nextJourneyAsset.step) === null || _nextJourneyAsset$ste6 === void 0 ? void 0 : _nextJourneyAsset$ste6.asset);
    }
  }, /*#__PURE__*/React.createElement(IKImage, {
    path: iconUrl,
    width: 79,
    height: 75,
    style: {
      borderRadius: "8px",
      objectFit: "cover"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$4.borders
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$4.details
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$4.tag
  }, "Recommended Content"), /*#__PURE__*/React.createElement(LinesEllipsis, {
    className: styles$4.name,
    text: name,
    maxLine: 2,
    basedOn: "letters",
    ellipsis: '...'
  }), _$1.get(nextJourneyAsset, 'step.asset.type', null) === 'ASSET' && /*#__PURE__*/React.createElement(ContentMetadata, {
    className: styles$4.additionalData,
    content: _$1.get(nextJourneyAsset, 'step.asset', '')
  }), _$1.get(nextJourneyAsset, 'step.asset.type', null) !== 'ASSET' && /*#__PURE__*/React.createElement(ContentStoryboardMetaData, {
    className: styles$4.additionalData,
    content: _$1.get(nextJourneyAsset, 'step.asset', '')
  }))), /*#__PURE__*/React.createElement(Modal.Body, {
    className: cx(styles$4.assetViewerBody, isJourneyAsset && _$1.get(contentPage, "items", []).length < 2 ? styles$4.journeyViewerBody : _$1.get(contentPage, "items", []).length < 2 ? styles$4.singleAssetViwerBody : '')
  }, _$1.get(contentPage, "items", []).length > 1 && /*#__PURE__*/React.createElement(ContentList, {
    contents: contentPage.items,
    loading: contentPage.loading,
    fetchAssets: fetchAdditionalContent,
    selected: _$1.get(activeAsset, 'uid'),
    onSelection: handleAssetSelection
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$4.assetsContainer
  }, (assetMappings || []).filter(function (item) {
    return item.type === 'ASSET';
  }).map(function (asset, index) {
    var active = asset.uid == _$1.get(activeAsset, 'uid') && !gatingContext.gating;
    var preload = state.preloadedAssets.find(function (item) {
      return item === asset.uid;
    }) != null;
    return /*#__PURE__*/React.createElement(AssetView, {
      key: asset.uid,
      asset: asset,
      preload: active || preload,
      active: active,
      fullscreen: fullscreen,
      handleJourneyPath: handleJourneyPath,
      nextJourneyAsset: nextJourneyAsset,
      setNextJourneyAsset: setNextJourneyAsset,
      journeyTriggered: journeyTriggered,
      setJourneyTrigger: setJourneyTrigger,
      journeyPaused: journeyPaused,
      activeAsset: activeAsset,
      setShowRecommendSlide: setShowRecommendSlide,
      hasConditionRun: hasConditionRun,
      setHasConditionRun: setHasConditionRun,
      isJourneyEnd: isJourneyEnd,
      setIsJourneyEnd: setIsJourneyEnd,
      isPreview: isPreview,
      pageSessionState: pageSessionState,
      setPageSessionState: setPageSessionState,
      journeyConfig: journeyConfig,
      setJourneyConfig: setJourneyConfig,
      onLoad: handleAssetLoaded,
      onVisibilityChange: handleAssetVisibilityChange,
      toggleFullScreen: toggleFullScreen,
      onClose: handleClose
    });
  }))));
}
var ContentCard = function ContentCard(_ref2) {
  var _cx4, _cx5;
  var asset = _ref2.asset,
    selected = _ref2.selected,
    onClick = _ref2.onClick;
  var ref = React.useRef(null);
  var name = getContentForFieldSelector(asset, 'name') || "";
  var icon = getContentForFieldSelector(asset, 'icon');
  var iconUrl = _$1.get(icon, 'url') || '/public/cleverstory/v2/static/default_card.jpg';
  useEffect(function () {
    if (selected) {
      scrollIntoView();
    }
  }, [selected]);
  var handleClick = function handleClick(asset) {
    onClick(asset);
  };
  var scrollIntoView = function scrollIntoView() {
    if (!ref.current) {
      return;
    }
    var scrollContainer = ref.current.parentNode;
    var parentWidth = scrollContainer.clientWidth;
    var scrollLeft = scrollContainer.scrollLeft;
    var offset = ref.current.offsetLeft;
    var cardWidth = ref.current.clientWidth;
    if (offset <= scrollLeft) {
      scrollTo(scrollContainer, offset - 25, 500);
    }
    if (offset + cardWidth > scrollLeft + parentWidth) {
      scrollTo(scrollContainer, offset + cardWidth + 25 - parentWidth, 500);
    }
  };
  var scrollTo = function scrollTo(element, to, duration) {
    var start = element.scrollLeft,
      change = to - start,
      currentTime = 0,
      increment = 20;
    var _animateScroll = function animateScroll() {
      var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      };
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollLeft = val;
      if (currentTime < duration) {
        setTimeout(_animateScroll, increment);
      }
    };
    _animateScroll();
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    key: asset.uid,
    className: cx(styles$4.contentCard, (_cx4 = {}, _cx4[styles$4.selected] = selected, _cx4)),
    onClick: function onClick() {
      return handleClick(asset);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles$4.icon, (_cx5 = {}, _cx5[styles$4.selected] = selected, _cx5))
  }, /*#__PURE__*/React.createElement(IKImage, {
    path: iconUrl,
    width: 140,
    height: 160
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$4.borders
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$4.details
  }, /*#__PURE__*/React.createElement(LinesEllipsis, {
    className: styles$4.name,
    text: name,
    maxLine: 2,
    basedOn: "letters",
    ellipsis: '...'
  }), _$1.get(asset, 'type', null) === 'ASSET' && /*#__PURE__*/React.createElement(ContentMetadata, {
    className: styles$4.additionalData,
    content: asset
  }), _$1.get(asset, 'type', null) !== 'ASSET' && /*#__PURE__*/React.createElement(ContentStoryboardMetaData, {
    className: styles$4.additionalData,
    content: asset
  })));
};
var ContentCardPlaceholder = function ContentCardPlaceholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles$4.contentCard, styles$4.placeholder)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles$4.icon)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$4.details
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.name
  }, /*#__PURE__*/React.createElement("span", null, "\xA0"), /*#__PURE__*/React.createElement("span", null, "\xA0")), /*#__PURE__*/React.createElement("div", {
    className: cx(styles$4.assetMetadata)
  }, _$1.times(3).map(function (index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles$4.metadata
    }, /*#__PURE__*/React.createElement("span", null, "\xA0"));
  }))));
};
var ContentStoryboardMetaData = function ContentStoryboardMetaData(_ref3) {
  var content = _ref3.content,
    className = _ref3.className;
  var storyboardType = _$1.get(content, 'content.asset.storyboardType', null);
  var getStoryBoardType = function getStoryBoardType(storyboardType) {
    switch (storyboardType) {
      case 'INTERACTIVE_CONTENT':
        return 'INTERACTIVE CONTENT';
      case 'LANDING_PAGE':
        return 'LANDING PAGE';
      case 'RESOURCE_CENTER':
        return 'RESOURCE CENTER';
      default:
        return "";
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles$4.contentMetadata, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.metadata
  }, getStoryBoardType(storyboardType)));
};
var ContentMetadata = function ContentMetadata(_ref4) {
  var content = _ref4.content,
    className = _ref4.className;
  var type = getContentForFieldSelector(content, 'contentType');
  var meta = _$1.get(content, 'content.asset.metadata');
  var metaData = FileService.metaData(meta);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles$4.contentMetadata, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.metadata
  }, type), metaData && /*#__PURE__*/React.createElement("div", {
    className: styles$4.metadata
  }, metaData));
};
var ContentList = function ContentList(_ref5) {
  var _cx6, _cx7;
  var contents = _ref5.contents,
    selected = _ref5.selected,
    loading = _ref5.loading,
    fetchAssets = _ref5.fetchAssets,
    onSelection = _ref5.onSelection;
  var listRef = React.useRef(null);
  var horizontalContentList = React.useRef(null);
  var _useState12 = useState(false),
    canShowLeftArrow = _useState12[0],
    setCanShowLeftArrow = _useState12[1];
  var _useState13 = useState(false),
    canShowRightArrow = _useState13[0],
    setCanShowRightArrow = _useState13[1];
  var _useState14 = useState(0),
    scrolledPosition = _useState14[0],
    setScrolledPosition = _useState14[1];
  var _useState15 = useState(false),
    hovered = _useState15[0],
    setHovered = _useState15[1];
  var handleCardClick = function handleCardClick(content) {
    onSelection(content);
  };
  useEffect(function () {
    calculateShowLeftArrow();
    calculateShowRightArrow();
  }, [scrolledPosition, contents]);
  var handleScroll = _$1.debounce(function (element, direction) {
    var position = element.scrollLeft;
    if (direction === "left") {
      scrollTo(element, position - 250, 150);
    }
    if (direction === "right") {
      scrollTo(element, position + 250, 150);
    }
    setScrolledPosition(position);
  }, 150);
  var scrollTo = function scrollTo(element, to, duration) {
    var start = element.scrollLeft,
      change = to - start,
      currentTime = 0,
      increment = 20;
    var _animateScroll2 = function animateScroll() {
      var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      };
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollLeft = val;
      if (currentTime < duration) {
        setTimeout(_animateScroll2, increment);
      }
    };
    _animateScroll2();
  };
  useEffect(function () {
    var element = horizontalContentList.current;
    element.addEventListener("scroll", function () {
      return handleScroll(element);
    });
    handleScroll(element);
    return function () {
      element.removeEventListener("scroll", function () {
        return handleScroll(element);
      });
    };
  }, []);
  var calculateShowLeftArrow = function calculateShowLeftArrow() {
    if (scrolledPosition != 0) {
      setCanShowLeftArrow(true);
    } else {
      setCanShowLeftArrow(false);
    }
  };
  var calculateShowRightArrow = function calculateShowRightArrow() {
    var element = horizontalContentList.current;
    var scrollWidth = element === null || element === void 0 ? void 0 : element.scrollWidth;
    var clientWidth = element === null || element === void 0 ? void 0 : element.clientWidth;
    var offsetWidth = element === null || element === void 0 ? void 0 : element.offsetWidth;
    if (scrolledPosition > scrollWidth) {
      setCanShowRightArrow(false);
    }
    if (scrolledPosition === scrollWidth - clientWidth) {
      setCanShowRightArrow(false);
    }
    if (scrolledPosition !== scrollWidth - clientWidth) {
      setCanShowRightArrow(true);
    }
    if (scrollWidth - Math.round(scrolledPosition) === offsetWidth) {
      setCanShowRightArrow(false);
    }
  };
  var handleClick = function handleClick(direction) {
    var element = horizontalContentList.current;
    handleScroll(element, direction);
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: listRef,
    className: cx(styles$4.contentList),
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    }
  }, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return handleClick("left");
    },
    className: cx(styles$4.arrows, styles$4.leftArrow, (_cx6 = {}, _cx6[styles$4.showLeftArrow] = canShowLeftArrow && hovered, _cx6))
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-drop-down-left')
  })), /*#__PURE__*/React.createElement("div", {
    className: cx(styles$4.cardsContainer),
    ref: horizontalContentList
  }, /*#__PURE__*/React.createElement(InfiniteScroll, {
    direction: "horizontal",
    loading: loading,
    loadData: fetchAssets
  }, contents && contents.map(function (asset, index) {
    var assetSelected = _$1.get(asset, 'uid') === selected;
    return /*#__PURE__*/React.createElement(ContentCard, {
      key: asset.uid,
      asset: asset,
      selected: assetSelected,
      onClick: function onClick(content) {
        return handleCardClick(content);
      }
    });
  }), loading && _$1.times(3).map(function (index) {
    return /*#__PURE__*/React.createElement(ContentCardPlaceholder, {
      key: index
    });
  }))), /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return handleClick("right");
    },
    className: cx(styles$4.arrows, styles$4.rightArrow, (_cx7 = {}, _cx7[styles$4.showRightArrow] = canShowRightArrow && hovered, _cx7))
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-drop-down-right')
  })));
};
var AssetView = function AssetView(_ref6) {
  var _document, _cx8;
  var asset = _ref6.asset,
    preload = _ref6.preload,
    active = _ref6.active,
    fullscreen = _ref6.fullscreen,
    onLoad = _ref6.onLoad,
    onVisibilityChange = _ref6.onVisibilityChange,
    toggleFullScreen = _ref6.toggleFullScreen,
    onClose = _ref6.onClose,
    handleJourneyPath = _ref6.handleJourneyPath,
    nextJourneyAsset = _ref6.nextJourneyAsset,
    setNextJourneyAsset = _ref6.setNextJourneyAsset,
    journeyTriggered = _ref6.journeyTriggered,
    setJourneyTrigger = _ref6.setJourneyTrigger,
    journeyPaused = _ref6.journeyPaused,
    activeAsset = _ref6.activeAsset,
    setShowRecommendSlide = _ref6.setShowRecommendSlide,
    hasConditionRun = _ref6.hasConditionRun,
    setHasConditionRun = _ref6.setHasConditionRun,
    isJourneyEnd = _ref6.isJourneyEnd,
    setIsJourneyEnd = _ref6.setIsJourneyEnd,
    isPreview = _ref6.isPreview,
    pageSessionState = _ref6.pageSessionState,
    setPageSessionState = _ref6.setPageSessionState,
    journeyConfig = _ref6.journeyConfig,
    setJourneyConfig = _ref6.setJourneyConfig;
  var contentContext = React.useContext(Content.Context);
  var gatingContext = React.useContext(GatingContext);
  var widgetContext = React.useContext(WidgetsContext);
  var _React$useState3 = React.useState(preload),
    initialised = _React$useState3[0],
    setInitialised = _React$useState3[1];
  var _React$useState4 = React.useState(null),
    analytics = _React$useState4[0],
    setAnalytics = _React$useState4[1];
  var _React$useState5 = React.useState(null),
    nextAsset = _React$useState5[0],
    setNextAsset = _React$useState5[1];
  var _useState16 = useState(_$1.get(asset, 'content.gatingConfigurations', [])),
    gatingConfigurations = _useState16[0],
    setGatingConfigurations = _useState16[1];
  var _useState17 = useState(false),
    showDownload = _useState17[0],
    setShowDownload = _useState17[1];
  var _useState18 = useState(false),
    checkPageSession = _useState18[0],
    setCheckPageSession = _useState18[1];
  var journeyConfigurations = useSelector(function (state) {
    return _$1.get(state, "content.journey." + (asset === null || asset === void 0 ? void 0 : asset.uid) + ".item");
  });
  var isJourneyPaused = useSelector(function (state) {
    return _$1.get(state, "content.journey." + (activeAsset === null || activeAsset === void 0 ? void 0 : activeAsset.uid) + ".item");
  });
  var journeyFailed = useSelector(function (state) {
    return _$1.get(state, "content.journey." + (activeAsset === null || activeAsset === void 0 ? void 0 : activeAsset.uid) + ".error");
  });
  var activeSession = useSelector(function (state) {
    return _$1.get(state, "content.analytics." + (asset === null || asset === void 0 ? void 0 : asset.uid) + ".item.id");
  });
  var disableDownload = _$1.get(asset, 'content.disableDownload', false);
  var frameAssetViewer = (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById("iframeembed");
  var _useDelayedInView = useDelayedInView({
      rootMargin: '-50% 0% -50% 0%',
      root: document.querySelector("." + styles$4.assetViewerDialog),
      onChange: function onChange(visible) {
        onVisibilityChange(asset, visible);
      }
    }),
    activeAssetRef = _useDelayedInView[0];
  useEffect(function () {
    var updatedItems = gatingConfigurations.filter(function (_ref7) {
      var id = _ref7.id;
      return !gatingContext.assetConfigurations.includes(id);
    });
    setGatingConfigurations(updatedItems);
  }, [gatingContext.assetConfigurations]);
  useEffect(function () {
    if (!isJourneyEnd && !journeyConfigurations && !journeyTriggered && !isPreview) {
      if (checkPageSession && pageSessionState) {
        contentContext.fetchAssetJourney(asset, null, null, pageSessionState);
        setCheckPageSession(false);
      } else if (checkPageSession && frameAssetViewer && !journeyTriggered && !isPreview) {
        var pageSession = frameAssetViewer === null || frameAssetViewer === void 0 ? void 0 : frameAssetViewer.getAttribute('data-page-session');
        setPageSessionState(pageSession);
        contentContext.fetchAssetJourney(asset, null, null, pageSession);
        setCheckPageSession(false);
      }
    } else {
      setCheckPageSession(false);
    }
  }, [pageSessionState, frameAssetViewer]);
  useEffect(function () {
    setShowDownload(!disableDownload && gatingConfigurations.length === 0);
  }, []);
  useEffect(function () {
    if (gatingContext.disabled) {
      setShowDownload(true);
    }
  }, [gatingContext.disabled]);
  var _useDelayedInView2 = useDelayedInView({
      rootMargin: '-50% 0% -50% 0%',
      root: document.querySelector("." + styles$4.assetViewerContent),
      skip: initialised,
      onChange: function onChange(visible) {
        if (visible) {
          setInitialised(true);
        }
      }
    }),
    preloadAssetRef = _useDelayedInView2[0];
  var setRefs = React.useCallback(function (node) {
    activeAssetRef(node);
    preloadAssetRef(node);
  }, [activeAssetRef, preloadAssetRef]);
  useEffect(function () {
    if (preload) {
      setInitialised(true);
    }
  }, [preload]);
  useEffect(function () {
    if (activeAsset && isJourneyPaused && !isJourneyEnd) {
      var _isJourneyPaused$jour;
      var isPausedJourneyActive = activeAsset.uid === (journeyPaused === null || journeyPaused === void 0 ? void 0 : journeyPaused.assetId) && (isJourneyPaused === null || isJourneyPaused === void 0 ? void 0 : (_isJourneyPaused$jour = isJourneyPaused.journeyExecution) === null || _isJourneyPaused$jour === void 0 ? void 0 : _isJourneyPaused$jour.paused);
      if (isPausedJourneyActive && !hasConditionRun) {
        var recommendedAsset = journeyRecommendationAsset(analytics, isJourneyPaused, nextJourneyAsset, setNextJourneyAsset, hasConditionRun, setHasConditionRun, setJourneyTrigger, setShowRecommendSlide, setIsJourneyEnd);
        handleNextAsset(recommendedAsset);
      }
    }
  }, [activeAsset, isJourneyPaused]);
  var handleNextAsset = function handleNextAsset(assetData) {
    if (!isEqual(assetData === null || assetData === void 0 ? void 0 : assetData.asset, nextAsset)) {
      setNextAsset(assetData === null || assetData === void 0 ? void 0 : assetData.asset);
    }
  };
  useEffect(function () {
    if (analytics && !(journeyPaused !== null && journeyPaused !== void 0 && journeyPaused.paused) && !hasConditionRun && !isJourneyEnd && journeyConfigurations) {
      var assetConditon = (activeAsset === null || activeAsset === void 0 ? void 0 : activeAsset.uid) == (journeyConfig === null || journeyConfig === void 0 ? void 0 : journeyConfig.asset);
      var journeyCondition = (journeyConfigurations === null || journeyConfigurations === void 0 ? void 0 : journeyConfigurations.id) == (journeyConfig === null || journeyConfig === void 0 ? void 0 : journeyConfig.journey);
      var nullCondition = (journeyConfig === null || journeyConfig === void 0 ? void 0 : journeyConfig.journey) == null && (journeyConfig === null || journeyConfig === void 0 ? void 0 : journeyConfig.asset) == null;
      if (nullCondition || !assetConditon && !journeyCondition) {
        setJourneyConfig({
          asset: activeAsset === null || activeAsset === void 0 ? void 0 : activeAsset.uid,
          journey: journeyConfigurations === null || journeyConfigurations === void 0 ? void 0 : journeyConfigurations.id
        });
      }
      if (nullCondition || assetConditon && journeyCondition) {
        var recommendedAsset = journeyRecommendationAsset(analytics, journeyConfigurations, nextJourneyAsset, setNextJourneyAsset, hasConditionRun, setHasConditionRun, setJourneyTrigger, setShowRecommendSlide, setIsJourneyEnd);
        handleNextAsset(recommendedAsset);
      }
    }
  }, [analytics, journeyConfigurations, journeyPaused]);
  useEffect(function () {
    if (nextAsset) {
      handleJourneyPath(nextAsset);
    }
  }, [nextAsset]);
  useEffect(function () {
    if (journeyFailed) {
      setJourneyTrigger(true);
    }
  }, [journeyFailed]);
  var handleViewerLoaded = function handleViewerLoaded() {
    if (!onLoad) return;
    onLoad(asset.uid);
  };
  var handleDownload = function handleDownload(asset) {
    if (disableDownload) {
      return;
    }
    var downloadUrl = _$1.get(asset, 'content.asset.downloadUrl');
    window.open(downloadUrl, "_blank");
    contentContext.onDownload(asset);
  };
  useEffect(function () {
    if (gatingContext.configuration) {
      return;
    }
    if (analytics) {
      triggerAssetGating(analytics);
    }
  }, [analytics]);
  useEffect(function () {
    if (analytics && (analytics === null || analytics === void 0 ? void 0 : analytics.duration) == 0 && (analytics === null || analytics === void 0 ? void 0 : analytics.percentageRead) == 0) {
      var _document2;
      var _frameAssetViewer = (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.getElementById("iframeembed");
      if (!isJourneyEnd && !journeyConfigurations && !isPreview) {
        if ((nextJourneyAsset === null || nextJourneyAsset === void 0 ? void 0 : nextJourneyAsset.step) != null) {
          var _nextJourneyAsset$ste7 = nextJourneyAsset === null || nextJourneyAsset === void 0 ? void 0 : nextJourneyAsset.step,
            stepId = _nextJourneyAsset$ste7.id;
          var _nextJourneyAsset$jou = nextJourneyAsset === null || nextJourneyAsset === void 0 ? void 0 : nextJourneyAsset.journeyExecution,
            journeyExecutionId = _nextJourneyAsset$jou.id;
          contentContext.fetchAssetJourney(asset, stepId, journeyExecutionId, pageSessionState);
        } else if (!journeyTriggered && !isPreview) {
          if (pageSessionState != null) {
            contentContext.fetchAssetJourney(asset, null, null, pageSessionState);
          } else if (_frameAssetViewer) {
            var pageSession = _frameAssetViewer === null || _frameAssetViewer === void 0 ? void 0 : _frameAssetViewer.getAttribute('data-page-session');
            setPageSessionState(pageSession);
            contentContext.fetchAssetJourney(asset, null, null, pageSession);
          } else {
            setCheckPageSession(true);
          }
        }
      }
      if (onLoad) {
        onLoad(asset.uid, journeyConfigurations);
      }
    }
  }, [analytics]);
  var triggerAssetGating = function triggerAssetGating(_ref8) {
    var duration = _ref8.duration,
      percentageRead = _ref8.percentageRead;
    if (gatingContext.preview) {
      return;
    }
    gatingConfigurations.every(function (item) {
      if (!item.enabled) {
        return true;
      }
      var triggerValue = _$1.get(item, 'trigger.value', 0);
      var limit = duration;
      if (_$1.get(item, 'trigger.type', '') === "PERCENTAGE") {
        limit = percentageRead;
      }
      if (triggerValue <= limit) {
        var gating = _$1.get(item, 'gating.id', null);
        if (gating) {
          widgetContext.fetchGating(gating);
          gatingContext.triggerGating(_$1.get(item, 'trigger.type', ''), null, _extends({}, item, {
            target: _extends({}, item.target, {
              assetModal: true
            })
          }));
          return false;
        }
      }
      return true;
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: setRefs,
    className: styles$4.asset,
    "data-asset": asset.uid
  }, /*#__PURE__*/React.createElement(AssetHeader, {
    asset: asset,
    analytics: analytics,
    fullscreen: fullscreen,
    toggleFullScreen: toggleFullScreen,
    canDownload: showDownload,
    onDownload: handleDownload,
    onClose: onClose,
    debug: contentContext.debug
  }), /*#__PURE__*/React.createElement("div", {
    className: cx(styles$4.body, (_cx8 = {}, _cx8[styles$4.initialised] = initialised, _cx8))
  }, initialised && /*#__PURE__*/React.createElement(AssetContentViewer, {
    asset: asset,
    active: active,
    onLoad: handleViewerLoaded,
    onAnalyticsChange: function onAnalyticsChange(analytics) {
      if (activeSession || active) {
        setAnalytics(analytics);
        contentContext.onAnalyticsChange(asset, analytics);
      }
    },
    onDebugAnalytics: function onDebugAnalytics(analytics) {
      if (contentContext.debug) {
        setAnalytics(analytics);
      }
    }
  })));
};
var AssetHeader = function AssetHeader(_ref9) {
  var asset = _ref9.asset,
    analytics = _ref9.analytics,
    fullscreen = _ref9.fullscreen,
    toggleFullScreen = _ref9.toggleFullScreen,
    canDownload = _ref9.canDownload,
    onDownload = _ref9.onDownload,
    onClose = _ref9.onClose,
    debug = _ref9.debug;
  var name = getContentForFieldSelector(asset, 'name');
  var downloadUrl = _$1.get(asset, 'content.asset.downloadUrl');
  var content_type = _$1.get(asset, 'content.asset.metadata.content_type');
  var _useState19 = useState(false),
    showDropdown = _useState19[0],
    setShowDropdown = _useState19[1];
  var removeQueryParamsFromURL = function removeQueryParamsFromURL(url) {
    var newUrl = new URL(url);
    return "" + newUrl.origin + newUrl.pathname;
  };
  var assetAlias = "" + _$1.get(asset, 'content.domain', '') + _$1.get(asset, 'url', '');
  var isLayout = _$1.includes(_$1.get(asset, 'uid'), 'layout');
  var assetUrl = isLayout ? assetAlias : removeQueryParamsFromURL(window.location.href);
  var copyAssetUrl = function copyAssetUrl(url) {
    var input = document.createElement('input');
    input.value = url;
    input.style.position = 'fixed';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
  };
  var handleSocialShare = function handleSocialShare(type) {
    var utmLink = assetUrl + "?" + new Date().getTime();
    utmLink = encodeURI(utmLink);
    var winTop = (screen.height - 500) / 2;
    var winLeft = (screen.width - 575) / 1.75;
    var url = '';
    switch (type) {
      case 'facebook':
        url = "https://www.facebook.com/sharer.php?u=" + utmLink + "&title=" + name;
        break;
      case 'linkedIn':
        url = "https://www.linkedin.com/shareArticle?mini=true&url=" + utmLink + "&title=" + name;
        break;
      case 'twitter':
        url = "https://twitter.com/share?url=" + utmLink + "&title=" + name;
        break;
    }
    window.open(url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + 500 + ',height=' + 575);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles$4.header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.details
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.name
  }, name), /*#__PURE__*/React.createElement(ContentMetadata, {
    content: asset
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$4.actions
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.column1
  }, debug && /*#__PURE__*/React.createElement(Button, {
    className: cx(styles$4.action, styles$4.debug)
  }, /*#__PURE__*/React.createElement(AnalyticsDebug, {
    asset: asset.content.asset,
    analytics: analytics
  })), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
    className: cx(styles$4.action, styles$4.shareDropdown),
    show: showDropdown,
    onToggle: function onToggle() {
      return setShowDropdown(!showDropdown);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowDropdown(false);
    }
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-custom-components"
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-share')
  }), /*#__PURE__*/React.createElement("span", null, "Share"), /*#__PURE__*/React.createElement("i", {
    className: cx(styles$4.arrow, 'cleverstory-drop-down')
  })), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      return copyAssetUrl(assetUrl);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-link')
  }), " Copy Link"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      return handleSocialShare('facebook');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-facebook')
  }), "Facebook"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      return handleSocialShare('linkedIn');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-linkedin')
  }), "LinkedIn"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      return handleSocialShare('twitter');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-twitter')
  }), "Twitter"))), downloadUrl && canDownload && content_type != "application/url" && /*#__PURE__*/React.createElement(Button, {
    className: cx(styles$4.action, styles$4.download),
    onClick: function onClick() {
      onDownload(asset);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-download')
  }), /*#__PURE__*/React.createElement("span", null, "Download")))), /*#__PURE__*/React.createElement("div", {
    className: styles$4.column2
  }, /*#__PURE__*/React.createElement(Button, {
    className: cx(styles$4.action, styles$4.fullscreen),
    onClick: toggleFullScreen
  }, /*#__PURE__*/React.createElement("i", {
    className: "cleverstory-" + (fullscreen ? 'minimize-editor' : 'expand-editor')
  })), /*#__PURE__*/React.createElement(Button, {
    className: cx(styles$4.action, styles$4.close),
    onClick: onClose
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-close')
  })))));
};

var ContentContext = React.createContext({
  debug: false,
  fetchMappingsForContentGrid: function fetchMappingsForContentGrid(contentGrid, page, limit) {},
  fetchPreviewDataForAsset: function fetchPreviewDataForAsset(asset) {},
  updateFiltersInContenGrid: function updateFiltersInContenGrid(contentGrid, filters) {},
  updateQueryInContenGrid: function updateQueryInContenGrid(contentGrid, query) {},
  resetFiltersInContenGrid: function resetFiltersInContenGrid(contentGrid) {},
  viewContent: function viewContent(widget, content) {},
  onContentChange: function onContentChange(contentGrid, content) {},
  onDownload: function onDownload(asset) {}
});
var ContentManager = function ContentManager(_ref) {
  var initialAsset = _ref.initialAsset,
    page = _ref.page,
    closeAssetViewer = _ref.closeAssetViewer,
    children = _ref.children,
    fetchMappingsForContentGrid = _ref.fetchMappingsForContentGrid,
    fetchPreviewDataForAsset = _ref.fetchPreviewDataForAsset,
    updateFiltersInContenGrid = _ref.updateFiltersInContenGrid,
    updateQueryInContenGrid = _ref.updateQueryInContenGrid,
    resetFiltersInContenGrid = _ref.resetFiltersInContenGrid,
    onContentChange = _ref.onContentChange,
    onAnalyticsChange = _ref.onAnalyticsChange,
    fetchAssetJourney = _ref.fetchAssetJourney,
    updateAssetJourneyExecution = _ref.updateAssetJourneyExecution,
    onDownload = _ref.onDownload,
    onClose = _ref.onClose,
    debug = _ref.debug;
  var _useState = useState(null),
    assetViewer = _useState[0],
    setAssetViewer = _useState[1];
  var embedContext = React.useContext(EmbedContext);
  useEffect(function () {
    setAssetViewer(initialAsset);
  }, []);
  useEffect(function () {
    if (closeAssetViewer) {
      handleCloseViewer();
    }
  }, [closeAssetViewer]);
  useEffect(function () {
    var _document$body, _document$body2;
    if (assetViewer) (_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.setAttribute("assetViewer", "true");else (_document$body2 = document.body) === null || _document$body2 === void 0 ? void 0 : _document$body2.removeAttribute("assetViewer");
  }, [assetViewer]);
  var pageSession = useSelector(function (state) {
    return _$1.get(state, "pages.analytics[" + page + "].id", null);
  });
  var handleViewContent = function handleViewContent(widget, content) {
    if (!content) {
      return;
    }
    if (embedContext.embedded) {
      if (!content.url) {
        return;
      }
      var currentWindow = window.self || window;
      var pageUrl = "" + _$1.get(content, 'content.domain', '') + _$1.get(content, 'url', '') + "?page=" + page + "&contentGrid=" + widget;
      var isInIframe = currentWindow.parent !== window;
      if (isInIframe) {
        var parentWindow = window.parent;
        parentWindow.postMessage({
          type: "cleverstory:embed:assetViewer",
          payload: {
            pageUrl: pageUrl,
            pageSession: pageSession
          }
        }, '*');
      }
      return;
    }
    switch (content.type) {
      case 'INTERACTIVE_CONTENT':
      case 'LANDING_PAGE':
      case 'RESOURCE_CENTER':
        {
          if (!content.url) {
            return;
          }
          var _pageUrl = "" + _$1.get(content, 'content.domain', '') + _$1.get(content, 'url', '');
          window.open(_pageUrl);
          break;
        }
      case 'ASSET':
        {
          setAssetViewer({
            asset: content,
            contentGrid: widget,
            redirect: true
          });
          break;
        }
    }
  };
  var handleCloseViewer = function handleCloseViewer() {
    setAssetViewer(null);
    var isInIframe = window.parent !== window;
    if (isInIframe) {
      var parentWindow = window.parent;
      parentWindow.postMessage({
        type: "cleverstory:close:assetViewer"
      }, '*');
    }
    if (onClose) {
      onClose();
    }
  };
  var contentContextValue = React.useMemo(function () {
    return {
      debug: debug,
      page: page,
      initialAsset: initialAsset,
      fetchMappingsForContentGrid: fetchMappingsForContentGrid,
      fetchPreviewDataForAsset: fetchPreviewDataForAsset,
      updateFiltersInContenGrid: updateFiltersInContenGrid,
      updateQueryInContenGrid: updateQueryInContenGrid,
      resetFiltersInContenGrid: resetFiltersInContenGrid,
      viewContent: handleViewContent,
      onContentChange: onContentChange,
      onAnalyticsChange: onAnalyticsChange,
      fetchAssetJourney: fetchAssetJourney,
      updateAssetJourneyExecution: updateAssetJourneyExecution,
      onDownload: onDownload
    };
  }, [debug, handleViewContent]);
  return /*#__PURE__*/React.createElement(ContentContext.Provider, {
    value: contentContextValue
  }, children, assetViewer && /*#__PURE__*/React.createElement(AssetViewer, {
    contentGrid: assetViewer.contentGrid,
    redirect: assetViewer.redirect,
    show: true,
    initialContent: _$1.get(assetViewer, 'asset'),
    debug: debug,
    onClose: handleCloseViewer
  }));
};
var Content = {
  Manager: ContentManager,
  Context: ContentContext
};

var Actions = React.createContext({
  onBeforeExecution: function onBeforeExecution(widget, action) {},
  onAfterExecution: function onAfterExecution(widget, action) {}
});
function useActionExectioner() {
  var context = React.useContext(Actions);
  var interactiveContext = React.useContext(CarouselNavigationContext);
  var widgetContext = React.useContext(WidgetsContext);
  var contentContext = React.useContext(Content.Context);
  var gatingContext = React.useContext(GatingContext);
  var _useState = useState({
      execute: function execute(widget, action) {}
    }),
    state = _useState[0],
    setState = _useState[1];
  useEffect(function () {
    setState({
      execute: handleExecution
    });
  }, [interactiveContext, widgetContext]);
  var handleBeforeExecution = function handleBeforeExecution(widget, action) {
    if (context.onBeforeExecution) {
      context.onBeforeExecution(widget, action);
    }
  };
  var handleAfterExecution = function handleAfterExecution(widget, action) {
    if (context.onAfterExecution) {
      context.onAfterExecution(widget, action);
    }
  };
  var handleExecution = function handleExecution(widget, action) {
    if (!action) {
      return false;
    }
    handleBeforeExecution(widget, action);
    var type = action.type;
    switch (type) {
      case 'link':
        {
          return handleLinkAction(widget, action);
        }
      case 'pageAnchor':
        {
          return handlePageAnchorAction(interactiveContext, widget, action, widgetContext);
        }
      case 'widgetAnchor':
        {
          return handleWidgetAnchorAction(interactiveContext, action, widgetContext);
        }
      case 'asset':
        {
          return handleAssetAction(widget, action, contentContext);
        }
      case 'page':
        {
          return handlePageAction(widget, action, widgetContext);
        }
      case 'gating':
        {
          return handleGatingAction(gatingContext, action, widgetContext);
        }
    }
    handleAfterExecution(widget, action);
    return false;
  };
  return state;
}
var handleLinkAction = function handleLinkAction(widget, action) {
  if (!action) {
    return false;
  }
  var newTab = action.newTab,
    value = action.value;
  var currentWindow = window.self || window;
  if (newTab) {
    currentWindow.open(value);
  } else {
    currentWindow.location = value;
  }
};
var handlePageAnchorAction = function handlePageAnchorAction(interactiveContext, widget, action, widgetContext) {
  if (!action || !interactiveContext) {
    return false;
  }
  var value = action.value;
  var storyboardType = _$1.get(widgetContext, 'storyboard.type', '');
  if (storyboardType === 'INTERACTIVE_CONTENT') {
    if (value || !_$1.has(action, 'value')) {
      interactiveContext.scrollToTop();
    } else {
      interactiveContext.scrollToBottom();
    }
  }
  if (storyboardType != 'INTERACTIVE_CONTENT') {
    if (value || !_$1.has(action, 'value')) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }
};
var handleWidgetAnchorAction = function handleWidgetAnchorAction(interactiveContext, action, widgetContext) {
  if (!action) {
    return false;
  }
  var storyboardType = _$1.get(widgetContext, 'storyboard.type', '');
  if (storyboardType === 'INTERACTIVE_CONTENT') {
    interactiveContext.scrollToWidget(action);
  } else {
    var value = action.value;
    var widgetElement = document.getElementById(value);
    widgetElement.scrollIntoView();
  }
};
var handlePageAction = function handlePageAction(widget, action, widgetContext) {
  if (!action) {
    return false;
  }
  var newTab = action.newTab;
  var domain = _$1.get(widgetContext, 'domain', null);
  var alias = _$1.get(action, 'value.canonical', null);
  var value = domain + alias;
  var currentWindow = window.self || window;
  if (newTab) {
    currentWindow.open(value);
  } else {
    currentWindow.location = value;
  }
};
var handleAssetAction = function handleAssetAction(widget, action, contentContext) {
  if (!action) {
    return false;
  }
  contentContext.viewContent(widget, action.value);
};
var handleGatingAction = function handleGatingAction(gatingContext, action, widgetContext) {
  if (!action) {
    return false;
  }
  var value = action.value;
  if (value.gating != null) {
    var gatingConfig = {
      optional: value.optional,
      target: null,
      enabled: true,
      entityType: "gating_configuration",
      gating: {
        id: value.gating
      },
      trigger: {
        type: 'BUTTON_GATING',
        value: null
      },
      name: "Button Gating"
    };
    widgetContext.fetchGating(value.gating);
    gatingContext.triggerGating('BUTTON_GATING', null, gatingConfig);
  }
};

function useWidgetSelector(id) {
  var context = React.useContext(WidgetsContext);
  var selector = context.selector;
  var widgets = useSelector(function (state) {
    return _$1.get(state, selector + ".widgets") || [];
  });
  return widgets.find(function (item) {
    return item.uid === id;
  });
}
function useWidgetChildrenSelector(parent) {
  var context = React.useContext(WidgetsContext);
  var selector = context.selector;
  var widgets = useSelector(function (state) {
    return _$1.get(state, selector + ".widgets") || [];
  });
  return widgets.filter(function (item) {
    return item.parent === parent;
  }).filter(function (item) {
    return _$1.get(item, "properties." + context.breakpoint + ".visible", true);
  }).sort(function (w1, w2) {
    var o1 = _$1.get(w1, 'order') || 1;
    var o2 = _$1.get(w2, 'order') || 1;
    return o1 - o2;
  });
}
function useWidgetSelectorForType(type) {
  var context = React.useContext(WidgetsContext);
  var selector = context.selector;
  var widgets = useSelector(function (state) {
    return _$1.get(state, selector + ".widgets") || [];
  });
  return widgets.filter(function (item) {
    return item.type === type && _$1.get(item, "properties." + context.breakpoint + ".visible");
  });
}
function getHotspotWidget(id) {
  var widgetContext = React.useContext(WidgetsContext);
  var selector = widgetContext.selector;
  var widgets = useSelector(function (state) {
    return _$1.get(state, selector + ".widgets") || [];
  });
  var hotspotWidget = widgets.find(function (item) {
    return item.parent === id && item.type === HOTSPOT && _$1.get(item, "properties." + (widgetContext === null || widgetContext === void 0 ? void 0 : widgetContext.breakpoint) + ".visible");
  });
  if (hotspotWidget) {
    return true;
  }
  return false;
}
function useParentWidgetSelectorForType(widget, widgetType) {
  var context = React.useContext(WidgetsContext);
  var selector = context.selector;
  var widgets = useSelector(function (state) {
    return _$1.get(state, selector + ".widgets") || [];
  });
  var _findParent2 = function _findParent(widgets, widget) {
    var item = findWidget(widgets, widget);
    if (!item) {
      return null;
    }
    var type = _$1.get(item, 'type');
    if (type === widgetType) {
      return item;
    }
    if (item && item.parent) {
      return _findParent2(widgets, item.parent);
    }
  };
  return _findParent2(widgets, widget);
}
function useContainerSelector(widget) {
  var context = React.useContext(WidgetsContext);
  var selector = context.selector;
  var widgets = useSelector(function (state) {
    return _$1.get(state, selector + ".widgets") || [];
  });
  var item = widgets.find(function (item) {
    return item.uid === widget;
  });
  if (item && item.parent) {
    return widgets.find(function (element) {
      return element.uid === item.parent;
    });
  }
  return null;
}
function useFormInputs(form) {
  var context = React.useContext(WidgetsContext);
  var selector = context.selector;
  var widgets = useSelector(function (state) {
    return _$1.get(state, selector + ".widgets") || [];
  });
  var formSteps = widgets.filter(function (item) {
    return item.type === FORM_STEP && item.parent === form;
  });
  formSteps = _$1.orderBy(formSteps, ['order'], ['asc']);
  var formStep = formSteps[0];
  var formFieldTypes = [FORM_FIELD, FORM_NUMBER, FORM_TEXTAREA, FORM_DROPDOWN_LIST, FORM_CHECK_LIST, FORM_CHECK_BOX];
  var inputWidgets = widgets.filter(function (item) {
    return _$1.includes(formFieldTypes, item.type) && item.parent === formStep.uid;
  });
  return inputWidgets;
}
function useOtpFormInput(form) {
  var context = React.useContext(WidgetsContext);
  var selector = context.selector;
  var widgets = useSelector(function (state) {
    return _$1.get(state, selector + ".widgets") || [];
  });
  var formOtpStep = widgets.filter(function (item) {
    return item.type === FORM_STEP && item.parent === form && item.name == "OTP";
  });
  var formFieldTypes = [OTP_INPUT];
  var otpInputWidget = widgets.filter(function (item) {
    var _formOtpStep$;
    return _$1.includes(formFieldTypes, item.type) && item.parent === ((_formOtpStep$ = formOtpStep[0]) === null || _formOtpStep$ === void 0 ? void 0 : _formOtpStep$.uid);
  });
  return otpInputWidget;
}
function findWidget(widgets, widget) {
  return widgets.find(function (item) {
    return item.uid === widget;
  });
}
function useLiveElementSelector(widget) {
  var context = React.useContext(WidgetsContext);
  var selector = context.selector;
  var widgets = useSelector(function (state) {
    return _$1.get(state, selector + ".widgets") || [];
  });
  var _findParent4 = function _findParent(widgets, widget) {
    var item = findWidget(widgets, widget);
    if (!item) {
      return false;
    }
    var type = _$1.get(item, 'type');
    if (type === LIVE_ELEMENT_CONTAINER) {
      return true;
    }
    if (item && item.parent) {
      return _findParent4(widgets, item.parent);
    }
  };
  return _findParent4(widgets, widget);
}
function useFormSuccessSelector(selector) {
  var widgets = useSelector(function (state) {
    return _$1.get(state, selector + ".widgets") || [];
  });
  var formWidgets = widgets.filter(function (item) {
    return item.type === FORM || item.type === EXTERNAL_FORM;
  });
  var formSuccess = formWidgets.some(function (item) {
    return item.success;
  });
  return formSuccess;
}
function useOtpFormSuccessSelector(selector) {
  var widgets = useSelector(function (state) {
    return _$1.get(state, selector + ".widgets") || [];
  });
  var formWidgets = widgets.filter(function (item) {
    return item.type === FORM;
  });
  var formOtpSuccess = formWidgets.some(function (item) {
    return item.otpSuccess;
  });
  return formOtpSuccess;
}
function useOtpRequiredSelector(selector) {
  var widgets = useSelector(function (state) {
    return _$1.get(state, selector + ".widgets") || [];
  });
  var formWidgets = widgets.filter(function (item) {
    return item.type === FORM;
  });
  var otpRequired = formWidgets.some(function (item) {
    return _$1.get(item, "properties.desktop.emailOtp", false);
  });
  return otpRequired;
}
function usePageDuration(alias) {
  var pages = useSelector(function (state) {
    return _$1.get(state, "pages.analytics." + alias + ".pages", []);
  });
  var duration = _$1.reduce(pages, function (sum, page) {
    return sum + page.duration;
  }, 0);
  return duration;
}
function useOnScreen(ref) {
  var _React$useState = React.useState(false),
    isOnScreen = _React$useState[0],
    setIsOnScreen = _React$useState[1];
  var observerRef = React.useRef(null);
  React.useEffect(function () {
    observerRef.current = new IntersectionObserver(function (_ref) {
      var entry = _ref[0];
      return setIsOnScreen(entry.isIntersecting);
    });
  }, []);
  React.useEffect(function () {
    if (ref.current) {
      observerRef.current.observe(ref.current);
    }
    return function () {
      observerRef.current.disconnect();
    };
  }, [ref]);
  return isOnScreen;
}

var Portal = function Portal(props) {
  var children = props.children,
    mountNode = props.mountNode;
  var _useState = useState(null),
    myDocument = _useState[0],
    setMyDocument = _useState[1];
  useEffect(function () {
    if (mountNode) {
      setMyDocument(mountNode);
      return;
    }
    setMyDocument(document.body);
  }, []);
  if (!myDocument) {
    return null;
  }
  return ReactDOM.createPortal(children, myDocument);
};

var HotspotContext = React.createContext({
  active: null,
  onMouseOver: function onMouseOver() {},
  onMouseOut: function onMouseOut() {},
  onClick: function onClick() {}
});
var HotspotRender = function HotspotRender(_ref) {
  var breakpoint = _ref.breakpoint,
    children = _ref.children;
  var _useState = useState({
      active: null,
      parent: null
    }),
    state = _useState[0],
    setState = _useState[1];
  var stateRef = useRef(state);
  var context = React.useContext(WidgetsContext);
  var hotspotWidgets = useWidgetSelectorForType(HOTSPOT);
  useEffect(function () {
    if (!context.development) {
      window.addEventListener("click", hideHotspotForClick);
      return function () {
        window.removeEventListener("click", hideHotspotForClick);
      };
    }
  }, []);
  useEffect(function () {
    stateRef.current = state;
  }, [state]);
  var handleMouseOver = function handleMouseOver(e, target, hotspot) {
    var hotspotId = _$1.get(hotspot, 'uid', null);
    if (!hotspotId) {
      return;
    }
    var hotspotElement = document.getElementById(hotspotId);
    var targetElement = document.getElementById(target.uid);
    hotspotElement === null || hotspotElement === void 0 ? void 0 : hotspotElement.setAttribute("data-hover-on", true);
    targetElement === null || targetElement === void 0 ? void 0 : targetElement.setAttribute("data-hover-on", true);
    setState(function (state) {
      return _extends({}, state, {
        active: hotspotId,
        parent: target.uid
      });
    });
  };
  var handleMouseOut = function handleMouseOut(e, target, hotspot) {
    var hotspotId = _$1.get(hotspot, 'uid', null);
    var targetId = _$1.get(target, 'uid', null);
    if (!hotspotId) {
      return;
    }
    var hotspotElement = document.getElementById(hotspotId);
    var targetElement = document.getElementById(targetId);
    hotspotElement === null || hotspotElement === void 0 ? void 0 : hotspotElement.removeAttribute("data-hover-on");
    targetElement === null || targetElement === void 0 ? void 0 : targetElement.removeAttribute("data-hover-on");
    hideHotpsotForHover();
  };
  var handleClick = function handleClick(e, target, hotspot) {
    var hotspotId = _$1.get(hotspot, 'uid', null);
    var targetId = _$1.get(target, 'uid', null);
    var hotspotElement = document.getElementById(hotspotId);
    var targetElement = document.getElementById(targetId);
    hotspotElement === null || hotspotElement === void 0 ? void 0 : hotspotElement.setAttribute("data-hover-on", true);
    targetElement === null || targetElement === void 0 ? void 0 : targetElement.setAttribute("data-hover-on", true);
    setState(function (state) {
      return _extends({}, state, {
        active: hotspotId,
        parent: target.uid
      });
    });
  };
  var hideHotpsotForHover = _$1.debounce(function () {
    var visibleHotposts = document.querySelector('[data-hover-on="true"]');
    if (!visibleHotposts || visibleHotposts.length === 0) {
      hideHotspot();
    }
  }, 500);
  var hideHotspotForClick = function hideHotspotForClick(event) {
    if (!stateRef.current.active) {
      return;
    }
    var hotspotElement = document.getElementById(stateRef.current.active);
    var targetElement = document.getElementById(stateRef.current.parent);
    if (hotspotElement && !hotspotElement.contains(event.target) && targetElement && !targetElement.contains(event.target)) {
      hotspotElement === null || hotspotElement === void 0 ? void 0 : hotspotElement.removeAttribute("data-hover-on");
      targetElement === null || targetElement === void 0 ? void 0 : targetElement.removeAttribute("data-hover-on");
      hideHotspot();
    }
  };
  var hideHotspot = function hideHotspot() {
    setState(function (state) {
      return _extends({}, state, {
        active: null,
        parent: null
      });
    });
  };
  var hotspotContextValue = React.useMemo(function () {
    return {
      active: state.active,
      onMouseOver: handleMouseOver,
      onMouseOut: handleMouseOut,
      onClick: handleClick
    };
  }, [state.active]);
  return /*#__PURE__*/React.createElement(HotspotContext.Provider, {
    value: hotspotContextValue
  }, children, (hotspotWidgets || []).map(function (item, index) {
    return /*#__PURE__*/React.createElement(Widget, {
      key: index,
      widgetProps: item,
      breakpoint: breakpoint
    });
  }));
};
var HotspotTriggerComponent = function HotspotTriggerComponent(_ref2) {
  var widget = _ref2.widget,
    breakpoint = _ref2.breakpoint,
    targetRef = _ref2.targetRef,
    children = _ref2.children;
  var hotspotContext = React.useContext(HotspotContext);
  var widgetContext = React.useContext(WidgetsContext);
  var selector = widgetContext.selector;
  var widgets = useSelector(function (state) {
    return _$1.get(state, selector + ".widgets") || [];
  });
  var hotspotWidget = widgets.find(function (item) {
    return item.parent === widget.uid && item.type === HOTSPOT;
  });
  var trigger = _$1.get(hotspotWidget, "properties." + breakpoint + ".trigger");
  useEffect(function () {
    if (hotspotWidget && trigger === 'hover') {
      targetRef.current.addEventListener('mouseover', handleMouseOver);
      targetRef.current.addEventListener('mouseout', handleMouseOut);
    }
    if (hotspotWidget && trigger === 'click') {
      targetRef.current.addEventListener('click', handleClick);
    }
    return function () {
      if (targetRef.current) {
        targetRef.current.removeEventListener('mouseover', handleMouseOver);
        targetRef.current.removeEventListener('mouseout', handleMouseOut);
      }
    };
  }, []);
  var handleMouseOver = function handleMouseOver(e) {
    hotspotContext.onMouseOver(e, widget, hotspotWidget);
  };
  var handleMouseOut = function handleMouseOut(e) {
    hotspotContext.onMouseOut(e, widget, hotspotWidget);
  };
  var handleClick = function handleClick(e) {
    hotspotContext.onClick(e, widget, hotspotWidget);
  };
  return children;
};
var hotspotTriggerEquals = function hotspotTriggerEquals(prevProps, nextProps) {
  var paths = ['widget', 'breakpoint', 'targetRef', 'children'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var HotspotTrigger = React.memo(HotspotTriggerComponent, hotspotTriggerEquals);

function getBoxShadow(value) {
  if (!value) {
    return null;
  }
  var styles = {};
  var shadowColor = colorToString(_$1.get(value, 'color', {
    r: 255,
    g: 255,
    b: 255,
    a: 1
  }));
  var xValue = _$1.get(value, 'axes.x', 0);
  var yValue = _$1.get(value, 'axes.y', 0);
  var bValue = _$1.get(value, 'axes.b', 0);
  var showShadow = _$1.get(value, 'show', false);
  if (!showShadow) {
    return null;
  }
  var boxShadow = xValue + "px " + yValue + "px " + bValue + "px " + shadowColor;
  styles['boxShadow'] = boxShadow;
  return styles;
}
function getDropShadow(value) {
  if (!value) {
    return null;
  }
  var shadowColor = colorToString(_$1.get(value, 'color', {
    r: 255,
    g: 255,
    b: 255,
    a: 1
  }));
  var xValue = _$1.get(value, 'axes.x', 0);
  var yValue = _$1.get(value, 'axes.y', 0);
  var bValue = _$1.get(value, 'axes.b', 0);
  var showShadow = _$1.get(value, 'show', false);
  if (!showShadow) {
    return null;
  }
  var shadow = {
    "filter": "drop-shadow(" + xValue + "px " + yValue + "px " + bValue + "px " + shadowColor + ")",
    "WebkitFilter": "drop-shadow(" + xValue + "px " + yValue + "px " + bValue + "px " + shadowColor + ")"
  };
  var isSafari = typeof window !== 'undefined' ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : false;
  if (isSafari) {
    shadow = _extends({}, shadow, {
      "willChange": "filter"
    });
  }
  return shadow;
}

var styles$5 = {"button":"_13_Cv","inner":"_3IYfZ"};

var ButtonWidgetComponent = function ButtonWidgetComponent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    onClick = _ref.onClick;
  var actionExcutioner = useActionExectioner();
  var ref = React.useRef();
  var id = _$1.get(widgetProps, 'uid');
  var content = _$1.get(widgetProps, 'content');
  var action = _$1.get(widgetProps, 'actions.0');
  var animation = _$1.get(widgetProps, "properties." + breakpoint + ".animation") || {};
  var properties = _$1.get(widgetProps, 'properties');
  var _useState = useState({}),
    buttonStyles = _useState[0],
    setButtonStyles = _useState[1];
  Fonts.useFont(_$1.get(widgetProps, 'fonts') || []);
  useEffect(function () {
    updateButtonStyles('regular');
  }, [breakpoint]);
  var updateButtonStyles = function updateButtonStyles(state) {
    var updatedStyles = getStyles$1(properties, breakpoint, state);
    var widgetStyles = _extends({}, updatedStyles, {
      width: style['width'],
      height: style['height']
    });
    setButtonStyles(widgetStyles);
  };
  var handleClick = onClick ? onClick : function (e) {
    if (action) {
      e.stopPropagation();
      actionExcutioner.execute(widgetProps, action);
    }
  };
  return /*#__PURE__*/React.createElement(HotspotTrigger, {
    widget: widgetProps,
    breakpoint: breakpoint,
    targetRef: ref
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    ref: ref,
    className: cx(className, styles$5.button),
    style: style,
    "data-widget-id": id,
    onClick: handleClick,
    onMouseOver: function onMouseOver() {
      return updateButtonStyles('hover');
    },
    onMouseOut: function onMouseOut() {
      return updateButtonStyles('regular');
    }
  }, /*#__PURE__*/React.createElement(AnimationComponent, animation, /*#__PURE__*/React.createElement("div", {
    className: styles$5.inner,
    style: buttonStyles
  }, content))));
};
var buttonWidgetEquals = function buttonWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'onClick'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var ButtonWidget = React.memo(ButtonWidgetComponent, buttonWidgetEquals);
function getStyles$1(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var defaultStyles = _$1.get(defaultProperties, "regular", {});
  var colorRgb = _$1.get(defaultProperties, active + ".font.color", null);
  var color = getColorStyles$1(colorRgb);
  styles = _extends({}, styles, color);
  var backgroundRgb = _$1.get(defaultProperties, active + ".background", null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = getColorsConfig(backgroundRgb);
  }
  styles['background'] = background;
  var font = _$1.get(defaultStyles, 'font', {});
  var fontFamily = _$1.get(font, 'fontFamily');
  if (fontFamily) {
    styles = _extends({}, styles, {
      fontFamily: fontFamily
    });
  }
  var fontSizeString = _$1.get(deviceProperties, 'regular.font.fontSize', null);
  var fontSize = 'inherit';
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }
  styles['fontSize'] = fontSize;
  var lineSpacingString = _$1.get(deviceProperties, 'regular.font.lineSpacing', null);
  if (lineSpacingString) {
    var lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }
  var letterSpacingString = _$1.get(deviceProperties, 'regular.font.letterSpacing', null);
  if (letterSpacingString) {
    var letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }
  var bold = _$1.get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }
  var italic = _$1.get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }
  var underline = _$1.get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }
  var border = _$1.get(defaultStyles, 'border', {});
  var borderColor = _$1.get(defaultProperties, active + ".border.color", null);
  var borderStyle = getBorderStyles(border, borderColor);
  styles = _extends({}, styles, borderStyle);
  var shadow = _$1.get(defaultProperties, active + ".shadow", null);
  var shadowStyle = getBoxShadow(shadow);
  styles = _extends({}, styles, shadowStyle);
  var alignment = _$1.get(deviceProperties, 'alignment', {});
  var position = _$1.get(alignment, 'position', 'center');
  styles['justifyContent'] = position;
  styles['textAlign'] = position;
  var margin = _$1.get(alignment, 'margin', 0);
  if (position === 'left') {
    styles = _extends({}, styles, {
      paddingLeft: margin + "px"
    });
  } else if (position === 'right') {
    styles = _extends({}, styles, {
      paddingRight: margin + "px"
    });
  }
  return styles;
}
function getColorStyles$1(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  var styles = {
    color: color
  };
  return styles;
}
function getBorderStyles(value, colorRgb) {
  if (!value) {
    return null;
  }
  var styles = {};
  var topLeft = _$1.get(value, 'radius.topLeft', null);
  var topRight = _$1.get(value, 'radius.topRight', null);
  var bottomLeft = _$1.get(value, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(value, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var color = 'transparent';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  styles['borderColor'] = color;
  var borderWidthString = _$1.get(value, 'width', null);
  var borderWidget = parseInt(borderWidthString) + 'px';
  styles['borderWidth'] = borderWidget;
  return styles;
}

var styles$6 = {"image":"_2BU_2","maskView":"_bhmnY"};

var ImageWidgetComponent = function ImageWidgetComponent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    onClick = _ref.onClick;
  var actionExcutioner = useActionExectioner();
  var ref = React.useRef();
  var id = _$1.get(widgetProps, 'uid');
  var crop = _$1.get(widgetProps, "properties." + breakpoint + ".crop");
  var animation = _$1.get(widgetProps, "properties." + breakpoint + ".animation") || {};
  var content = _$1.get(widgetProps, 'content');
  var layout = _$1.get(widgetProps, "properties." + breakpoint + ".layout");
  var url = _$1.get(content, 'url');
  var alt = _$1.get(widgetProps, "properties.desktop.alt", '');
  var action = _$1.get(widgetProps, 'actions.0');
  var border = _$1.get(widgetProps, "properties." + breakpoint + ".border") || 0;
  var boxShadow = _$1.get(widgetProps, "properties." + breakpoint + ".shadow", null);
  var parameter = _$1.get(widgetProps, 'parameter');
  var width = parseFloat(layout.width);
  var height = parseFloat(layout.height);
  var hotspotWidget = getHotspotWidget(id);
  var handleClick = onClick ? onClick : function (e) {
    if (action) {
      e.stopPropagation();
      actionExcutioner.execute(widgetProps, action);
    }
  };
  var widgetStyle = _extends({}, style);
  var maskStyle = {};
  if (action || hotspotWidget) {
    widgetStyle = _extends({}, widgetStyle, {
      cursor: 'pointer'
    });
  }
  var imageStyles = _extends({}, getStyles$2(widgetProps, breakpoint, crop));
  if (crop) {
    var borderStyle = getBorderStyles$1(border);
    var shadow = getBoxShadow(boxShadow);
    maskStyle = _extends({}, borderStyle, shadow);
  }
  return /*#__PURE__*/React.createElement(HotspotTrigger, {
    widget: widgetProps,
    breakpoint: breakpoint,
    targetRef: ref
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    ref: ref,
    className: cx(className, styles$6.image, 'image_widget'),
    style: widgetStyle,
    "data-widget-id": id,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(AnimationComponent, animation, /*#__PURE__*/React.createElement("div", {
    className: styles$6.maskView,
    style: maskStyle
  }, /*#__PURE__*/React.createElement(ImageView$1, {
    breakpoint: breakpoint,
    content: content,
    alt: alt,
    width: width,
    height: height,
    style: imageStyles,
    crop: crop,
    parameter: parameter
  })))));
};
var ImageView$1 = function ImageView(_ref2) {
  var content = _ref2.content,
    alt = _ref2.alt,
    width = _ref2.width,
    height = _ref2.height,
    crop = _ref2.crop,
    style = _ref2.style,
    parameter = _ref2.parameter;
  var url = _$1.get(content, 'url');
  var imageWidth = _$1.get(content, 'width');
  var imageHeight = _$1.get(content, 'height');
  var _React$useState = React.useState(_extends({}, style, {
      width: width,
      height: height,
      maskImage: crop && crop.mask ? "url(" + crop.mask + ")" : "unset",
      WebkitMaskImage: crop && crop.mask ? "url(" + crop.mask + ")" : "unset"
    })),
    setStyles = _React$useState[1];
  var transformation = [];
  if (crop && !parameter) {
    transformation.push({
      width: 2 * crop.zoomWidth,
      height: 2 * crop.zoomHeight,
      crop: 'force'
    });
    transformation.push({
      width: 2 * crop.width,
      height: 2 * crop.height,
      cropMode: 'extract',
      x: 2 * crop.x,
      y: 2 * crop.y
    });
  } else if (imageWidth > 0 && crop) {
    var cropWidth = parseInt(width) * 2;
    cropWidth = Math.min(cropWidth, imageWidth);
    transformation.push({
      width: cropWidth,
      x: 2 * crop.x,
      y: 2 * crop.y
    });
  }
  var cropWidth = parseInt(width) * 2;
  var cropHeight = parseInt(height) * 2;
  cropWidth = Math.min(cropWidth, imageWidth);
  cropHeight = Math.min(cropHeight, imageHeight);
  transformation.push({
    width: cropWidth,
    height: cropHeight,
    crop: 'force'
  });
  transformation.push({
    quality: 80,
    format: 'webp'
  });
  React.useEffect(function () {
    setStyles(function (styles) {
      return _extends({}, styles, {
        width: width,
        height: height,
        maskImage: crop && crop.mask ? "url(" + crop.mask + ")" : "unset",
        WebkitMaskImage: crop && crop.mask ? "url(" + crop.mask + ")" : "unset"
      });
    });
  }, [width, height, crop]);
  return /*#__PURE__*/React.createElement(IKImage, {
    path: url,
    alt: alt,
    width: width,
    height: height,
    transformation: transformation,
    lqip: {
      active: true
    },
    style: _extends({}, style, {
      width: "100%",
      height: "100%",
      maskImage: crop && crop.mask ? "url(" + crop.mask + ")" : "unset",
      borderStyle: crop ? "none" : "solid"
    })
  });
};
function getStyles$2(properties, breakpoint, crop) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var deviceProperties = _$1.get(properties, "properties." + breakpoint);
  var topLeft = _$1.get(deviceProperties, 'border.radius.topLeft', null);
  var topRight = _$1.get(deviceProperties, 'border.radius.topRight', null);
  var bottomLeft = _$1.get(deviceProperties, 'border.radius.bottomLeft', null);
  var bottomRight = _$1.get(deviceProperties, 'border.radius.bottomRight', null);
  if (!crop) {
    if (topLeft) {
      styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
    }
    if (topRight) {
      styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
    }
    if (bottomLeft) {
      styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
    }
    if (bottomRight) {
      styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
    }
    var colorRgb = _$1.get(deviceProperties, 'border.color');
    var color = 'transparent';
    if (colorRgb) {
      color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
    }
    styles['borderColor'] = color;
    var borderWidthString = _$1.get(deviceProperties, 'border.width') || "0";
    var borderWidget = parseInt(borderWidthString) + 'px';
    styles['borderWidth'] = borderWidget;
    styles['borderStyle'] = "solid";
    var objectPosition = getImagePosition(_$1.get(deviceProperties, 'position'));
    styles['objectPosition'] = objectPosition;
    var shadow = _$1.get(deviceProperties, "shadow", {});
    var shadowStyle = getDropShadow(shadow);
    styles = _extends({}, styles, shadowStyle);
  }
  return styles;
}
function getImagePosition(position) {
  var backgroundPosition = 'center center';
  switch (position) {
    case POSITION.TOP_LEFT:
      backgroundPosition = 'left top';
      break;
    case POSITION.TOP_CENTER:
      backgroundPosition = 'center top';
      break;
    case POSITION.TOP_RIGHT:
      backgroundPosition = 'right top';
      break;
    case POSITION.CENTER_LEFT:
      backgroundPosition = 'left center';
      break;
    case POSITION.CENTER:
      backgroundPosition = 'center center';
      break;
    case POSITION.CENTER_RIGHT:
      backgroundPosition = 'right center';
      break;
    case POSITION.BOTTOM_LEFT:
      backgroundPosition = 'left bottom';
      break;
    case POSITION.BOTTOM_CENTER:
      backgroundPosition = 'center bottom';
      break;
    case POSITION.BOTTOM_RIGHT:
      backgroundPosition = 'right bottom';
      break;
  }
  return backgroundPosition;
}
function getBorderStyles$1(value) {
  if (!value) {
    return null;
  }
  var styles = {};
  var topLeft = _$1.get(value, 'radius.topLeft', null);
  var topRight = _$1.get(value, 'radius.topRight', null);
  var bottomLeft = _$1.get(value, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(value, 'radius.bottomRight', null);
  var colorRgb = _$1.get(value, 'color', "transparent");
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var color = 'transparent';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  styles['borderColor'] = color;
  var borderWidthString = _$1.get(value, 'width', null);
  var borderWidget = parseInt(borderWidthString) + 'px';
  styles['borderWidth'] = borderWidget;
  styles['backgroundColor'] = color;
  styles['borderStyle'] = "solid";
  styles['overflow'] = "hidden";
  return styles;
}
var imageWidgetEquals = function imageWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var ImageWidget = React.memo(ImageWidgetComponent, imageWidgetEquals);

var styles$7 = {"videoPlayer":"_9oXs6"};

var VideoWidgetComponent = function VideoWidgetComponent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var videoAimation = _$1.get(widgetProps, "properties." + breakpoint + ".animation", {});
  var ref = React.useRef();
  var _useInView = useInView$1({
      threshold: 0.3
    }),
    inView = _useInView.inView;
  var id = _$1.get(widgetProps, 'uid');
  var content = _$1.get(widgetProps, 'content');
  var hotspotWidget = getHotspotWidget(id);
  var widgetStyle = _extends({}, style);
  if (hotspotWidget) {
    widgetStyle = _extends({}, widgetStyle, {
      cursor: 'pointer'
    });
  }
  return /*#__PURE__*/React.createElement(HotspotTrigger, {
    widget: widgetProps,
    breakpoint: breakpoint,
    targetRef: ref
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    ref: ref,
    className: cx(className, styles$7.video),
    style: widgetStyle,
    "data-widget-id": id
  }, /*#__PURE__*/React.createElement(AnimationComponent, videoAimation, /*#__PURE__*/React.createElement(VideoView$1, {
    content: content,
    breakpoint: breakpoint,
    inView: inView
  }))));
};
var VideoView$1 = function VideoView(_ref2) {
  var content = _ref2.content,
    breakpoint = _ref2.breakpoint,
    inView = _ref2.inView;
  var videoRef = useRef(null);
  var context = React.useContext(Widgets.Context);
  var url = _$1.get(content, 'url');
  useEffect(function () {
    if (videoRef && videoRef.current) {
      if (inView) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  }, [inView]);
  useEffect(function () {
    if (!videoRef.current) {
      return;
    }
    var videoUrl = context.imageCDN + "/" + url;
    if (breakpoint === 'mobile') {
      var height = videoRef.current.offsetHeight;
      var maxHeight = _$1.get(content, 'media.height') || 1080;
      if (height <= 360) {
        height = 360;
      } else if (height <= 480) {
        height = 480;
      } else if (height <= 720) {
        height = 720;
      } else {
        height = 1080;
      }
      height = Math.min(height, maxHeight);
      if (height >= 360) {
        videoUrl = videoUrl + "?tr=h-" + height;
      }
    }
    videoRef.current.src = videoUrl;
  }, [breakpoint]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    name: "media",
    className: styles$7.videoPlayer,
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true,
    poster: context.imageCDN + "/" + url + "/ik-thumbnail.jpg"
  }));
};
var videoWidgetEquals = function videoWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var VideoWidget = React.memo(VideoWidgetComponent, videoWidgetEquals);

var styles$8 = {"page":"_1n3_C","mobile":"_16RNn","pageBackground":"_1mwc3","pageBackgroundMobile":"_2ripR","landingPageBackground":"_1hnqL","mobileLandingPageBackground":"_thXQn","landingPage":"_uv4Ky"};

var PageContext = React.createContext({
  zoom: 1
});
var PageWidgetComponent = function PageWidgetComponent(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children;
  var id = _$1.get(widgetProps, 'uid');
  var pageRef = useRef(null);
  var container = _$1.get(widgetProps, "properties." + breakpoint + ".container");
  var background = _$1.get(widgetProps, 'properties.desktop.background');
  var layout = _$1.get(widgetProps, "properties." + breakpoint + ".layout", {});
  var layoutWidth = parseInt(_$1.get(layout, 'width', '1200'));
  var context = React.useContext(WidgetsContext);
  var carouselContext = React.useContext(CarouselContext);
  var _useState = useState(1),
    zoom = _useState[0],
    setZoom = _useState[1];
  var storyboardType = _$1.get(context, 'storyboard.type', '');
  var activePage = _$1.get(carouselContext, 'activePage');
  useEffect(function () {
    calculateZoom();
    window.addEventListener('resize', calculateZoom);
    return function () {
      window.removeEventListener('resize', calculateZoom);
    };
  }, [storyboardType, breakpoint, layoutWidth]);
  var calculateZoom = function calculateZoom() {
    var windowWidth = document.body.clientWidth;
    var zoomValue = 1;
    if (context.shouldZoom) {
      zoomValue = windowWidth / container.minWidth;
      if (storyboardType !== 'INTERACTIVE_CONTENT' && windowWidth > 1200) {
        zoomValue = 1;
      }
    }
    setZoom(zoomValue);
  };
  var widgetStyle = _extends({}, style, {
    width: '100%',
    minWidth: container.minWidth
  });
  if (breakpoint === 'mobile') {
    var widgetStyle = _extends({}, style, {
      width: container.minWidth,
      height: layout.height
    });
  }
  widgetStyle = _extends({}, widgetStyle, {
    transform: "scale(" + zoom + ")"
  });
  var pageContextValue = React.useMemo(function () {
    return {
      zoom: zoom,
      pageWidth: container.minWidth
    };
  }, [zoom, container.minWidth]);
  return /*#__PURE__*/React.createElement(PageContext.Provider, {
    value: pageContextValue
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$8.page, 'cs_page_root', (_cx = {}, _cx[styles$8.mobile] = breakpoint === 'mobile', _cx[styles$8.landingPage] = storyboardType !== 'INTERACTIVE_CONTENT', _cx)),
    ref: pageRef,
    "data-widget-id": id,
    "data-container": true,
    style: widgetStyle
  }, /*#__PURE__*/React.createElement(PageBackground, {
    id: id,
    breakpoint: breakpoint,
    context: context,
    ref: pageRef,
    storyboardType: storyboardType,
    background: background,
    activePage: activePage
  }), /*#__PURE__*/React.createElement(HotspotRender, {
    breakpoint: breakpoint
  }, children)));
};
var PageBackground = React.forwardRef(function (_ref2, ref) {
  var _cx2;
  var id = _ref2.id,
    breakpoint = _ref2.breakpoint,
    context = _ref2.context,
    background = _ref2.background,
    storyboardType = _ref2.storyboardType,
    activePage = _ref2.activePage;
  if (!background || context.development) {
    return null;
  }
  if (storyboardType === 'INTERACTIVE_CONTENT') {
    var activeId = ref.current ? ref.current.parentElement.id : null;
    var activePageElement = ref.current ? ref.current.parentElement : null;
    var activePageParent = activePageElement ? activePageElement.parentElement : null;
    var index = activePage.index,
      fullscreen = activePage.fullscreen;
    useEffect(function () {
      var parentPage = document.getElementById("page_" + index);
      if (fullscreen && activeId == index && parentPage) {
        parentPage.style.backgroundColor = 'transparent';
      }
    }, [fullscreen, index]);
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: id
    }, fullscreen && activeId == index && breakpoint === 'desktop' && /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(BackgroundView, {
      background: background,
      breakpoint: breakpoint
    })), fullscreen && activeId == index && breakpoint === 'mobile' && activePageParent && /*#__PURE__*/React.createElement(Portal, {
      mountNode: activePageParent
    }, /*#__PURE__*/React.createElement(BackgroundView, {
      className: styles$8.pageBackgroundMobile,
      background: background,
      breakpoint: breakpoint
    })), !fullscreen && /*#__PURE__*/React.createElement(BackgroundView, {
      className: styles$8.pageBackground,
      background: background,
      breakpoint: breakpoint
    }));
  }
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(BackgroundView, {
    className: cx(styles$8.landingPageBackground, (_cx2 = {}, _cx2[styles$8.mobileLandingPageBackground] = breakpoint === 'mobile', _cx2)),
    background: background,
    breakpoint: breakpoint
  }));
});
var pageWidgetEquals = function pageWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var PageWidget = React.memo(PageWidgetComponent, pageWidgetEquals);

var styles$9 = {"text":"_2tyvA"};

var TextWidgetComponent = function TextWidgetComponent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var elementRef = React.useRef(null);
  var actionExcutioner = useActionExectioner();
  var id = _$1.get(widgetProps, 'uid');
  var content = _$1.get(widgetProps, 'content');
  var actions = _$1.get(widgetProps, 'actions');
  var fontSize = _$1.get(widgetProps, "properties." + breakpoint + ".fontSize");
  var mobileFontSize = _$1.get(widgetProps, "properties." + MOBILE + ".fontSize");
  var desktopFontSize = _$1.get(widgetProps, "properties." + DESKTOP + ".fontSize");
  var fontAlignment = _$1.get(widgetProps, "properties." + breakpoint + ".alignment");
  var textAimation = _$1.get(widgetProps, "properties." + breakpoint + ".animation") || {};
  var lineSpacing = _$1.get(widgetProps, "properties." + breakpoint + ".lineSpacing");
  var letterSpacing = _$1.get(widgetProps, "properties." + breakpoint + ".letterSpacing");
  Fonts.useFont(_$1.get(widgetProps, 'fonts') || []);
  React.useEffect(function () {
    if (elementRef.current) {
      elementRef.current.addEventListener('click', handleClickEvent);
    }
    return function () {
      if (elementRef.current) {
        elementRef.current.removeEventListener('click', handleClickEvent);
      }
    };
  }, [actionExcutioner]);
  var widgetStyle = _extends({}, style, {
    textAlign: fontAlignment,
    lineHeight: "" + lineSpacing,
    letterSpacing: fontSize * letterSpacing + "px"
  });
  var _processChildNodes = function processChildNodes(node, ratio) {
    if (!node || node.nodeType != 1) {
      return;
    }
    var fontValue = node.style.fontSize;
    if (fontValue) {
      fontValue = parseFloat(fontValue);
      var newValue = fontValue * ratio;
      newValue = Math.max(13, newValue);
      node.style.fontSize = newValue + "px";
    }
    Array.from(node.children).forEach(function (child) {
      _processChildNodes(child, ratio);
    });
  };
  var processedContent = React.useMemo(function () {
    if (breakpoint === DESKTOP) {
      return content;
    }
    var root = document.createElement('div');
    root.innerHTML = (content || "").trim();
    var ratio = mobileFontSize / desktopFontSize;
    Array.from(root.children).forEach(function (child) {
      child.style.fontSize = mobileFontSize + "px";
      Array.from(child.children).forEach(function (childNode) {
        _processChildNodes(childNode, ratio);
      });
    });
    return root.innerHTML;
  }, [content, breakpoint]);
  var handleClickEvent = function handleClickEvent(e) {
    var target = e.target;
    var anchor = target.closest("." + styles$9.text + " a");
    if (!anchor) {
      return;
    }
    var actionId = anchor.dataset.action;
    var action = actionId && actions.find(function (item) {
      return item.uid === actionId;
    });
    if (action) {
      e.preventDefault();
      e.stopPropagation();
      actionExcutioner.execute(widgetProps, action);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    ref: elementRef,
    className: cx(className, styles$9.text, 'cs_text_widget'),
    style: widgetStyle,
    "data-widget-id": id
  }, /*#__PURE__*/React.createElement(AnimationComponent, textAimation, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: processedContent
    }
  })));
};
var textWidgetEquals$1 = function textWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var TextWidget = React.memo(TextWidgetComponent, textWidgetEquals$1);

var styles$a = {"svgWrapper":"_3FH41"};

var ShapeWidgetComponent = function ShapeWidgetComponent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    onClick = _ref.onClick;
  var actionExcutioner = useActionExectioner();
  var ref = React.useRef();
  var id = _$1.get(widgetProps, 'uid');
  var content = _$1.get(widgetProps, 'content');
  var action = _$1.get(widgetProps, 'actions.0');
  var properties = _$1.get(widgetProps, "properties." + breakpoint);
  var defaultProperties = _$1.get(widgetProps, "properties.desktop", {});
  var animation = _$1.get(widgetProps, "properties." + breakpoint + ".animation") || {};
  var layout = _$1.get(properties, 'layout');
  var fillColor = _$1.get(defaultProperties, "fill");
  var stroke = _$1.get(defaultProperties, "stroke");
  var flip = _$1.get(properties, "flip");
  var shadow = _$1.get(defaultProperties, "shadow", {});
  var hotspotWidget = getHotspotWidget(id);
  var widgetStyle = _extends({}, style, getStyles$3(defaultProperties));
  if (action || hotspotWidget) {
    widgetStyle = _extends({}, widgetStyle, {
      cursor: 'pointer'
    });
  }
  var handleClick = onClick ? onClick : function (e) {
    if (action) {
      e.stopPropagation();
      actionExcutioner.execute(widgetProps, action);
    }
  };
  return /*#__PURE__*/React.createElement(HotspotTrigger, {
    widget: widgetProps,
    breakpoint: breakpoint,
    targetRef: ref
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    ref: ref,
    className: cx(className, styles$a.shape),
    style: widgetStyle,
    "data-widget-id": id,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(AnimationComponent, animation, /*#__PURE__*/React.createElement(Shape, {
    url: content,
    width: layout.width,
    height: layout.height,
    fill: fillColor.color || fillColor,
    flip: flip,
    stroke: stroke,
    shadow: shadow
  }))));
};
var Shape = function Shape(_ref2) {
  var url = _ref2.url,
    width = _ref2.width,
    height = _ref2.height,
    fill = _ref2.fill,
    stroke = _ref2.stroke,
    flip = _ref2.flip;
  var elementRef = React.useRef(null);
  var isVisible = useOnScreen(elementRef);
  var fillColor = getColorsConfig(fill);
  var strokeColor = getColorsConfig(_$1.get(stroke, 'color'));
  var strokeWidth = parseInt(_$1.get(stroke, 'width', 0));
  var horizontalFlip = _$1.get(flip, 'horizontal');
  var verticalFlip = _$1.get(flip, 'vertical');
  var rotate = getFlipStyles(horizontalFlip, verticalFlip);
  var style = {
    fill: fillColor,
    stroke: strokeColor,
    strokeWidth: strokeWidth,
    height: height,
    width: width,
    transform: rotate
  };
  useEffect(function () {
    calculateViewBox();
  }, [width, height, strokeWidth]);
  var calculateViewBox = function calculateViewBox() {
    if (strokeWidth <= 0 || !elementRef.current || !isVisible) {
      return;
    }
    var graphicElement = elementRef.current.querySelector("g");
    var box = graphicElement.getBBox();
    var viewBox = [-strokeWidth / 2, -strokeWidth / 2, box.width + strokeWidth, box.height + strokeWidth];
    elementRef.current.setAttribute('viewBox', viewBox.join(" "));
  };
  return /*#__PURE__*/React.createElement(ReactSVG, {
    className: styles$a.svgWrapper,
    width: width,
    height: height,
    src: url,
    style: style,
    afterInjection: function afterInjection(error, svg) {
      elementRef.current = svg;
      calculateViewBox();
    }
  });
};
var shapeWidgetEquals = function shapeWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var ShapeWidget = React.memo(ShapeWidgetComponent, shapeWidgetEquals);
function getStyles$3(properties, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var fillRgb = _$1.get(properties, 'fill', null);
  var fill = getFillStyles(fillRgb);
  styles = _extends({}, styles, fill);
  var strokeRgb = _$1.get(properties, 'stroke', null);
  var stroke = getStrokeStyles(strokeRgb);
  styles = _extends({}, styles, stroke);
  var shadow = _$1.get(properties, 'shadow', {});
  var shadowStyle = getDropShadow(shadow);
  styles = _extends({}, styles, shadowStyle);
  return styles;
}
function getFlipStyles(horizontal, vertical) {
  var transform = '';
  if (!vertical && !horizontal) {
    return 'rotate(0deg)';
  }
  if (vertical) {
    transform = 'rotateX(180deg)';
  }
  if (horizontal) {
    transform = transform + " rotateY(180deg)";
  }
  return transform;
}
function getFillStyles(value) {
  if (!value) {
    return null;
  }
  var fillRgb = value;
  var fill = 'inherit';
  if (fillRgb) {
    fill = "rgba(" + fillRgb.r + ", " + fillRgb.g + ", " + fillRgb.b + ", " + fillRgb.a + ")";
  }
  var styles = {
    fill: fill
  };
  return styles;
}
function getStrokeStyles(value) {
  if (!value) {
    return null;
  }
  var strokeRgb = _$1.get(value, 'color');
  var strokeWidth = _$1.get(value, 'width', 0);
  var stroke = 'inherit';
  if (strokeRgb) {
    stroke = "rgba(" + strokeRgb.r + ", " + strokeRgb.g + ", " + strokeRgb.b + ", " + strokeRgb.a + ")";
  }
  var styles = {
    'stroke': stroke,
    'strokeWidth': strokeWidth
  };
  return styles;
}

var styles$b = {"rectangle":"_2KN6s","inner":"_1W1hY"};

var RectangleWidgetComponent = function RectangleWidgetComponent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    onClick = _ref.onClick;
  var actionExcutioner = useActionExectioner();
  var ref = React.useRef();
  var id = _$1.get(widgetProps, 'uid');
  var action = _$1.get(widgetProps, 'actions.0');
  var properties = _$1.get(widgetProps, "properties." + breakpoint);
  var defaultProperties = _$1.get(widgetProps, "properties.desktop", {});
  var animation = _$1.get(widgetProps, "properties." + breakpoint + ".animation") || {};
  var layout = _$1.get(properties, 'layout');
  var flip = _$1.get(properties, "flip");
  var horizontalFlip = _$1.get(flip, 'horizontal');
  var verticalFlip = _$1.get(flip, 'vertical');
  var rotate = getFlipStyles$1(horizontalFlip, verticalFlip);
  var hotspotWidget = getHotspotWidget(id);
  var widgetStyle = _extends({}, style, {
    height: layout.height,
    width: layout.width
  });
  if (action || hotspotWidget) {
    widgetStyle = _extends({}, widgetStyle, {
      cursor: 'pointer'
    });
  }
  var rectangleStyle = _extends({
    height: layout.height,
    width: layout.width,
    transform: rotate
  }, getStyles$4(defaultProperties));
  var handleClick = onClick ? onClick : function (e) {
    if (action) {
      e.stopPropagation();
      actionExcutioner.execute(widgetProps, action);
    }
  };
  return /*#__PURE__*/React.createElement(HotspotTrigger, {
    widget: widgetProps,
    breakpoint: breakpoint,
    targetRef: ref
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    ref: ref,
    className: cx(className, styles$b.rectangle),
    style: widgetStyle,
    "data-widget-id": id,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(AnimationComponent, animation, /*#__PURE__*/React.createElement("div", {
    className: styles$b.inner,
    style: rectangleStyle
  }))));
};
var rectangleWidgetEquals = function rectangleWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var RectangleWidget = React.memo(RectangleWidgetComponent, rectangleWidgetEquals);
function getStyles$4(deviceProperties) {
  var styles = {};
  if (!deviceProperties) {
    return styles;
  }
  var fillRgb = _$1.get(deviceProperties, 'background', null);
  var background = 'inherit';
  if (fillRgb) {
    background = getColorsConfig(fillRgb);
  }
  styles['background'] = background;
  var border = _$1.get(deviceProperties, 'border', {});
  var borderStyle = getBorderStyles$2(border);
  styles = _extends({}, styles, borderStyle);
  var shadow = _$1.get(deviceProperties, 'shadow', {});
  var shadowStyle = getDropShadow(shadow);
  styles = _extends({}, styles, shadowStyle);
  return styles;
}
function getFlipStyles$1(horizontal, vertical) {
  var transform = '';
  if (!vertical && !horizontal) {
    return 'rotate(0deg)';
  }
  if (vertical) {
    transform = 'rotateX(180deg)';
  }
  if (horizontal) {
    transform = transform + " rotateY(180deg)";
  }
  return transform;
}
function getBorderStyles$2(value) {
  if (!value) {
    return null;
  }
  var styles = {};
  var topLeft = _$1.get(value, 'radius.topLeft', null);
  var topRight = _$1.get(value, 'radius.topRight', null);
  var bottomLeft = _$1.get(value, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(value, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var colorRgb = _$1.get(value, 'color');
  var color = 'transparent';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }
  styles['borderColor'] = color;
  var borderWidthString = _$1.get(value, 'width', null);
  var borderWidget = parseInt(borderWidthString) + 'px';
  styles['borderWidth'] = borderWidget;
  return styles;
}

var styles$c = {"lineWidget":"_1J5rA","line":"_2yFEJ"};

var LineWidgetComponent = function LineWidgetComponent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var id = _$1.get(widgetProps, 'uid');
  var ref = React.useRef();
  var properties = _$1.get(widgetProps, "properties." + breakpoint);
  var defaultProperties = _$1.get(widgetProps, "properties.desktop", {});
  var type = _$1.get(widgetProps, "properties.desktop.type");
  var shapeAimation = _$1.get(widgetProps, "properties." + breakpoint + ".animation", {}) || {};
  var layout = _$1.get(defaultProperties, 'layout');
  var fillColor = _$1.get(defaultProperties, "fill");
  var stroke = _$1.get(defaultProperties, "stroke");
  var legacyStyle = _$1.get(defaultProperties, "legacyStyle");
  var hotspotWidget = getHotspotWidget(id);
  var Styles = _extends({}, style, {
    marginTop: legacyStyle ? '10px' : 'unset'
  });
  if (hotspotWidget) {
    Styles = _extends({}, Styles, {
      cursor: 'pointer'
    });
  }
  return /*#__PURE__*/React.createElement(HotspotTrigger, {
    widget: widgetProps,
    breakpoint: breakpoint,
    targetRef: ref
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    ref: ref,
    className: cx(className, styles$c.lineWidget),
    style: Styles,
    "data-widget-id": id
  }, /*#__PURE__*/React.createElement(AnimationComponent, shapeAimation, /*#__PURE__*/React.createElement(Line, {
    type: type,
    fill: fillColor,
    stroke: stroke
  }))));
};
var Line = function Line(_ref2) {
  var className = _ref2.className,
    type = _ref2.type,
    stroke = _ref2.stroke,
    fill = _ref2.fill;
  var fillColor = getColorsConfig(fill);
  var strokeColor = getColorsConfig(_$1.get(stroke, 'color'));
  var strokeWidth = parseInt(_$1.get(stroke, 'width', 0));
  var style = {
    fill: fillColor,
    borderTopColor: strokeColor,
    borderTopWidth: strokeWidth,
    borderTopStyle: type
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles$c.line, className),
    style: style
  });
};
var lineWidgetEquals = function lineWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var LineWidget = React.memo(LineWidgetComponent, lineWidgetEquals);

var styles$d = {"iframe":"_2Ut7l"};

var IFrameWidgetComponent = function IFrameWidgetComponent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps;
  var id = _$1.get(widgetProps, 'uid');
  var url = _$1.get(widgetProps, 'content');
  var empty = !(url && url.trim().length > 0) || url === 'null';
  var widgetStyle = _extends({}, style);
  if (empty) {
    return false;
  }
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$d.iframe),
    style: widgetStyle,
    "data-widget-id": id
  }, /*#__PURE__*/React.createElement("iframe", {
    sandbox: "allow-same-origin allow-forms allow-popups allow-scripts allow-pointer-lock",
    src: url
  }));
};
var iframeWidgetEquals = function iframeWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'content'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var IFrameWidget = React.memo(IFrameWidgetComponent, iframeWidgetEquals);

var styles$e = {"htmlIframe":"_3SmSZ"};

var HtmlWidgetComponent = function HtmlWidgetComponent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps;
  var id = _$1.get(widgetProps, 'uid');
  var iframe = _$1.get(widgetProps, 'properties.desktop.iframe', false);
  var widgetStyle = _extends({}, style);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$e.htmlWidget),
    style: widgetStyle,
    "data-widget-id": id
  }, /*#__PURE__*/React.createElement(HtmlView, {
    widgetProps: widgetProps,
    content: widgetProps.content,
    iframe: iframe,
    id: id
  }));
};
var HtmlView = function HtmlView(_ref2) {
  var content = _ref2.content,
    iframe = _ref2.iframe,
    id = _ref2.id;
  var _React$useState = React.useState(''),
    url = _React$useState[0],
    setUrl = _React$useState[1];
  var html = _$1.get(content, 'html', "<div></div>");
  var css = _$1.get(content, 'css');
  var script = _$1.get(content, 'script');
  var processedHtml = _$1.get(content, 'processedHtml');
  var resources = _$1.get(content, 'resources', []);
  var tags = (resources || []).map(function (data, id) {
    if (data.type === 'SCRIPT') {
      return "<script key='" + id + "' src='" + data.url + "' ></script>";
    } else {
      return "<link key='" + id + "' href='" + data.url + "' rel=\"stylesheet\" ></script>";
    }
  }).join('');
  var renderCss = function renderCss() {
    if (document.getElementById("style" + id)) {
      var existingStyle = document.getElementById("style" + id);
      existingStyle.textContent = css;
      return;
    }
    var style = document.createElement('style');
    style.id = "style" + id;
    style.textContent = css;
    document.head.appendChild(style);
  };
  var renderJS = function renderJS() {
    var jsScript = "try{\n      " + script + "\n    } catch(err){\n      console.log(err)\n    }";
    if (document.getElementById("script" + id)) {
      var existingJs = document.getElementById("script" + id);
      existingJs.textContent = jsScript;
      return;
    }
    var js = document.createElement('script');
    js.id = "script" + id;
    js.textContent = jsScript;
    document.body.appendChild(js);
  };
  useEffect(function () {
    if (processedHtml) {
      setUrl(processedHtml);
    }
  }, []);
  useEffect(function () {
    if (content && !content.processedHtml) {
      processHtml();
    }
  }, [content]);
  useEffect(function () {
    if (css && !iframe) {
      renderCss();
    }
  }, [css]);
  useEffect(function () {
    if (script && !iframe) {
      renderJS();
    }
  }, [script]);
  var renderTag = function renderTag() {
    resources === null || resources === void 0 ? void 0 : resources.map(function (data) {
      if (data.type === "SCRIPT") {
        var script = document.createElement('script');
        script.src = data.url;
        document.body.appendChild(script);
      } else {
        var link = document.createElement('link');
        link.href = data.url;
        link.rel = 'stylesheet';
        document.head.appendChild(link);
      }
    });
  };
  useEffect(function () {
    if (process.browser) {
      renderTag();
    }
  }, [resources]);
  var htmlString = "\n  <!DOCTYPE HTML>\n  <html lang=\"en\">\n      <head>\n          <meta charset=\"utf-8\" />\n          <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\" />\n          " + tags + "\n          <style type=\"text/css\">\n              " + css + "\n          </style>\n      </head>\n      <body>\n          " + html + "\n          <script th:inline=\"javascript\">\n              " + script + "\n          </script>\n      </body>\n  </html>";
  var processHtml = function processHtml() {
    var blob = new Blob([htmlString], {
      type: 'text/html'
    });
    var newurl = window.URL.createObjectURL(blob);
    setUrl(newurl);
  };
  var isEmpty = !(html && html.trim().length > 0);
  return /*#__PURE__*/React.createElement(React.Fragment, null, iframe && /*#__PURE__*/React.createElement("iframe", {
    width: '100%',
    height: "100%",
    className: styles$e.htmlIframe,
    src: url
  }), !iframe && !isEmpty && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: html
    }
  })));
};
var htmlWidgetEquals = function htmlWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'content'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var HtmlWidget = React.memo(HtmlWidgetComponent, htmlWidgetEquals);

var styles$f = {"form":"_31-nF","formStep":"_2gsMe","disabled":"_3YTLw"};

var _excluded$2 = ["email"];
var FormWidgetContext = React.createContext({
  updateField: function updateField() {},
  fields: {},
  onFormSubmit: function onFormSubmit() {},
  onOtpFormSubmit: function onOtpFormSubmit() {},
  onOtpResend: function onOtpResend() {}
});
var FormWidget = function FormEditor(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children;
  var context = React.useContext(WidgetsContext);
  var formContext = React.useContext(FormContext);
  var _useState = useState({
      formStyles: {},
      step: ''
    }),
    state = _useState[0],
    setState = _useState[1];
  var _useState2 = useState({
      errors: {},
      fields: []
    }),
    formContextState = _useState2[0],
    setFormContextState = _useState2[1];
  var id = _$1.get(widgetProps, 'uid');
  var formSuccess = _$1.get(widgetProps, 'success', false);
  var otpSuccess = _$1.get(widgetProps, 'otpSuccess', false);
  var submitting = _$1.get(widgetProps, 'submitting', false);
  var formErrors = _$1.get(widgetProps, 'error');
  var formOtpId = _$1.get(widgetProps, 'formOtpId');
  var isOtpRequired = _$1.get(widgetProps, "properties." + breakpoint + ".emailOtp", false);
  var formSteps = children.filter(function (item) {
    return _$1.get(item, 'props.widgetProps.type') === FORM_STEP;
  }).map(function (item) {
    return _$1.get(item, 'props.widgetProps');
  });
  var inputWidgets = useFormInputs(id);
  var otpInputWidget = useOtpFormInput(id);
  var properties = _$1.get(widgetProps, 'properties', {});
  var deviceProperties = _$1.get(properties, "" + breakpoint, {});
  Fonts$1.useFont(_$1.get(widgetProps, 'fonts') || []);
  useEffect(function () {
    formSteps = _$1.orderBy(formSteps, ['order'], ['asc']);
    var formStep = formSteps[0];
    setState(function (state) {
      return _extends({}, state, {
        step: _$1.get(widgetProps, 'step', _$1.get(formStep, 'uid', null))
      });
    });
    setFormContextState(function (state) {
      return _extends({}, state, {
        updateField: handleUpdateField,
        onFormSubmit: handleFormSubmit,
        onOtpFormSubmit: handleOtpFormSubmit,
        onOtpResend: handleOtpResend,
        submitting: false
      });
    });
  }, []);
  useEffect(function () {
    if (formSuccess) {
      var _formSteps;
      formSteps = _$1.orderBy(formSteps, ['order'], ['desc']);
      var formStep;
      if (((_formSteps = formSteps) === null || _formSteps === void 0 ? void 0 : _formSteps.length) > 2) {
        formStep = isOtpRequired ? formSteps[0] : formSteps[1];
      } else {
        formStep = formSteps[0];
      }
      setState(function (state) {
        return _extends({}, state, {
          step: _$1.get(widgetProps, 'step', _$1.get(formStep, 'uid', null))
        });
      });
    }
  }, [formSuccess, isOtpRequired]);
  useEffect(function () {
    if (otpSuccess) {
      formSteps = _$1.orderBy(formSteps, ['order'], ['desc']);
      var formStep = formSteps[1];
      setState(function (state) {
        return _extends({}, state, {
          step: _$1.get(widgetProps, 'step', _$1.get(formStep, 'uid', null))
        });
      });
    }
  }, [otpSuccess]);
  useEffect(function () {
    setFormContextState(function (state) {
      return _extends({}, state, {
        submitting: submitting
      });
    });
  }, [submitting]);
  useEffect(function () {
    setFormContextState(function (state) {
      if (formErrors && formErrors.email) {
        var emailField = inputWidgets.find(function (widget) {
          return _$1.get(widget, 'properties.desktop.field') === 'email';
        });
        if (emailField) {
          var _extends2;
          var email = formErrors.email,
            restErrors = _objectWithoutPropertiesLoose(formErrors, _excluded$2);
          return _extends({}, state, {
            errors: _extends({}, restErrors, (_extends2 = {}, _extends2[emailField.uid] = email, _extends2))
          });
        }
      }
      return _extends({}, state, {
        errors: formErrors || {}
      });
    });
  }, [formErrors]);
  useEffect(function () {
    var formStyles = getStyles$5(properties, breakpoint);
    setState(function (state) {
      return _extends({}, state, {
        formStyles: formStyles
      });
    });
  }, [deviceProperties]);
  useEffect(function () {
    setFormContextState(function (state) {
      return _extends({}, state, {
        updateField: handleUpdateField,
        onFormSubmit: handleFormSubmit,
        onOtpFormSubmit: handleOtpFormSubmit,
        onOtpResend: handleOtpResend
      });
    });
  }, [formContextState.fields]);
  var widgetStyle = _extends({}, style, state.formStyles);
  var handleUpdateField = function handleUpdateField(uid, field, fieldId, value) {
    setFormContextState(function (state) {
      var fields = state.fields || [];
      fields = fields.filter(function (item) {
        return item.uid != uid;
      });
      fields = [].concat(fields, [{
        uid: uid,
        id: field,
        fieldId: fieldId,
        value: value
      }]);
      var errors = _$1.omit(state.errors, uid);
      return _extends({}, state, {
        fields: fields,
        errors: errors
      });
    });
  };
  var handleFormSubmit = function handleFormSubmit() {
    var errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormContextState(function (state) {
        return _extends({}, state, {
          errors: errors
        });
      });
      return;
    }
    formContext.onFormSubmit(context.session, id, {
      fields: formContextState.fields,
      parent: context.parent
    });
  };
  var handleOtpFormSubmit = function handleOtpFormSubmit() {
    var _formContextState$fie;
    var errors = validateOtpForm();
    if (Object.keys(errors).length > 0) {
      setFormContextState(function (state) {
        return _extends({}, state, {
          errors: errors
        });
      });
      return;
    }
    var otpObject = formContextState === null || formContextState === void 0 ? void 0 : (_formContextState$fie = formContextState.fields) === null || _formContextState$fie === void 0 ? void 0 : _formContextState$fie.find(function (item) {
      return item.id === "otp";
    });
    var otp = otpObject === null || otpObject === void 0 ? void 0 : otpObject.value;
    formContext.onOtpFormSubmit(context.session, id, {
      fields: formContextState.fields,
      parent: context.parent,
      formOtpId: formOtpId && formOtpId,
      otp: otp && otp
    });
  };
  var handleOtpResend = function handleOtpResend() {
    formContext.onOtpResend(context.session, id, {
      formOtpId: formOtpId
    });
  };
  var validateForm = function validateForm() {
    var errors = {};
    (inputWidgets || []).forEach(function (widget) {
      var field = (formContextState.fields || []).find(function (field) {
        return _$1.get(widget, 'uid', '') === field.uid;
      });
      var value = _$1.get(field, 'value', '');
      var uid = _$1.get(widget, 'uid', null);
      var properties = _$1.get(widget, 'properties.desktop', {});
      var mandatory = properties.mandatory;
      if (properties.field === 'email' && !validateEmail(value)) {
        errors[uid] = "Please provide a valid " + (properties.label || 'value');
        return;
      }
      if (mandatory && (!value || Array.isArray(value) && value.length === 0 || value === false)) {
        if (_$1.get(widget, 'type') == FORM_CHECK_BOX) {
          errors[uid] = "This field cannot be empty";
          return;
        }
        errors[uid] = "Please provide a valid " + (properties.label || 'value');
      }
    });
    return errors;
  };
  var validateOtpForm = function validateOtpForm() {
    var errors = {};
    (otpInputWidget || []).forEach(function (widget) {
      var field = (formContextState.fields || []).find(function (field) {
        return _$1.get(widget, 'uid', '') === field.uid;
      });
      var value = _$1.get(field, 'value', '');
      var uid = _$1.get(widget, 'uid', null);
      var properties = _$1.get(widget, 'properties.desktop', {});
      var mandatory = properties.mandatory;
      if (mandatory && properties.field === 'otp' && !validateOtp(value)) {
        errors[uid] = "Please provide a valid otp";
        return;
      }
    });
    return errors;
  };
  var validateEmail = function validateEmail(email) {
    if (!email) {
      return false;
    }
    var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
  };
  var validateOtp = function validateOtp(otp, requiredLength) {
    if (requiredLength === void 0) {
      requiredLength = 4;
    }
    if (!otp) {
      return false;
    }
    var trimmedOtp = otp.trim();
    if (trimmedOtp.length !== requiredLength) {
      return false;
    }
    return trimmedOtp;
  };
  return /*#__PURE__*/React.createElement(FormWidgetContext.Provider, {
    value: formContextState
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$f.form),
    style: widgetStyle,
    "data-widget-id": id
  }, children.filter(function (item) {
    return _$1.get(item, 'props.widgetProps.uid') === state.step;
  })));
};
function getStyles$5(properties, breakpoint) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var font = _$1.get(defaultProperties, 'font', {});
  var colorRgb = _$1.get(font, 'color', null);
  var color = getColorStyles$2(colorRgb);
  styles = _extends({}, styles, color);
  var fontFamily = _$1.get(font, 'fontFamily', 'inherit');
  styles = _extends({}, styles, {
    fontFamily: fontFamily
  });
  var fontSizeString = _$1.get(deviceProperties, 'regular.font.fontSize', null);
  var fontSize = 'inherit';
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }
  styles['fontSize'] = fontSize;
  var paddingString = _$1.get(deviceProperties, 'padding', null);
  var padding = '20';
  if (paddingString) {
    padding = parseInt(paddingString) + 'px';
  }
  styles['padding'] = padding;
  var bold = _$1.get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }
  var italic = _$1.get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }
  var underline = _$1.get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }
  var backgroundRgb = _$1.get(defaultProperties, 'background', null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = getColorsConfig(backgroundRgb);
  }
  styles['background'] = background;
  var border = _$1.get(defaultProperties, 'border', {});
  var borderStyle = getBorderStyles$3(border);
  styles = _extends({}, styles, borderStyle);
  var alignment = _$1.get(deviceProperties, 'alignment', {});
  var justifyContent = _$1.get(alignment, 'justifyContent', 'left');
  styles['justifyContent'] = justifyContent;
  var flexDirection = _$1.get(alignment, 'flexDrection', 'column');
  styles['flexDirection'] = flexDirection;
  var alignItems = _$1.get(alignment, 'alignItems', 'start');
  styles['alignItems'] = alignItems;
  var overflow = "visible";
  styles['overflow'] = overflow;
  return styles;
}
function getColorStyles$2(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }
  var styles = {
    color: color
  };
  return styles;
}
function getBorderStyles$3(value) {
  if (!value) {
    return null;
  }
  var borderStyles = {};
  var topLeft = _$1.get(value, 'radius.topLeft', null);
  var topRight = _$1.get(value, 'radius.topRight', null);
  var bottomLeft = _$1.get(value, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(value, 'radius.bottomRight', null);
  if (topLeft) {
    borderStyles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    borderStyles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    borderStyles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    borderStyles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var colorRgb = _$1.get(value, 'color');
  var color = 'transparent';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }
  borderStyles['borderColor'] = color;
  var borderWidthString = _$1.get(value, 'width', 0);
  var borderWidget = parseInt(borderWidthString) + 'px';
  borderStyles['borderWidth'] = borderWidget;
  return borderStyles;
}

var FormStepWidget = function FormStepWidget(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children;
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var properties = _$1.get(widgetProps, 'properties', {});
  var parentWidget = useWidgetSelector(widgetProps.parent);
  var width = _$1.get(parentWidget, "properties." + breakpoint + ".layout.width") || 'auto';
  var height = _$1.get(parentWidget, "properties." + breakpoint + ".layout.height") || 'auto';
  var widgetStyles = _extends({}, style, {
    width: width,
    height: height
  });
  var rearrangeOrderByPosition = function rearrangeOrderByPosition(childrenWidgets) {
    var translateData = childrenWidgets.map(function (item) {
      var translateString = _$1.get(item, 'props.widgetProps.properties.desktop.layout.transform.translate', '0px,0px');
      var _translateString$repl = translateString.replace('px', '').split(',').map(function (value) {
          return Math.round(parseFloat(value.trim()));
        }),
        _translateString$repl2 = _translateString$repl[0],
        translateX = _translateString$repl2 === void 0 ? 0 : _translateString$repl2,
        _translateString$repl3 = _translateString$repl[1],
        translateY = _translateString$repl3 === void 0 ? 0 : _translateString$repl3;
      return {
        item: _extends({}, item),
        order: _$1.get(item, 'props.widgetProps.order'),
        translateX: isNaN(translateX) ? 0 : translateX,
        translateY: isNaN(translateY) ? 0 : translateY
      };
    });
    translateData.sort(function (a, b) {
      return a.translateY - b.translateY || a.translateX - b.translateX;
    });
    var sortedOrderNumbers = translateData.map(function (data) {
      return data.order;
    }).sort(function (a, b) {
      return a - b;
    });
    translateData.forEach(function (data, index) {
      data.item.props.widgetProps.order = sortedOrderNumbers[index];
    });
    return _$1.sortBy(childrenWidgets, 'props.widgetProps.order');
  };
  var childrenWidgets = rearrangeOrderByPosition(children);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$f.formStep),
    style: widgetStyles,
    "data-widget-id": id,
    "data-widget-type": type
  }, childrenWidgets);
};

var styles$g = {"inputField":"_3FOoA","error":"_39z6_","active":"_29x-S"};

var FormTextWidget = function TextInputEditor(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var context = React.useContext(FormWidgetContext);
  var _React$useState = React.useState(''),
    value = _React$useState[0],
    setValue = _React$useState[1];
  var _React$useState2 = React.useState(''),
    errors = _React$useState2[0],
    setErrors = _React$useState2[1];
  var id = _$1.get(widgetProps, 'uid');
  var properties = _$1.get(widgetProps, 'properties', {});
  var label = _$1.get(widgetProps, 'properties.desktop.label') || "";
  var placeholder = _$1.get(widgetProps, 'properties.desktop.placeholder') || "";
  var placeholderColor = getPlaceholderColor(properties);
  var field = _$1.get(widgetProps, 'properties.desktop.field') || "";
  var fieldId = _$1.get(widgetProps, 'content.id') || "";
  var error = _$1.get(context.errors, id);
  useEffect(function () {
    setErrors('');
    context.updateField(id, field, fieldId, value);
  }, [value]);
  Fonts$1.useFont(_$1.get(widgetProps, 'fonts') || []);
  var widgetStyles = _extends({}, style, getFieldStyles(properties, breakpoint, 'regular'));
  var labelStyles = getLabelStyles(properties, breakpoint, 'regular');
  var inputStyles = getInputStyles(properties, breakpoint);
  var handleInputChange = function handleInputChange(e) {
    var value = e.target.value;
    if (_$1.size(value) > 250) {
      setErrors('Maximum limit of 250 characters');
      return;
    }
    setValue(value);
  };
  useEffect(function () {
    setErrors(error);
  }, [error]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$g.inputField),
    style: widgetStyles,
    "data-widget-id": id
  }, placeholderColor && /*#__PURE__*/React.createElement("style", null, "\n            #" + id + " input::-webkit-input-placeholder {\n              color: " + placeholderColor + ";\n            }\n          "), label && /*#__PURE__*/React.createElement("label", {
    style: labelStyles
  }, label), /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: placeholder,
    style: inputStyles,
    value: value,
    onChange: function onChange(e) {
      return handleInputChange(e);
    },
    disabled: false
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(styles$g.error, (_cx = {}, _cx[styles$g.active] = errors, _cx))
  }, errors));
};
function getFieldStyles(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var activeStyles = _$1.get(defaultProperties, "" + active, {});
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  styles['alignItems'] = alignment;
  if (alignment === 'left') {
    styles['alignItems'] = 'flex-start';
  } else if (alignment === 'right') {
    styles['alignItems'] = 'flex-end';
  }
  return styles;
}
function getLabelStyles(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var activeStyles = _$1.get(defaultProperties, "" + active, {});
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  var fieldSpacing = _$1.get(deviceProperties, 'styles.layout.fieldSpacing') || 0;
  styles['paddingBottom'] = fieldSpacing + "px";
  var labelPadding = _$1.get(deviceProperties, 'styles.layout.labelPadding') || 0;
  if (alignment === 'left') {
    styles['paddingLeft'] = labelPadding + "px";
  } else if (alignment === 'right') {
    styles['paddingRight'] = labelPadding + "px";
  }
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.label');
  var fontStyles = getFontStyle(inputStyles);
  styles = _extends({}, styles, fontStyles);
  return styles;
}
function getInputStyles(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  var inputPadding = _$1.get(deviceProperties, 'styles.layout.inputPadding') || 0;
  if (alignment === 'left') {
    styles['paddingLeft'] = inputPadding + "px";
  } else if (alignment === 'right') {
    styles['paddingRight'] = inputPadding + "px";
  }
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.input');
  var fontStyles = getFontStyle(inputStyles);
  styles = _extends({}, styles, fontStyles);
  var border = _$1.get(defaultProperties, 'styles.regular.border');
  var borderStyles = getBorderStyles$4(border);
  styles = _extends({}, styles, borderStyles);
  return styles;
}
function getPlaceholderColor(properties) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.input');
  var colorRgb = _$1.get(inputStyles, 'placeholderColor', null);
  if (!colorRgb) {
    return null;
  }
  return getColorsConfig(colorRgb);
}
function getColorStyles$3(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }
  var styles = {
    color: color
  };
  return styles;
}
function getBorderStyles$4(border) {
  var styles = {};
  if (!border) {
    return styles;
  }
  var topLeft = _$1.get(border, 'radius.topLeft', null);
  var topRight = _$1.get(border, 'radius.topRight', null);
  var bottomLeft = _$1.get(border, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(border, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var borderStyle = _$1.get(border, 'style') || 'bottom';
  if (borderStyle !== 'none') {
    var borderWidthString = _$1.get(border, 'width') || 0;
    var borderWidget = parseInt(borderWidthString) + 'px';
    var fieldName = borderStyle == 'all' ? 'borderWidth' : 'borderBottomWidth';
    styles[fieldName] = borderWidget;
    var colorRgb = _$1.get(border, 'color');
    var color = 'transparent';
    if (colorRgb) {
      color = getColorsConfig(colorRgb);
    }
    styles['borderColor'] = color;
  }
  return styles;
}
function getFontStyle(fontStyles) {
  var styles = {};
  if (!fontStyles) {
    return styles;
  }
  var backgroundColorRgb = _$1.get(fontStyles, 'background', null);
  if (backgroundColorRgb) {
    styles = _extends({}, styles, {
      background: getColorsConfig(backgroundColorRgb)
    });
  }
  var colorRgb = _$1.get(fontStyles, 'color', null);
  var color = getColorStyles$3(colorRgb);
  styles = _extends({}, styles, color);
  var fontFamily = _$1.get(fontStyles, 'font.fontFamily', 'inherit');
  styles = _extends({}, styles, {
    fontFamily: fontFamily
  });
  var fontSizeString = _$1.get(fontStyles, "font.fontSize") || 14;
  if (fontSizeString) {
    var fontSize = parseInt(fontSizeString) + 'px';
    styles['fontSize'] = fontSize;
  }
  return styles;
}

var styles$h = {"inputField":"_3pDXs","error":"_3es3J","active":"_285nI"};

var FormOtpInputWidget = function OtpInputEditor(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var context = React.useContext(FormWidgetContext);
  var _React$useState = React.useState(''),
    otp = _React$useState[0],
    setOtp = _React$useState[1];
  var _React$useState2 = React.useState(''),
    errors = _React$useState2[0],
    setErrors = _React$useState2[1];
  var id = _$1.get(widgetProps, 'uid');
  var properties = _$1.get(widgetProps, 'properties', {});
  var placeholder = _$1.get(widgetProps, 'properties.desktop.placeholder') || "";
  var placeholderColor = getPlaceholderColor$1(properties);
  var field = _$1.get(widgetProps, 'properties.desktop.field') || "";
  var fieldId = _$1.get(widgetProps, 'content.id') || "";
  var error = _$1.get(context.errors, id);
  var errorResponse = _$1.get(context, 'errors.errors[0].message');
  useEffect(function () {
    setErrors('');
    if (context.errors) {
      context.errors.errors = [];
    }
    context.updateField(id, field, fieldId, otp);
  }, [otp]);
  Fonts$1.useFont(_$1.get(widgetProps, 'fonts') || []);
  var widgetStyles = _extends({}, style, getFieldStyles$1(properties, breakpoint, 'regular'));
  var labelStyles = getLabelStyles$1(properties, breakpoint, 'regular');
  var inputStyles = getInputStyles$1(properties, breakpoint);
  var isBottomBorder = (inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.borderBottomWidth) == undefined ? false : true;
  var isBorder = (inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.borderWidth) == undefined ? false : true;
  var borderCondition;
  if (isBottomBorder) {
    borderCondition = {
      borderBottom: (inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.borderBottomWidth) + " solid " + (inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.borderColor)
    };
  } else if (isBorder) {
    borderCondition = {
      border: (inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.borderWidth) + " solid " + (inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.borderColor)
    };
  } else {
    borderCondition = {
      border: "none"
    };
  }
  var handleChange = function handleChange(otp) {
    return setOtp(otp);
  };
  var handlePaste = function handlePaste(event) {
    var pastedData = event.clipboardData.getData('text');
    var filteredData = pastedData.replace(/[^0-9]/g, '');
    if (filteredData !== pastedData) {
      event.preventDefault();
      var input = event.target;
      var start = input.selectionStart;
      var end = input.selectionEnd;
      input.value = input.value.slice(0, start) + filteredData + input.value.slice(end);
      input.setSelectionRange(start + filteredData.length, start + filteredData.length);
      var inputEvent = new Event('input', {
        bubbles: true
      });
      input.dispatchEvent(inputEvent);
    }
  };
  useEffect(function () {
    setErrors(error);
  }, [error]);
  useEffect(function () {
    if (errorResponse) {
      setErrors(errorResponse);
    }
  }, [errorResponse]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$h.inputField),
    style: widgetStyles,
    "data-widget-id": id
  }, placeholderColor && /*#__PURE__*/React.createElement("style", null, "\n          #" + id + " input::-webkit-input-placeholder {\n            color: " + placeholderColor + ";\n          }\n        "), /*#__PURE__*/React.createElement(OtpInput, {
    value: otp,
    onChange: handleChange,
    numInputs: 4,
    renderSeparator: /*#__PURE__*/React.createElement("span", {
      style: {
        width: "" + (labelStyles === null || labelStyles === void 0 ? void 0 : labelStyles.paddingBottom)
      }
    }),
    isInputNum: true,
    shouldAutoFocus: true,
    inputStyle: borderCondition && _extends({}, borderCondition, {
      background: "" + (inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.background),
      borderBottomLeftRadius: "" + ((inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.borderBottomLeftRadius) && (inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.borderBottomLeftRadius)),
      borderBottomRightRadius: "" + ((inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.borderBottomRightRadius) && (inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.borderBottomRightRadius)),
      borderTopLeftRadius: "" + ((inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.borderTopLeftRadius) && (inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.borderTopLeftRadius)),
      borderTopRightRadius: "" + ((inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.borderTopRightRadius) && (inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.borderTopRightRadius)),
      width: "" + (labelStyles === null || labelStyles === void 0 ? void 0 : labelStyles.width),
      height: "" + (labelStyles === null || labelStyles === void 0 ? void 0 : labelStyles.height),
      fontSize: "" + (inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.fontSize),
      color: "" + (inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.color),
      fontWeight: "400",
      padding: "" + (inputStyles === null || inputStyles === void 0 ? void 0 : inputStyles.paddingLeft)
    }),
    renderInput: function renderInput(props, index) {
      return /*#__PURE__*/React.createElement("input", _extends({}, props, {
        placeholder: placeholder,
        onPaste: handlePaste,
        inputMode: "numeric",
        onKeyPress: function onKeyPress(e) {
          if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
          }
        }
      }));
    },
    focusStyle: {
      outline: "none"
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(styles$h.error, (_cx = {}, _cx[styles$h.active] = errors, _cx))
  }, errors));
};
function getFieldStyles$1(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var activeStyles = _$1.get(defaultProperties, "" + active, {});
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  styles['alignItems'] = alignment;
  if (alignment === 'left') {
    styles['alignItems'] = 'flex-start';
  } else if (alignment === 'right') {
    styles['alignItems'] = 'flex-end';
  }
  return styles;
}
function getLabelStyles$1(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var activeStyles = _$1.get(defaultProperties, "" + active, {});
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  var fieldSpacing = _$1.get(deviceProperties, 'styles.layout.fieldSpacing') || 0;
  styles['paddingBottom'] = fieldSpacing + "px";
  var fieldWidth = _$1.get(deviceProperties, 'styles.layout.width') || 0;
  styles['width'] = fieldWidth + "px";
  var fieldHeight = _$1.get(deviceProperties, 'styles.layout.height') || 0;
  styles['height'] = fieldHeight + "px";
  var labelPadding = _$1.get(deviceProperties, 'styles.layout.labelPadding') || 0;
  if (alignment === 'left') {
    styles['paddingLeft'] = labelPadding + "px";
  } else if (alignment === 'right') {
    styles['paddingRight'] = labelPadding + "px";
  }
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.label');
  var fontStyles = getFontStyle$1(inputStyles);
  styles = _extends({}, styles, fontStyles);
  return styles;
}
function getInputStyles$1(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  var inputPadding = _$1.get(deviceProperties, 'styles.layout.inputPadding') || 0;
  if (alignment === 'left') {
    styles['paddingLeft'] = inputPadding + "px";
  } else if (alignment === 'right') {
    styles['paddingRight'] = inputPadding + "px";
  }
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.input');
  var fontStyles = getFontStyle$1(inputStyles);
  styles = _extends({}, styles, fontStyles);
  var border = _$1.get(defaultProperties, 'styles.regular.border');
  var borderStyles = getBorderStyles$5(border);
  styles = _extends({}, styles, borderStyles);
  return styles;
}
function getPlaceholderColor$1(properties) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.input');
  var colorRgb = _$1.get(inputStyles, 'placeholderColor', null);
  if (!colorRgb) {
    return null;
  }
  return getColorsConfig(colorRgb);
}
function getColorStyles$4(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }
  var styles = {
    color: color
  };
  return styles;
}
function getBorderStyles$5(border) {
  var styles = {};
  if (!border) {
    return styles;
  }
  var topLeft = _$1.get(border, 'radius.topLeft', null);
  var topRight = _$1.get(border, 'radius.topRight', null);
  var bottomLeft = _$1.get(border, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(border, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var borderStyle = _$1.get(border, 'style') || 'bottom';
  if (borderStyle !== 'none') {
    var borderWidthString = _$1.get(border, 'width') || 0;
    var borderWidget = parseInt(borderWidthString) + 'px';
    var fieldName = borderStyle == 'all' ? 'borderWidth' : 'borderBottomWidth';
    styles[fieldName] = borderWidget;
    var colorRgb = _$1.get(border, 'color');
    var color = 'transparent';
    if (colorRgb) {
      color = getColorsConfig(colorRgb);
    }
    styles['borderColor'] = color;
  }
  return styles;
}
function getFontStyle$1(fontStyles) {
  var styles = {};
  if (!fontStyles) {
    return styles;
  }
  var backgroundColorRgb = _$1.get(fontStyles, 'background', null);
  if (backgroundColorRgb) {
    styles = _extends({}, styles, {
      background: getColorsConfig(backgroundColorRgb)
    });
  }
  var colorRgb = _$1.get(fontStyles, 'color', null);
  var color = getColorStyles$4(colorRgb);
  styles = _extends({}, styles, color);
  var fontFamily = _$1.get(fontStyles, 'font.fontFamily', 'inherit');
  styles = _extends({}, styles, {
    fontFamily: fontFamily
  });
  var fontSizeString = _$1.get(fontStyles, "font.fontSize") || 14;
  if (fontSizeString) {
    var fontSize = parseInt(fontSizeString) + 'px';
    styles['fontSize'] = fontSize;
  }
  return styles;
}

var styles$i = {"tooltip":"_1Go-Z"};

var Tooltip = function Tooltip(_ref) {
  var placement = _ref.placement,
    className = _ref.className,
    content = _ref.content,
    children = _ref.children,
    disabled = _ref.disabled;
  if (disabled) {
    return children;
  }
  return /*#__PURE__*/React.createElement(OverlayTrigger, {
    container: document.body,
    placement: placement,
    trigger: ['focus', 'hover'],
    overlay: /*#__PURE__*/React.createElement(Tooltip$1, {
      className: cx(styles$i.tooltip, className),
      placement: placement
    }, content)
  }, children);
};

var TruncatedTextWithTooltip = function TruncatedTextWithTooltip(_ref) {
  var content = _ref.content,
    className = _ref.className,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? "top" : _ref$placement;
  var _useState = useState(false),
    tooltip = _useState[0],
    setTooltip = _useState[1];
  var handleTooltip = function handleTooltip(isTruncated) {
    setTooltip(isTruncated);
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    placement: placement,
    disabled: !tooltip,
    content: content
  }, /*#__PURE__*/React.createElement("span", {
    className: className
  }, /*#__PURE__*/React.createElement(Truncate, {
    lines: 1,
    width: maxWidth,
    ellipsis: "...",
    onTruncate: handleTooltip
  }, content)));
};

var styles$j = {"dropDownContainer":"_2cPJA","customDropdown":"_2C4M0","overlap":"_jM05n","toggleButton":"_3fgEo","actionConatiner":"_3s0eo","selectedFields":"_2Vz-H","inputContainer":"_2aWI9","selected":"_1hwNl","count":"_PzOBR","clearBtn":"_10VWh","dropDownIndicator":"_1ID4h","open":"_3GFVB","customOptionWrapper":"_2C1zv","searchBox":"_37oWc","searchIcon":"_K79Yp","field":"_3msyY","displayMenu":"_DZeCo","checkBoxItem":"_2FjG2","singleSelect":"_3LOa3","error":"_PK55u","active":"_2WDE7"};

var FormDropdownList = React.memo(function DropDownListEditor(_ref) {
  var _cx, _cx2;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    _ref$show = _ref.show,
    show = _ref$show === void 0 ? false : _ref$show,
    breakpoint = _ref.breakpoint;
  var context = React.useContext(FormWidgetContext);
  var dropdownRef = useRef(null);
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var _useState2 = useState([]),
    checkedItems = _useState2[0],
    setCheckedItems = _useState2[1];
  var _useState3 = useState(''),
    errors = _useState3[0],
    setErrors = _useState3[1];
  var id = _$1.get(widgetProps, 'uid');
  var properties = _$1.get(widgetProps, 'properties', {});
  var label = _$1.get(widgetProps, 'properties.desktop.label') || '';
  var multiSelect = _$1.get(widgetProps, "properties.desktop.multiSelect") || false;
  var field = _$1.get(widgetProps, 'properties.desktop.field') || '';
  var fieldId = _$1.get(widgetProps, 'content.id') || "";
  var listOptions = _$1.get(widgetProps, 'content.options', []);
  var error = _$1.get(context.errors, id);
  useEffect(function () {
    setErrors('');
    var values = checkedItems.map(function (item) {
      return item.id;
    });
    context.updateField(id, field, fieldId, values);
  }, [checkedItems]);
  var handleInputChange = function handleInputChange(selectedOption) {
    setCheckedItems(function (prevState) {
      if (multiSelect) {
        var alreadyExist = prevState.some(function (item) {
          return item.id === selectedOption.id;
        });
        if (alreadyExist) {
          return prevState.filter(function (item) {
            return item.id !== selectedOption.id;
          });
        } else {
          return _$1.uniqBy([].concat(prevState, [selectedOption]), 'id');
        }
      } else {
        setIsOpen(false);
        return [selectedOption];
      }
    });
  };
  useEffect(function () {
    setErrors(error);
  }, [error]);
  useEffect(function () {
    setIsOpen(show);
  }, [show]);
  var handleClickOutside = function handleClickOutside(event) {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !show) {
      setIsOpen(false);
    }
  };
  useEffect(function () {
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [show]);
  Fonts$1.useFont(_$1.get(widgetProps, 'fonts') || []);
  var labelStyles = getLabelStyles$2(properties, breakpoint, 'regular');
  var inputStyles = getInputStyles$2(properties, breakpoint);
  var dropdownMenuStyles = getDropDownMenuStyles(properties, breakpoint);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$j.dropDownContainer, (_cx = {}, _cx[styles$j.overlap] = isOpen, _cx)),
    style: style,
    "data-widget-id": id
  }, label && /*#__PURE__*/React.createElement("label", {
    style: labelStyles
  }, label), /*#__PURE__*/React.createElement(Dropdown, {
    className: styles$j.customDropdown,
    show: isOpen,
    ref: dropdownRef
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown_button_" + id,
    as: CustomToggle,
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    checkedItems: checkedItems,
    setCheckedItems: setCheckedItems,
    inputStyles: inputStyles,
    properties: properties,
    isOpen: isOpen,
    multiSelect: multiSelect,
    tabIndex: 0
  }), isOpen && /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: styles$j.customOptionWrapper,
    align: "end",
    style: dropdownMenuStyles,
    as: CustomMenu,
    show: isOpen
  }, _$1.map(listOptions, function (option) {
    var isChecked = _$1.some(checkedItems, {
      id: option.id
    });
    return /*#__PURE__*/React.createElement(Dropdown.Item, {
      key: option.id,
      id: option.id,
      as: CheckDropdownItem,
      multiSelect: multiSelect,
      checked: isChecked,
      onChange: function onChange() {
        return handleInputChange(option);
      }
    }, option.value);
  }))), /*#__PURE__*/React.createElement("span", {
    className: cx(styles$j.error, (_cx2 = {}, _cx2[styles$j.active] = errors, _cx2))
  }, errors));
});
var CustomToggle = React.forwardRef(function (_ref2, ref) {
  var _cx3, _cx4;
  var checkedItems = _ref2.checkedItems,
    setCheckedItems = _ref2.setCheckedItems,
    isOpen = _ref2.isOpen,
    properties = _ref2.properties,
    inputStyles = _ref2.inputStyles,
    multiSelect = _ref2.multiSelect,
    _onClick = _ref2.onClick,
    tabIndex = _ref2.tabIndex;
  var placeholder = _$1.get(properties, 'desktop.placeholder') || '';
  var placeholderColor = getPlaceholderColor$2(properties);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: inputStyles,
    className: cx(styles$j.toggleButton),
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      _onClick(e);
    },
    tabIndex: tabIndex
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$j.actionConatiner
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$j.selectedFields
  }, _$1.size(checkedItems) > 0 ? /*#__PURE__*/React.createElement(RenderSelectedOptions, {
    selectedOptions: checkedItems.map(function (option) {
      return option.value;
    })
  }) : /*#__PURE__*/React.createElement("span", {
    style: placeholderColor,
    className: styles$j.placeholder
  }, placeholder)), _$1.size(checkedItems) > 0 && multiSelect && /*#__PURE__*/React.createElement("span", {
    className: styles$j.clearBtn,
    onClick: function onClick() {
      return setCheckedItems([]);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-close')
  })), /*#__PURE__*/React.createElement("span", {
    className: cx(styles$j.dropDownIndicator, (_cx3 = {}, _cx3[styles$j.open] = isOpen, _cx3))
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-drop-down', styles$j.dropDownIcon, (_cx4 = {}, _cx4[styles$j.showDropdown] = false, _cx4))
  }))));
});
var CustomMenu = React.forwardRef(function (_ref3, ref) {
  var _cx5;
  var children = _ref3.children,
    style = _ref3.style,
    className = _ref3.className,
    show = _ref3.show;
  var _React$useState = React.useState(''),
    searchText = _React$useState[0],
    setSearchText = _React$useState[1];
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: cx(className, (_cx5 = {}, _cx5[styles$j.displayMenu] = show, _cx5)),
    ref: ref
  }, /*#__PURE__*/React.createElement(SearchBox, {
    searchText: searchText,
    setSearchText: setSearchText
  }), React.Children.toArray(children).filter(function (child) {
    return !searchText || child.props.children.toLowerCase().includes(searchText.toLowerCase());
  }));
});
var CheckDropdownItem = React.forwardRef(function (_ref4, ref) {
  var _cx6;
  var children = _ref4.children,
    id = _ref4.id,
    checked = _ref4.checked,
    onChange = _ref4.onChange,
    multiSelect = _ref4.multiSelect;
  return /*#__PURE__*/React.createElement(Form.Group, {
    key: id,
    ref: ref,
    className: cx(styles$j.checkBoxItem),
    controlId: id
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: 'checkbox',
    label: children,
    checked: checked,
    className: cx((_cx6 = {}, _cx6[styles$j.singleSelect] = !multiSelect, _cx6)),
    onChange: onChange
  }));
});
var SearchBox = React.memo(function (_ref5) {
  var searchText = _ref5.searchText,
    setSearchText = _ref5.setSearchText;
  return /*#__PURE__*/React.createElement(InputGroup, {
    className: styles$j.searchBox
  }, /*#__PURE__*/React.createElement(InputGroup.Text, {
    className: styles$j.searchIcon,
    id: "basic-addon1"
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-search')
  })), /*#__PURE__*/React.createElement(Form.Control, {
    className: styles$j.field,
    placeholder: "Search",
    onChange: function onChange(e) {
      return setSearchText(e.target.value);
    },
    value: searchText
  }));
});
var RenderSelectedOptions = function RenderSelectedOptions(_ref6) {
  var selectedOptions = _ref6.selectedOptions;
  var containerRef = useRef(null);
  var _useState4 = useState({
      visibleOptions: [],
      remainingCount: 0
    }),
    content = _useState4[0],
    setContent = _useState4[1];
  var calculateVisibleOptions = useCallback(function () {
    if (containerRef.current) {
      var containerWidth = containerRef.current.offsetWidth - 30;
      var totalWidth = 0;
      var lastIndex = 0;
      selectedOptions.forEach(function (string, index) {
        var stringWidth = document.createElement('span');
        stringWidth.style.visibility = 'hidden';
        stringWidth.style.position = 'absolute';
        stringWidth.innerText = string;
        document.body.appendChild(stringWidth);
        var width = stringWidth.offsetWidth;
        if (width > 150) {
          width = 150;
        }
        document.body.removeChild(stringWidth);
        if (totalWidth + width > containerWidth) {
          if (index === 0) {
            totalWidth = containerWidth;
            lastIndex = 1;
          }
          return;
        }
        totalWidth += width;
        lastIndex = index + 1;
      });
      setContent({
        visibleOptions: selectedOptions.slice(0, lastIndex),
        remainingCount: selectedOptions.length - lastIndex
      });
    }
  }, [selectedOptions]);
  useEffect(function () {
    calculateVisibleOptions();
  }, [selectedOptions, calculateVisibleOptions]);
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: styles$j.inputContainer
  }, content.visibleOptions.map(function (value, index, allOptions) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(TruncatedTextWithTooltip, {
      className: styles$j.selected,
      content: value,
      maxWidth: allOptions.length === 1 ? containerRef.current.offsetWidth - 30 : 150,
      placement: "top"
    }), index === allOptions.length - 1 ? "  " : ", ");
  }), _$1.size(selectedOptions) > 1 && content.remainingCount > 0 && /*#__PURE__*/React.createElement("span", {
    className: styles$j.count
  }, "+", content.remainingCount));
};
function getLabelStyles$2(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var activeStyles = _$1.get(defaultProperties, "" + active, {});
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  var fieldSpacing = _$1.get(deviceProperties, 'styles.layout.fieldSpacing') || 0;
  styles['paddingBottom'] = fieldSpacing + "px";
  var labelPadding = _$1.get(deviceProperties, 'styles.layout.labelPadding') || 0;
  if (alignment === 'left') {
    styles['paddingLeft'] = labelPadding + "px";
  } else if (alignment === 'right') {
    styles['paddingRight'] = labelPadding + "px";
  }
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.label');
  var fontStyles = getFontStyle$2(inputStyles);
  styles = _extends({}, styles, fontStyles);
  return styles;
}
function getInputStyles$2(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var inputPadding = _$1.get(deviceProperties, 'styles.layout.inputPadding') || 0;
  styles['padding'] = "0px " + inputPadding + "px";
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.input');
  var fontStyles = getFontStyle$2(inputStyles);
  styles = _extends({}, styles, fontStyles);
  var border = _$1.get(defaultProperties, 'styles.regular.border');
  var borderStyles = getBorderStyles$6(border);
  styles = _extends({}, styles, borderStyles);
  return styles;
}
function getDropDownMenuStyles(properties, breakpoint) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var listLayoutStyles = _$1.get(deviceProperties, 'styles.layout');
  var verticalPadding = _$1.get(listLayoutStyles, 'verticalPadding') || 4;
  var horizontalPadding = _$1.get(listLayoutStyles, 'horizontalPadding') || 4;
  var spaceBetweenItems = _$1.get(listLayoutStyles, 'spaceBetweenItems') || 2;
  styles = _extends({}, styles, {
    display: 'grid',
    gridGap: spaceBetweenItems + "px",
    padding: verticalPadding + "px " + horizontalPadding + "px"
  });
  var border = _$1.get(defaultProperties, 'styles.openProperty.border');
  var borderStyles = getBorderStyles$6(border);
  styles = _extends({}, styles, borderStyles);
  var backgroundColorRgb = _$1.get(defaultProperties, 'styles.openProperty.background', null);
  if (backgroundColorRgb) {
    styles = _extends({}, styles, {
      background: getColorsConfig(backgroundColorRgb)
    });
  }
  var colorRgb = _$1.get(defaultProperties, 'styles.openProperty.text', null);
  var color = getColorStyles$5(colorRgb);
  styles = _extends({}, styles, color);
  return styles;
}
function getPlaceholderColor$2(properties) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.input');
  var colorRgb = _$1.get(inputStyles, 'placeholderColor', null);
  if (!colorRgb) {
    return null;
  }
  return {
    color: getColorsConfig(colorRgb)
  };
}
function getColorStyles$5(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }
  var styles = {
    color: color
  };
  return styles;
}
function getBorderStyles$6(border) {
  var styles = {};
  if (!border) {
    return styles;
  }
  var topLeft = _$1.get(border, 'radius.topLeft', null);
  var topRight = _$1.get(border, 'radius.topRight', null);
  var bottomLeft = _$1.get(border, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(border, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var borderStyle = _$1.get(border, 'style') || 'bottom';
  if (borderStyle !== 'none') {
    var borderWidthString = _$1.get(border, 'width') || 0;
    var borderWidget = parseInt(borderWidthString) + 'px';
    var fieldName = borderStyle == 'all' ? 'borderWidth' : 'borderBottomWidth';
    styles[fieldName] = borderWidget;
    var colorRgb = _$1.get(border, 'color');
    var color = 'transparent';
    if (colorRgb) {
      color = getColorsConfig(colorRgb);
    }
    styles['borderColor'] = color;
  }
  return styles;
}
function getFontStyle$2(fontStyles) {
  var styles = {};
  if (!fontStyles) {
    return styles;
  }
  var backgroundColorRgb = _$1.get(fontStyles, 'background', null);
  if (backgroundColorRgb) {
    styles = _extends({}, styles, {
      background: getColorsConfig(backgroundColorRgb)
    });
  }
  var colorRgb = _$1.get(fontStyles, 'color', null);
  var color = getColorStyles$5(colorRgb);
  styles = _extends({}, styles, color);
  var fontFamily = _$1.get(fontStyles, 'font.fontFamily', 'inherit');
  styles = _extends({}, styles, {
    fontFamily: fontFamily
  });
  var fontSizeString = _$1.get(fontStyles, "font.fontSize") || 14;
  if (fontSizeString) {
    var fontSize = parseInt(fontSizeString) + 'px';
    styles['fontSize'] = fontSize;
  }
  return styles;
}

var styles$k = {"inputField":"_3Mvuw","error":"_PfeuS","active":"_3S6Zl","checkBoxField":"_1D-oQ","singleColumn":"_-4H-E","listItem":"_3tbSF","multiColumn":"_24uoh","checkbox":"_37Iqz","radioBtn":"_1ASU7"};

var FomrCheckBoxListWidget = function TextInputEditor(_ref) {
  var _cx, _cx3;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var context = React.useContext(FormWidgetContext);
  var _useState = useState([]),
    checkedItems = _useState[0],
    setCheckedItems = _useState[1];
  var _useState2 = useState(''),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var id = _$1.get(widgetProps, 'uid');
  var formId = _$1.get(widgetProps, 'parent');
  var properties = _$1.get(widgetProps, 'properties', {});
  var label = _$1.get(widgetProps, 'properties.desktop.label') || '';
  var multiColumn = _$1.get(widgetProps, 'properties.desktop.multiColumn') || false;
  var multiSelect = _$1.get(widgetProps, "properties.desktop.multiSelect") || false;
  var field = _$1.get(widgetProps, 'properties.desktop.field') || '';
  var fieldId = _$1.get(widgetProps, 'content.id') || "";
  var listOptions = _$1.get(widgetProps, 'content.options', []);
  var error = _$1.get(context.errors, id) || '';
  useEffect(function () {
    setErrors('');
    var values = checkedItems.map(function (item) {
      return item.id;
    });
    context.updateField(id, field, fieldId, values);
  }, [checkedItems]);
  var handleInputChange = function handleInputChange(selectedOption) {
    setCheckedItems(function (prevState) {
      if (multiSelect) {
        var alreadyExist = prevState.some(function (item) {
          return item.id === selectedOption.id;
        });
        if (alreadyExist) {
          return prevState.filter(function (item) {
            return item.id !== selectedOption.id;
          });
        } else {
          return _$1.uniqBy([].concat(prevState, [selectedOption]), 'id');
        }
      } else {
        return [selectedOption];
      }
    });
  };
  useEffect(function () {
    setErrors(error);
  }, [error]);
  Fonts$1.useFont(_$1.get(widgetProps, 'fonts') || []);
  var widgetStyles = _extends({}, style, getFieldStyles$2(properties, breakpoint, 'regular'));
  var labelStyles = getLabelStyles$3(properties, breakpoint, 'regular');
  var containerStyles = getContainerStyles(properties, breakpoint);
  var inputStyles = getInputStyles$3(properties, breakpoint);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$k.checkBoxField),
    style: widgetStyles,
    "data-widget-id": id
  }, label && /*#__PURE__*/React.createElement("label", {
    style: labelStyles
  }, label), /*#__PURE__*/React.createElement("div", {
    style: containerStyles,
    className: cx(styles$k.container, (_cx = {}, _cx[styles$k.singleColumn] = !multiColumn, _cx[styles$k.multiColumn] = multiColumn, _cx))
  }, _$1.map(listOptions, function (option, index) {
    var _cx2;
    var isChecked = _$1.some(checkedItems, {
      id: option.id
    });
    return /*#__PURE__*/React.createElement(Form.Group, {
      key: "check_wrapper_" + index,
      id: formId + "_" + option.id,
      className: styles$k.listItem,
      controlId: option.id,
      style: inputStyles
    }, /*#__PURE__*/React.createElement(Form.Check, {
      id: formId + "_" + option.id,
      className: cx((_cx2 = {}, _cx2[styles$k.checkbox] = multiSelect, _cx2[styles$k.radioBtn] = !multiSelect, _cx2)),
      type: multiSelect ? 'checkbox' : 'radio',
      label: option.value,
      checked: isChecked,
      onChange: function onChange() {
        return handleInputChange(option);
      }
    }));
  })), /*#__PURE__*/React.createElement("span", {
    className: cx(styles$k.error, (_cx3 = {}, _cx3[styles$k.active] = errors, _cx3))
  }, errors));
};
function getFieldStyles$2(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var activeStyles = _$1.get(defaultProperties, "" + active, {});
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  styles['alignItems'] = alignment;
  if (alignment === 'left') {
    styles['alignItems'] = 'flex-start';
  } else if (alignment === 'right') {
    styles['alignItems'] = 'flex-end';
  }
  return styles;
}
function getLabelStyles$3(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var activeStyles = _$1.get(defaultProperties, "" + active, {});
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  var fieldSpacing = _$1.get(deviceProperties, 'styles.layout.fieldSpacing') || 0;
  styles['paddingBottom'] = fieldSpacing + "px";
  var labelPadding = _$1.get(deviceProperties, 'styles.layout.labelPadding') || 0;
  if (alignment === 'left') {
    styles['paddingLeft'] = labelPadding + "px";
  } else if (alignment === 'right') {
    styles['paddingRight'] = labelPadding + "px";
  }
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.label');
  var fontStyles = getFontStyle$3(inputStyles);
  styles = _extends({}, styles, fontStyles);
  return styles;
}
function getContainerStyles(properties, breakpoint) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var spaceBetweenItems = _$1.get(deviceProperties, 'styles.layout.spaceBetweenItems') || 0;
  styles['rowGap'] = spaceBetweenItems + "px";
  var inputPadding = _$1.get(deviceProperties, 'styles.layout.inputPadding') || 0;
  styles['paddingLeft'] = inputPadding + "px";
  return styles;
}
function getInputStyles$3(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  var inputPadding = _$1.get(deviceProperties, 'styles.layout.inputPadding') || 0;
  if (alignment === 'left') {
    styles['paddingLeft'] = inputPadding + "px";
  } else if (alignment === 'right') {
    styles['paddingRight'] = inputPadding + "px";
  }
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.input');
  var fontStyles = getFontStyle$3(inputStyles);
  styles = _extends({}, styles, fontStyles);
  var border = _$1.get(defaultProperties, 'styles.regular.border');
  var borderStyles = getBorderStyles$7(border);
  styles = _extends({}, styles, borderStyles);
  return styles;
}
function getColorStyles$6(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }
  var styles = {
    color: color
  };
  return styles;
}
function getBorderStyles$7(border) {
  var styles = {};
  if (!border) {
    return styles;
  }
  var topLeft = _$1.get(border, 'radius.topLeft', null);
  var topRight = _$1.get(border, 'radius.topRight', null);
  var bottomLeft = _$1.get(border, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(border, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var borderStyle = _$1.get(border, 'style') || 'bottom';
  if (borderStyle !== 'none') {
    var borderWidthString = _$1.get(border, 'width') || 0;
    var borderWidget = parseInt(borderWidthString) + 'px';
    var fieldName = borderStyle == 'all' ? 'borderWidth' : 'borderBottomWidth';
    styles[fieldName] = borderWidget;
    var colorRgb = _$1.get(border, 'color');
    var color = 'transparent';
    if (colorRgb) {
      color = getColorsConfig(colorRgb);
    }
    styles['borderColor'] = color;
  }
  return styles;
}
function getFontStyle$3(fontStyles) {
  var styles = {};
  if (!fontStyles) {
    return styles;
  }
  var colorRgb = _$1.get(fontStyles, 'color', null);
  var color = getColorStyles$6(colorRgb);
  styles = _extends({}, styles, color);
  var fontFamily = _$1.get(fontStyles, 'font.fontFamily', 'inherit');
  styles = _extends({}, styles, {
    fontFamily: fontFamily
  });
  var fontSizeString = _$1.get(fontStyles, "font.fontSize") || 14;
  if (fontSizeString) {
    var fontSize = parseInt(fontSizeString) + 'px';
    styles['fontSize'] = fontSize;
  }
  return styles;
}

var styles$l = {"error":"_1E65X","active":"_1gQU3","checkBoxItem":"_2PKZZ"};

var FormCheckBox = React.memo(function (_ref) {
  var _cx, _cx2;
  var className = _ref.className,
    widgetProps = _ref.widgetProps,
    style = _ref.style,
    breakpoint = _ref.breakpoint;
  var context = React.useContext(FormWidgetContext);
  var _React$useState = React.useState(false),
    value = _React$useState[0],
    setValue = _React$useState[1];
  var _React$useState2 = React.useState(''),
    errors = _React$useState2[0],
    setErrors = _React$useState2[1];
  var id = _$1.get(widgetProps, 'uid');
  var properties = _$1.get(widgetProps, 'properties', {});
  var instructions = _$1.get(widgetProps, 'content.instructions') || '';
  var initialState = _$1.get(widgetProps, 'content.initialState') || false;
  var field = _$1.get(widgetProps, 'properties.desktop.field') || '';
  var fieldId = _$1.get(widgetProps, 'content.id') || "";
  var error = _$1.get(context.errors, id);
  useEffect(function () {
    setErrors('');
    context.updateField(id, field, fieldId, value);
  }, [value]);
  var handleChange = function handleChange(value) {
    setValue(value);
  };
  useEffect(function () {
    setValue(initialState);
  }, [initialState]);
  useEffect(function () {
    setErrors(error);
  }, [error]);
  Fonts$1.useFont(_$1.get(widgetProps, 'fonts') || []);
  var checkBoxStyles = getCheckBoxStyles(properties);
  var instuctionStyles = getInstuctionStyles(properties, breakpoint);
  return /*#__PURE__*/React.createElement("div", {
    id: "checkbox-wrapper-" + id,
    className: cx(className, styles$l.inputField),
    style: style,
    "data-widget-id": "checkbox-wrapper-" + id
  }, /*#__PURE__*/React.createElement("style", null, "\n          #checkbox-input-" + id + ":checked[type=checkbox] {\n            background-color: " + _$1.get(checkBoxStyles, 'color') + ";\n            box-shadow: 'none';\n            border-color: " + _$1.get(checkBoxStyles, 'color') + ";\n          }\n        "), /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    id: "checkbox-" + id + "}",
    className: styles$l.checkBoxItem
  }, /*#__PURE__*/React.createElement(Form.Check.Input, {
    style: checkBoxStyles,
    id: "checkbox-input-" + id,
    type: "checkbox",
    checked: value,
    value: value,
    onMouseDown: function onMouseDown(e) {
      return handleChange(!e.target.checked);
    }
  }), /*#__PURE__*/React.createElement(Form.Check.Label, {
    style: instuctionStyles
  }, instructions), errors && /*#__PURE__*/React.createElement(Form.Control.Feedback, {
    className: cx(styles$l.error, (_cx = {}, _cx[styles$l.active] = errors, _cx)),
    type: "invalid"
  }, errors)), /*#__PURE__*/React.createElement("span", {
    className: cx(styles$l.error, (_cx2 = {}, _cx2[styles$l.active] = errors, _cx2))
  }, errors));
});
function getCheckBoxStyles(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.input');
  var colorRgb = _$1.get(inputStyles, 'color', null);
  var color = getColorStyles$7(colorRgb);
  styles = _extends({}, styles, color, {
    borderColor: color
  });
  return styles;
}
function getInstuctionStyles(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var inputPadding = _$1.get(deviceProperties, 'styles.layout.inputPadding') || 0;
  styles['paddingLeft'] = inputPadding + "px";
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.input');
  var fontStyles = getFontStyle$4(inputStyles);
  styles = _extends({}, styles, fontStyles, {
    color: getPlaceholderColor$3(properties)
  });
  return styles;
}
function getPlaceholderColor$3(properties) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.input');
  var colorRgb = _$1.get(inputStyles, 'placeholderColor', null);
  if (!colorRgb) {
    return null;
  }
  return getColorsConfig(colorRgb);
}
function getColorStyles$7(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }
  var styles = {
    color: color
  };
  return styles;
}
function getFontStyle$4(fontStyles) {
  var styles = {};
  if (!fontStyles) {
    return styles;
  }
  var colorRgb = _$1.get(fontStyles, 'color', null);
  var color = getColorStyles$7(colorRgb);
  styles = _extends({}, styles, color);
  var fontFamily = _$1.get(fontStyles, 'font.fontFamily', 'inherit');
  styles = _extends({}, styles, {
    fontFamily: fontFamily
  });
  var fontSizeString = _$1.get(fontStyles, "font.fontSize") || 14;
  if (fontSizeString) {
    var fontSize = parseInt(fontSizeString) + 'px';
    styles['fontSize'] = fontSize;
  }
  return styles;
}
var FormCheckBoxField = FormCheckBox;

var styles$m = {"inputField":"_39HZk","error":"_2ZeXL","active":"_1Ta4-"};

var FormNumberWidget = function TextInputEditor(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var context = React.useContext(FormWidgetContext);
  var _React$useState = React.useState(''),
    value = _React$useState[0],
    setValue = _React$useState[1];
  var _React$useState2 = React.useState(''),
    errors = _React$useState2[0],
    setErrors = _React$useState2[1];
  var id = _$1.get(widgetProps, 'uid');
  var properties = _$1.get(widgetProps, 'properties', {});
  var label = _$1.get(widgetProps, 'properties.desktop.label') || "";
  var placeholder = _$1.get(widgetProps, 'properties.desktop.placeholder') || "";
  var placeholderColor = getPlaceholderColor$4(properties);
  var field = _$1.get(widgetProps, 'properties.desktop.field') || "";
  var fieldId = _$1.get(widgetProps, 'content.id') || "";
  var error = _$1.get(context.errors, id);
  useEffect(function () {
    setErrors('');
    context.updateField(id, field, fieldId, value);
  }, [value]);
  Fonts$1.useFont(_$1.get(widgetProps, 'fonts') || []);
  var widgetStyles = _extends({}, style, getFieldStyles$3(properties, breakpoint, 'regular'));
  var labelStyles = getLabelStyles$4(properties, breakpoint, 'regular');
  var inputStyles = getInputStyles$4(properties, breakpoint);
  var handleInputChange = function handleInputChange(e) {
    var value = e.target.value;
    if (_$1.size(value) > 16) {
      setErrors('Maximum limit of 16 digits');
      return;
    }
    if (isNaN(value) && value.trim() !== '') {
      setErrors('Please enter only numbers');
      return;
    }
    setValue(value);
  };
  useEffect(function () {
    setErrors(error);
  }, [error]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$m.inputField),
    style: widgetStyles,
    "data-widget-id": id
  }, placeholderColor && /*#__PURE__*/React.createElement("style", null, "\n            #" + id + " input::-webkit-input-placeholder {\n              color: " + placeholderColor + ";\n            }\n          "), label && /*#__PURE__*/React.createElement("label", {
    style: labelStyles
  }, label), /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: placeholder,
    style: inputStyles,
    value: value,
    onChange: function onChange(e) {
      return handleInputChange(e);
    },
    disabled: false
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(styles$m.error, (_cx = {}, _cx[styles$m.active] = errors, _cx))
  }, errors));
};
function getFieldStyles$3(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var activeStyles = _$1.get(defaultProperties, "" + active, {});
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  styles['alignItems'] = alignment;
  if (alignment === 'left') {
    styles['alignItems'] = 'flex-start';
  } else if (alignment === 'right') {
    styles['alignItems'] = 'flex-end';
  }
  return styles;
}
function getLabelStyles$4(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var activeStyles = _$1.get(defaultProperties, "" + active, {});
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  var fieldSpacing = _$1.get(deviceProperties, 'styles.layout.fieldSpacing') || 0;
  styles['paddingBottom'] = fieldSpacing + "px";
  var labelPadding = _$1.get(deviceProperties, 'styles.layout.labelPadding') || 0;
  if (alignment === 'left') {
    styles['paddingLeft'] = labelPadding + "px";
  } else if (alignment === 'right') {
    styles['paddingRight'] = labelPadding + "px";
  }
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.label');
  var fontStyles = getFontStyle$5(inputStyles);
  styles = _extends({}, styles, fontStyles);
  return styles;
}
function getInputStyles$4(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  var inputPadding = _$1.get(deviceProperties, 'styles.layout.inputPadding') || 0;
  if (alignment === 'left') {
    styles['paddingLeft'] = inputPadding + "px";
  } else if (alignment === 'right') {
    styles['paddingRight'] = inputPadding + "px";
  }
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.input');
  var fontStyles = getFontStyle$5(inputStyles);
  styles = _extends({}, styles, fontStyles);
  var border = _$1.get(defaultProperties, 'styles.regular.border');
  var borderStyles = getBorderStyles$8(border);
  styles = _extends({}, styles, borderStyles);
  return styles;
}
function getPlaceholderColor$4(properties) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.input');
  var colorRgb = _$1.get(inputStyles, 'placeholderColor', null);
  if (!colorRgb) {
    return null;
  }
  return getColorsConfig(colorRgb);
}
function getColorStyles$8(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }
  var styles = {
    color: color
  };
  return styles;
}
function getBorderStyles$8(border) {
  var styles = {};
  if (!border) {
    return styles;
  }
  var topLeft = _$1.get(border, 'radius.topLeft', null);
  var topRight = _$1.get(border, 'radius.topRight', null);
  var bottomLeft = _$1.get(border, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(border, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var borderStyle = _$1.get(border, 'style') || 'bottom';
  if (borderStyle !== 'none') {
    var borderWidthString = _$1.get(border, 'width') || 0;
    var borderWidget = parseInt(borderWidthString) + 'px';
    var fieldName = borderStyle == 'all' ? 'borderWidth' : 'borderBottomWidth';
    styles[fieldName] = borderWidget;
    var colorRgb = _$1.get(border, 'color');
    var color = 'transparent';
    if (colorRgb) {
      color = getColorsConfig(colorRgb);
    }
    styles['borderColor'] = color;
  }
  return styles;
}
function getFontStyle$5(fontStyles) {
  var styles = {};
  if (!fontStyles) {
    return styles;
  }
  var backgroundColorRgb = _$1.get(fontStyles, 'background', null);
  if (backgroundColorRgb) {
    styles = _extends({}, styles, {
      background: getColorsConfig(backgroundColorRgb)
    });
  }
  var colorRgb = _$1.get(fontStyles, 'color', null);
  var color = getColorStyles$8(colorRgb);
  styles = _extends({}, styles, color);
  var fontFamily = _$1.get(fontStyles, 'font.fontFamily', 'inherit');
  styles = _extends({}, styles, {
    fontFamily: fontFamily
  });
  var fontSizeString = _$1.get(fontStyles, "font.fontSize") || 14;
  if (fontSizeString) {
    var fontSize = parseInt(fontSizeString) + 'px';
    styles['fontSize'] = fontSize;
  }
  return styles;
}

var styles$n = {"inputField":"_t0Fwl","error":"_2tjQW","active":"_3EYBt"};

var FormTextAreaWidget = function TextAreaInputEditor(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var context = React.useContext(FormWidgetContext);
  var _React$useState = React.useState(''),
    value = _React$useState[0],
    setValue = _React$useState[1];
  var _React$useState2 = React.useState(''),
    errors = _React$useState2[0],
    setErrors = _React$useState2[1];
  var id = _$1.get(widgetProps, 'uid');
  var properties = _$1.get(widgetProps, 'properties', {});
  var label = _$1.get(widgetProps, 'properties.desktop.label') || "";
  var placeholder = _$1.get(widgetProps, 'properties.desktop.placeholder') || "";
  var placeholderColor = getPlaceholderColor$5(properties);
  var field = _$1.get(widgetProps, 'properties.desktop.field') || "";
  var fieldId = _$1.get(widgetProps, 'content.id') || "";
  var error = _$1.get(context.errors, id);
  useEffect(function () {
    setErrors('');
    context.updateField(id, field, fieldId, value);
  }, [value]);
  Fonts$1.useFont(_$1.get(widgetProps, 'fonts') || []);
  var widgetStyles = _extends({}, style, getFieldStyles$4(properties, breakpoint, 'regular'));
  var labelStyles = getLabelStyles$5(properties, breakpoint, 'regular');
  var inputStyles = getInputStyles$5(properties, breakpoint);
  var handleInputChange = function handleInputChange(e) {
    var value = e.target.value;
    if (_$1.size(value) > 1000) {
      setErrors('Maximum limit of 1000 characters');
      return;
    }
    setValue(value);
  };
  useEffect(function () {
    setErrors(error);
  }, [error]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$n.inputField),
    style: widgetStyles,
    "data-widget-id": id
  }, placeholderColor && /*#__PURE__*/React.createElement("style", null, "\n            #" + id + " textarea::-webkit-input-placeholder {\n              color: " + placeholderColor + ";\n            }\n          "), label && /*#__PURE__*/React.createElement("label", {
    style: labelStyles
  }, label), /*#__PURE__*/React.createElement("textarea", {
    id: "textarea_" + id,
    rows: "4",
    style: inputStyles,
    cols: "50",
    onChange: function onChange(e) {
      return handleInputChange(e);
    },
    value: value,
    placeholder: placeholder
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(styles$n.error, (_cx = {}, _cx[styles$n.active] = errors, _cx))
  }, errors));
};
function getFieldStyles$4(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var activeStyles = _$1.get(defaultProperties, "" + active, {});
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  styles['alignItems'] = alignment;
  if (alignment === 'left') {
    styles['alignItems'] = 'flex-start';
  } else if (alignment === 'right') {
    styles['alignItems'] = 'flex-end';
  }
  return styles;
}
function getLabelStyles$5(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var activeStyles = _$1.get(defaultProperties, "" + active, {});
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  var fieldSpacing = _$1.get(deviceProperties, 'styles.layout.fieldSpacing') || 0;
  styles['paddingBottom'] = fieldSpacing + "px";
  var labelPadding = _$1.get(deviceProperties, 'styles.layout.labelPadding') || 0;
  if (alignment === 'left') {
    styles['paddingLeft'] = labelPadding + "px";
  } else if (alignment === 'right') {
    styles['paddingRight'] = labelPadding + "px";
  }
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.label');
  var fontStyles = getFontStyle$6(inputStyles);
  styles = _extends({}, styles, fontStyles);
  return styles;
}
function getInputStyles$5(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var alignment = _$1.get(deviceProperties, 'styles.layout.alignment') || 'left';
  var inputPadding = _$1.get(deviceProperties, 'styles.layout.inputPadding') || 0;
  if (alignment === 'left') {
    styles['paddingLeft'] = inputPadding + "px";
  } else if (alignment === 'right') {
    styles['paddingRight'] = inputPadding + "px";
  }
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.input');
  var fontStyles = getFontStyle$6(inputStyles);
  styles = _extends({}, styles, fontStyles);
  var border = _$1.get(defaultProperties, 'styles.regular.border');
  var borderStyles = getBorderStyles$9(border);
  styles = _extends({}, styles, borderStyles);
  return styles;
}
function getPlaceholderColor$5(properties) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var inputStyles = _$1.get(defaultProperties, 'styles.regular.input');
  var colorRgb = _$1.get(inputStyles, 'placeholderColor', null);
  if (!colorRgb) {
    return null;
  }
  return getColorsConfig(colorRgb);
}
function getColorStyles$9(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }
  var styles = {
    color: color
  };
  return styles;
}
function getBorderStyles$9(border) {
  var styles = {};
  if (!border) {
    return styles;
  }
  var topLeft = _$1.get(border, 'radius.topLeft', null);
  var topRight = _$1.get(border, 'radius.topRight', null);
  var bottomLeft = _$1.get(border, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(border, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var borderStyle = _$1.get(border, 'style') || 'bottom';
  if (borderStyle !== 'none') {
    var borderWidthString = _$1.get(border, 'width') || 0;
    var borderWidget = parseInt(borderWidthString) + 'px';
    var fieldName = borderStyle == 'all' ? 'borderWidth' : 'borderBottomWidth';
    styles[fieldName] = borderWidget;
    var colorRgb = _$1.get(border, 'color');
    var color = 'transparent';
    if (colorRgb) {
      color = getColorsConfig(colorRgb);
    }
    styles['borderColor'] = color;
  }
  return styles;
}
function getFontStyle$6(fontStyles) {
  var styles = {};
  if (!fontStyles) {
    return styles;
  }
  var backgroundColorRgb = _$1.get(fontStyles, 'background', null);
  if (backgroundColorRgb) {
    styles = _extends({}, styles, {
      background: getColorsConfig(backgroundColorRgb)
    });
  }
  var colorRgb = _$1.get(fontStyles, 'color', null);
  var color = getColorStyles$9(colorRgb);
  styles = _extends({}, styles, color);
  var fontFamily = _$1.get(fontStyles, 'font.fontFamily', 'inherit');
  styles = _extends({}, styles, {
    fontFamily: fontFamily
  });
  var fontSizeString = _$1.get(fontStyles, "font.fontSize") || 14;
  if (fontSizeString) {
    var fontSize = parseInt(fontSizeString) + 'px';
    styles['fontSize'] = fontSize;
  }
  return styles;
}

var SubmitButtonWidgetComponent = function SubmitButtonWidgetComponent(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var context = React.useContext(FormWidgetContext);
  var handleClick = function handleClick() {
    if (context.onFormSubmit) {
      context.onFormSubmit();
      return;
    }
  };
  return /*#__PURE__*/React.createElement(ButtonWidget, {
    widgetProps: widgetProps,
    className: cx(className, styles$f.submitButton, (_cx = {}, _cx[styles$f.disabled] = context.submitting, _cx)),
    key: widgetProps.uid,
    breakpoint: breakpoint,
    style: style,
    onClick: handleClick
  });
};
var buttonWidgetEquals$1 = function buttonWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'onClick'];
  var next = _.pick(nextProps, paths);
  var previous = _.pick(prevProps, paths);
  var equals = _.isEqual(next, previous);
  return equals;
};
var SubmitButtonWidget = React.memo(SubmitButtonWidgetComponent, buttonWidgetEquals$1);

var OtpSubmitButtonWidgetComponent = function OtpSubmitButtonWidgetComponent(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var context = React.useContext(FormWidgetContext);
  var handleClick = function handleClick() {
    if (context.onOtpFormSubmit) {
      context.onOtpFormSubmit();
      return;
    }
  };
  return /*#__PURE__*/React.createElement(ButtonWidget, {
    widgetProps: widgetProps,
    className: cx(className, styles$f.submitButton, (_cx = {}, _cx[styles$f.disabled] = context.submitting, _cx)),
    key: widgetProps.uid,
    breakpoint: breakpoint,
    style: style,
    onClick: handleClick
  });
};
var buttonWidgetEquals$2 = function buttonWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'onClick'];
  var next = _.pick(nextProps, paths);
  var previous = _.pick(prevProps, paths);
  var equals = _.isEqual(next, previous);
  return equals;
};
var OtpSubmitButtonWidget = React.memo(OtpSubmitButtonWidgetComponent, buttonWidgetEquals$2);

var OtpResendButtonWidgetComponent = function OtpResendButtonWidgetComponent(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var context = React.useContext(FormWidgetContext);
  var handleClick = function handleClick() {
    if (context.onOtpResend) {
      context.onOtpResend();
      return;
    }
  };
  return /*#__PURE__*/React.createElement(ButtonWidget, {
    widgetProps: widgetProps,
    className: cx(className, styles$f.submitButton, (_cx = {}, _cx[style.disabled] = context.submitting, _cx)),
    key: widgetProps.uid,
    breakpoint: breakpoint,
    style: style,
    onClick: handleClick
  });
};
var buttonWidgetEquals$3 = function buttonWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'onClick'];
  var next = _.pick(nextProps, paths);
  var previous = _.pick(prevProps, paths);
  var equals = _.isEqual(next, previous);
  return equals;
};
var OtpResendButtonWidget = React.memo(OtpResendButtonWidgetComponent, buttonWidgetEquals$3);

var styles$o = {"anchorWidget":"_18B5L"};

var AnchorWidget = React.memo(function AnchorWidget(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    widgetRef = _ref.widgetRef;
  var ref = widgetRef;
  var id = _$1.get(widgetProps, 'uid');
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    ref: ref,
    className: cx(className, styles$o.anchorWidget),
    style: style,
    "data-widget-id": id
  });
});

function BrandThemeManager(_ref) {
  var className = _ref.className,
    themes = _ref.themes;
  if (_$1.size(themes) === 0) {
    return false;
  }
  return /*#__PURE__*/React.createElement(Helmet, null, themes.map(function (theme, index) {
    var format = _$1.get(theme, 'type');
    var fontSize = _$1.get(theme, 'font.fontSize');
    var fontFamily = _$1.get(theme, 'font.fontFamily');
    var color = _$1.get(theme, 'font.color');
    return /*#__PURE__*/React.createElement("style", {
      key: format
    }, className + " " + format + " {\n                font-size: " + fontSize + "px;\n                font-family: " + fontFamily + ";\n                color: " + colorToString(color) + ";\n              }");
  }));
}

var styles$p = {"liveElement":"_32k3K","liveElementContainer":"_1Ictw"};

var LiveElementWidgetComponent = function LiveElementWidgetComponent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  return function (style, _widgetProps$children, _cx) {
    var context = React.useContext(WidgetsContext);
    var hasMenuType = ((_widgetProps$children = widgetProps.children) === null || _widgetProps$children === void 0 ? void 0 : _widgetProps$children.some(function (child) {
      var _child$properties$bre;
      return child.type === 'cleverstory.v2.widgets.menu' && ((_child$properties$bre = child.properties[breakpoint]) === null || _child$properties$bre === void 0 ? void 0 : _child$properties$bre.stretched) === true;
    })) || false;
    var id = _$1.get(widgetProps, 'uid');
    var _React$useState = React.useState(_extends({}, context, context.createLiveElementContext(widgetProps))),
      widgetContextState = _React$useState[0],
      setWidgetContextState = _React$useState[1];
    var style = _extends({}, style, hasMenuType && {
      width: "calc(100% + 0px)",
      marginLeft: 0
    });
    useMemo(function () {
      var paths = ['breakpoint', 'imageCDN', 'storyboard'];
      var next = _$1.pick(context, paths);
      var previous = _$1.pick(widgetContextState, paths);
      var equals = _$1.isEqual(next, previous);
      if (!equals) {
        setWidgetContextState(function (state) {
          return _extends({}, state, next);
        });
      }
    }, [context]);
    var widgetChildren = (widgetProps.children || []).filter(function (item) {
      return item.type === LIVE_ELEMENT_CONTAINER;
    });
    return /*#__PURE__*/React.createElement("div", {
      id: id,
      className: cx(className, styles$p.liveElement, 'cs_live_element', (_cx = {}, _cx[styles$p.mobile] = breakpoint === 'mobile', _cx)),
      "data-widget-id": id,
      "data-container": true,
      "data-selectable": true,
      style: style
    }, /*#__PURE__*/React.createElement(BrandThemeManager, {
      className: "#" + id + " .cs_text_widget",
      themes: widgetProps.themes
    }), /*#__PURE__*/React.createElement(WidgetsContext.Provider, {
      value: widgetContextState
    }, widgetChildren.map(function (item) {
      return /*#__PURE__*/React.createElement(Widget, {
        key: item.uid,
        widgetProps: item,
        breakpoint: breakpoint
      });
    })));
  }(style);
};
var liveElementWidgetEquals = function liveElementWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var LiveElementWidget = React.memo(LiveElementWidgetComponent, liveElementWidgetEquals);

var LiveElementContainerWidgetComponent = function LiveElementContainerWidgetComponent(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children;
  var hasMenuType = (children === null || children === void 0 ? void 0 : children.some(function (child) {
    var _child$props$widgetPr;
    return child.props.widgetProps.type === 'cleverstory.v2.widgets.menu' && ((_child$props$widgetPr = child.props.widgetProps.properties[breakpoint]) === null || _child$props$widgetPr === void 0 ? void 0 : _child$props$widgetPr.stretched) === true;
  })) || false;
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var widgetStyle = _extends({}, style, hasMenuType && {
    width: "calc(100% + 0px)"
  });
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$p.liveElementContainer, 'cs_live_element_container', (_cx = {}, _cx[styles$p.mobile] = breakpoint === 'mobile', _cx)),
    "data-widget-id": id,
    "data-widget-type": type,
    "data-container": true,
    "data-selectable": true,
    style: widgetStyle
  }, children);
};
var liveElementContainerEquals = function liveElementContainerEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var LiveElementContainerWidget = React.memo(LiveElementContainerWidgetComponent, liveElementContainerEquals);

var styles$q = {"section":"_18ZAP","mobile":"_3B0qv","stretched":"_psdhr"};

var _excluded$3 = ["className", "style", "widgetProps", "breakpoint", "children"];
var SectionWidgetComponent = function SectionWidgetComponent(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  var context = React.useContext(WidgetsContext);
  var storyboardType = _$1.get(context, 'storyboard.type');
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var stretched = _$1.get(widgetProps, 'properties.desktop.stretched', false) && storyboardType !== 'INTERACTIVE_CONTENT';
  var background = _$1.get(widgetProps, 'properties.desktop.background');
  var columns = _$1.size(children);
  var columnSpacing = _$1.get(widgetProps, "properties." + breakpoint + ".columnSpacing", 0);
  var adjustedColumnSpacing = columnSpacing * ((columns - 1) / columns);
  var widgetStyle = _extends({}, style, getStyles$6(widgetProps, breakpoint));
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$q.section, 'cs_section', (_cx = {}, _cx[styles$q.stretched] = stretched, _cx[styles$q.mobile] = breakpoint === 'mobile', _cx)),
    style: widgetStyle,
    "data-widget-id": id,
    "data-widget-type": type
  }, /*#__PURE__*/React.createElement(BackgroundView, {
    background: background,
    breakpoint: breakpoint
  }), React.Children.map(children, function (child) {
    return React.cloneElement(child, {
      columnGap: adjustedColumnSpacing
    }, null);
  }));
};
function getStyles$6(widgetProps, breakpoint) {
  var stretched = _$1.get(widgetProps, 'properties.desktop.stretched', false);
  var margin = _$1.get(widgetProps, 'properties.desktop.margin', 0);
  var padding = _$1.get(widgetProps, "properties." + breakpoint + ".padding", 0);
  var columnSpacing = _$1.get(widgetProps, "properties." + breakpoint + ".columnSpacing", 0);
  var widgetStyles = {
    paddingTop: padding + "px",
    paddingBottom: padding + "px"
  };
  if (breakpoint === 'desktop') {
    widgetStyles = _extends({}, widgetStyles, {
      width: "1200px",
      columnGap: columnSpacing + "px",
      paddingLeft: padding + "px",
      paddingRight: padding + "px"
    });
    if (stretched) {
      widgetStyles = _extends({}, widgetStyles, {
        marginLeft: margin,
        width: "calc(100% - 2 * " + margin + "px)",
        left: "calc((100% - 2 * " + margin + "px))/2)"
      });
    }
  }
  if (breakpoint === 'mobile') {
    widgetStyles = _extends({}, widgetStyles, {
      rowGap: columnSpacing + "px"
    });
  }
  var shadow = _$1.get(widgetProps, "properties.desktop.shadow", {});
  var shadowStyle = getBoxShadow(shadow);
  widgetStyles = _extends({}, widgetStyles, shadowStyle);
  return widgetStyles;
}
var sectionWidgetEquals = function sectionWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var SectionWidget = React.memo(SectionWidgetComponent, sectionWidgetEquals);

var styles$r = {"column":"_1Kndt","inner":"_GWPMK"};

var SectionColumnWidgetComponent = function SectionColumnWidgetComponent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children,
    columnGap = _ref.columnGap;
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var background = _$1.get(widgetProps, 'properties.desktop.background');
  var layout = _$1.get(widgetProps, 'properties.desktop.layout');
  var visibleWidth = _$1.get(widgetProps, "properties." + breakpoint + ".container.minWidth");
  var widgetStyle = _extends({}, style, {
    transform: 'none'
  }, getStyles$7(widgetProps, breakpoint, columnGap));
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$r.column, 'cs_column'),
    style: widgetStyle,
    "data-widget-id": id,
    "data-widget-type": type
  }, /*#__PURE__*/React.createElement(BackgroundView, {
    background: background,
    breakpoint: breakpoint
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$r.inner
  }, children));
};
function getStyles$7(widget, breakpoint, columnGap) {
  var styles = {};
  if (breakpoint === 'desktop') {
    var width = parseFloat(_$1.get(widget, "properties." + breakpoint + ".layout.width", 100));
    styles = _extends({}, styles, {
      maxWidth: "calc(" + width + "% - " + columnGap + "px)",
      height: '100%'
    });
  }
  return styles;
}
var sectionColumnWidgetEquals = function sectionColumnWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var SectionColumnWidget = React.memo(SectionColumnWidgetComponent, sectionColumnWidgetEquals);

var autoGrowLayout = createAction(AUTO_GROW_LAYOUT_REQUEST, function (editorSession, breakpoint, widget, delta) {
  return {
    editorSession: editorSession,
    breakpoint: breakpoint,
    widget: widget,
    delta: delta
  };
});

var AutoGrowLayout = React.forwardRef(function (_ref, ref) {
  var editorSession = _ref.editorSession,
    breakpoint = _ref.breakpoint,
    widget = _ref.widget,
    children = _ref.children;
  var dispatch = useDispatch();
  var resizeObserverRef = React.useRef(null);
  var snapshotRef = React.useRef(null);
  var context = React.useContext(WidgetsContext);
  var id = _$1.get(widget, 'uid');
  useEffect(function () {
    attachResizeObserver();
    return function () {
      if (resizeObserverRef.current && ref.current) {
        resizeObserverRef.current.unobserve(ref.current);
      }
    };
  }, [breakpoint]);
  var attachResizeObserver = function attachResizeObserver() {
    if (!ref.current || context.development) {
      console.warn("Target not found");
      return;
    }
    resizeObserverRef.current = new ResizeObserver(function (entries) {
      captureSnapshot();
    });
    resizeObserverRef.current.observe(ref.current);
  };
  var captureSnapshot = function captureSnapshot() {
    var _extends2;
    if (!ref.current || context.development) {
      return;
    }
    var height = ref.current.offsetHeight;
    var deviceSnapshot = _$1.get(snapshotRef.current, breakpoint);
    if (deviceSnapshot) {
      var previousHeight = _$1.get(deviceSnapshot, "height", 0);
      var delta = height - previousHeight;
      if (delta == 0) {
        return;
      }
      dispatch(autoGrowLayout(editorSession, breakpoint, id, delta));
    }
    snapshotRef.current = _extends({}, snapshotRef.current || {}, (_extends2 = {}, _extends2[breakpoint] = {
      height: height
    }, _extends2));
  };
  return children;
});

var styles$s = {"grid":"_3q3d8"};

var GridView = function GridView(_ref) {
  var children = _ref.children,
    width = _ref.width,
    rowSpacing = _ref.rowSpacing,
    columnSpacing = _ref.columnSpacing,
    alignment = _ref.alignment,
    className = _ref.className;
  var widgetStyles = {
    rowGap: rowSpacing + "px",
    columnGap: columnSpacing + "px",
    gridTemplateColumns: "repeat(auto-fit, " + width + ")",
    justifyContent: alignment
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles$s.grid, className),
    style: widgetStyles
  }, children);
};

var styles$t = {"content":"_verX_","stretched":"_1O4up","mobile":"_9IiTr","layoutRender":"_tGxXb","pagination":"_3PAA4","filterContainer":"_2iMfi","dimLoader":"_3b926"};

var styles$u = {"filters":"_1cq68","childContainer":"_3Nw25","scrollWrapper":"_1G7yF","sticky":"_3Us0J","slide":"_1eDkT","fade":"_1s7Zj","background_slide":"_1vxms","background_slide_show":"_3EjoK","background_slide_hide":"_25Krx","background_fade":"_Po1qQ","background_fade_show":"_366eb","background_fade_hide":"_1KN3m"};

var _excluded$4 = ["className", "style", "widgetProps", "breakpoint", "children"];
var FilterWidgetComponent = function FilterWidgetComponent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var _useState = useState({
      initiate: false,
      animate: false
    });
  var _useState2 = useState(0);
  var _React$useContext = React.useContext(PageContext),
    _React$useContext$pag = _React$useContext.pageWidth,
    pageWidth = _React$useContext$pag === void 0 ? '100%' : _React$useContext$pag;
  var filterListenerRef = useRef();
  var id = _$1.get(widgetProps, 'uid');
  var parentId = _$1.get(widgetProps, 'parent');
  var parentWidgetProps = useWidgetSelector(parentId);
  var showFilters = _$1.get(parentWidgetProps, 'properties.desktop.filters');
  var showSearch = _$1.get(parentWidgetProps, 'properties.desktop.search');
  var type = _$1.get(widgetProps, 'type');
  var deviceLayout = _$1.get(widgetProps, "properties." + breakpoint + ".layout");
  var background = _$1.get(widgetProps, 'properties.desktop.background');
  var scrollEffect = _$1.get(widgetProps, 'properties.desktop.scrollEffect');
  var alignment = getContainerAlignment(widgetProps, breakpoint);
  var buttonAlignmnet = getDropDownAlignment(widgetProps, breakpoint);
  var parentProps = useWidgetSelector(parentId);
  var stretched = _$1.get(parentProps, "properties.desktop.stretched");
  var widgetChildren = useWidgetChildrenSelector(id);
  var widgetStyle = _extends({}, style, getStyles$8(widgetProps, stretched, breakpoint, pageWidth));
  useEffect(function () {}, [deviceLayout]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$u.filters, {}),
    style: widgetStyle,
    "data-widget-id": id,
    "data-widget-type": type
  }, /*#__PURE__*/React.createElement(BackgroundView, {
    background: background,
    breakpoint: breakpoint
  }), /*#__PURE__*/React.createElement("div", {
    style: alignment,
    className: cx(styles$u.childContainer)
  }, React.Children.map(children, function (child, index) {
    var childType = _$1.get(child, 'props.widgetProps.type');
    if (childType == CONTENT_FILTER_CONTAINER && showFilters) {
      return React.cloneElement(child, {
        key: index,
        parentProps: widgetProps,
        alignment: buttonAlignmnet
      });
    }
    if (childType == CONTENT_SEARCH && showSearch) {
      return React.cloneElement(child, {
        key: index,
        parentProps: widgetProps
      });
    }
  })));
};
function getStyles$8(widgetProps, stretched, breakpoint, pageWidth) {
  var margin = _$1.get(widgetProps, 'properties.desktop.margin', 0);
  var padding = _$1.get(widgetProps, "properties." + breakpoint + ".padding", 0);
  var widgetStyles = {
    paddingTop: padding + "px",
    paddingBottom: padding + "px",
    transformOrigin: 'top',
    marginLeft: "calc((100% - " + pageWidth + "px) * 0.5)"
  };
  if (breakpoint === 'desktop') {
    widgetStyles = _extends({}, widgetStyles, {
      width: "1200px",
      paddingLeft: padding + "px",
      paddingRight: padding + "px"
    });
  }
  if (stretched) {
    widgetStyles = _extends({}, widgetStyles, {
      marginLeft: '0px',
      width: "calc(100% - 2 * " + margin + "px)",
      left: "calc((100% - 2 * " + margin + "px))/2)"
    });
  }
  if (breakpoint === 'mobile') {
    widgetStyles = _extends({}, widgetStyles, {
      width: pageWidth
    });
  }
  return widgetStyles;
}
function getContainerAlignment(widgetProps, breakpoint) {
  var alignment = _$1.get(widgetProps, "properties." + breakpoint + ".alignment", {
    position: 'center',
    margin: 0
  });
  var horizontalColumn = _$1.get(widgetProps, "properties." + breakpoint + ".horizontalColumn", false);
  var columnReverse = _$1.get(widgetProps, "properties." + breakpoint + ".columnReverse", false);
  var spacing = _$1.get(widgetProps, "properties." + breakpoint + ".spacing", 16);
  var verticalAlignment = _$1.get(widgetProps, "properties." + breakpoint + ".verticalAlignment", {
    position: 'center',
    margin: 0
  });
  var position = _$1.get(alignment, 'position', 'center');
  var margin = _$1.get(alignment, 'margin', 0);
  var verticalPosition = _$1.get(verticalAlignment, 'position', 'center');
  var verticalMargin = _$1.get(verticalAlignment, 'margin', 0);
  var containerStyles = {};
  containerStyles['alignItems'] = position;
  if (position === 'left') {
    containerStyles = _extends({}, containerStyles, {
      alignItems: 'flex-start',
      paddingLeft: breakpoint == 'mobile' ? '0px' : margin + "px"
    });
  } else if (position === 'right') {
    containerStyles = _extends({}, containerStyles, {
      alignItems: 'flex-end',
      paddingRight: breakpoint == 'mobile' ? '0px' : margin + "px"
    });
  }
  containerStyles['justifyContent'] = verticalPosition;
  if (verticalPosition === 'top') {
    containerStyles = _extends({}, containerStyles, {
      justifyContent: 'flex-start',
      paddingTop: verticalMargin + "px"
    });
  } else if (verticalPosition === 'bottom') {
    containerStyles = _extends({}, containerStyles, {
      justifyContent: 'flex-end',
      paddingBottom: verticalMargin + "px"
    });
  }
  if (spacing && !horizontalColumn) {
    containerStyles = _extends({}, containerStyles, {
      rowGap: spacing + "px"
    });
  }
  if (breakpoint == 'mobile') {
    containerStyles = _extends({}, containerStyles, {
      flexDirection: columnReverse ? 'column-reverse' : 'column'
    });
    return containerStyles;
  }
  containerStyles['flexDirection'] = 'column';
  if (horizontalColumn && breakpoint == 'desktop') {
    containerStyles = _extends({}, containerStyles, {
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingLeft: '0px',
      paddingRight: '0px'
    });
  }
  if (columnReverse) {
    containerStyles = _extends({}, containerStyles, {
      flexDirection: horizontalColumn ? 'row-reverse' : 'column-reverse'
    });
  }
  return containerStyles;
}
function getDropDownAlignment(widgetProps, breakpoint) {
  var alignment = _$1.get(widgetProps, "properties." + breakpoint + ".alignment", {
    position: 'center',
    margin: 0
  });
  var verticalAlignment = _$1.get(widgetProps, "properties." + breakpoint + ".verticalAlignment", {
    position: 'center',
    margin: 0
  });
  var position = _$1.get(alignment, 'position', 'center');
  var margin = _$1.get(alignment, 'margin', 0);
  var verticalPosition = _$1.get(verticalAlignment, 'position', 'center');
  var verticalMargin = _$1.get(verticalAlignment, 'margin', 0);
  var containerStyles = {};
  containerStyles['justifyContent'] = position;
  if (position === 'left') {
    containerStyles = _extends({}, containerStyles, {
      justifyContent: 'flex-start',
      paddingLeft: margin + "px"
    });
  } else if (position === 'right') {
    containerStyles = _extends({}, containerStyles, {
      justifyContent: 'flex-end',
      paddingRight: margin + "px"
    });
  }
  containerStyles['alignItems'] = verticalPosition;
  if (verticalPosition === 'top') {
    containerStyles = _extends({}, containerStyles, {
      alignItems: 'flex-start',
      paddingTop: verticalMargin + "px"
    });
  } else if (verticalPosition === 'bottom') {
    containerStyles = _extends({}, containerStyles, {
      alignItems: 'flex-end',
      paddingBottom: verticalMargin + "px"
    });
  }
  return containerStyles;
}
var filterWidgetEquals = function filterWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var FilterWidget = React.memo(FilterWidgetComponent, filterWidgetEquals);

var ContentWidgetComponent = function ContentWidgetComponent(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var context = React.useContext(WidgetsContext);
  var contentRef = React.useRef(null);
  var storyboardType = _$1.get(context, 'storyboard.type');
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var stretched = _$1.get(widgetProps, 'properties.desktop.stretched', false) && storyboardType !== 'INTERACTIVE_CONTENT';
  var showfilters = _$1.get(widgetProps, 'properties.desktop.filters', false) && storyboardType == 'RESOURCE_CENTER';
  var showSearch = _$1.get(widgetProps, 'properties.desktop.search', false) && storyboardType == 'RESOURCE_CENTER';
  var background = _$1.get(widgetProps, 'properties.desktop.background', null);
  var childrenWidgets = useWidgetChildrenSelector(id);
  var contentFilters = childrenWidgets.find(function (item) {
    return _$1.get(item, 'type') === CONTENT_FILTER;
  });
  var pagination = _$1.get(widgetProps, 'properties.desktop.layoutStyle.pagination', 'infinite_scroll');
  var paginationButton = pagination === 'load_more' && childrenWidgets.find(function (item) {
    return _$1.get(item, 'type') === CONTENT_PAGINATION_BUTTON;
  });
  var widgetStyle = _extends({}, style, getStyles$9(context.storyboard, widgetProps, breakpoint));
  return /*#__PURE__*/React.createElement(AutoGrowLayout, {
    ref: contentRef,
    editorSession: context.session,
    breakpoint: breakpoint,
    widget: widgetProps
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    ref: contentRef,
    className: cx(className, styles$t.content, 'content_widget', (_cx = {}, _cx[styles$t.stretched] = stretched, _cx[styles$t.mobile] = breakpoint === 'mobile', _cx)),
    style: widgetStyle,
    "data-widget-id": id,
    "data-widget-type": type
  }, /*#__PURE__*/React.createElement(BackgroundView, {
    background: background,
    breakpoint: breakpoint
  }), (showfilters || showSearch) && contentFilters && /*#__PURE__*/React.createElement("div", {
    className: styles$t.filterContainer
  }, /*#__PURE__*/React.createElement(Widget, {
    widgetProps: contentFilters,
    breakpoint: breakpoint
  })), /*#__PURE__*/React.createElement(ContentLayoutView, {
    widget: widgetProps,
    breakpoint: breakpoint
  }), paginationButton && /*#__PURE__*/React.createElement("div", {
    className: cx(styles$t.pagination, 'pagination_button_container')
  }, /*#__PURE__*/React.createElement(Widget, {
    key: paginationButton.uid,
    contentGrid: id,
    widgetProps: paginationButton,
    breakpoint: breakpoint
  }))));
};
var ContentLayoutView = function ContentLayoutView(_ref2) {
  var widget = _ref2.widget,
    breakpoint = _ref2.breakpoint;
  var context = React.useContext(WidgetsContext);
  var contentContext = React.useContext(Content.Context);
  var id = _$1.get(widget, 'uid');
  var layoutContent = _$1.get(widget, 'content', null);
  var filters = _$1.get(widget, 'filters', []);
  var fetch = _$1.get(layoutContent, 'mappings.fetch', false);
  var mappings = _$1.get(layoutContent, 'mappings.items') || [];
  var loading = _$1.get(layoutContent, 'mappings.loading', true);
  var fetched = _$1.get(layoutContent, 'mappings.fetched', false);
  var pagination = _$1.get(widget, 'properties.desktop.layoutStyle.pagination', 'infinite_scroll');
  var currentPage = _$1.get(widget, 'content.mappings.pagination.current');
  var totalPages = _$1.get(widget, 'content.mappings.pagination.totalPages');
  var itemsPerPage = _$1.get(widget, 'properties.desktop.layoutStyle.itemsPerPage', 2);
  var rowSpacing = _$1.get(widget, 'properties.desktop.layoutStyle.rowSpacing', 10);
  var columnSpacing = _$1.get(widget, 'properties.desktop.layoutStyle.columnSpacing', 10);
  var alignment = _$1.get(widget, 'properties.desktop.layoutStyle.alignment') || 'center';
  var cardTemplate = useSelector(function (state) {
    var widgets = _$1.get(state, context.selector + ".widgets") || [];
    var card = widgets.find(function (item) {
      return item.parent === id && item.type === CONTENT_CARD_TEMPLATE;
    });
    return card;
  });
  var width = _$1.get(cardTemplate, "properties." + breakpoint + ".layout.width");
  var widgetChildren = useWidgetChildrenSelector(id) || [];
  var loadingWidget = widgetChildren.find(function (item) {
    return item.parent === id && item.type === CONTENT_LOADING_MESSAGE;
  });
  var emptyMessage = widgetChildren.find(function (item) {
    return item.parent === id && item.type === CONTENT_EMPTY_MESSAGE;
  });
  widgetChildren = widgetChildren.filter(function (item) {
    return _$1.get(item, "type") === CONTENT_CARD;
  });
  widgetChildren = _$1.orderBy(widgetChildren, 'order', 'asc');
  useEffect(function () {
    if (id || fetch) {
      contentContext.fetchMappingsForContentGrid(id, 0, itemsPerPage);
    }
  }, [id, fetch]);
  var handleFetchMappings = function handleFetchMappings() {
    var nextPage = currentPage + 1;
    if (nextPage >= totalPages || pagination === 'none') {
      return;
    }
    contentContext.fetchMappingsForContentGrid(id, nextPage, itemsPerPage);
  };
  var wrapWithInfiniteScroll = function wrapWithInfiniteScroll(children) {
    if (pagination === 'infinite_scroll') {
      return /*#__PURE__*/React.createElement(InfiniteScroll, {
        loading: loading,
        loadData: handleFetchMappings
      }, children);
    }
    return children;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles$t.layoutRender
  }, !loading && fetched && _$1.size(mappings) === 0 && emptyMessage && /*#__PURE__*/React.createElement(Widget, {
    widgetProps: emptyMessage,
    breakpoint: breakpoint
  }), loading && _$1.size(mappings) === 0 && loadingWidget && /*#__PURE__*/React.createElement(Widget, {
    widgetProps: loadingWidget,
    breakpoint: breakpoint
  }), wrapWithInfiniteScroll(/*#__PURE__*/React.createElement(GridView, {
    className: loading && loadingWidget ? styles$t.dimLoader : null,
    width: width,
    rowSpacing: rowSpacing,
    columnSpacing: columnSpacing,
    alignment: alignment
  }, loading && _$1.size(mappings) === 0 && _$1.times(itemsPerPage).map(function (index) {
    return /*#__PURE__*/React.createElement(Widget, {
      key: index,
      widgetProps: cardTemplate,
      breakpoint: breakpoint
    });
  }), widgetChildren.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Widget, {
      key: item.uid,
      widgetProps: item,
      breakpoint: breakpoint
    });
  }), loading && _$1.size(mappings) > 0 && _$1.times(1).map(function (index) {
    return /*#__PURE__*/React.createElement(Widget, {
      key: index,
      widgetProps: cardTemplate,
      breakpoint: breakpoint
    });
  }))));
};
function getStyles$9(storyboard, widgetProps, breakpoint) {
  var storyboardType = _$1.get(storyboard, 'type');
  var stretched = _$1.get(widgetProps, 'properties.desktop.stretched', false) && storyboardType !== 'INTERACTIVE_CONTENT';
  var margin = _$1.get(widgetProps, 'properties.desktop.margin', 0);
  var widgetStyles = {};
  if (breakpoint === 'desktop') {
    widgetStyles = _extends({}, widgetStyles, {
      width: "1200px"
    });
    if (stretched) {
      widgetStyles = _extends({}, widgetStyles, {
        marginLeft: margin,
        width: "calc(100% - 2 * " + margin + "px)",
        left: "calc((100% - 2 * " + margin + "px))/2)"
      });
    }
  }
  var shadow = _$1.get(widgetProps, "properties.desktop.shadow", {});
  var shadowStyle = getBoxShadow(shadow);
  widgetStyles = _extends({}, widgetStyles, shadowStyle);
  return widgetStyles;
}
var contentWidgetEquals = function contentWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var ContentWidget = React.memo(ContentWidgetComponent, contentWidgetEquals);

var styles$v = {"contentCard":"_2l8A-","cardBackground":"_11H3R"};

var ContentCardWidget = React.memo(function ContentCardWidget(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children;
  var contentContext = React.useContext(Content.Context);
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var background = _$1.get(widgetProps, "properties.desktop.background");
  var hoverStyle = _$1.get(widgetProps, "properties.desktop.hoverStyle") || 'move_up_with_shadow';
  var content = _$1.get(widgetProps, 'template.content');
  var widgetStyles = _extends({}, style, getStyles$a(widgetProps, breakpoint));
  var handleItemClick = function handleItemClick() {
    contentContext.viewContent(widgetProps.parent, content);
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$v.contentCard, hoverStyle, "widget"),
    "data-widget-id": id,
    "data-widget-type": type,
    style: widgetStyles,
    onClick: handleItemClick
  }, /*#__PURE__*/React.createElement(BackgroundView, {
    background: background,
    breakpoint: breakpoint,
    className: styles$v.cardBackground
  }), children);
});
function getStyles$a(widget, breakpoint) {
  if (!widget) {
    return null;
  }
  var border = _$1.get(widget, "properties." + breakpoint + ".border");
  var styles = {};
  var topLeft = _$1.get(border, 'radius.topLeft', null);
  var topRight = _$1.get(border, 'radius.topRight', null);
  var bottomLeft = _$1.get(border, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(border, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var colorRgb = _$1.get(border, 'color');
  var color = 'transparent';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  styles['borderColor'] = color;
  var borderWidthString = _$1.get(border, 'width', 0);
  var borderWidget = parseInt(borderWidthString) + 'px';
  styles['borderWidth'] = borderWidget;
  var shadow = _$1.get(widget, "properties." + breakpoint + ".shadow", {});
  var shadowStyle = getBoxShadow(shadow);
  styles = _extends({}, styles, shadowStyle);
  return styles;
}

var styles$w = {"card":"_3kpVB","placeholder":"_2Rg9k","default":"_2WwUA","text":"_kJRAa","placeholder-glow":"_3ZVnc"};

var _excluded$5 = ["widgetProps", "breakpoint"];
var PlaceholderCardWidget = React.memo(function PlaceholderCardWidget(_ref) {
  var style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children;
  return function (children) {
    var id = _$1.get(widgetProps, 'uid');
    var type = _$1.get(widgetProps, 'type');
    var background = _$1.get(widgetProps, "properties.desktop.background");
    var widgetChildren = useWidgetChildrenSelector(id);
    var widgetStyles = _extends({}, style, getStyles$a(widgetProps, breakpoint));
    var children = widgetChildren.map(function (item) {
      return /*#__PURE__*/React.createElement(_PlaceholderWidget, {
        key: item.uid,
        widgetProps: item,
        breakpoint: breakpoint
      });
    });
    return /*#__PURE__*/React.createElement("div", {
      className: styles$w.card,
      style: widgetStyles
    }, /*#__PURE__*/React.createElement(BackgroundView, {
      background: background,
      breakpoint: breakpoint
    }), children);
  }(children);
});
var _PlaceholderWidget = function PlaceholderWidget(_ref2) {
  var widgetProps = _ref2.widgetProps,
    breakpoint = _ref2.breakpoint,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded$5);
  var id = _$1.get(widgetProps, 'uid');
  var container = useContainerSelector(id);
  var widgetChildren = useWidgetChildrenSelector(id);
  var parentContainer = useContainerSelector(container === null || container === void 0 ? void 0 : container.uid);
  var type = _$1.get(widgetProps, 'type');
  var Component = getWidgetComponentFotType(type);
  if (!Component) {
    console.warn("Component not found for type " + type);
    return false;
  }
  var layout = _$1.get(widgetProps, "properties." + breakpoint + ".layout");
  var widgetStyle = getStylesForLayout(layout, breakpoint, container, parentContainer);
  var children = widgetChildren.map(function (item) {
    return /*#__PURE__*/React.createElement(_PlaceholderWidget, {
      key: item.uid,
      widgetProps: item,
      breakpoint: breakpoint
    });
  });
  return React.createElement(Component, _extends({
    widgetProps: widgetProps,
    className: styles$w.placeholder,
    key: id,
    breakpoint: breakpoint,
    style: widgetStyle
  }, rest), children);
};
var getWidgetComponentFotType = function getWidgetComponentFotType(type) {
  switch (type) {
    case BASIC_TEXT:
    case TEXT:
      return PlaceholderTextWidget;
    case IMAGE:
    case VIDEO:
    case BUTTON:
      return PlaceholderDefaultWidget;
    case SHAPE:
      return ShapeWidget;
    case RECTANGLE:
      return RectangleWidget;
    case LINE:
      return LineWidget;
    default:
      return false;
  }
};
var PlaceholderDefaultWidget = function PlaceholderDefaultWidget(_ref3) {
  var className = _ref3.className,
    style = _ref3.style;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(className, styles$w["default"]),
    style: style
  });
};
var PlaceholderTextWidget = function PlaceholderTextWidget(_ref4) {
  var className = _ref4.className,
    widgetProps = _ref4.widgetProps,
    style = _ref4.style,
    breakpoint = _ref4.breakpoint;
  var lineHeight = _$1.get(widgetProps, "properties." + breakpoint + ".lineSpacing", 1.2);
  var fontSize = _$1.get(widgetProps, "properties." + breakpoint + ".fontSize", 16);
  var height = _$1.get(widgetProps, "properties." + breakpoint + ".layout.height");
  height = parseInt(height);
  var textHeight = lineHeight * fontSize;
  height = Math.max(height, textHeight);
  var lines = Math.floor(height / textHeight);
  var textStyle = getTextStyles(widgetProps, breakpoint);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(className, styles$w.text),
    style: style
  }, _$1.times(lines).map(function (index) {
    return /*#__PURE__*/React.createElement("span", {
      key: index,
      style: textStyle
    }, "\xA0");
  }));
};
var getTextStyles = function getTextStyles(widget, breakpoint) {
  var textStyle = {};
  var backgroundRgb = _$1.get(widget, "properties." + breakpoint + ".background", null);
  var background = '#333';
  if (backgroundRgb) {
    background = "rgba(" + backgroundRgb.r + ", " + backgroundRgb.g + ", " + backgroundRgb.b + ", " + backgroundRgb.a + ")";
  }
  textStyle['backgroundColor'] = background;
  var fontSize = _$1.get(widget, "properties." + breakpoint + ".fontSize", 16);
  textStyle['height'] = fontSize + "px";
  return textStyle;
};

var styles$x = {"dropdownContainer":"_qCBwg","dropdownButton":"_3ORAg","lastButton":"_MCSU3","dropDownIcon":"_3cx_e","dropdownItem":"_ztfwe","alignmentLeft":"_3fpEV","alignmentRight":"_2JCS_","clearFilters":"_1JMk0","closeIcon":"_1WGQg","dropdownMenu":"_1qovi","checkboxLabel":"_2OoLv","filterMenuItem":"_3ZbxV","label":"_257M-","value":"_-kVJG","selected":"_3PSse","size":"_3Mn5D","valueCount":"_2ETML"};

var FilterDropdownComponent = function FilterDropdownComponent(_ref) {
  var className = _ref.className,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    filterContent = _ref.filterContent,
    alignment = _ref.alignment;
  var wrapperStyles = dropdownButtonWrapperStyles(widgetProps, alignment, breakpoint);
  var _useState = useState(null),
    openDropdownIndex = _useState[0],
    setOpenDropdownIndex = _useState[1];
  var handleToggle = function handleToggle(index) {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };
  return /*#__PURE__*/React.createElement("div", {
    style: wrapperStyles,
    className: cx(className, styles$x.dropdownContainer)
  }, filterContent && _$1.size(filterContent) == 1 && (_$1.compact(filterContent) || []).map(function (filter) {
    var options = [{
      id: 'all',
      value: 'All'
    }].concat(filter.options);
    return options.map(function (option, index) {
      return /*#__PURE__*/React.createElement(ButtonTab, {
        filter: filter,
        option: option,
        widgetProps: widgetProps,
        breakpoint: breakpoint,
        index: index
      });
    });
  }), filterContent && _$1.size(filterContent) > 1 && (_$1.compact(filterContent) || []).map(function (filter, index) {
    return /*#__PURE__*/React.createElement(Dropdown, {
      show: openDropdownIndex === index,
      onToggle: function onToggle() {
        return handleToggle(index);
      },
      key: index
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      as: CustomToggle$1,
      id: "dropdown-custom-components",
      widgetProps: widgetProps,
      breakpoint: breakpoint,
      index: index,
      filter: filter,
      contentLength: filterContent.length,
      onClick: function onClick(e) {
        e.stopPropagation();
        handleToggle(index);
      }
    }, filter.name), /*#__PURE__*/React.createElement(Dropdown.Menu, {
      as: CustomMenu$1
    }, /*#__PURE__*/React.createElement(DropdownMenu, {
      widgetProps: widgetProps,
      filter: filter
    })));
  }), filterContent && _$1.size(filterContent) > 1 && /*#__PURE__*/React.createElement(RenderResetButton, {
    widgetProps: widgetProps,
    breakpoint: breakpoint
  }));
};
var RenderResetButton = function RenderResetButton(_ref2) {
  var widgetProps = _ref2.widgetProps,
    breakpoint = _ref2.breakpoint;
  var contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);
  var filters = _$1.get(contentWidget, 'filters', []);
  if (!filters || _$1.size(filters) == 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Dropdown, null, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    as: ResetButton,
    widgetProps: widgetProps,
    breakpoint: breakpoint
  }));
};
var ButtonTab = function ButtonTab(_ref3) {
  var filter = _ref3.filter,
    option = _ref3.option,
    widgetProps = _ref3.widgetProps,
    breakpoint = _ref3.breakpoint;
  var _useState2 = useState({
      buttonStyle: {},
      hover: false
    }),
    state = _useState2[0],
    setState = _useState2[1];
  var contentContext = React.useContext(Content.Context);
  var contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);
  var filters = _$1.get(contentWidget, 'filters', []);
  var selectedFilter = filters.find(function (item) {
    return item.property.fieldId === filter.id;
  });
  var selectedValue = selectedFilter && selectedFilter.value ? selectedFilter.value[0] : null;
  var selected = (filter.options || []).find(function (item) {
    return item.id === selectedValue;
  }) || {
    id: "all",
    option: "All"
  };
  var hoverStyle = getStyles$b(widgetProps, breakpoint, 'hover');
  var buttonTabStyle = selected.id == option.id ? hoverStyle : state.buttonStyle;
  useEffect(function () {
    var regularBtnStyle = getStyles$b(widgetProps, breakpoint, 'regular');
    setState(function (state) {
      return _extends({}, state, {
        buttonStyle: regularBtnStyle
      });
    });
  }, [breakpoint, widgetProps]);
  useEffect(function () {
    var updatedStyle = getStyles$b(widgetProps, breakpoint, state.hover ? 'hover' : 'regular');
    setState(function (state) {
      return _extends({}, state, {
        buttonStyle: updatedStyle
      });
    });
  }, [state.hover]);
  var handleOnMouseOver = function handleOnMouseOver(hover) {
    setState(function (state) {
      return _extends({}, state, {
        hover: hover
      });
    });
  };
  var handleClick = function handleClick(e) {
    e.stopPropagation();
    var request = {
      property: {
        type: "CUSTOM_FIELD",
        fieldId: filter.id
      },
      operator: "IS",
      value: null
    };
    if (option && option.id !== 'all') {
      request = _extends({}, request, {
        value: [option.id]
      });
    }
    contentContext.updateFiltersInContenGrid(contentWidget.uid, request);
  };
  return /*#__PURE__*/React.createElement("div", {
    onMouseLeave: function onMouseLeave() {
      return handleOnMouseOver(false);
    },
    onMouseEnter: function onMouseEnter() {
      return handleOnMouseOver(true);
    },
    className: cx(styles$x.dropdownButton),
    style: buttonTabStyle,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles$x.filterMenuItem)
  }, /*#__PURE__*/React.createElement(TruncatedTextWithTooltip$1, {
    content: option.value,
    className: styles$x.label,
    maxWidth: 300,
    placement: "top"
  })));
};
var DropdownMenu = function DropdownMenu(_ref4) {
  var widgetProps = _ref4.widgetProps,
    filter = _ref4.filter;
  var options = filter.multiselect ? filter.options : [{
    id: 'all',
    value: 'All'
  }].concat(filter.options);
  return /*#__PURE__*/React.createElement(Fragment, null, (options || []).map(function (option, index) {
    return /*#__PURE__*/React.createElement(Dropdown.Item, {
      as: DropdownOption,
      key: index,
      widgetProps: widgetProps,
      breakpoint: "desktop",
      filter: filter,
      option: option,
      index: index
    });
  }));
};
var CustomToggle$1 = React.forwardRef(function (_ref5, ref) {
  var _cx, _cx2, _cx3;
  var _onClick = _ref5.onClick,
    index = _ref5.index,
    contentLength = _ref5.contentLength,
    breakpoint = _ref5.breakpoint,
    widgetProps = _ref5.widgetProps,
    filter = _ref5.filter;
  var _useState3 = useState({
      buttonStyle: {},
      hover: false
    }),
    state = _useState3[0],
    setState = _useState3[1];
  var contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);
  var filters = _$1.get(contentWidget, 'filters', []);
  var selectedFilter = filters.find(function (item) {
    return item.property.fieldId === filter.id;
  });
  var selecetdValue = selectedFilter && selectedFilter.value ? selectedFilter.value[0] : null;
  var selectedValues = selectedFilter && selectedFilter.value ? selectedFilter.value : null;
  var valueCount = _$1.size(selectedValues);
  var selected = (filter.options || []).find(function (item) {
    return item.id === selecetdValue;
  });
  useEffect(function () {
    var activeButtonStyle = getStyles$b(widgetProps, breakpoint, 'regular');
    setState(function (state) {
      return _extends({}, state, {
        buttonStyle: activeButtonStyle
      });
    });
  }, [breakpoint, widgetProps]);
  useEffect(function () {
    var updatedStyle = getStyles$b(widgetProps, breakpoint, state.hover ? 'hover' : 'regular');
    setState(function (state) {
      return _extends({}, state, {
        buttonStyle: updatedStyle
      });
    });
  }, [state.hover]);
  var handleOnMouseOver = function handleOnMouseOver(hover) {
    setState(function (state) {
      return _extends({}, state, {
        hover: hover
      });
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    onMouseLeave: function onMouseLeave() {
      return handleOnMouseOver(false);
    },
    onMouseEnter: function onMouseEnter() {
      return handleOnMouseOver(true);
    },
    className: cx(styles$x.dropdownButton, (_cx = {}, _cx[styles$x.lastButton] = index === contentLength - 1 && filters.length === 0, _cx)),
    ref: ref,
    style: state.buttonStyle,
    onClick: function onClick(e) {
      e.preventDefault();
      _onClick(e);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles$x.filterMenuItem, (_cx2 = {}, _cx2[styles$x.selected] = selected != null, _cx2))
  }, /*#__PURE__*/React.createElement(TruncatedTextWithTooltip$1, {
    content: filter.name,
    className: styles$x.label,
    maxWidth: 300,
    placement: "top"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$x.size
  }, /*#__PURE__*/React.createElement(TruncatedTextWithTooltip$1, {
    content: _$1.get(selected, 'value'),
    className: styles$x.value,
    maxWidth: 300,
    placement: "top"
  }), valueCount > 1 && /*#__PURE__*/React.createElement("span", {
    className: styles$x.valueCount
  }, " + ", valueCount - 1))), /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-drop-down', styles$x.dropDownIcon, (_cx3 = {}, _cx3[styles$x.showDropdown] = false, _cx3))
  }));
});
var ResetButton = function ResetButton(_ref6) {
  var breakpoint = _ref6.breakpoint,
    widgetProps = _ref6.widgetProps;
  var _useState4 = useState({
      buttonStyle: {},
      hover: false
    }),
    state = _useState4[0],
    setState = _useState4[1];
  var contentContext = React.useContext(Content.Context);
  var contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);
  var filters = _$1.get(contentWidget, 'filters', []);
  var handleOnMouseOver = function handleOnMouseOver(hover) {
    setState(function (state) {
      return _extends({}, state, {
        hover: hover
      });
    });
  };
  useEffect(function () {
    var updatedStyle = getStyles$b(widgetProps, breakpoint, state.hover ? 'hover' : 'regular');
    setState(function (state) {
      return _extends({}, state, {
        buttonStyle: updatedStyle
      });
    });
  }, [state.hover]);
  var handleResetClick = function handleResetClick() {
    contentContext.resetFiltersInContenGrid(contentWidget.uid);
  };
  if (!filters || filters.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    onMouseLeave: function onMouseLeave() {
      return handleOnMouseOver(false);
    },
    onMouseEnter: function onMouseEnter() {
      return handleOnMouseOver(true);
    },
    className: cx(styles$x.dropdownButton, styles$x.lastButton),
    style: state.buttonStyle,
    onClick: function onClick(e) {
      e.preventDefault();
      handleResetClick();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles$x.filterMenuItem)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$x.label
  }, "Reset")));
};
var CustomMenu$1 = React.forwardRef(function (_ref7, ref) {
  var children = _ref7.children,
    className = _ref7.className,
    labeledBy = _ref7['aria-labelledby'];
  var _useState5 = useState(''),
    value = _useState5[0];
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: cx(className, styles$x.dropdownMenu),
    "aria-labelledby": labeledBy
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-unstyled"
  }, React.Children.toArray(children).filter(function (child) {
    return !value || child.props.children.toLowerCase().startsWith(value);
  })));
});
var DropdownOption = function DropdownOption(_ref8) {
  var filter = _ref8.filter,
    option = _ref8.option,
    index = _ref8.index,
    widgetProps = _ref8.widgetProps,
    breakpoint = _ref8.breakpoint;
  var contentContext = React.useContext(Content.Context);
  var _useState6 = useState(getDropDownStyles(widgetProps, 'regular', breakpoint)),
    subFilterMenuStyle = _useState6[0],
    setSubFilterMenuStyle = _useState6[1];
  var contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);
  var filters = _$1.get(contentWidget, 'filters', []);
  var valueObj = filters.find(function (item) {
    return item.property.fieldId === filter.id;
  });
  var isOptionChecked = function isOptionChecked() {
    return valueObj ? _$1.includes(valueObj.value, option.id) : false;
  };
  var handleSubMenuHover = function handleSubMenuHover(active) {
    var updatedStyle = getDropDownStyles(widgetProps, active, breakpoint);
    setSubFilterMenuStyle(updatedStyle);
  };
  var filterValue = function filterValue(values, optionId) {
    if (values.includes(optionId)) {
      return values.filter(function (id) {
        return id !== optionId;
      });
    }
    return [].concat(values, [optionId]);
  };
  var handleClick = function handleClick(e) {
    e.stopPropagation();
    var values = valueObj && valueObj.value || [];
    var isMultiselect = filter.multiselect;
    var optionId = option && option.id !== 'all' ? option.id : null;
    var value = optionId != null ? [optionId] : null;
    if (isMultiselect) {
      value = filterValue(values, optionId);
      value = value.length === 0 ? null : value;
    }
    var request = {
      property: {
        type: "CUSTOM_FIELD",
        fieldId: filter.id
      },
      operator: "IS",
      value: value
    };
    if (!isMultiselect) {
      document.body.click();
    }
    contentContext.updateFiltersInContenGrid(contentWidget.uid, request);
  };
  return /*#__PURE__*/React.createElement("div", {
    style: subFilterMenuStyle,
    key: index,
    onMouseLeave: function onMouseLeave() {
      return handleSubMenuHover('regular');
    },
    onMouseEnter: function onMouseEnter() {
      return handleSubMenuHover('hover');
    },
    onClick: handleClick,
    className: styles$x.dropdownItem
  }, filter.multiselect && /*#__PURE__*/React.createElement(Form.Group, {
    className: styles$x.checkboxLabel
  }, /*#__PURE__*/React.createElement(Form.Check, {
    style: _extends({}, subFilterMenuStyle, {
      padding: '0px'
    }),
    type: "checkbox",
    checked: isOptionChecked()
  })), /*#__PURE__*/React.createElement(TruncatedTextWithTooltip$1, {
    content: option.value,
    maxWidth: 300,
    placement: "top"
  }));
};
var filterDropdownEquals = function filterDropdownEquals(prevProps, nextProps) {
  var paths = ['className', 'widgetProps', 'breakpoint', 'filterContent', 'active', 'alignment'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var FilterDropdown = React.memo(FilterDropdownComponent, filterDropdownEquals);
function getDropDownStyles(widgetProps, active, breakpoint, filter) {
  var styles = {};
  if (!widgetProps) {
    return styles;
  }
  var defaultProperties = _$1.get(widgetProps, "properties.desktop");
  var defaultStyles = _$1.get(defaultProperties, "regular.filterStyles", {});
  var colorRgb = _$1.get(defaultProperties, active + ".dropdownColor", null);
  var color = getColorStyles$a(colorRgb);
  styles = _extends({}, styles, {
    color: color
  });
  var backgroundRgb = _$1.get(defaultProperties, active + ".dropdownBackground", null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = "rgba(" + backgroundRgb.r + ", " + backgroundRgb.g + ", " + backgroundRgb.b + ", " + backgroundRgb.a + ")";
  }
  styles['backgroundColor'] = background;
  var font = _$1.get(defaultStyles, 'font', {});
  var fontFamily = _$1.get(font, 'fontFamily');
  if (fontFamily) {
    styles = _extends({}, styles, {
      fontFamily: fontFamily
    });
  }
  var layoutHeight = _$1.get(defaultProperties, 'layout.height');
  if (layoutHeight) {
    styles['lineHeight'] = layoutHeight;
  }
  var bold = _$1.get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }
  var italic = _$1.get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }
  var underline = _$1.get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }
  var lineSpacingString = _$1.get(defaultProperties, 'regular.filterStyles.font.lineSpacing', null);
  if (lineSpacingString) {
    var lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }
  var letterSpacingString = _$1.get(defaultProperties, 'regular.filterStyles.font.letterSpacing', null);
  if (letterSpacingString) {
    var letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }
  var fontSizeString = breakpoint === 'desktop' ? _$1.get(defaultProperties, "regular.filterStyles.font.fontSize", null) : 14;
  var fontSize = 'inherit';
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }
  styles['fontSize'] = fontSize;
  styles['justifyContent'] = 'center';
  styles['textAlign'] = 'center';
  var border = _$1.get(defaultProperties, active + ".dropdownBorder", {});
  var borderColor = _$1.get(border, "color", null);
  var borderStyle = getBorderStyles$a(border, borderColor);
  styles = _extends({}, styles, borderStyle);
  var spacing = _$1.get(defaultProperties, 'padding');
  var horizontalPadding = _$1.get(defaultProperties, 'itemHorizontalPadding');
  var verticalPadding = _$1.get(defaultProperties, 'itemVerticalPadding');
  styles = _extends({}, styles, {
    paddingLeft: horizontalPadding + "px",
    paddingRight: horizontalPadding + "px",
    paddingTop: verticalPadding + "px",
    paddingBottom: verticalPadding + "px"
  });
  return styles;
}
function dropdownButtonWrapperStyles(widget, alignment, breakpoint) {
  var styles = {};
  if (!widget) {
    return styles;
  }
  var defaultProperties = _$1.get(widget, "properties.desktop", {});
  var spacing = _$1.get(defaultProperties, 'padding');
  styles = _extends({}, styles, {
    gridColumnGap: spacing + "px"
  });
  if (breakpoint === 'mobile') {
    styles = _extends({}, styles, alignment);
  }
  return styles;
}
function getStyles$b(widget, breakpoint, active) {
  var styles = {};
  if (!widget) {
    return styles;
  }
  var defaultProperties = _$1.get(widget, "properties.desktop", {});
  var deviceProperties = _$1.get(widget, "properties." + breakpoint, {});
  var defaultStyles = _$1.get(defaultProperties, "regular.filterStyles", {});
  var colorRgb = _$1.get(defaultProperties, active + ".filterStyles.font.color", null);
  var color = getColorStyles$a(colorRgb);
  styles = _extends({}, styles, {
    color: color
  });
  var backgroundRgb = _$1.get(defaultProperties, active + ".filterStyles.background", null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = "rgba(" + backgroundRgb.r + ", " + backgroundRgb.g + ", " + backgroundRgb.b + ", " + backgroundRgb.a + ")";
  }
  styles['backgroundColor'] = background;
  var font = _$1.get(defaultStyles, 'font', {});
  var fontFamily = _$1.get(font, 'fontFamily');
  if (fontFamily) {
    styles = _extends({}, styles, {
      fontFamily: fontFamily
    });
  }
  var fontSizeString = _$1.get(deviceProperties, 'regular.filterStyles.font.fontSize', null);
  var fontSize = 'inherit';
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }
  styles['fontSize'] = fontSize;
  var letterSpacingString = _$1.get(deviceProperties, 'regular.filterStyles.font.letterSpacing', null);
  if (letterSpacingString) {
    var letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }
  var layoutHeight = _$1.get(deviceProperties, 'layout.height');
  if (layoutHeight && breakpoint === 'desktop') {
    styles['lineHeight'] = layoutHeight;
  }
  var lineSpacingString = _$1.get(deviceProperties, 'regular.filterStyles.font.lineSpacing', null);
  if (lineSpacingString) {
    var lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }
  var bold = _$1.get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }
  var italic = _$1.get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }
  var underline = _$1.get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }
  var border = _$1.get(defaultProperties, active + ".filterStyles.border", {});
  var borderColor = _$1.get(defaultProperties, active + ".filterStyles.border.color", null);
  var borderStyle = getBorderStyles$a(border, borderColor);
  styles = _extends({}, styles, borderStyle);
  var spacing = _$1.get(defaultProperties, 'padding');
  var horizontalPadding = _$1.get(defaultProperties, 'itemHorizontalPadding');
  var verticalPadding = _$1.get(defaultProperties, 'itemVerticalPadding');
  styles = _extends({}, styles, {
    paddingLeft: horizontalPadding + "px",
    paddingRight: horizontalPadding + "px",
    paddingTop: verticalPadding + "px",
    paddingBottom: verticalPadding + "px"
  });
  var alignment = _$1.get(deviceProperties, 'alignment', {});
  var position = _$1.get(alignment, 'position', 'center');
  styles['justifyContent'] = position;
  styles['textAlign'] = position;
  var margin = _$1.get(alignment, 'margin', 0);
  if (position === 'left') {
    styles = _extends({}, styles, {
      paddingLeft: margin + "px"
    });
  } else if (position === 'right') {
    styles = _extends({}, styles, {
      paddingRight: margin + "px"
    });
  }
  return styles;
}
function getColorStyles$a(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  return color;
}
function getBorderStyles$a(value, colorRgb) {
  if (!value) {
    return null;
  }
  var styles = {};
  var topLeft = _$1.get(value, 'radius.topLeft', null);
  var topRight = _$1.get(value, 'radius.topRight', null);
  var bottomLeft = _$1.get(value, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(value, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var color = 'transparent';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  styles['borderColor'] = color;
  var borderWidthString = _$1.get(value, 'width', null);
  var borderWidget = parseInt(borderWidthString) + 'px';
  styles['borderWidth'] = borderWidget;
  return styles;
}
var TruncatedTextWithTooltip$1 = function TruncatedTextWithTooltip(_ref9) {
  var content = _ref9.content,
    className = _ref9.className,
    _ref9$maxWidth = _ref9.maxWidth,
    maxWidth = _ref9$maxWidth === void 0 ? 200 : _ref9$maxWidth,
    _ref9$placement = _ref9.placement,
    placement = _ref9$placement === void 0 ? "top" : _ref9$placement;
  var _useState7 = useState(false),
    tooltip = _useState7[0],
    setTooltip = _useState7[1];
  var handleTooltip = function handleTooltip(isTruncated) {
    setTooltip(isTruncated);
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    placement: placement,
    disabled: !tooltip,
    content: content
  }, /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Truncate, {
    lines: 1,
    width: maxWidth,
    ellipsis: "...",
    onTruncate: handleTooltip
  }, content)));
};

var styles$y = {"filterContainer":"_1NDjk","filterListView":"_3ScbK","filterColumnWrapper":"_ShptG","expandView":"_t_-cr","alignmentLeft":"_f2evc","alignmentRight":"_dkJtj"};

var FilterContainerWidgetComponent = function FilterContainerWidgetComponent(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    parentProps = _ref.parentProps,
    alignment = _ref.alignment;
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var properties = _$1.get(widgetProps, 'properties', {});
  var deviceProperties = _$1.get(properties, "" + breakpoint, {});
  var trayAlignment = _$1.get(widgetProps, "properties." + breakpoint + ".trayAlignment.position");
  var horizontalColumn = _$1.get(parentProps, "properties.desktop.horizontalColumn", false);
  var layout = _$1.get(widgetProps, "properties." + breakpoint + ".layout");
  var animation = _$1.get(widgetProps, "properties." + breakpoint + ".animation") || {};
  var _useState = useState(false),
    expand = _useState[0],
    setExpand = _useState[1];
  var filterContent = _$1.get(widgetProps, 'content');
  var widgetStyle = _extends({}, style, getStyles$c(widgetProps, breakpoint));
  var columnStyles = _extends({}, style, getColumnStyles(deviceProperties, horizontalColumn, breakpoint));
  if (breakpoint === 'mobile') {
    widgetStyle = _extends({}, widgetStyle, {
      position: 'relative'
    });
  }
  var handleOnClick = function handleOnClick(e) {
    setExpand(!expand);
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "filter_container_column_" + id,
    style: columnStyles,
    className: cx((_cx = {}, _cx[styles$y.filterColumnWrapper] = horizontalColumn && breakpoint == 'desktop', _cx))
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$y.filterContainer, 'cs_filtercontainer'),
    style: widgetStyle,
    "data-widget-id": id,
    tabIndex: 0,
    onClick: handleOnClick,
    "data-widget-type": type
  }, /*#__PURE__*/React.createElement(FilterDropdown, {
    filterContent: filterContent,
    alignment: alignment,
    breakpoint: breakpoint,
    active: "regular",
    widgetProps: widgetProps
  })));
};
function getColumnStyles(properties, horizontalColumn, breakpoint) {
  var containerStyles = {};
  if (!properties) {
    return containerStyles;
  }
  var columnAlignment = _$1.get(properties, "horizontalAlignment", {
    position: 'center',
    margin: 0
  });
  var alignmentPosition = _$1.get(columnAlignment, 'position', 'center');
  var alignmnetMargin = _$1.get(columnAlignment, 'margin', 0);
  containerStyles['justifyContent'] = alignmentPosition;
  if (!horizontalColumn || breakpoint == 'mobile') {
    return containerStyles;
  }
  if (alignmentPosition === 'left') {
    containerStyles = _extends({}, containerStyles, {
      justifyContent: 'flex-start',
      paddingLeft: alignmnetMargin + "px"
    });
  } else if (alignmentPosition === 'right') {
    containerStyles = _extends({}, containerStyles, {
      justifyContent: 'flex-end',
      paddingRight: alignmnetMargin + "px"
    });
  }
  return containerStyles;
}
function getStyles$c(widget, breakpoint) {
  var styles = {};
  if (breakpoint === 'desktop') {
    var width = parseFloat(_$1.get(widget, "properties." + breakpoint + ".layout.width", 100));
    var height = parseFloat(_$1.get(widget, "properties." + breakpoint + ".layout.height", 100));
    styles = _extends({}, styles, {
      maxWidth: width,
      height: height
    });
  }
  return styles;
}
var filterContainerWidgetEquals = function filterContainerWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'parentProps'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var FilterContainerWidget = React.memo(FilterContainerWidgetComponent, filterContainerWidgetEquals);

var PaginationButtonWidgetComponent = function PaginationButtonWidgetComponent(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var contentContext = React.useContext(Content.Context);
  var contentGrid = useWidgetSelector(widgetProps.parent);
  var loading = _$1.get(contentGrid, 'content.mappings.loading');
  var currentPage = _$1.get(contentGrid, 'content.mappings.pagination.current');
  var totalPages = _$1.get(contentGrid, 'content.mappings.pagination.totalPages');
  var hasMore = currentPage < totalPages - 1;
  var itemsPerPage = _$1.get(contentGrid, 'properties.desktop.layoutStyle.itemsPerPage', 2);
  var handleClick = function handleClick() {
    var nextPage = currentPage + 1;
    if (nextPage >= totalPages) {
      return;
    }
    contentContext.fetchMappingsForContentGrid(contentGrid.uid, nextPage, itemsPerPage);
  };
  if (!hasMore) {
    return false;
  }
  return /*#__PURE__*/React.createElement(ButtonWidget, {
    widgetProps: widgetProps,
    className: cx(className, styles$t.paginationButton, (_cx = {}, _cx[style.disabled] = loading, _cx)),
    key: widgetProps.uid,
    breakpoint: breakpoint,
    style: style,
    onClick: handleClick
  });
};
var buttonWidgetEquals$4 = function buttonWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'onClick'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var PaginationButtonWidget = React.memo(PaginationButtonWidgetComponent, buttonWidgetEquals$4);

var styles$z = {"emptyMessage":"_NCnHY"};

var EmptyMessageView = React.memo(function EmptyMessage(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children;
  var context = React.useContext(WidgetsContext);
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var stretched = _$1.get(widgetProps, 'properties.desktop.stretched', false);
  var parent = _$1.get(widgetProps, 'parent');
  var background = _$1.get(widgetProps, 'properties.desktop.background');
  var widgetStyles = _extends({}, style, {
    marginLeft: 0
  });
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    style: widgetStyles,
    className: cx(className, styles$z.emptyMessage, 'widget'),
    "data-widget-id": id,
    "data-widget-type": type
  }, /*#__PURE__*/React.createElement(BackgroundView, {
    background: background,
    breakpoint: breakpoint
  }), children);
});
var EmptyMessageWidget = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(EmptyMessageView, _extends({}, props, {
    ref: ref
  }));
});

var styles$A = {"loaderSection":"_2ftG-"};

var LoadingView = function LoadingWidget(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children;
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var stretched = _$1.get(widgetProps, 'properties.desktop.stretched', false);
  var parent = _$1.get(widgetProps, 'parent');
  var background = _$1.get(widgetProps, 'properties.desktop.background');
  var widgetStyles = _extends({}, style, {
    marginLeft: 0
  });
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    style: widgetStyles,
    className: cx(className, styles$A.loaderSection, 'widget'),
    "data-widget-id": id,
    "data-widget-type": type
  }, /*#__PURE__*/React.createElement(BackgroundView, {
    background: background,
    breakpoint: breakpoint
  }), children);
};
var LoadingWidget = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(LoadingView, _extends({}, props, {
    ref: ref
  }));
});

var styles$B = {"groupWidget":"_3-r4T","groupWidgetAnimation":"_3aCNr"};

var GroupWidgetComponent = function GroupWidgetComponent(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children;
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var animation = _$1.get(widgetProps, "properties." + breakpoint + ".animation") || {};
  var widgetStyle = _extends({}, style);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$B.groupWidget, 'cs_group_widget', (_cx = {}, _cx[styles$B.mobile] = breakpoint === 'mobile', _cx)),
    "data-widget-id": id,
    "data-widget-type": type,
    "data-container": false,
    "data-selectable": true,
    style: widgetStyle
  }, /*#__PURE__*/React.createElement(AnimationComponent, animation, /*#__PURE__*/React.createElement("div", {
    className: styles$B.groupWidgetAnimation
  }, children)));
};
var groupWidgetEquals = function groupWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var GroupWidget = React.memo(GroupWidgetComponent, groupWidgetEquals);

var styles$C = {"modalWidget":"_Tma5J","modalContainer":"_37FY0","ReactModal__Body--open":"_3KkQw","modalOverlay":"_2OgRF","modalBackground":"_2l4IV","overlayBackground":"_1-v_I","close":"_3tp6e","modalDeviceRender":"_1wNhh"};

var ModalWidgetComponent = function ModalWidgetComponent(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children,
    show = _ref.show;
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var _useState = useState(1),
    zoom = _useState[0],
    setZoom = _useState[1];
  var modalContainer = useRef(null);
  var context = React.useContext(WidgetsContext);
  if (context.development) {
    return /*#__PURE__*/React.createElement(ModalDeviceRender, {
      className: className,
      style: style,
      widgetProps: widgetProps,
      breakpoint: breakpoint,
      children: children,
      show: show
    });
  }
  var modalContext = React.useContext(ModalContext);
  var _React$useState = React.useState(null),
    backdropContainer = _React$useState[0],
    setBackdropContainer = _React$useState[1];
  var close = _$1.get(modalContext, 'close', null);
  var properties = _$1.get(widgetProps, 'properties', {});
  var background = _$1.get(widgetProps, 'properties.desktop.background');
  var backdrop = _$1.get(widgetProps, 'properties.desktop.backdrop');
  var layout = _$1.get(widgetProps, "properties." + breakpoint + ".layout", {});
  var layoutWidth = parseInt(_$1.get(layout, 'width', '1200'));
  var modalWidgetStyle = {
    content: {
      width: style.width,
      transform: "scale(" + zoom + ")"
    }
  };
  var modalContainerStyle = _extends({}, style, getModalStyles(properties), {
    transform: 'none'
  });
  useEffect(function () {
    calculateZoom();
    window.addEventListener('resize', calculateZoom);
    return function () {
      window.removeEventListener('resize', calculateZoom);
    };
  }, [breakpoint, layoutWidth]);
  useEffect(function () {
    function handleGatingMessage(event) {
      var _event$data = event.data,
        type = _event$data.type,
        payload = _event$data.payload;
      if (type === 'cleverstory:embed:gatingCommonViewer') {
        var _ref2 = payload || {},
          scrollYOffset = _ref2.scrollYOffset,
          interactionTopOffset = _ref2.interactionTopOffset;
        try {
          var _document$body;
          var assetViewer = (_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.getAttribute("assetViewer");
          var childElement = backdropContainer === null || backdropContainer === void 0 ? void 0 : backdropContainer.children[0];
          if (childElement) {
            var topPosition = 0;
            if (assetViewer) {
              topPosition = (interactionTopOffset || 0) + 50;
            } else {
              topPosition = (scrollYOffset + interactionTopOffset || 0) + 50;
            }
            if (topPosition + childElement.clientHeight > window.innerHeight) {
              var balanceHeight = topPosition + childElement.clientHeight - window.innerHeight;
              childElement.style.top = topPosition - balanceHeight + "px";
            } else {
              childElement.style.top = topPosition + "px";
            }
            childElement.style.opacity = "1";
          }
        } catch (_unused) {}
      }
    }
    window.addEventListener('message', handleGatingMessage);
    return function () {
      window.removeEventListener('message', handleGatingMessage);
    };
  }, [backdropContainer]);
  var handleClose = function handleClose() {
    if (close) {
      var isInIframe = window.parent !== window;
      if (isInIframe) {
        var parentWindow = window.parent;
        parentWindow.postMessage({
          type: "cleverstory:close:gatingViewer"
        }, '*');
      }
      close();
    }
  };
  useEffect(function () {
    var fullscreenContainer = document.fullscreenElement;
    var videoElement = fullscreenContainer ? fullscreenContainer.querySelector('video') : null;
    if (show && modalContainer && videoElement) {
      var gatingElement = document.getElementById(id);
      if (gatingElement) {
        var modalElement = gatingElement.parentElement.parentElement;
        fullscreenContainer.appendChild(modalElement);
      }
    }
  }, [modalContainer.current]);
  var onAfterOpen = function onAfterOpen(event) {
    var container = event.overlayEl;
    if (container) {
      try {
        setBackdropContainer(container);
        var isInIframe = window.parent !== window;
        if (isInIframe) {
          var _container$children;
          var parentWindow = window.parent;
          parentWindow.postMessage({
            type: "cleverstory:embed:gatingViewer"
          }, '*');
          if (container !== null && container !== void 0 && (_container$children = container.children) !== null && _container$children !== void 0 && _container$children[0]) {
            container.children[0].style.opacity = "0";
            setTimeout(function () {
              container.children[0].style.opacity = "1";
            }, 500);
          }
        }
      } catch (_unused2) {}
    }
  };
  var calculateZoom = function calculateZoom() {
    var windowWidth = window.innerWidth;
    var zoomValue = 1;
    if (layoutWidth > windowWidth) {
      zoomValue = windowWidth / layoutWidth;
    }
    setZoom(zoomValue);
  };
  return /*#__PURE__*/React.createElement(Modal$1, {
    id: id,
    ref: modalContainer,
    className: cx(className, styles$C.modalWidget, 'cs_modal_widget', (_cx = {}, _cx[styles$C.mobile] = breakpoint === 'mobile', _cx)),
    overlayClassName: cx(styles$C.modalOverlay, 'cs-modal-overlay'),
    style: modalWidgetStyle,
    "data-widget-id": id,
    "data-widget-type": type,
    isOpen: show,
    ariaHideApp: false,
    onAfterOpen: onAfterOpen
  }, /*#__PURE__*/React.createElement(HotspotRender, {
    breakpoint: breakpoint
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$C.modalContainer,
    style: modalContainerStyle
  }, /*#__PURE__*/React.createElement(BrandThemeManager, {
    className: "#" + id + " .cs_text_widget",
    themes: widgetProps.themes
  }), /*#__PURE__*/React.createElement(BackgroundView, {
    background: background,
    className: styles$C.modalBackground,
    breakpoint: breakpoint
  }), backdropContainer && /*#__PURE__*/React.createElement(Portal, {
    mountNode: backdropContainer
  }, /*#__PURE__*/React.createElement(BackgroundView, {
    background: backdrop,
    className: styles$C.overlayBackground,
    breakpoint: breakpoint
  })), close && /*#__PURE__*/React.createElement(Button, {
    className: styles$C.close,
    onClick: handleClose
  }, /*#__PURE__*/React.createElement("i", {
    className: cx(styles$C.closeIcon, 'cleverstory-close')
  })), /*#__PURE__*/React.createElement(ParallaxProvider, null, children))));
};
var ModalDeviceRender = function ModalDeviceRender(_ref3) {
  var _cx2;
  var className = _ref3.className,
    style = _ref3.style,
    widgetProps = _ref3.widgetProps,
    breakpoint = _ref3.breakpoint,
    children = _ref3.children;
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var properties = _$1.get(widgetProps, 'properties', {});
  var background = _$1.get(widgetProps, 'properties.desktop.background');
  var widgetStyle = _extends({}, style, getModalStyles(properties), {
    transform: 'none'
  });
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$C.modalDeviceRender, 'cs_modal_widget', (_cx2 = {}, _cx2[styles$C.mobile] = breakpoint === 'mobile', _cx2)),
    style: widgetStyle,
    "data-widget-id": id,
    "data-widget-type": type
  }, /*#__PURE__*/React.createElement(BackgroundView, {
    background: background,
    className: styles$C.modalBackground,
    breakpoint: breakpoint
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$C.modalContainer
  }, children));
};
function getModalStyles(properties) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var border = _$1.get(defaultProperties, 'border');
  var borderStyles = getBorderStyles$b(border);
  styles = _extends({}, styles, borderStyles);
  return styles;
}
function getBorderStyles$b(border) {
  var styles = {};
  if (!border) {
    return styles;
  }
  var topLeft = _$1.get(border, 'radius.topLeft', null);
  var topRight = _$1.get(border, 'radius.topRight', null);
  var bottomLeft = _$1.get(border, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(border, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var borderStyle = _$1.get(border, 'style') || 'bottom';
  if (borderStyle !== 'none') {
    var colorRgb = _$1.get(border, 'color');
    var color = 'transparent';
    if (colorRgb) {
      color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
    }
    styles['borderColor'] = color;
    var borderWidthString = _$1.get(border, 'width', 0);
    var borderWidget = parseInt(borderWidthString) + 'px';
    styles['borderWidth'] = borderWidget;
  }
  return styles;
}
var modalWidgetEquals = function modalWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var ModalWidget = React.memo(ModalWidgetComponent, modalWidgetEquals);

var styles$D = {"assetSearchBox":"_kkNAH","searchIcon":"_2j_TS","inputField":"_1tapJ","searchButton":"_1h_GM"};

var SearchComponent = function SearchComponent(_ref) {
  var className = _ref.className,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var contentContext = React.useContext(Content.Context);
  var id = _$1.get(widgetProps, 'uid');
  var properties = _$1.get(widgetProps, 'properties', {});
  var _useState = useState(''),
    value = _useState[0],
    setValue = _useState[1];
  var placeholder = _$1.get(widgetProps, 'properties.desktop.placeholder') || "";
  var searchIconColor = getColorStyles$b(_$1.get(widgetProps, 'properties.desktop.searchIconColor'));
  var contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);
  var itemsPerPage = _$1.get(contentWidget, 'properties.desktop.layoutStyle.itemsPerPage', 3);
  var inputWrapperStyles = getInputWrapperStyles(properties);
  var placeholderStyle = getPlaceholderStyle(properties);
  var inputFieldStyle = getInputFieldStyles(properties);
  var handleSearchOnChange = function handleSearchOnChange(e) {
    setValue(e.target.value);
    contentContext.updateQueryInContenGrid(contentWidget.uid, e.target.value);
    if (_$1.isEmpty(e.target.value)) {
      executeSearchAsset();
    }
  };
  var executeSearchAsset = function executeSearchAsset() {
    if (contentWidget.uid) {
      contentContext.fetchMappingsForContentGrid(contentWidget.uid, 0, itemsPerPage);
    }
  };
  return /*#__PURE__*/React.createElement(InputGroup, {
    style: inputWrapperStyles,
    className: cx(styles$D.assetSearchBox, className)
  }, placeholderStyle && /*#__PURE__*/React.createElement("style", null, "\n            #" + id + " input::-webkit-input-placeholder {\n              color: " + placeholderStyle.color + ";\n              font-family: " + placeholderStyle.fontFamily + "\n            }\n          "), /*#__PURE__*/React.createElement("i", {
    style: searchIconColor,
    className: cx('cleverstory-search', styles$D.searchIcon)
  }), /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: placeholder,
    style: inputFieldStyle,
    className: styles$D.inputField,
    value: value,
    onChange: handleSearchOnChange,
    onKeyPress: function onKeyPress(event) {
      if (event.key === 'Enter') {
        contentContext.fetchMappingsForContentGrid(contentWidget.uid, 0, itemsPerPage);
      }
    },
    disabled: false
  }), /*#__PURE__*/React.createElement(SearchButtonWidget, {
    breakpoint: breakpoint,
    widgetProps: widgetProps,
    onClick: executeSearchAsset
  }));
};
var SearchButtonWidget = function SearchButtonWidget(_ref2) {
  var breakpoint = _ref2.breakpoint,
    widgetProps = _ref2.widgetProps,
    onClick = _ref2.onClick;
  var _useState2 = useState({}),
    buttonStyles = _useState2[0],
    setButtonStyles = _useState2[1];
  Fonts.useFont(_$1.get(widgetProps, 'fonts') || []);
  var properties = _$1.get(widgetProps, 'properties', {});
  useEffect(function () {
    updateButtonStyles('regular');
  }, [breakpoint, widgetProps]);
  var updateButtonStyles = function updateButtonStyles(state) {
    var updatedStyles = getButtonStyles(properties, state);
    setButtonStyles(updatedStyles);
  };
  return /*#__PURE__*/React.createElement(Button, {
    className: styles$D.searchButton,
    style: buttonStyles,
    variant: "secondary",
    id: "search_button",
    onClick: onClick,
    onMouseOver: function onMouseOver() {
      return updateButtonStyles('hover');
    },
    onMouseOut: function onMouseOut() {
      return updateButtonStyles('regular');
    }
  }, "Search");
};
var searchComponentEquals = function searchComponentEquals(prevProps, nextProps) {
  var paths = ['className', 'widgetProps', 'breakpoint'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
function getInputFieldStyles(properties) {
  var inputstyles = {};
  if (!properties) {
    return inputstyles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var inputStyles = _$1.get(defaultProperties, 'font');
  var fontStyles = getFontStyle$7(inputStyles);
  inputstyles = _extends({}, inputstyles, fontStyles);
  var colorRgb = _$1.get(defaultProperties, 'inputTextColor', null);
  var color = getColorStyles$b(colorRgb);
  inputstyles = _extends({}, inputstyles, color);
  var fontFamily = _$1.get(defaultProperties, 'font.fontFamily', 'inherit');
  inputstyles = _extends({}, inputstyles, {
    fontFamily: fontFamily
  });
  var fontSizeString = _$1.get(defaultProperties, "font.fontSize") || 14;
  if (fontSizeString) {
    var fontSize = parseInt(fontSizeString) + 'px';
    inputstyles['fontSize'] = fontSize;
  }
  return inputstyles;
}
function getInputWrapperStyles(properties) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var inputPadding = _$1.get(defaultProperties, 'padding') || 0;
  if (inputPadding) {
    styles['padding'] = "0px " + inputPadding + "px";
  }
  var border = _$1.get(defaultProperties, 'border');
  var borderStyles = getBorderStyles$c(border);
  styles = _extends({}, styles, borderStyles);
  var backgroundColorRgb = _$1.get(defaultProperties, 'background', null);
  if (backgroundColorRgb) {
    styles = _extends({}, styles, {
      background: getColorsConfig(backgroundColorRgb)
    });
  }
  return styles;
}
function getPlaceholderStyle(properties) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var font = _$1.get(defaultProperties, 'font', {});
  var colorRgb = _$1.get(defaultProperties, 'placeholderColor', null);
  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }
  var styles = _extends({}, styles, {
    color: color
  });
  var fontFamily = _$1.get(font, 'fontFamily');
  if (fontFamily) {
    styles = _extends({}, styles, {
      fontFamily: fontFamily
    });
  }
  return styles;
}
function getColorStyles$b(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }
  var styles = _extends({}, styles, {
    color: color
  });
  return styles;
}
function getBorderStyles$c(border) {
  var styles = {};
  if (!border) {
    return styles;
  }
  var topLeft = _$1.get(border, 'radius.topLeft', null);
  var topRight = _$1.get(border, 'radius.topRight', null);
  var bottomLeft = _$1.get(border, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(border, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var borderStyle = _$1.get(border, 'style') || 'all';
  if (borderStyle !== 'none') {
    var borderWidthString = _$1.get(border, 'width') || 0;
    var borderWidget = parseInt(borderWidthString) + 'px';
    var fieldName = borderStyle == 'all' ? 'borderWidth' : 'borderBottomWidth';
    styles[fieldName] = borderWidget;
    var colorRgb = _$1.get(border, 'color');
    var color = 'transparent';
    if (colorRgb) {
      color = getColorsConfig(colorRgb);
    }
    styles['borderColor'] = color;
  }
  return styles;
}
function getButtonStyles(properties, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var defaultStyles = _$1.get(defaultProperties, "buttonStyles.regular", {});
  var colorRgb = _$1.get(defaultProperties, "buttonStyles." + active + ".font.color", null);
  var color = getColorStyles$b(colorRgb);
  styles = _extends({}, styles, color);
  var backgroundRgb = _$1.get(defaultProperties, "buttonStyles." + active + ".background", null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = getColorsConfig(backgroundRgb);
  }
  styles['background'] = background;
  var font = _$1.get(defaultStyles, 'font', {});
  var fontFamily = _$1.get(font, 'fontFamily');
  if (fontFamily) {
    styles = _extends({}, styles, {
      fontFamily: fontFamily
    });
  }
  var fontSizeString = _$1.get(defaultProperties, 'buttonStyles.regular.font.fontSize', null);
  var fontSize = 'inherit';
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }
  styles['fontSize'] = fontSize;
  var lineSpacingString = _$1.get(defaultProperties, 'buttonStyles.regular.font.lineSpacing', null);
  if (lineSpacingString) {
    var lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }
  var letterSpacingString = _$1.get(defaultProperties, 'buttonStyles.regular.font.letterSpacing', null);
  if (letterSpacingString) {
    var letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }
  var bold = _$1.get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }
  var italic = _$1.get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }
  var underline = _$1.get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }
  var border = _$1.get(defaultStyles, 'border', {});
  var borderColor = _$1.get(defaultProperties, "buttonStyles." + active + ".border.color", null);
  var borderStyle = getBorderStyles$c(border);
  styles = _extends({}, styles, borderStyle);
  var shadow = _$1.get(defaultProperties, "buttonStyles." + active + ".shadow", null);
  var shadowStyle = getBoxShadow(shadow);
  styles = _extends({}, styles, shadowStyle);
  return styles;
}
function getFontStyle$7(fontStyles) {
  var styles = {};
  if (!fontStyles) {
    return styles;
  }
  var colorRgb = _$1.get(fontStyles, 'color', null);
  var color = getColorStyles$b(colorRgb);
  styles = _extends({}, styles, color);
  var fontFamily = _$1.get(fontStyles, 'fontFamily', 'inherit');
  styles = _extends({}, styles, {
    fontFamily: fontFamily
  });
  var fontSizeString = _$1.get(fontStyles, "fontSize") || 14;
  if (fontSizeString) {
    var fontSize = parseInt(fontSizeString) + 'px';
    styles['fontSize'] = fontSize;
  }
  return styles;
}
var AssetSearchBox = React.memo(SearchComponent, searchComponentEquals);

var styles$E = {"searchColumnWrapper":"_3LLFu","searchContainer":"_36aBa","mobileColum":"_2OIac"};

var SearchContainerWidgetComponent = function SearchContainerWidgetComponent(_ref) {
  var _cx;
  var style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    parentProps = _ref.parentProps;
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var properties = _$1.get(widgetProps, 'properties', {});
  var deviceProperties = _$1.get(properties, "desktop", {});
  var horizontalColumn = _$1.get(parentProps, "properties.desktop.horizontalColumn", false);
  var columnStyles = _extends({}, style, {
    transform: 'none'
  }, getColumnStyles$1(deviceProperties, horizontalColumn, breakpoint));
  return /*#__PURE__*/React.createElement("div", {
    id: "search_container_column_" + id,
    style: columnStyles,
    className: cx((_cx = {}, _cx[styles$E.searchColumnWrapper] = horizontalColumn && breakpoint == 'desktop', _cx[styles$E.mobileColum] = breakpoint == 'mobile', _cx))
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(styles$E.searchContainer),
    style: _extends({}, style, {
      transform: 'none'
    })
  }, /*#__PURE__*/React.createElement(AssetSearchBox, {
    className: styles$E.widgetWrapperStyle,
    widgetProps: widgetProps,
    breakpoint: breakpoint
  })));
};
function getColumnStyles$1(properties, horizontalColumn, breakpoint) {
  var containerStyles = {};
  if (!properties) {
    return containerStyles;
  }
  var columnAlignment = _$1.get(properties, "horizontalAlignment", {
    position: 'center',
    margin: 0
  });
  var alignmentPosition = _$1.get(columnAlignment, 'position', 'center');
  var alignmnetMargin = _$1.get(columnAlignment, 'margin', 0);
  containerStyles['justifyContent'] = alignmentPosition;
  if (!horizontalColumn || breakpoint == 'mobile') {
    return containerStyles;
  }
  if (alignmentPosition === 'left') {
    containerStyles = _extends({}, containerStyles, {
      justifyContent: 'flex-start',
      paddingLeft: alignmnetMargin + "px"
    });
  } else if (alignmentPosition === 'right') {
    containerStyles = _extends({}, containerStyles, {
      justifyContent: 'flex-end',
      paddingRight: alignmnetMargin + "px"
    });
  }
  return containerStyles;
}
var searchContainerWidgetEquals = function searchContainerWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'parentProps'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var SearchContainerWidget = React.memo(SearchContainerWidgetComponent, searchContainerWidgetEquals);

var styles$F = {"menu":"_2ZSdL","mobile":"_2Vn0X","stretched":"_1VSu-","scrollWrapper":"_2XhiE","childContainer":"_8bUtA","portalWrapper":"_hqfXc","sticky":"_1m61X","slide":"_3DYUr","fade":"_2xDf_","background_slide":"_38n_z","background_slide_show":"_1LTGJ","background_slide_hide":"_1hDtQ","background_fade":"_fPnGW","background_fade_show":"_2N8m8","background_fade_hide":"_X5Ti1"};

var _excluded$6 = ["className", "style", "widgetProps", "breakpoint", "children"];
var MenuWidgetComponent = function MenuWidgetComponent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  var context = React.useContext(WidgetsContext);
  var _React$useContext = React.useContext(PageContext),
    zoom = _React$useContext.zoom,
    _React$useContext$pag = _React$useContext.pageWidth,
    pageWidth = _React$useContext$pag === void 0 ? '100%' : _React$useContext$pag;
  var _useState = useState({
      initiate: false,
      animate: false,
      menuHeight: 0
    }),
    scrollAnimation = _useState[0],
    setScrollAnimation = _useState[1];
  var _useState2 = useState(0),
    menuOffset = _useState2[0],
    setMenuOffset = _useState2[1];
  var menuListenerRef = useRef();
  var menuRef = useRef();
  var id = _$1.get(widgetProps, 'uid');
  var parentId = _$1.get(widgetProps, 'parent');
  var type = _$1.get(widgetProps, 'type');
  var deviceLayout = _$1.get(widgetProps, "properties." + breakpoint + ".layout");
  var stretched = _$1.get(widgetProps, 'properties.desktop.stretched', false);
  var background = _$1.get(widgetProps, 'properties.desktop.background');
  var scrollEffect = _$1.get(widgetProps, 'properties.desktop.scrollEffect');
  var alignment = getContainerAlignment$1(widgetProps, breakpoint);
  var liveElemenet = useLiveElementSelector(id);
  var prevScrollpos = 0;
  var widgetStyle = _extends({}, style, getStyles$d(widgetProps, breakpoint, pageWidth), getscrollEffect(scrollEffect, menuOffset, scrollAnimation, zoom, stretched, breakpoint));
  var menuPlaceholderStyles = _extends({}, style, {
    width: '100%',
    marginLeft: '0px',
    height: '1px',
    transform: "translate(0px, " + menuOffset + "px) rotate(0deg)"
  });
  useEffect(function () {
    var menuWidgetOffset = parseInt(_$1.get(deviceLayout, 'transform.translate').split(",")[1]);
    setMenuOffset(menuWidgetOffset);
  }, [breakpoint]);
  useEffect(function () {
    if (context.preview) {
      var parentDocument = window.parent.document;
      var iframe = parentDocument.getElementById('cs-preview-iframe');
      handleEventsForPreview(iframe);
      return;
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleOnScroll);
    }
    return function () {
      window.removeEventListener('scroll', handleOnScroll);
      if (context.preview) {
        var _parentDocument = window.parent.document;
        var _iframe = _parentDocument.getElementById('cs-preview-iframe');
        if (_iframe) {
          var iframeDocument = _iframe.contentDocument || _iframe.contentWindow.document;
          if (iframeDocument) {
            var iframeBody = iframeDocument.body;
            if (iframeBody) {
              iframeBody.removeEventListener('scroll', handleOnScroll);
            }
          }
        }
      }
    };
  }, [deviceLayout]);
  var handleEventsForPreview = function handleEventsForPreview(iframe) {
    if (iframe) {
      var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      if (iframeDocument) {
        var iframeBody = iframeDocument.body;
        if (iframeBody) {
          iframeBody.addEventListener('scroll', handleOnScroll);
        }
      }
    }
  };
  var handleOnScroll = function handleOnScroll() {
    if (scrollEffect === 'NONE') {
      return;
    }
    var scrollTopOffset = menuListenerRef.current.getBoundingClientRect().top;
    var menuHeight = menuRef.current.getBoundingClientRect().height;
    switch (scrollEffect) {
      case 'STICKY':
        setScrollAnimation(_extends({}, scrollAnimation, {
          initiate: window.pageYOffset >= scrollTopOffset && scrollTopOffset < 0
        }));
        break;
      case 'SLIDE':
      case 'FADE':
        var currentScrollPos = window.pageYOffset;
        setScrollAnimation({
          initiate: scrollTopOffset < 0,
          animate: prevScrollpos > currentScrollPos && scrollTopOffset < 0,
          menuHeight: menuHeight
        });
        prevScrollpos = currentScrollPos;
        break;
      case 'BACKGROUND_SLIDE':
      case 'BACKGROUND_FADE':
        var currentScrollPos = window.pageYOffset;
        setScrollAnimation(_extends({}, scrollAnimation, {
          initiate: window.pageYOffset >= scrollTopOffset && scrollTopOffset < 0,
          animate: scrollTopOffset < 0
        }));
        prevScrollpos = currentScrollPos;
        break;
      default:
        setScrollAnimation(false);
        break;
    }
  };
  var renderMenu = function renderMenu() {
    var _cx;
    return /*#__PURE__*/React.createElement("div", {
      id: id,
      className: cx(className, styles$F.menu, styles$F[scrollEffect.toLowerCase()], (_cx = {}, _cx[styles$F.stretched] = stretched, _cx[styles$F.mobile] = breakpoint === 'mobile', _cx)),
      ref: menuRef,
      style: widgetStyle,
      "data-widget-id": id,
      "data-widget-type": type
    }, /*#__PURE__*/React.createElement(BackgroundView, {
      background: background,
      className: scrollAnimation.animate ? styles$F[scrollEffect.toLowerCase() + "_show"] : styles$F[scrollEffect.toLowerCase() + "_hide"],
      breakpoint: breakpoint
    }), React.Children.map(children, function (child) {
      var widgetType = _$1.get(child, 'props.widgetProps.type');
      if (widgetType === MENU_CONTAINER) {
        return /*#__PURE__*/React.createElement("div", {
          style: alignment,
          className: cx(styles$F.childContainer)
        }, React.cloneElement(child, {
          parentRef: menuRef,
          parentStyle: widgetStyle
        }, null));
      }
      return React.cloneElement(child, {
        parentRef: menuRef,
        parentStyle: widgetStyle
      }, null);
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, (!_$1.has(context, 'development') || context.development || scrollEffect === 'NONE') && /*#__PURE__*/React.createElement(React.Fragment, null, renderMenu()), _$1.has(context, 'development') && !context.development && scrollEffect !== 'NONE' && /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement("div", {
    ref: menuListenerRef,
    style: menuPlaceholderStyles,
    className: styles$F.portalWrapper
  }), renderMenu()));
};
function getStyles$d(widgetProps, breakpoint, pageWidth) {
  var stretched = _$1.get(widgetProps, 'properties.desktop.stretched', false);
  var margin = _$1.get(widgetProps, 'properties.desktop.margin', 0);
  var padding = _$1.get(widgetProps, "properties." + breakpoint + ".padding", 0);
  var widgetStyles = {
    paddingTop: padding + "px",
    paddingBottom: padding + "px",
    transformOrigin: 'top'
  };
  if (breakpoint === 'desktop') {
    widgetStyles = _extends({}, widgetStyles, {
      width: "1200px",
      paddingLeft: padding + "px",
      paddingRight: padding + "px"
    });
    if (stretched) {
      widgetStyles = _extends({}, widgetStyles, {
        marginLeft: margin,
        width: "calc(100% - 2 * " + margin + "px)",
        left: "calc((100% - 2 * " + margin + "px))/2)"
      });
    }
  }
  if (breakpoint === 'mobile') {
    widgetStyles = _extends({}, widgetStyles, {
      width: pageWidth
    });
  }
  return widgetStyles;
}
function getscrollEffect(scrollEffect, menuOffset, scrollAnimation, zoom, stretched, breakpoint) {
  var initiate = scrollAnimation.initiate,
    animate = scrollAnimation.animate,
    menuHeight = scrollAnimation.menuHeight;
  var styles = scrollEffect === 'NONE' ? {} : {
    transform: "translate(0px, " + menuOffset + "px) rotate(0deg) scale(" + zoom + ")"
  };
  if (breakpoint === 'desktop' && stretched && scrollEffect !== 'NONE') {
    styles = _extends({}, styles, {
      width: "calc(100vw / " + zoom + ")",
      transformOrigin: '0 0'
    });
  }
  if (!initiate) {
    return styles;
  }
  switch (scrollEffect) {
    case 'STICKY':
      {
        return _extends({}, styles, {
          position: 'fixed',
          top: "0px",
          zIndex: 900,
          transform: "scale(" + zoom + ")"
        });
      }
    case 'SLIDE':
      {
        return _extends({}, styles, {
          position: 'fixed',
          top: animate ? '0px' : "-" + menuHeight + "px",
          zIndex: 900,
          transform: "scale(" + zoom + ")"
        });
      }
    case 'FADE':
      {
        return _extends({}, styles, {
          position: 'fixed',
          opacity: animate ? 1 : 0,
          zIndex: 900,
          transform: "scale(" + zoom + ")"
        });
      }
    case 'BACKGROUND_SLIDE':
    case 'BACKGROUND_FADE':
      {
        return _extends({}, styles, {
          position: 'fixed',
          top: "0px",
          zIndex: 900,
          transform: "scale(" + zoom + ")"
        });
      }
  }
  return styles;
}
function getContainerAlignment$1(widgetProps, breakpoint) {
  var alignment = _$1.get(widgetProps, "properties." + breakpoint + ".alignment", {
    position: 'center',
    margin: 0
  });
  var position = _$1.get(alignment, 'position', 'center');
  var margin = _$1.get(alignment, 'margin', 0);
  var verticalAlignment = _$1.get(widgetProps, "properties." + breakpoint + ".verticalAlignment", {
    position: 'center',
    margin: 0
  });
  var verticalPosition = _$1.get(verticalAlignment, 'position', 'center');
  var verticalMargin = _$1.get(verticalAlignment, 'margin', 0);
  var containerStyles = {};
  containerStyles['justifyContent'] = position;
  if (position === 'left') {
    containerStyles = _extends({}, containerStyles, {
      justifyContent: 'flex-start',
      paddingLeft: margin + "px"
    });
  } else if (position === 'right') {
    containerStyles = _extends({}, containerStyles, {
      justifyContent: 'flex-end',
      paddingRight: margin + "px"
    });
  }
  containerStyles['alignItems'] = verticalPosition;
  if (verticalPosition === 'top') {
    containerStyles = _extends({}, containerStyles, {
      alignItems: 'flex-start',
      paddingTop: verticalMargin + "px"
    });
  } else if (verticalPosition === 'bottom') {
    containerStyles = _extends({}, containerStyles, {
      alignItems: 'flex-end',
      paddingBottom: verticalMargin + "px"
    });
  }
  return containerStyles;
}
var menuWidgetEquals = function menuWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var MenuWidget = React.memo(MenuWidgetComponent, menuWidgetEquals);

var styles$G = {"buttonContainer":"_2qJ-B","menuButton":"_27QYB","lastButton":"_8iWeI","dropdownWrapper":"_e9Jk6","dropDownIcon":"_1-1NP","showDropdown":"_jIEHN","dropdownMenu":"_3IgHF","dropdownItem":"_NMKZ4","verticalView":"_1_htg","mobileDropdownMenu":"_1QLGn","mobileMenuButton":"_3xBvv","textContainer":"_bCICy","listView":"_2NME5","active":"_321HF","alignmentLeft":"_29gOS","alignmentRight":"_pJp7e"};

var MenuButtonComponent = function MenuButtonComponent(_ref) {
  var _cx, _cx2;
  var className = _ref.className,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    menuContent = _ref.menuContent;
  var trayBackground = breakpoint !== 'mobile' ? 'rgba(255, 255, 255, 0)' : getColorStyles$c(_$1.get(widgetProps, "properties." + breakpoint + ".trayBackground"));
  Fonts.useFont(_$1.get(widgetProps, 'fonts') || []);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(className, (_cx = {}, _cx[styles$G.buttonContainer] = breakpoint === 'desktop', _cx), (_cx2 = {}, _cx2[styles$G.verticalView] = breakpoint === 'mobile', _cx2)),
    style: {
      backgroundColor: trayBackground
    }
  }, (menuContent || []).map(function (menu, index) {
    if (menu.children && menu.children.length > 0) {
      return /*#__PURE__*/React.createElement(DropdownMenu$1, {
        index: index,
        key: index,
        menu: menu,
        contentLength: menuContent.length,
        widgetProperties: widgetProps,
        breakpoint: breakpoint
      });
    } else {
      return /*#__PURE__*/React.createElement(MenuItem, {
        index: index,
        key: index,
        menu: menu,
        contentLength: menuContent.length,
        widgetProperties: widgetProps,
        breakpoint: breakpoint
      });
    }
  }));
};
var MenuItem = function MenuItem(_ref2) {
  var _cx3;
  var menu = _ref2.menu,
    contentLength = _ref2.contentLength,
    index = _ref2.index,
    breakpoint = _ref2.breakpoint,
    widgetProperties = _ref2.widgetProperties;
  var actionExcutioner = useActionExectioner();
  var _useState = useState({}),
    buttonStyles = _useState[0],
    setButtonStyles = _useState[1];
  var widgetProps = _$1.get(widgetProperties, 'properties');
  var trayAlignment = _$1.get(widgetProps, 'mobile.trayAlignment.position');
  var action = _$1.get(menu, 'action');
  var handleClick = function handleClick(e) {
    if (action) {
      e.stopPropagation();
      actionExcutioner.execute(widgetProperties, action);
    }
  };
  useEffect(function () {
    updateButtonStyles('regular');
  }, [breakpoint, widgetProperties]);
  var updateButtonStyles = function updateButtonStyles(state) {
    var updatedStyle = getStyles$e(widgetProps, breakpoint, state);
    setButtonStyles(updatedStyle);
  };
  return /*#__PURE__*/React.createElement("div", {
    key: index,
    className: cx(styles$G.menuButton, (_cx3 = {}, _cx3[styles$G.lastButton] = index === contentLength - 1, _cx3)),
    style: buttonStyles,
    onClick: handleClick,
    onMouseOver: function onMouseOver() {
      return updateButtonStyles('hover');
    },
    onMouseOut: function onMouseOut() {
      return updateButtonStyles('regular');
    }
  }, (trayAlignment === "left" || trayAlignment === "right") && breakpoint === "mobile" ? /*#__PURE__*/React.createElement(TruncatedTextWithTooltip, {
    content: menu.name,
    maxWidth: 240,
    placement: "top"
  }) : menu.name);
};
var DropdownMenu$1 = function DropdownMenu(_ref3) {
  var _cx4, _cx5;
  var menu = _ref3.menu,
    contentLength = _ref3.contentLength,
    index = _ref3.index,
    widgetProperties = _ref3.widgetProperties,
    breakpoint = _ref3.breakpoint;
  var widgetProps = _$1.get(widgetProperties, 'properties');
  var subMenuRef = useRef();
  var _useState2 = useState({
      buttonStyle: {},
      showDropdown: false,
      active: 'regular'
    }),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    var activeButtonStyle = getStyles$e(widgetProps, breakpoint, 'regular');
    setState(function (state) {
      return _extends({}, state, {
        buttonStyle: activeButtonStyle,
        showDropdown: false
      });
    });
  }, [breakpoint, widgetProperties]);
  var handleOnMouseOver = function handleOnMouseOver(show, active) {
    var updatedStyle = getStyles$e(widgetProps, breakpoint, active);
    setState(function (state) {
      return _extends({}, state, {
        buttonStyle: updatedStyle,
        showDropdown: show,
        active: active
      });
    });
  };
  var toggleDropDown = function toggleDropDown(show) {
    var updatedStyle = getStyles$e(widgetProps, breakpoint, show ? 'hover' : 'regular');
    setState(function (state) {
      return _extends({}, state, {
        buttonStyle: updatedStyle,
        showDropdown: show,
        active: show ? 'hover' : 'regular'
      });
    });
  };
  var adjustSubMenuPosition = function adjustSubMenuPosition() {
    var submenuRect = subMenuRef.current.getBoundingClientRect();
    var overFlowLeft = Math.round(submenuRect.left);
    var overFlowRight = overFlowLeft + subMenuRef.current.scrollWidth;
    if (overFlowRight > window.innerWidth) {
      subMenuRef.current.style.transform = "translateX(-" + (overFlowRight - window.innerWidth) + "px)";
    }
  };
  useEffect(function () {
    if (state.showDropdown && breakpoint == 'desktop') {
      adjustSubMenuPosition();
    }
  }, [state.showDropdown]);
  if (breakpoint === 'mobile') {
    return /*#__PURE__*/React.createElement(MobileDropDownMenu, {
      menu: menu,
      index: index,
      state: state,
      widgetProps: widgetProps,
      toggleDropDown: toggleDropDown,
      handleOnMouseOver: handleOnMouseOver,
      contentLength: contentLength
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    onMouseLeave: function onMouseLeave() {
      return handleOnMouseOver(false, 'regular');
    },
    onMouseEnter: function onMouseEnter() {
      return handleOnMouseOver(true, 'hover');
    },
    className: styles$G.dropdownWrapper
  }, /*#__PURE__*/React.createElement("button", {
    className: cx(styles$G.menuButton, (_cx4 = {}, _cx4[styles$G.lastButton] = index === contentLength - 1, _cx4)),
    style: state.buttonStyle,
    key: index,
    onClick: function onClick() {
      return toggleDropDown(!state.showDropdown);
    }
  }, menu.name, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-drop-down', styles$G.dropDownIcon, (_cx5 = {}, _cx5[styles$G.showDropdown] = state.showDropdown, _cx5))
  })), state.showDropdown && /*#__PURE__*/React.createElement("div", {
    ref: subMenuRef,
    className: styles$G.dropdownMenu
  }, (menu.children || []).map(function (submenu, index) {
    return /*#__PURE__*/React.createElement(SubMenuOption, {
      key: index,
      widgetProps: widgetProps,
      breakpoint: "desktop",
      action: submenu.action,
      name: submenu.name,
      index: index
    });
  })));
};
var MobileDropDownMenu = function MobileDropDownMenu(_ref4) {
  var _cx6, _cx7, _cx8;
  var menu = _ref4.menu,
    index = _ref4.index,
    state = _ref4.state,
    widgetProps = _ref4.widgetProps,
    handleOnMouseOver = _ref4.handleOnMouseOver,
    toggleDropDown = _ref4.toggleDropDown,
    contentLength = _ref4.contentLength;
  var spacing = _$1.get(state.buttonStyle, 'marginBottom');
  var trayAlignment = _$1.get(widgetProps, 'mobile.trayAlignment.position');
  var dropdownButtonStyle = _extends({}, state.buttonStyle, {
    marginBottom: '0px'
  });
  return /*#__PURE__*/React.createElement("div", {
    key: index,
    style: {
      marginBottom: spacing
    },
    onClick: function onClick() {
      return toggleDropDown(!state.showDropdown);
    },
    onMouseLeave: function onMouseLeave() {
      return handleOnMouseOver(state.showDropdown, 'regular');
    },
    onMouseEnter: function onMouseEnter() {
      return handleOnMouseOver(state.showDropdown, 'hover');
    },
    className: cx(styles$G.mobileDropdownMenu),
    id: "menu"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles$G.mobileMenuButton, (_cx6 = {}, _cx6[styles$G.lastButton] = index === contentLength - 1, _cx6)),
    style: dropdownButtonStyle
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$G.textContainer
  }, trayAlignment === "left" || trayAlignment === "right" ? /*#__PURE__*/React.createElement(TruncatedTextWithTooltip, {
    content: menu.name,
    maxWidth: 240,
    placement: "top"
  }) : menu.name), /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-drop-down', (_cx7 = {}, _cx7[styles$G.showDropdown] = state.showDropdown, _cx7))
  })), /*#__PURE__*/React.createElement("ul", {
    className: cx(styles$G.listView, (_cx8 = {}, _cx8[styles$G.active] = state.showDropdown, _cx8)),
    id: "listview"
  }, (menu.children || []).map(function (submenu, index) {
    return /*#__PURE__*/React.createElement(SubMenuOption, {
      key: index,
      widgetProps: widgetProps,
      breakpoint: "mobile",
      action: submenu.action,
      name: submenu.name,
      index: index
    });
  })));
};
var SubMenuOption = function SubMenuOption(_ref5) {
  var name = _ref5.name,
    index = _ref5.index,
    widgetProps = _ref5.widgetProps,
    breakpoint = _ref5.breakpoint,
    action = _ref5.action;
  var actionExcutioner = useActionExectioner();
  var _useState3 = useState(getDropDownStyles$1(widgetProps, 'regular', breakpoint)),
    subMenuStyle = _useState3[0],
    setSubMenuStyle = _useState3[1];
  var handleSubMenuHover = function handleSubMenuHover(active) {
    var updatedStyle = getDropDownStyles$1(widgetProps, active, breakpoint);
    setSubMenuStyle(updatedStyle);
  };
  var handleClick = function handleClick(e) {
    if (action) {
      e.stopPropagation();
      actionExcutioner.execute(widgetProps, action);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    style: subMenuStyle,
    key: index,
    onMouseLeave: function onMouseLeave() {
      return handleSubMenuHover('regular');
    },
    onMouseEnter: function onMouseEnter() {
      return handleSubMenuHover('hover');
    },
    onClick: handleClick,
    className: styles$G.dropdownItem
  }, name);
};
var menuButtonEquals = function menuButtonEquals(prevProps, nextProps) {
  var paths = ['className', 'widgetProps', 'breakpoint', 'menuContent', 'active'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var MenuButton = React.memo(MenuButtonComponent, menuButtonEquals);
function getDropDownStyles$1(widgetProperties, active, breakpoint) {
  var styles = {};
  if (!widgetProperties) {
    return styles;
  }
  var defaultProperties = _$1.get(widgetProperties, "desktop");
  var defaultStyles = _$1.get(defaultProperties, "regular.menuStyles", {});
  var colorRgb = _$1.get(defaultProperties, active + ".dropdownColor", null);
  var color = getColorStyles$c(colorRgb);
  styles = _extends({}, styles, {
    color: color
  });
  var backgroundRgb = _$1.get(defaultProperties, active + ".dropdownBackground", null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = getColorsConfig(backgroundRgb);
  }
  styles['background'] = background;
  var font = _$1.get(defaultStyles, 'font', {});
  var fontFamily = _$1.get(font, 'fontFamily');
  if (fontFamily) {
    styles = _extends({}, styles, {
      fontFamily: fontFamily
    });
  }
  var layoutHeight = _$1.get(defaultProperties, 'layout.height');
  if (layoutHeight) {
    styles['lineHeight'] = layoutHeight;
  }
  var bold = _$1.get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }
  var italic = _$1.get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }
  var underline = _$1.get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }
  var lineSpacingString = _$1.get(defaultProperties, 'regular.menuStyles.font.lineSpacing', null);
  if (lineSpacingString) {
    var lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }
  var letterSpacingString = _$1.get(defaultProperties, 'regular.menuStyles.font.letterSpacing', null);
  if (letterSpacingString) {
    var letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }
  var fontSizeString = breakpoint === 'desktop' ? _$1.get(defaultProperties, "regular.menuStyles.font.fontSize", null) : 14;
  var fontSize = 'inherit';
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }
  styles['fontSize'] = fontSize;
  styles['justifyContent'] = 'center';
  styles['textAlign'] = 'center';
  var border = _$1.get(defaultProperties, active + ".dropdownBorder", {});
  var borderColor = _$1.get(border, "color", null);
  var borderStyle = getBorderStyles$d(border, borderColor);
  styles = _extends({}, styles, borderStyle);
  return styles;
}
function getStyles$e(properties, breakpoint, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var defaultStyles = _$1.get(defaultProperties, "regular.menuStyles", {});
  var colorRgb = _$1.get(defaultProperties, active + ".menuStyles.font.color", null);
  var color = getColorStyles$c(colorRgb);
  styles = _extends({}, styles, {
    color: color
  });
  var backgroundRgb = _$1.get(defaultProperties, active + ".menuStyles.background", null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = getColorsConfig(backgroundRgb);
  }
  styles['background'] = background;
  var font = _$1.get(defaultStyles, 'font', {});
  var fontFamily = _$1.get(font, 'fontFamily');
  if (fontFamily) {
    styles = _extends({}, styles, {
      fontFamily: fontFamily
    });
  }
  var fontSizeString = _$1.get(deviceProperties, 'regular.menuStyles.font.fontSize', null);
  var fontSize = 'inherit';
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }
  styles['fontSize'] = fontSize;
  var letterSpacingString = _$1.get(deviceProperties, 'regular.menuStyles.font.letterSpacing', null);
  if (letterSpacingString) {
    var letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }
  var layoutHeight = _$1.get(deviceProperties, 'layout.height');
  var lineSpacingString = _$1.get(deviceProperties, 'regular.menuStyles.font.lineSpacing', null);
  if (lineSpacingString) {
    var lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }
  var bold = _$1.get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }
  var italic = _$1.get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }
  var underline = _$1.get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }
  var border = _$1.get(defaultProperties, active + ".menuStyles.border", {});
  var borderColor = _$1.get(defaultProperties, active + ".menuStyles.border.color", null);
  var borderStyle = getBorderStyles$d(border, borderColor);
  styles = _extends({}, styles, borderStyle);
  var spacing = _$1.get(defaultProperties, 'padding');
  var horizontalPadding = _$1.get(defaultProperties, 'itemHorizontalPadding');
  var verticalPadding = _$1.get(defaultProperties, 'itemVerticalPadding');
  styles = _extends({}, styles, {
    paddingLeft: horizontalPadding + "px",
    paddingRight: horizontalPadding + "px",
    paddingTop: verticalPadding + "px",
    paddingBottom: verticalPadding + "px"
  });
  if (breakpoint === 'mobile') {
    styles = _extends({}, styles, {
      marginBottom: spacing + "px"
    });
  } else if (breakpoint === 'desktop') {
    styles = _extends({}, styles, {
      marginRight: spacing + "px"
    });
  }
  var alignment = _$1.get(deviceProperties, 'alignment', {});
  var position = _$1.get(alignment, 'position', 'center');
  styles['textAlign'] = position;
  var margin = _$1.get(alignment, 'margin', 0);
  if (position === 'left') {
    styles = _extends({}, styles, {
      paddingLeft: margin + "px",
      justifyContent: 'flex-start'
    });
  } else if (position === 'right') {
    styles = _extends({}, styles, {
      paddingRight: margin + "px",
      justifyContent: 'flex-end'
    });
  }
  return styles;
}
function getColorStyles$c(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  return color;
}
function getBorderStyles$d(value, colorRgb) {
  if (!value) {
    return null;
  }
  var styles = {};
  var topLeft = _$1.get(value, 'radius.topLeft', null);
  var topRight = _$1.get(value, 'radius.topRight', null);
  var bottomLeft = _$1.get(value, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(value, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var color = 'transparent';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  styles['borderColor'] = color;
  var borderWidthString = _$1.get(value, 'width', null);
  var borderWidget = parseInt(borderWidthString) + 'px';
  styles['borderWidth'] = borderWidget;
  return styles;
}

var styles$H = {"menuContainer":"_29dM-","menuListView":"_8R4NE","expandView":"_2Diws","mobileView":"_2aPAZ","wrapper":"_2h3Ed","hamburger":"_3sWJl","menuIcon":"_on1U6","alignmentLeft":"_2hI_h","alignmentRight":"_15WnN"};

var MenuContainerWidgetComponent = function MenuContainerWidgetComponent(_ref) {
  var _cx, _cx2, _cx3, _cx4, _cx5, _cx6, _cx7;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    parentRef = _ref.parentRef,
    parentStyle = _ref.parentStyle;
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var properties = _$1.get(widgetProps, 'properties', {});
  var deviceProperties = _$1.get(properties, "" + breakpoint, {});
  var trayAlignment = _$1.get(widgetProps, "properties." + breakpoint + ".trayAlignment.position");
  var layout = _$1.get(widgetProps, "properties." + breakpoint + ".layout");
  var _useState = useState('regular'),
    iconState = _useState[0];
  var animation = _$1.get(widgetProps, "properties." + breakpoint + ".animation") || {};
  var _useState2 = useState(false),
    expand = _useState2[0],
    setExpand = _useState2[1];
  var menuContent = _$1.get(widgetProps, 'content');
  var iconStyle = getIconStyles(properties, iconState);
  var widgetStyle = _extends({}, style, getStyles$f(widgetProps, breakpoint));
  var handleOnClick = function handleOnClick(e) {
    setExpand(!expand);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, (_cx = {}, _cx[styles$H.menuContainer] = breakpoint === 'desktop', _cx), (_cx2 = {}, _cx2[styles$H.mobileView] = breakpoint === 'mobile', _cx2), 'cs_menucontainer'),
    style: widgetStyle,
    "data-widget-id": id,
    tabIndex: 0,
    onClick: handleOnClick,
    "data-widget-type": type
  }, breakpoint === 'mobile' && /*#__PURE__*/React.createElement(AnimationComponent, animation, /*#__PURE__*/React.createElement("div", {
    style: {
      height: layout.height
    },
    className: styles$H.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    style: iconStyle,
    className: styles$H.hamburger
  }, /*#__PURE__*/React.createElement("i", {
    className: cx((_cx3 = {}, _cx3['cleverstory-menu'] = !expand, _cx3), (_cx4 = {}, _cx4['cleverstory-close'] = expand, _cx4), styles$H.menuIcon)
  })))), breakpoint === 'desktop' && /*#__PURE__*/React.createElement(MenuButton, {
    menuContent: menuContent,
    breakpoint: breakpoint,
    active: "regular",
    widgetProps: widgetProps
  })), breakpoint === 'mobile' && parentRef.current && ReactDOM.createPortal(/*#__PURE__*/React.createElement("div", {
    style: {
      top: "" + parentStyle.height
    },
    className: cx(styles$H.menuListView, (_cx5 = {}, _cx5[styles$H.expandView] = expand, _cx5), (_cx6 = {}, _cx6[styles$H.alignmentLeft] = trayAlignment === 'left', _cx6), (_cx7 = {}, _cx7[styles$H.alignmentRight] = trayAlignment === 'right', _cx7))
  }, /*#__PURE__*/React.createElement(MenuButton, {
    menuContent: menuContent,
    breakpoint: breakpoint,
    active: "regular",
    widgetProps: widgetProps
  })), parentRef.current));
};
function getStyles$f(widget, breakpoint) {
  var styles = {};
  if (breakpoint === 'desktop') {
    var width = parseFloat(_$1.get(widget, "properties." + breakpoint + ".layout.width", 100));
    var height = parseFloat(_$1.get(widget, "properties." + breakpoint + ".layout.height", 100));
    styles = _extends({}, styles, {
      maxWidth: width,
      height: height,
      marginLeft: 0
    });
  }
  return styles;
}
function getIconStyles(properties, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, 'mobile');
  var defaultStyles = _$1.get(defaultProperties, active + ".menuStyles", {});
  var colorRgb = _$1.get(defaultStyles, "font.color", null);
  var color = getColorStyles$d(colorRgb);
  styles = _extends({}, styles, color);
  var backgroundRgb = _$1.get(defaultStyles, "background", null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = getColorsConfig(backgroundRgb);
  }
  styles['background'] = background;
  var border = _$1.get(defaultStyles, 'border', {});
  var borderColor = _$1.get(defaultStyles, "border.color", null);
  var borderStyle = getBorderStyles$e(border, borderColor);
  styles = _extends({}, styles, borderStyle);
  styles['justifyContent'] = 'center';
  styles['textAlign'] = 'center';
  return styles;
}
function getColorStyles$d(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  var styles = {
    color: color
  };
  return styles;
}
function getBorderStyles$e(value, colorRgb) {
  if (!value) {
    return null;
  }
  var styles = {};
  var topLeft = _$1.get(value, 'radius.topLeft', null);
  var topRight = _$1.get(value, 'radius.topRight', null);
  var bottomLeft = _$1.get(value, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(value, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var color = 'transparent';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  styles['borderColor'] = color;
  var borderWidthString = _$1.get(value, 'width', null);
  var borderWidget = parseInt(borderWidthString) + 'px';
  styles['borderWidth'] = borderWidget;
  return styles;
}
var menuContainerWidgetEquals = function menuContainerWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var MenuContainerWidget = React.memo(MenuContainerWidgetComponent, menuContainerWidgetEquals);

var styles$I = {"form":"_22r-X","externalForm":"_2kRYz","pardotForm":"_3BDNe","loadingMarketoForm":"_1F6Q8","externalFormIframe":"_2D17y"};

var HubspotFormView = function HubspotFormView(_ref) {
  var form = _ref.form,
    uid = _ref.uid;
  var portalId = _$1.get(form.configuration, "portalId", null);
  var formId = _$1.get(form.configuration, "guid", null);
  var region = _$1.get(form, "region", null);
  var context = React.useContext(ExternalFormWidgetContext);
  var widgetContextRef = React.useRef(null);
  var _useState = useState(false),
    scriptLoaded = _useState[0],
    setScriptLoaded = _useState[1];
  useEffect(function () {
    widgetContextRef.current = context;
  }, [context]);
  useEffect(function () {
    appendScript();
  }, []);
  useEffect(function () {
    if (window && window.hbspt) {
      window.hbspt.forms.create({
        region: region || "na1",
        portalId: portalId,
        formId: formId,
        target: "#contact_form_" + uid,
        onFormSubmit: function onFormSubmit(form) {},
        onFormSubmitted: function onFormSubmitted(event, form) {
          var email = form.submissionValues.email;
          var firstName = _$1.get(form.submissionValues, 'firstname') || null;
          var lastName = _$1.get(form.submissionValues, 'lastname') || null;
          var workphone = _$1.get(form.submissionValues, 'phone') || null;
          var company = _$1.get(form.submissionValues, 'company') || null;
          var contactRequest = {
            email: email,
            firstName: firstName,
            lastName: lastName,
            workphone: workphone,
            company: company,
            formSource: 'hubspot'
          };
          handleFormSubmit(contactRequest);
        }
      });
    }
  }, [formId, scriptLoaded, context]);
  var handleFormSubmit = useCallback(function (contactRequest) {
    var widgetContext = widgetContextRef.current;
    if (widgetContext && widgetContext.onFormSubmit) {
      widgetContext.onFormSubmit(contactRequest, widgetContext.parent);
    }
  }, [widgetContextRef]);
  var appendScript = function appendScript() {
    if (!window || window.hbspt) return;
    var script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/shell.js";
    script.key = "hubspot_form";
    script.type = "text/javascript";
    script.onload = function () {
      return window && window.hbspt ? setScriptLoaded(true) : null;
    };
    document.body.appendChild(script);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles$I.externalForm)
  }, /*#__PURE__*/React.createElement("div", {
    id: "contact_form_" + uid
  }));
};

var MarketoFormView = function MarketoFormView(_ref) {
  var _cx;
  var form = _ref.form,
    uid = _ref.uid;
  var context = React.useContext(ExternalFormWidgetContext);
  var formContainerRef = React.useRef(null);
  var widgetContextRef = React.useRef(null);
  var _useState = useState({
      loading: false,
      scriptLoaded: false,
      formloaded: false
    }),
    state = _useState[0],
    setState = _useState[1];
  var formId = _$1.get(form.configuration, 'formId', null);
  var munchkinId = _$1.get(form.configuration, 'munchkinId', null);
  var domain = _$1.get(form.configuration, 'domain', null);
  var handleFormSubmit = function handleFormSubmit(contactRequest) {
    var widgetContext = widgetContextRef.current;
    if (widgetContext.onFormSubmit) {
      widgetContext.onFormSubmit(contactRequest, widgetContext.parent);
      return;
    }
  };
  var appendScript = function appendScript(baseUrl) {
    if (window.MktoForms2) {
      return;
    }
    var script = document.createElement("script");
    script.src = baseUrl + "/js/forms2/js/forms2.min.js";
    script.onload = function () {
      loadForm();
    };
    document.body.appendChild(script);
  };
  useEffect(function () {
    widgetContextRef.current = context;
  }, [context]);
  useEffect(function () {
    if (!window.MktoForms2) {
      appendScript(domain);
    } else {
      loadForm();
    }
  }, [context.onFormSubmit]);
  var loadForm = function loadForm() {
    if (!window.MktoForms2 || !context.onFormSubmit) {
      return;
    }
    window.MktoForms2.whenReady(function (form) {
      setState(function (state) {
        return _extends({}, state, {
          loading: false
        });
      });
    });
    var loadedForm = window.MktoForms2.getForm(formId);
    if (loadedForm) {
      destroyForm();
      renderForm(loadedForm);
    } else {
      window.MktoForms2.loadForm(domain, munchkinId, formId, function (form) {
        destroyForm();
        renderForm(form);
      });
    }
  };
  var renderForm = function renderForm(form) {
    if (!form) {
      return;
    }
    var formElement = document.createElement("form");
    var rendered = form.render(formElement);
    if (_$1.size(rendered) == 0) {
      return;
    }
    window.postMessage({
      type: "cleverstory:marketo:form:loaded",
      payload: {
        formId: formId
      }
    }, '*');
    rendered[0].setAttribute("id", "marketo_" + new Date().getTime());
    formContainerRef.current.appendChild(rendered[0]);
    form.onSubmit(function () {});
    form.onSuccess(function (values, followUpUrl) {
      var vals = form.vals();
      var email = _$1.get(vals, 'Email');
      var firstName = _$1.get(vals, 'FirstName') || null;
      var lastName = _$1.get(vals, 'LastName') || null;
      var title = _$1.get(vals, 'Title') || null;
      var company = _$1.get(vals, 'Company') || null;
      var phone = _$1.get(vals, 'Phone') || null;
      var contactRequest = {
        email: email.toString(),
        firstName: firstName,
        lastName: lastName,
        title: title,
        company: company,
        workphone: phone,
        formSource: 'marketo'
      };
      handleFormSubmit(contactRequest);
      return false;
    });
  };
  var destroyForm = function destroyForm() {
    formContainerRef.current.innerHTML = "";
  };
  return /*#__PURE__*/React.createElement("div", {
    key: uid,
    className: cx(styles$I.externalForm, (_cx = {}, _cx[styles$I.loadingMarketoForm] = state.loading, _cx))
  }, state.loading && /*#__PURE__*/React.createElement("div", null, " Loading Marketo Form .... "), /*#__PURE__*/React.createElement("div", {
    ref: formContainerRef
  }));
};

var ExternalForm = function ExternalForm(_ref) {
  var form = _ref.form,
    widget = _ref.widget,
    breakpoint = _ref.breakpoint;
  var context = React.useContext(ExternalFormWidgetContext);
  var url = _$1.get(form.configuration, "url", null);
  var contextRef = useRef(context);
  var width = _$1.get(widget, "properties." + breakpoint + ".layout.width");
  var height = _$1.get(widget, "properties." + breakpoint + ".layout.height");
  useEffect(function () {
    contextRef.current = context;
  }, [context]);
  useEffect(function () {
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
    eventer(messageEvent, _handleFormSubmit, false);
  }, []);
  var _handleFormSubmit = function handleFormSubmit(e) {
    var currentContext = contextRef.current;
    if (currentContext && e.data.type === 'EXTERNAL_FORM_SUBMISSION') {
      var detachEventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
      var deEventer = window[detachEventMethod];
      var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";
      var email = e.data.payload.email;
      var firstName = e.data.payload.firstName;
      var lastName = e.data.payload.lastName;
      var company = e.data.payload.company;
      var title = e.data.payload.title;
      var workPhone = e.data.payload.workPhone;
      var contactRequest = {
        email: email,
        firstName: firstName,
        lastName: lastName,
        company: company,
        title: title,
        workPhone: workPhone,
        formSource: 'external'
      };
      currentContext.onFormSubmit(contactRequest, currentContext.parent);
      deEventer(messageEvent, _handleFormSubmit, false);
      return;
    }
  };
  if (!url) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles$I.externalForm)
  }, /*#__PURE__*/React.createElement("iframe", {
    className: styles$I.externalFormIframe,
    src: url,
    width: width,
    height: height
  }));
};

var PardotFormView = function PardotFormView(_ref) {
  var form = _ref.form,
    uid = _ref.uid,
    widget = _ref.widget,
    breakpoint = _ref.breakpoint;
  var context = React.useContext(ExternalFormWidgetContext);
  var widgetContextRef = React.useRef(null);
  var embedCode = _$1.get(form.configuration, "embedCode", "") || "";
  var _useState = useState(null),
    currentUid = _useState[0],
    setCurrentUid = _useState[1];
  var height = _$1.get(widget, "properties." + breakpoint + ".layout.height");
  embedCode = embedCode.replace(/\bheight="(\d+)"/g, "height=\"" + height + "\"");
  useEffect(function () {
    widgetContextRef.current = context;
  }, [context]);
  useEffect(function () {
    if (currentUid && context.onFormSubmit) {
      var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
      var eventer = window[eventMethod];
      var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
      eventer(messageEvent, _handleFormSubmit, false);
    }
  }, [currentUid, context.onFormSubmit]);
  var _handleFormSubmit = function handleFormSubmit(e) {
    var widgetContext = widgetContextRef.current;
    if (widgetContext && e.data.type === 'PARDOT_FORM_SUBMISSION') {
      var detachEventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
      var deEventer = window[detachEventMethod];
      var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";
      var email = e.data.payload.email;
      var firstName = e.data.payload.firstName;
      var lastName = e.data.payload.lastName;
      var company = e.data.payload.company;
      var title = e.data.payload.title;
      var contactRequest = {
        email: email,
        firstName: firstName,
        lastName: lastName,
        company: company,
        title: title,
        formSource: 'pardot'
      };
      widgetContext.onFormSubmit(contactRequest, widgetContext.parent);
      deEventer(messageEvent, _handleFormSubmit, false);
      return;
    }
  };
  var handleClick = function handleClick() {
    if (currentUid == uid) {
      return;
    }
    setCurrentUid(uid);
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "pardot_form_" + breakpoint + "_" + uid,
    style: {
      height: height
    },
    className: cx(styles$I.externalForm, styles$I.pardotForm),
    onMouseOver: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: height
    },
    dangerouslySetInnerHTML: {
      __html: embedCode
    }
  }));
};

var ExternalFormWidgetContext = React.createContext({
  onFormSubmit: function onFormSubmit() {}
});
var ExternalFormWidget = function ExternalFormEditor(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children;
  var context = React.useContext(WidgetsContext);
  var externalFormContext = React.useContext(FormContext);
  var _useState = useState({
      formStyles: {},
      step: ''
    }),
    externalFormState = _useState[0],
    setExternalFormState = _useState[1];
  var _useState2 = useState({
      parent: null
    }),
    externalFormContextState = _useState2[0],
    setExternalFormContextState = _useState2[1];
  var id = _$1.get(widgetProps, 'uid');
  var formSteps = children.filter(function (item) {
    return _$1.get(item, 'props.widgetProps.type') === FORM_STEP;
  }).map(function (item) {
    return _$1.get(item, 'props.widgetProps');
  });
  formSteps.push(widgetProps);
  formSteps = _$1.orderBy(formSteps, ['order'], ['asc']);
  var properties = _$1.get(widgetProps, 'properties', {});
  var deviceProperties = _$1.get(properties, "" + breakpoint, {});
  Fonts$1.useFont(_$1.get(widgetProps, 'fonts') || []);
  var widgetStyle = _extends({}, style, externalFormState.formStyles);
  var handleFormSubmit = function handleFormSubmit(contactRequest, parent) {
    formSteps = _$1.orderBy(formSteps, ['order'], ['desc']);
    var steps = formSteps.filter(function (item) {
      return _$1.get(item, 'type') === FORM_STEP;
    });
    var successStep = steps[0];
    setExternalFormState(function (externalFormState) {
      return _extends({}, externalFormState, {
        step: _$1.get(widgetProps, 'step', _$1.get(successStep, 'uid', null))
      });
    });
    if (externalFormContext.onFormSubmit) {
      externalFormContext.onFormSubmit(context.session, id, {
        contactRequest: contactRequest,
        parent: parent,
        external: true
      });
    }
  };
  useEffect(function () {
    var formStyles = getStyles$g(properties, breakpoint);
    setExternalFormState(function (externalFormState) {
      return _extends({}, externalFormState, {
        formStyles: formStyles
      });
    });
  }, [deviceProperties]);
  useEffect(function () {
    setExternalFormContextState(function (state) {
      return _extends({}, state, {
        onFormSubmit: handleFormSubmit,
        parent: context.parent
      });
    });
  }, [context.parent]);
  return /*#__PURE__*/React.createElement(ExternalFormWidgetContext.Provider, {
    value: externalFormContextState
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$I.form),
    style: widgetStyle,
    "data-widget-id": id
  }, React.Children.map(children, function (child) {
    var active = _$1.get(child, 'props.widgetProps.uid') === externalFormState.step;
    if (!active) {
      return /*#__PURE__*/React.createElement(ExternalFormView, {
        widgetProps: widgetProps,
        breakpoint: breakpoint
      });
    }
    return React.cloneElement(child, {
      activeStep: active
    }, null);
  })));
};
var ExternalFormView = function ExternalFormView(props) {
  var form = _$1.get(props.widgetProps, "content", null);
  var uid = _$1.get(props.widgetProps, "uid", "");
  switch (form && form.type) {
    case "hubspot":
      return /*#__PURE__*/React.createElement(HubspotFormView, {
        form: form,
        uid: uid
      });
    case "marketo":
      return /*#__PURE__*/React.createElement(MarketoFormView, {
        form: form,
        uid: uid
      });
    case "pardot":
      return /*#__PURE__*/React.createElement(PardotFormView, {
        form: form,
        uid: uid,
        widget: props.widgetProps,
        breakpoint: props.breakpoint
      });
    case "external":
      return /*#__PURE__*/React.createElement(ExternalForm, {
        form: form,
        uid: uid,
        widget: props.widgetProps,
        breakpoint: props.breakpoint
      });
    default:
      return null;
  }
};
function getStyles$g(properties, breakpoint) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultProperties = _$1.get(properties, "desktop");
  var deviceProperties = _$1.get(properties, "" + breakpoint);
  var font = _$1.get(defaultProperties, 'font', {});
  var colorRgb = _$1.get(font, 'color', null);
  var color = getColorStyles$e(colorRgb);
  styles = _extends({}, styles, color);
  var fontFamily = _$1.get(font, 'fontFamily', 'inherit');
  styles = _extends({}, styles, {
    fontFamily: fontFamily
  });
  var fontSizeString = _$1.get(deviceProperties, 'regular.font.fontSize', null);
  var fontSize = 'inherit';
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }
  styles['fontSize'] = fontSize;
  var paddingString = _$1.get(deviceProperties, 'padding', null);
  var padding = '20';
  if (paddingString) {
    padding = parseInt(paddingString) + 'px';
  }
  styles['padding'] = padding;
  var bold = _$1.get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }
  var italic = _$1.get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }
  var underline = _$1.get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }
  var backgroundRgb = _$1.get(defaultProperties, 'background', null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = "rgba(" + backgroundRgb.r + ", " + backgroundRgb.g + ", " + backgroundRgb.b + ", " + backgroundRgb.a + ")";
  }
  styles['backgroundColor'] = background;
  var border = _$1.get(defaultProperties, 'border', {});
  var borderStyle = getBorderStyles$f(border);
  styles = _extends({}, styles, borderStyle);
  var alignment = _$1.get(deviceProperties, 'alignment', {});
  var justifyContent = _$1.get(alignment, 'justifyContent', 'left');
  styles['justifyContent'] = justifyContent;
  var flexDirection = _$1.get(alignment, 'flexDrection', 'column');
  styles['flexDirection'] = flexDirection;
  var alignItems = _$1.get(alignment, 'alignItems', 'start');
  styles['alignItems'] = alignItems;
  return styles;
}
function getColorStyles$e(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  var styles = {
    color: color
  };
  return styles;
}
function getBorderStyles$f(value) {
  if (!value) {
    return null;
  }
  var borderStyles = {};
  var topLeft = _$1.get(value, 'radius.topLeft', null);
  var topRight = _$1.get(value, 'radius.topRight', null);
  var bottomLeft = _$1.get(value, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(value, 'radius.bottomRight', null);
  if (topLeft) {
    borderStyles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    borderStyles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    borderStyles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    borderStyles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var colorRgb = _$1.get(value, 'color');
  var color = 'transparent';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  borderStyles['borderColor'] = color;
  var borderWidthString = _$1.get(value, 'width', 0);
  var borderWidget = parseInt(borderWidthString) + 'px';
  borderStyles['borderWidth'] = borderWidget;
  return borderStyles;
}

var styles$J = {"hotspotWidget":"_13Zug","overlay":"_277bS","overlayContainer":"_3tiB4","show":"_1m2lM"};

var HotspotWidgetComponent = function HotspotWidgetComponent(_ref) {
  var _cx, _cx2;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children;
  var ref = React.useRef();
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var context = React.useContext(WidgetsContext);
  var _React$useContext = React.useContext(PageContext),
    zoom = _React$useContext.zoom;
  var parent = useWidgetSelector(widgetProps.parent);
  var container = useContainerSelector(parent.uid);
  var containerParent = useContainerSelector((container === null || container === void 0 ? void 0 : container.parent) && container.parent);
  var hotspotContext = React.useContext(HotspotContext);
  var show = hotspotContext.active === id;
  var properties = _$1.get(widgetProps, 'properties', {});
  var animation = _$1.get(widgetProps, "properties." + breakpoint + ".animation") || {};
  var background = _$1.get(widgetProps, 'properties.desktop.background');
  var trigger = _$1.get(widgetProps, "properties.desktop.trigger");
  var storyboardType = _$1.get(context, 'storyboard.type', '');
  var widgetLayoutStyle = _extends({}, style, getLayoutStyles(parent, breakpoint, container, zoom, containerParent, storyboardType));
  var widgetStyles = _extends({}, getStyles$h(widgetProps, breakpoint), {
    width: '100%',
    height: style.height,
    borderStyle: 'solid',
    position: 'relative'
  });
  var backgroundStyle = getBackgroundStyle(properties, breakpoint);
  useEffect(function () {
    if (trigger === 'hover') {
      ref.current.addEventListener('mouseover', handleMouseOver);
      ref.current.addEventListener('mouseout', handleMouseOut);
      return function () {
        if (ref.current) {
          ref.current.removeEventListener('mouseover', handleMouseOver);
          ref.current.removeEventListener('mouseout', handleMouseOut);
        }
      };
    }
  }, []);
  var handleMouseOver = function handleMouseOver(e) {
    hotspotContext.onMouseOver(e, parent, widgetProps);
  };
  var handleMouseOut = function handleMouseOut(e) {
    hotspotContext.onMouseOut(e, parent, widgetProps);
  };
  if (typeof window === 'undefined') {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: cx(styles$J.overlayContainer, "overlay_container", (_cx = {}, _cx[styles$J.show] = show, _cx))
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$J.hotspotWidget, 'cs_hotspot_widget', (_cx2 = {}, _cx2[styles$J.mobile] = breakpoint === 'mobile', _cx2)),
    "data-widget-id": id,
    "data-widget-type": type,
    "data-container": true,
    "data-selectable": true,
    style: widgetLayoutStyle
  }, /*#__PURE__*/React.createElement(AnimationComponent, _extends({
    triggerOnce: true
  }, animation), /*#__PURE__*/React.createElement("div", {
    style: widgetStyles
  }, /*#__PURE__*/React.createElement(BackgroundView, {
    background: background,
    style: backgroundStyle,
    breakpoint: breakpoint
  }), children))));
};
var hotspotWidgetEquals = function hotspotWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var HotspotWidget = React.memo(HotspotWidgetComponent, hotspotWidgetEquals);
function getStyles$h(widget, breakpoint) {
  if (!widget) {
    return null;
  }
  var border = _$1.get(widget, "properties." + breakpoint + ".border");
  var styles = {};
  var topLeft = _$1.get(border, 'radius.topLeft', null);
  var topRight = _$1.get(border, 'radius.topRight', null);
  var bottomLeft = _$1.get(border, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(border, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var colorRgb = _$1.get(border, 'color');
  var color = 'transparent';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  styles['borderColor'] = color;
  var borderWidthString = _$1.get(border, 'width', 0);
  var borderWidget = parseInt(borderWidthString) + 'px';
  styles['borderWidth'] = borderWidget;
  var shadow = _$1.get(widget, "properties." + breakpoint + ".shadow", {});
  var shadowStyle = getBoxShadow(shadow);
  styles = _extends({}, styles, shadowStyle);
  return styles;
}
function getBackgroundStyle(properties, breakpoint) {
  var styles = {
    overflow: 'hidden'
  };
  var defaultProperties = _$1.get(properties, "" + breakpoint);
  var border = _$1.get(defaultProperties, 'border');
  var borderWidthString = _$1.get(border, 'width') || 0;
  var borderWidget = parseInt(borderWidthString) + 'px';
  var topLeft = _$1.get(border, 'radius.topLeft', null);
  var topRight = _$1.get(border, 'radius.topRight', null);
  var bottomLeft = _$1.get(border, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(border, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = "calc(" + (parseInt(topLeft) + 'px') + " - " + borderWidget + ")";
  }
  if (topRight) {
    styles['borderTopRightRadius'] = "calc(" + (parseInt(topRight) + 'px') + " - " + borderWidget + ")";
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = "calc(" + (parseInt(bottomLeft) + 'px') + " - " + borderWidget + ")";
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = "calc(" + (parseInt(bottomRight) + 'px') + " - " + borderWidget + ")";
  }
  return styles;
}
function getLayoutStyles(parent, breakpoint, container, zoom, containerParent, storyboardType) {
  var styles = {};
  if (typeof window === 'undefined') {
    return styles;
  }
  var parentPosition = getBoundingRectFromWidget(parent.uid, {
    x: 0,
    y: 0
  });
  var parentContainerPosition = containerParent && getBoundingRectFromWidget(containerParent === null || containerParent === void 0 ? void 0 : containerParent.uid, {
    x: 0,
    y: 0
  });
  var parentElement = document.getElementById(parent.uid);
  if (!parentElement) {
    return;
  }
  var parentComputedStyles = window.getComputedStyle(parentElement);
  var parentLeftMargin = parentComputedStyles.marginLeft;
  if (container) {
    var minWidth = _$1.get(container, "properties." + breakpoint + ".container.minWidth", 375);
    var alignment = _$1.get(container, "properties." + breakpoint + ".container.alignment") || 'center';
    var parentAlignment = containerParent && _$1.get(containerParent, "properties." + breakpoint + ".container.alignment") || 'center';
    var multiplier = 0.5;
    switch (alignment) {
      case 'left':
        multiplier = 0;
        break;
      case 'right':
        multiplier = 1;
        break;
      case 'center':
      default:
        multiplier = 0.5;
        break;
    }
    var containerElement = document.getElementById(container.uid);
    var parentContainerElement = containerParent && document.getElementById(containerParent === null || containerParent === void 0 ? void 0 : containerParent.uid);
    var sectionElement = containerParent && document.getElementById(containerParent === null || containerParent === void 0 ? void 0 : containerParent.parent);
    if (!containerElement) {
      return styles;
    }
    var containerRect = containerElement.getBoundingClientRect();
    var parentContainerRect = parentContainerElement === null || parentContainerElement === void 0 ? void 0 : parentContainerElement.getBoundingClientRect();
    var sectionComputedStyle = sectionElement && window.getComputedStyle(sectionElement);
    var sectionPadding = sectionComputedStyle !== null && sectionComputedStyle !== void 0 && sectionComputedStyle.paddingTop ? sectionComputedStyle.paddingTop : 0;
    var order = container.type !== PAGE || container.type !== SLIDE ? container.order - 1 : 0;
    var parentOrder = containerParent && ((containerParent === null || containerParent === void 0 ? void 0 : containerParent.type) !== PAGE ? containerParent.order - 1 : 0);
    var childMarginPosition = (breakpoint === 'mobile' || container.type !== SECTION_COLUMN ? 0 : containerRect.width * order / zoom) + parentPosition.x;
    var marginPostion = getMarginPositionForHotpost(childMarginPosition, breakpoint, container, zoom, containerParent, parentContainerRect, parentContainerPosition, parentOrder, parentAlignment, storyboardType);
    var marginLeft = parentPosition.x + "px";
    if (minWidth) {
      marginLeft = "calc(calc((100% - " + (breakpoint === 'desktop' ? 1200 : minWidth) + "px) * " + multiplier + ") + " + marginPostion + "px";
      if (minWidth < 1200) {
        marginLeft = "calc(calc((100% - " + (breakpoint === 'desktop' ? 1200 : minWidth) + "px) * " + multiplier + ") + " + marginPostion + "px - " + parentLeftMargin + ")";
      }
    }
    var marginTop = parentPosition.y + "px";
    if (breakpoint === 'mobile' && container.type === SECTION_COLUMN) {
      marginTop = containerRect.height * order + parentPosition.y + "px";
    }
    if ((container === null || container === void 0 ? void 0 : container.type) === CAROUSEL_CARD && (containerParent === null || containerParent === void 0 ? void 0 : containerParent.type) === SECTION_COLUMN) {
      if (breakpoint === 'mobile') {
        marginTop = "calc(" + (containerRect.height * parentOrder + parentPosition.y) + "px + " + sectionPadding + ")";
      } else if (breakpoint === 'desktop') {
        marginTop = "calc(" + parentPosition.y + "px + " + sectionPadding + ")";
      }
    }
    if (parentPosition) {
      styles['marginLeft'] = marginLeft;
      styles['marginTop'] = marginTop;
    }
  }
  return styles;
}
var getMarginPositionForHotpost = function getMarginPositionForHotpost(childMarginPosition, breakpoint, container, zoom, containerParent, parentContainerRect, parentContainerPosition, parentOrder, parentAlignment, storyboardType) {
  var _window;
  var isCarouselCardInSectionColumnOnDesktop = _$1.includes([CAROUSEL_CARD], container === null || container === void 0 ? void 0 : container.type) && _$1.includes([SECTION_COLUMN], containerParent === null || containerParent === void 0 ? void 0 : containerParent.type) && breakpoint === 'desktop';
  if (!isCarouselCardInSectionColumnOnDesktop) {
    return childMarginPosition;
  }
  var baseParentMargin = (breakpoint === 'mobile' || containerParent.type !== SECTION_COLUMN ? 0 : parentContainerRect.width * parentOrder / zoom) + (parentContainerPosition === null || parentContainerPosition === void 0 ? void 0 : parentContainerPosition.x);
  var sectionElement = containerParent && document.getElementById(containerParent === null || containerParent === void 0 ? void 0 : containerParent.parent);
  var columnElements = sectionElement === null || sectionElement === void 0 ? void 0 : sectionElement.querySelectorAll("[data-widget-type=\"" + SECTION_COLUMN + "\"]");
  var numberOfColumns = (columnElements === null || columnElements === void 0 ? void 0 : columnElements.length) || 1;
  var columnMarginOffset = numberOfColumns > 1 ? 600 / numberOfColumns : 0;
  var innerWidth = (_window = window) === null || _window === void 0 ? void 0 : _window.innerWidth;
  var additionalMargin = innerWidth >= 1200 ? ((parentContainerRect === null || parentContainerRect === void 0 ? void 0 : parentContainerRect.width) / 2 - columnMarginOffset) * (numberOfColumns - 1) : 0;
  var calculatedMargin = baseParentMargin + childMarginPosition - additionalMargin;
  var alignmentOffset = additionalMargin / (numberOfColumns - 1) || 0;
  switch (parentAlignment) {
    case 'left':
      calculatedMargin -= numberOfColumns === 1 ? 120 : alignmentOffset;
      break;
    case 'right':
      calculatedMargin += numberOfColumns === 1 ? 120 : alignmentOffset;
      break;
  }
  if (storyboardType === 'INTERACTIVE_CONTENT' || storyboardType === 'SPATIAL') {
    return baseParentMargin + childMarginPosition;
  }
  return calculatedMargin;
};
function getBoundingRectFromWidget(widget, widgetRect) {
  var _parentElement$classL, _parentElement$classL2;
  var widgetElement = document.getElementById(widget);
  if (!widgetElement) {
    return widgetRect;
  }
  var computedStyle = window.getComputedStyle(widgetElement);
  var transformValue = computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.getPropertyValue('transform');
  if (transformValue && transformValue.startsWith('matrix')) {
    var match = transformValue.match(/matrix\(([^,]+),\s*([^,]+),\s*([^,]+),\s*([^,]+),\s*([^,]+),\s*([^,]+)\)/);
    if (match) {
      var horizontalTranslation = parseFloat(match[5]);
      var verticalTranslation = parseFloat(match[6]);
      widgetRect['x'] = widgetRect.x + horizontalTranslation;
      widgetRect['y'] = widgetRect.y + verticalTranslation;
    }
  }
  var parentElement = findClosestParent(widgetElement.parentElement);
  if (!parentElement || !parentElement.id) {
    return widgetRect;
  }
  if (parentElement !== null && parentElement !== void 0 && (_parentElement$classL = parentElement.classList) !== null && _parentElement$classL !== void 0 && _parentElement$classL.contains('cs_page_root') || parentElement !== null && parentElement !== void 0 && (_parentElement$classL2 = parentElement.classList) !== null && _parentElement$classL2 !== void 0 && _parentElement$classL2.contains('cs_slide_root')) {
    return widgetRect;
  }
  return getBoundingRectFromWidget(parentElement === null || parentElement === void 0 ? void 0 : parentElement.id, widgetRect);
}
function findClosestParent(element) {
  while (element) {
    if (element.id && element.id.startsWith("widget_")) {
      return element;
    }
    element = element.parentElement;
  }
  return null;
}

var previewContent = {
  id: "66434d3ae06b8d60a3eeeee4",
  chats: [{
    "id": "66434d3ae06b8d60a3eeeee4",
    "question": "What is Seek?",
    "citations": [],
    "answer": "Seek leverages uploaded content to provide contextual insights to your users.",
    "session": "66434d3ae06b8d60a3eeeee4",
    "contentMappings": [{
      "id": null,
      "uid": "asset_662cc67c7726a260b1e16866",
      "type": "ASSET",
      "content": {
        "id": "662cc67c7726a260b1e16866",
        "name": null,
        "entityType": "asset",
        "source": "CLEVERSTORY",
        "seekStatus": null,
        "seekEnabled": false,
        "asset": {
          "id": "662cc659b888b157c6155b8d",
          "name": "Marketing Campaign Per...",
          "entityType": "asset",
          "alias": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1-ylxn8w",
          "summary": null,
          "metadata": {
            "content_type": "application/pdq",
            "modified_date": 1714210393000,
            "url": "5c5e8b6b46e0fb000131662c/assets/b2591ac5-dd55-4204-9bff-a701b414ed21.pdf",
            "md5_checksum": null,
            "original_name": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1.pdf",
            "content_length": 15746706,
            "extension": "pdf",
            "etag": "74bf655d5ad187e928161adccbc199fe",
            "pages": 28,
            "read_time": 806.218487394958
          },
          "icon": {
            "id": "662cc6c6997e4a204cfff6d7",
            "type": "image",
            "thumbnail": "/images/seek/pdfThumbnail.jpg",
            "full": "https://dwoemqguc7qqj.cloudfront.net/5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c",
            "key": "5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c"
          }
        }
      },
      "fields": [{
        "name": "name",
        "content": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1",
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }, {
        "name": "description",
        "content": null,
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }, {
        "name": "icon",
        "content": {
          "id": "662cc6c6997e4a204cfff6d7",
          "name": null,
          "contentType": null,
          "type": "image",
          "width": 0,
          "height": 0,
          "url": "5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c"
        },
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }, {
        "name": "contentType",
        "content": "PDF",
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }, {
        "name": "fileSize",
        "content": "15 MB",
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }, {
        "name": "author",
        "content": "",
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }],
      "url": "/media/f3c58b1e-d84d-4309-b11e-3ccb46a632f1-9atxz0",
      "order": 0,
      "override": false
    }, {
      "id": null,
      "uid": "asset_662cc67c7726a260b1e16865",
      "type": "ASSET",
      "content": {
        "id": "662cc67c7726a260b1e16865",
        "name": null,
        "entityType": "asset",
        "source": "CLEVERSTORY",
        "gatingConfigurations": [],
        "customFields": null,
        "tags": null,
        "disableDownload": false,
        "excludeFromSearch": false,
        "seekStatus": null,
        "seekEnabled": false,
        "asset": {
          "id": "662cc659b888b157c6155b8d",
          "name": "Sales Pitch Deck for Q3...",
          "entityType": "asset",
          "alias": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1-ylxn8w",
          "summary": null,
          "metadata": {
            "content_type": "video/mp4",
            "modified_date": 1714210393000,
            "url": "5c5e8b6b46e0fb000131662c/assets/b2591ac5-dd55-4204-9bff-a701b414ed21.pdf",
            "md5_checksum": null,
            "original_name": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1.pdf",
            "content_length": 15746706,
            "extension": "Video",
            "etag": "74bf655d5ad187e928161adccbc199fe",
            "pages": 28,
            "read_time": 806.218487394958
          },
          "icon": {
            "id": "662cc6c6997e4a204cfff6d7",
            "type": "image",
            "thumbnail": "/images/seek/videoThumbnail.jpg",
            "full": "https://dwoemqguc7qqj.cloudfront.net/5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c",
            "key": "5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c"
          }
        }
      },
      "fields": [{
        "name": "name",
        "content": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1",
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }, {
        "name": "description",
        "content": null,
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }, {
        "name": "icon",
        "content": {
          "id": "662cc6c6997e4a204cfff6d7",
          "name": null,
          "contentType": null,
          "type": "image",
          "width": 0,
          "height": 0,
          "url": "5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c"
        },
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }, {
        "name": "contentType",
        "content": "PD",
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }, {
        "name": "fileSize",
        "content": "15 MB",
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }, {
        "name": "author",
        "content": "",
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }],
      "url": "",
      "order": 0,
      "override": false
    }, {
      "id": null,
      "uid": "asset_662cc67c7726a260b1e16863",
      "type": "ASSET",
      "content": {
        "id": "662cc67c7726a260b1e16863",
        "name": null,
        "entityType": "asset",
        "source": "CLEVERSTORY",
        "gatingConfigurations": [],
        "customFields": null,
        "tags": null,
        "disableDownload": false,
        "excludeFromSearch": false,
        "seekStatus": null,
        "seekEnabled": false,
        "asset": {
          "id": "662cc659b888b157c6155b8",
          "name": "Customer Engagement Metrics...",
          "entityType": "asset",
          "alias": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1-ylxn8w",
          "summary": null,
          "metadata": {
            "content_type": "application/vnd.google-apps.presentation",
            "modified_date": 1714210393000,
            "url": "5c5e8b6b46e0fb000131662c/assets/b2591ac5-dd55-4204-9bff-a701b414ed21.pdf",
            "md5_checksum": null,
            "original_name": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1.pdf",
            "content_length": 15746706,
            "extension": "PPT",
            "etag": "74bf655d5ad187e928161adccbc199fe",
            "pages": 28,
            "read_time": 806.218487394958
          },
          "icon": {
            "id": "662cc6c6997e4a204cfff6d7",
            "type": "image",
            "thumbnail": "/images/seek/pptThumbnail.jpg",
            "full": "https://dwoemqguc7qqj.cloudfront.net/5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c",
            "key": "5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c"
          }
        }
      },
      "fields": [{
        "name": "name",
        "content": "f3c58b1e-d84d-4309-b11e-3ccb46a632f1",
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }, {
        "name": "description",
        "content": null,
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }, {
        "name": "icon",
        "content": {
          "id": "662cc6c6997e4a204cfff6d7",
          "name": null,
          "contentType": null,
          "type": "image",
          "width": 0,
          "height": 0,
          "url": "5c5e8b6b46e0fb000131662c/images/662cc6c6997e4a204cfff6d7/766325af-14c8-4fbc-9e0b-791d40a44a8c"
        },
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }, {
        "name": "contentType",
        "content": "PDF",
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }, {
        "name": "fileSize",
        "content": "15 MB",
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }, {
        "name": "author",
        "content": "",
        "custom": false,
        "override": false,
        "desktop": true,
        "mobile": true
      }],
      "url": "/media/f3c58b1e-d84d-4309-b11e-3ccb46a632f1-9atxz0",
      "order": 0,
      "override": false
    }]
  }],
  sessionId: '66434d3ae06b8d60a3eeeee2'
};

var styles$K = {"searchBoxContainer":"_3PPZL","inputFieldWrapper":"_36TBv","InputGroup":"_WVVS-","searchField":"_aa7-N","seekButton":"_3nk0W","label":"_iqU7s","newChatWrapper":"_Qcftx","newChatButton":"_a24p1","Icon":"_1fLon","promptsContainer":"_2Pqkr","prompt":"_37QSM","disabled":"_3P_uS","mobileViewPrompts":"_3ia6l"};

var SearchBoxComponent = function SearchBoxComponent(_ref) {
  var className = _ref.className,
    widgetProps = _ref.widgetProps,
    value = _ref.value,
    _onChange = _ref.onChange,
    onSubmit = _ref.onSubmit,
    breakpoint = _ref.breakpoint,
    _ref$newChat = _ref.newChat,
    newChat = _ref$newChat === void 0 ? false : _ref$newChat,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? true : _ref$disabled,
    handleSuggestionClick = _ref.handleSuggestionClick;
  var seekContext = React.useContext(SeekContext);
  var _useState = useState({
      fontStyles: {},
      inputFieldStyle: {},
      placeHolderStyle: {},
      promptStyle: {}
    }),
    searchBoxStyles = _useState[0],
    setSearchBoxStyles = _useState[1];
  var id = _$1.get(widgetProps, 'uid');
  var widgetProperties = _$1.get(widgetProps, 'properties');
  var seekBarProps = _$1.get(widgetProperties, breakpoint + ".questionDesign.bar", {});
  var seekResponseProps = _$1.get(widgetProperties, breakpoint + ".responseDesign", {});
  var responseStyle = _$1.get(seekResponseProps, "type", 'inline');
  var accentColor = _$1.get(seekResponseProps, 'accentColor', {
    r: 245,
    g: 245,
    b: 245,
    a: 1
  });
  var session = _$1.get(seekContext, "seekSession." + id + ".item");
  var loading = _$1.get(seekContext, "seekSession." + id + ".loading", false);
  var querying = (_$1.get(session, 'chats') || []).find(function (chat) {
    return chat.querying;
  }) != null;
  var placeHolder = _$1.get(seekBarProps, 'placeholderQuestion', 'Enter your question here');
  var promptEnabled = _$1.get(seekBarProps, 'promptEnabled', false);
  var promptQuestions = _$1.get(seekBarProps, 'prompts', []);
  useEffect(function () {
    updateSearchBoxStyles();
  }, [widgetProperties, breakpoint]);
  var updateSearchBoxStyles = function updateSearchBoxStyles() {
    var inputFieldStyle = getSearchBarStyles(widgetProperties, breakpoint);
    var fontStyles = getFontStyles(widgetProperties, breakpoint);
    var placeHolderStyles = getPlaceholderStyles(widgetProperties, breakpoint);
    var promptStyles = getPromptStyles(widgetProperties, breakpoint);
    setSearchBoxStyles({
      inputFieldStyle: inputFieldStyle,
      fontStyles: fontStyles,
      placeHolderStyle: placeHolderStyles,
      promptStyle: promptStyles
    });
  };
  var wrapperStyles = getStyles$i(widgetProps, breakpoint);
  var handleSubmit = function handleSubmit() {
    onSubmit(value);
  };
  var handleStartNewChat = function handleStartNewChat() {
    seekContext.invalidateSeekSession(id);
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "search_input_" + id,
    style: wrapperStyles,
    className: cx(styles$K.searchBoxContainer, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles$K.inputFieldWrapper)
  }, /*#__PURE__*/React.createElement(InputGroup, {
    style: searchBoxStyles.inputFieldStyle,
    className: styles$K.InputGroup
  }, /*#__PURE__*/React.createElement("style", null, "\n                #" + ("search_input_" + id) + " input[data-device=" + breakpoint + "]::-webkit-input-placeholder {\n                  color: " + _$1.get(searchBoxStyles, 'placeHolderStyle.color') + ";\n                }\n                #seekSearchButton i[data-device=" + breakpoint + "]::before {\n                  color: " + _$1.get(searchBoxStyles, 'fontStyles.color') + ";\n                }\n            "), /*#__PURE__*/React.createElement("input", {
    "data-device": breakpoint,
    className: styles$K.searchField,
    style: searchBoxStyles.fontStyles,
    value: value,
    placeholder: placeHolder,
    disabled: querying || disabled,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    onKeyPress: function onKeyPress(e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
        handleSubmit();
      }
    },
    id: "seekSearch"
  }), /*#__PURE__*/React.createElement(Button, {
    className: styles$K.seekButton,
    variant: "info",
    id: "seekSearchButton",
    onClick: handleSubmit
  }, /*#__PURE__*/React.createElement("i", {
    "data-device": breakpoint,
    className: cx(styles$K.Icon, 'cleverstory-paperflite-logo')
  }))), /*#__PURE__*/React.createElement("span", {
    className: styles$K.label
  }, "Powered by OpenAI")), promptEnabled && _$1.size(_$1.get(session, 'chats')) === 0 && !loading && /*#__PURE__*/React.createElement(PromptQuestion, {
    promptQuestions: promptQuestions,
    newChat: newChat,
    disabled: querying || disabled,
    breakpoint: breakpoint,
    responseStyle: responseStyle,
    promptStyles: searchBoxStyles.promptStyle,
    onSelect: handleSuggestionClick
  }), newChat && /*#__PURE__*/React.createElement("div", {
    id: "newChatButton",
    className: styles$K.newChatWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    disabled: querying || disabled,
    style: getColorStyles$f(accentColor),
    className: styles$K.newChatButton,
    onClick: handleStartNewChat
  }, /*#__PURE__*/React.createElement("i", {
    style: getColorStyles$f(accentColor),
    className: cx(styles$K.Icon, 'cleverstory-plus')
  }), "New Chat"), /*#__PURE__*/React.createElement("style", null, "\n                #newChatButton i::before {\n                  color: " + getColorsConfig(accentColor) + ";\n                }\n              ")));
};
var PromptQuestion = function PromptQuestion(_ref2) {
  var _cx, _cx2;
  var onSelect = _ref2.onSelect,
    newChat = _ref2.newChat,
    disabled = _ref2.disabled,
    breakpoint = _ref2.breakpoint,
    responseStyle = _ref2.responseStyle,
    promptStyles = _ref2.promptStyles,
    promptQuestions = _ref2.promptQuestions;
  var handleSelect = function handleSelect(suggestion) {
    if (disabled) {
      return;
    }
    onSelect(suggestion);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles$K.promptsContainer, (_cx = {}, _cx[styles$K.disabled] = disabled, _cx), (_cx2 = {}, _cx2[styles$K.mobileViewPrompts] = breakpoint === 'mobile' || newChat && responseStyle === 'slider', _cx2))
  }, _$1.map(promptQuestions, function (prompt, index) {
    if (_$1.size(prompt) == 0) {
      return;
    }
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      style: promptStyles,
      onClick: function onClick() {
        return handleSelect(prompt);
      },
      className: styles$K.prompt
    }, prompt);
  }));
};
var searchBoxEquals = function searchBoxEquals(prevProps, nextProps) {
  var paths = ['className', 'widgetProps', 'breakpoint', 'value', 'onChange', 'onSubmit', 'handleSuggestionClick', 'newChat', 'disabled'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var SeekSearchBox = React.memo(SearchBoxComponent, searchBoxEquals);
function getStyles$i(widgetProps, breakpoint, type) {
  var deviceProperties = _$1.get(widgetProps, "properties." + breakpoint);
  var padding = _$1.get(deviceProperties, "padding", 0);
  var widgetStyles = {};
  var backgroundRgb = _$1.get(deviceProperties, "responseDesign.backgroundColor", null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = getColorsConfig(backgroundRgb);
  }
  widgetStyles['background'] = background;
  if (breakpoint === 'desktop') {
    widgetStyles = _extends({}, widgetStyles, {
      padding: padding + "px"
    });
  }
  if (breakpoint === 'mobile') {
    widgetStyles = _extends({}, widgetStyles, {
      padding: padding + "px"
    });
  }
  return widgetStyles;
}
function getPlaceholderStyles(widgetProperties, breakpoint) {
  var styles = {};
  if (!widgetProperties) {
    return styles;
  }
  var deviceProperties = _$1.get(widgetProperties, "" + breakpoint);
  var fontStyles = _$1.get(deviceProperties, "font", {});
  var colorRgb = _$1.get(fontStyles, "tertiaryColor", null);
  var color = getColorStyles$f(colorRgb);
  styles = _extends({}, styles, color);
  var fontFamily = _$1.get(fontStyles, 'fontFamily');
  if (fontFamily) {
    styles = _extends({}, styles, {
      fontFamily: fontFamily
    });
  }
  var fontSizeString = _$1.get(fontStyles, 'fontSize', null);
  var fontSize = 'inherit';
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }
  styles['fontSize'] = fontSize;
  return styles;
}
function getPromptStyles(widgetProperties, breakpoint) {
  var styles = {};
  if (!widgetProperties) {
    return styles;
  }
  var deviceProperties = _$1.get(widgetProperties, "" + breakpoint);
  var fontStyles = _$1.get(deviceProperties, "font", {});
  var colorRgb = _$1.get(fontStyles, "secondaryColor", {
    r: 111,
    g: 111,
    b: 111,
    a: 1
  });
  var color = getColorStyles$f(colorRgb);
  styles = _extends({}, styles, color);
  var fontFamily = _$1.get(fontStyles, 'fontFamily');
  if (fontFamily) {
    styles = _extends({}, styles, {
      fontFamily: fontFamily
    });
  }
  return styles;
}
function getSearchBarStyles(widgetProperties, breakpoint) {
  var styles = {};
  if (!widgetProperties) {
    return styles;
  }
  var defaultProperties = _$1.get(widgetProperties, "" + breakpoint);
  var barStyles = _$1.get(defaultProperties, "questionDesign.bar", {});
  var inputFieldColor = _$1.get(barStyles, "inputFieldColor", {
    r: 255,
    g: 255,
    b: 255,
    a: 1
  });
  var background = 'inherit';
  if (inputFieldColor) {
    background = getColorsConfig(inputFieldColor);
  }
  styles['background'] = background;
  var border = _$1.get(barStyles, "border", {});
  var borderStyle = getBorderStyles$g(border);
  styles = _extends({}, styles, borderStyle);
  return styles;
}
function getColorStyles$f(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }
  var styles = {
    color: color
  };
  return styles;
}
function getFontStyles(widgetProperties, breakpoint) {
  var styles = {};
  if (!widgetProperties) {
    return styles;
  }
  var deviceProperties = _$1.get(widgetProperties, "" + breakpoint);
  var fontStyles = _$1.get(deviceProperties, "font", {});
  var colorRgb = _$1.get(fontStyles, "color", null);
  var color = getColorStyles$f(colorRgb);
  styles = _extends({}, styles, color);
  var fontFamily = _$1.get(fontStyles, 'fontFamily');
  if (fontFamily) {
    styles = _extends({}, styles, {
      fontFamily: fontFamily
    });
  }
  var fontSizeString = _$1.get(fontStyles, 'fontSize', "12");
  var fontSize = 'inherit';
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }
  styles['fontSize'] = fontSize;
  return styles;
}
function getBorderStyles$g(border) {
  var styles = {};
  if (!border) {
    return styles;
  }
  var topLeft = _$1.get(border, 'radius.topLeft', null);
  var topRight = _$1.get(border, 'radius.topRight', null);
  var bottomLeft = _$1.get(border, 'radius.bottomLeft', null);
  var bottomRight = _$1.get(border, 'radius.bottomRight', null);
  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }
  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }
  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }
  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }
  var borderStyle = _$1.get(border, 'style', 'bottom');
  if (borderStyle !== 'none') {
    var borderWidthString = _$1.get(border, 'width') || 0;
    var borderWidget = parseInt(borderWidthString) + 'px';
    var fieldName = borderStyle == 'all' ? 'borderWidth' : 'borderBottomWidth';
    styles[fieldName] = borderWidget;
    var colorRgb = _$1.get(border, 'color');
    var color = 'transparent';
    if (colorRgb) {
      color = getColorsConfig(colorRgb);
    }
    styles['borderColor'] = color;
  }
  return styles;
}

var styles$L = {"sessionContainer":"_27SHT","responseChatWindow":"_3UQ4t","header":"_Pg8vw","closeButton":"_3uXm-","loader":"_2mKyN","loadMessage":"_3o_Wz","bodyWrapper":"_3stVQ","loadIcon":"_H5ncv","spin":"_3widC","scrollUp":"_16rVh","chatContainer":"_M5YPm","activeChat":"_3Osjy","footerWrapper":"_z6CdH","knowMore":"_1B8F4","infoTextWrapper":"_1YqMa","label":"_2BatU","seek":"_37Ngw","innerContainer":"_1WP9R","session":"_2vXuU","loading":"_1h-uC","chat":"_1hn5i","avatar":"_3xFpU","contact":"_29YYv","logo":"_k3zRF","question":"_3KAzB","text":"_1B441","answer":"_2Qm0T","summary":"_3HcNw","wrapper":"_3iO8u","assets":"_1DgNq","entering":"_Cb5Bq","entered":"_34Lt8","exiting":"_228Zz","exited":"_32rbC","actions":"_1tca3","action":"_1h8hw","feedback":"_3x5Sp","noAssets":"_3zDw_","thumb":"_1AT5c","up":"_1Hun5","newChat":"_2W7kZ","show_new_chat_button":"_372Ye","asset":"_ZcpCa","internalIcon":"_2zOsd","iconLock":"_2tzRk","item":"_2tjzv","iconWrapper":"_1ZG_5","extension":"_2LxSA","pages":"_2DRNM","link":"_10q8z","additionalData":"_2Lqxf","size":"_3fDUv","overlay":"_1lYNS","slideUp":"_2bqFi","icon":"_6yVMx","name":"_3e8Zu","meta":"_3SjlR","suggestions":"_1g8Hf","suggestion":"_3zSql","line":"_1rAOx"};

var DefaultAssetIcon = '/images/default_asset.png';
var SessionContainer = function SessionContainer(_ref) {
  var _cx;
  var widgetProps = _ref.widgetProps,
    handleSuggestionClick = _ref.handleSuggestionClick,
    onSubmit = _ref.onSubmit,
    breakpoint = _ref.breakpoint,
    onClose = _ref.onClose,
    _ref$preview = _ref.preview,
    preview = _ref$preview === void 0 ? false : _ref$preview;
  var seekContext = React.useContext(SeekContext);
  var id = _$1.get(widgetProps, 'uid');
  var _useState = useState({
      disableTyping: false,
      question: '',
      showChats: false
    }),
    state = _useState[0],
    setState = _useState[1];
  var widgetProperties = _$1.get(widgetProps, 'properties');
  var seekResponseProps = _$1.get(widgetProperties, breakpoint + ".responseDesign", {});
  var accentColor = _$1.get(seekResponseProps, 'accentColor', {
    r: 245,
    g: 245,
    b: 245,
    a: 1
  });
  var layoutType = _$1.get(seekResponseProps, 'type', breakpoint === 'desktop' ? 'inline' : 'popup');
  var fontStyles = _$1.get(widgetProperties, breakpoint + ".font", {});
  var containerStyles = getBackgroundStyles(seekResponseProps);
  var loading = _$1.get(seekContext, "seekSession." + id + ".loading", false);
  var session = preview ? previewContent : _$1.get(seekContext, "seekSession." + id + ".item", null);
  var chats = _$1.get(session, 'chats');
  var handleDisableTyping = function handleDisableTyping(value) {
    setState(function (state) {
      return _extends({}, state, {
        disableTyping: value
      });
    });
  };
  var handleSubmit = function handleSubmit() {
    onSubmit(state.question);
    setState(function (state) {
      return _extends({}, state, {
        question: ''
      });
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles$L.sessionContainer
  }, /*#__PURE__*/React.createElement("div", {
    style: containerStyles,
    className: styles$L.responseChatWindow
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$L.header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$L.logoContainer
  }), layoutType !== 'inline' && /*#__PURE__*/React.createElement(Button, {
    variant: "info",
    className: styles$L.closeButton,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-close', styles$L.closeIcon)
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles$L.bodyWrapper
  }, loading && _$1.size(chats) == 0 && /*#__PURE__*/React.createElement("div", {
    id: "loaderSeek",
    className: styles$L.loader
  }, /*#__PURE__*/React.createElement("style", null, "\n                #loaderSeek i::before {\n                  color: " + getColorsConfig(accentColor) + ";\n                }\n              "), /*#__PURE__*/React.createElement("div", {
    className: styles$L.loadMessage
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-seek-fan', styles$L.loadIcon)
  }))), _$1.size(chats) > 0 && /*#__PURE__*/React.createElement(ScrollToBottom, {
    followButtonClassName: styles$L.scrollUp,
    mode: preview ? 'top' : 'bottom',
    initialScrollBehavior: "auto",
    className: cx(styles$L.chatContainer, (_cx = {}, _cx[styles$L.activeChat] = session, _cx))
  }, /*#__PURE__*/React.createElement(SeekSessionContainer, {
    widget: id,
    onDisableTyping: handleDisableTyping,
    widgetProps: widgetProps,
    seekResponseProps: seekResponseProps,
    fontStyles: fontStyles,
    session: session
  })), /*#__PURE__*/React.createElement(SeekSearchBox, {
    widgetProps: widgetProps,
    newChat: true,
    value: state.question,
    onChange: function onChange(value) {
      setState(function (state) {
        return _extends({}, state, {
          question: value
        });
      });
    },
    disabled: state.disableTyping,
    handleSuggestionClick: handleSuggestionClick,
    className: styles$L.searchInputField,
    breakpoint: breakpoint,
    onSubmit: handleSubmit
  }))), /*#__PURE__*/React.createElement(SeekInfoFooter, null));
};
var SeekSessionContainer = function SeekSessionContainer(_ref2) {
  var widget = _ref2.widget,
    onDisableTyping = _ref2.onDisableTyping,
    widgetProps = _ref2.widgetProps,
    seekResponseProps = _ref2.seekResponseProps,
    fontStyles = _ref2.fontStyles,
    session = _ref2.session;
  var seekContext = React.useContext(SeekContext);
  var loading = _$1.get(seekContext, "seekSession." + widget + ".loading", false);
  var scrollToBottom = useScrollToBottom();
  useEffect(function () {
    if (loading) {
      scrollToBottom();
    }
  }, [loading]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles$L.session
  }, (_$1.get(session, 'chats') || []).map(function (chat, index) {
    return /*#__PURE__*/React.createElement(SeekChatContainer, {
      widgetProps: widgetProps,
      onDisableTyping: onDisableTyping,
      seekResponseProps: seekResponseProps,
      fontStyles: fontStyles,
      key: index,
      chat: chat,
      widget: widget
    });
  }));
};
var SeekChatContainer = function SeekChatContainer(_ref3) {
  var chat = _ref3.chat,
    onDisableTyping = _ref3.onDisableTyping,
    widgetProps = _ref3.widgetProps,
    seekResponseProps = _ref3.seekResponseProps,
    fontStyles = _ref3.fontStyles,
    widget = _ref3.widget,
    key = _ref3.key;
  var summaryRef = React.useRef();
  var typewriter = React.useRef(null);
  var chatId = _$1.get(chat, 'id', null);
  var _useState2 = useState({
      typeWritter: null,
      isHelpful: false,
      showAssets: false,
      type: 'placeholder',
      animate: chat.querying
    }),
    state = _useState2[0],
    setState = _useState2[1];
  var accentColor = _$1.get(seekResponseProps, 'accentColor', {
    r: 0,
    g: 189,
    b: 231,
    a: 1
  });
  var questionStyle = getQuestionStyle(fontStyles);
  var answerStyle = getAnswerStyle(fontStyles);
  var processingMessage = _$1.get(seekResponseProps, 'processingMessage', 'Processing your request...');
  useEffect(function () {
    typewriter.current = new Typewriter(summaryRef.current, {
      delay: 0,
      devMode: false
    });
    setState(function (state) {
      return _extends({}, state, {
        isHelpful: _$1.get(chat, 'isHelpful', false)
      });
    });
    if (!chat.querying) {
      updateSummary(chat, state.type);
    } else {
      renderPlaceholderMessage();
    }
  }, []);
  useEffect(function () {
    if (!chat.querying) {
      updateSummary(chat, 'answer');
    } else {
      setState(function (state) {
        return _extends({}, state, {
          animate: chat.querying
        });
      });
    }
    setState(function (state) {
      return _extends({}, state, {
        isHelpful: _$1.get(chat, 'isHelpful', false)
      });
    });
  }, [chatId, chat.querying]);
  useEffect(function () {
    if (!state.animate && !chat.querying) {
      updateSummary(chat, 'answer');
    }
  }, []);
  var updateSummary = function updateSummary(chat, type) {
    var summary = chat.answer;
    if (_$1.size(chat.assets) > 0) {
      summary = summary + " \n\nTo better understand the topic, we suggest you read the asset provided below. It will give you more information and help you learn more.";
    }
    if (state.animate) {
      typewriter.current = new Typewriter(summaryRef.current, {
        delay: 0,
        devMode: false
      });
      onDisableTyping(true);
      typewriter.current.typeString(summary).callFunction(function () {
        if (type !== 'placeholder') {
          setState(function (state) {
            return _extends({}, state, {
              showAssets: true,
              animate: false
            });
          });
          onDisableTyping(false);
        }
      }).start();
    } else {
      if (type !== 'placeholder') {
        setState(function (state) {
          return _extends({}, state, {
            showAssets: true
          });
        });
      }
      summaryRef.current.innerHTML = summary;
    }
  };
  var renderPlaceholderMessage = function renderPlaceholderMessage() {
    var message = processingMessage;
    typewriter.current.typeString(message).callFunction(function () {
      setState(function (state) {
        return _extends({}, state, {
          typing: false
        });
      });
    }).start();
  };
  return /*#__PURE__*/React.createElement("div", {
    key: key,
    id: "chat_" + widget,
    className: styles$L.chat
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$L.question
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      borderColor: colorStyle(accentColor)
    },
    className: cx(styles$L.avatar, styles$L.contact)
  }, /*#__PURE__*/React.createElement("style", null, "\n                #" + ("chat_" + widget) + " i::before {\n                  color: " + colorStyle(accentColor) + ";\n                }\n            "), /*#__PURE__*/React.createElement("i", {
    className: "cleverstory-user1"
  })), /*#__PURE__*/React.createElement("p", {
    style: questionStyle,
    className: cx(styles$L.text)
  }, chat.question)), /*#__PURE__*/React.createElement("div", {
    className: styles$L.answer
  }, /*#__PURE__*/React.createElement("img", {
    src: "/images/seek/seekLogo.png",
    className: cx(styles$L.avatar, styles$L.logo)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$L.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    id: "summaryElement",
    style: answerStyle,
    className: styles$L.summary,
    ref: summaryRef
  }), /*#__PURE__*/React.createElement(Assets, {
    chat: chat,
    showAssets: state.showAssets,
    seekResponseProps: seekResponseProps,
    widgetProps: widgetProps
  }))));
};
var SeekInfoFooter = function SeekInfoFooter() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$L.footerWrapper
  }, /*#__PURE__*/React.createElement("a", {
    className: styles$L.knowMore,
    href: "https://experiences.cleverstory.io/introducing-seek",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-help', styles$L.infoIcon)
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$L.infoTextWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$L.label
  }, "Seek - Powered by AI")));
};
var Assets = function Assets(_ref4) {
  var chat = _ref4.chat,
    showAssets = _ref4.showAssets,
    widgetProps = _ref4.widgetProps,
    seekResponseProps = _ref4.seekResponseProps;
  var contentMappings = _$1.get(chat, 'contentMappings') || [];
  return /*#__PURE__*/React.createElement(Transition, {
    "in": showAssets && contentMappings.length > 0,
    timeout: {
      enter: 500,
      exit: 300
    }
  }, function (state) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: cx(styles$L.assets, styles$L[state])
    }, (_$1.uniqBy(chat.contentMappings, 'uid') || []).map(function (data) {
      var entityType = _$1.get(data, 'content.entityType');
      if (entityType == 'page') {
        return /*#__PURE__*/React.createElement(PageAsset, {
          key: data.uid,
          data: data,
          widgetProps: widgetProps
        });
      }
      return /*#__PURE__*/React.createElement(Asset, {
        key: data.id,
        data: data,
        widgetProps: widgetProps
      });
    })), /*#__PURE__*/React.createElement("div", {
      className: cx(styles$L.actions, styles$L[state])
    }, /*#__PURE__*/React.createElement(Feedback, {
      chat: chat,
      widget: _$1.get(widgetProps, 'uid'),
      seekResponseProps: seekResponseProps
    })));
  });
};
var Asset = function Asset(_ref5) {
  var key = _ref5.key,
    data = _ref5.data,
    widgetProps = _ref5.widgetProps;
  var asset = _$1.get(data, 'content.asset');
  var icon = asset.icon ? asset.icon.thumbnail : DefaultAssetIcon;
  var name = _$1.get(asset, 'name', '');
  var extension = FileService.fileType(_$1.get(asset, 'metadata'));
  var size = _$1.get(asset, 'metadata.content_length');
  var sizeOfAsset = FileService.formatSize(size);
  var pages = _$1.get(asset, 'metadata.pages');
  var contentType = _$1.get(asset, 'metadata.content_type');
  var contentContext = React.useContext(Content.Context);
  var link = false;
  var additionalData = '';
  if (pages) {
    additionalData = asset.metadata.pages + " Pages";
  } else if (asset.metadata.video_duration) {
    additionalData = "" + formartVideoDuration(asset.metadata.video_duration);
  }
  if (contentType.endsWith('url')) {
    link = true;
  }
  var handleAssetClick = function handleAssetClick() {
    contentContext.viewContent(widgetProps, data);
  };
  return /*#__PURE__*/React.createElement("div", {
    key: key,
    className: styles$L.asset
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$L.iconWrapper,
    onClick: handleAssetClick,
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    className: cx(styles$L.icon, styles$L.trial),
    src: icon,
    alt: "img"
  }), link ? /*#__PURE__*/React.createElement("span", {
    className: styles$L.link
  }, "Link") : '', extension ? /*#__PURE__*/React.createElement("span", {
    className: styles$L.extension
  }, extension) : '', /*#__PURE__*/React.createElement("span", {
    className: styles$L.additionalData
  }, additionalData), size ? /*#__PURE__*/React.createElement("span", {
    className: styles$L.size
  }, sizeOfAsset) : '', /*#__PURE__*/React.createElement("div", {
    className: styles$L.overlay
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$L.name
  }, name));
};
var PageAsset = function PageAsset(_ref6) {
  var key = _ref6.key,
    data = _ref6.data,
    widgetProps = _ref6.widgetProps;
  var asset = _$1.get(data, 'content.asset');
  var icon = asset.icon ? asset.icon.url : DefaultAssetIcon;
  var name = _$1.get(asset, 'name', '');
  var storyboardType = _$1.get(asset, 'storyboardType');
  var contentContext = React.useContext(Content.Context);
  var handleAssetClick = function handleAssetClick() {
    contentContext.viewContent(widgetProps, data);
  };
  var pageTypeLabel = function pageTypeLabel() {
    switch (storyboardType) {
      case 'INTERACTIVE_CONTENT':
        return 'Interactive Content';
      case 'LANDING_PAGE':
        return 'Landing page';
      default:
        return 'Resource Center';
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    key: key,
    className: styles$L.asset
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$L.iconWrapper,
    onClick: handleAssetClick,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(IKImage, {
    path: icon,
    width: 90,
    height: 110,
    style: {
      borderRadius: '10px'
    }
  }), storyboardType ? /*#__PURE__*/React.createElement("span", {
    className: styles$L.pages
  }, pageTypeLabel()) : '', /*#__PURE__*/React.createElement("div", {
    className: styles$L.overlay
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$L.name
  }, name));
};
var formartVideoDuration = function formartVideoDuration(timeSpent) {
  var timeSpentValue = padNumber(timeSpent, 1) + " Seconds";
  if (timeSpent >= 60) {
    var minutes = Math.round(timeSpent / 60);
    timeSpentValue = padNumber(minutes, 1) + " Minute" + (minutes == 1 ? '' : 's');
  }
  return timeSpentValue;
};
var padNumber = function padNumber(number, pad) {
  if (number === void 0) {
    number = 0;
  }
  number = Math.ceil(number);
  var length = pad - String(number).length + 1;
  var padding = '';
  if (length > 0) {
    padding = Array(pad - String(number).length + 1).join('0');
  }
  return padding + number;
};
var Feedback = function Feedback(_ref7) {
  var _cx2;
  var chat = _ref7.chat,
    widget = _ref7.widget,
    seekResponseProps = _ref7.seekResponseProps;
  var seekContext = React.useContext(SeekContext);
  var _useState3 = useState(false),
    helpfulHovered = _useState3[0],
    setHelpfulHovered = _useState3[1];
  var _useState4 = useState(false),
    notHelpfulHovered = _useState4[0],
    setNotHelpfulHovered = _useState4[1];
  var _useState5 = useState(chat.isHelpful),
    helpful = _useState5[0],
    setHelpful = _useState5[1];
  var accentColor = _$1.get(seekResponseProps, 'accentColor', {
    r: 0,
    g: 189,
    b: 231,
    a: 1
  });
  var handleFeedback = function handleFeedback(value) {
    if (helpful !== value) {
      setHelpful(value);
    }
    seekContext.updateSeekHelpful(widget, chat.id, value);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles$L.feedback, (_cx2 = {}, _cx2[styles$L.noAssets] = _$1.size(chat.assets) === 0, _cx2))
  }, /*#__PURE__*/React.createElement("style", null, "\n            #" + ("chat_" + widget) + " i::before {\n                color: " + colorStyle(accentColor) + ";\n              }\n          "), /*#__PURE__*/React.createElement(Button, {
    onMouseEnter: function onMouseEnter() {
      return setHelpfulHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHelpfulHovered(false);
    },
    className: cx(styles$L.thumb, styles$L.up),
    onClick: function onClick() {
      return handleFeedback(true);
    }
  }, helpful || helpfulHovered ? /*#__PURE__*/React.createElement("i", {
    className: "cleverstory-like-active"
  }) : /*#__PURE__*/React.createElement("i", {
    className: "cleverstory-like"
  })), /*#__PURE__*/React.createElement(Button, {
    onMouseEnter: function onMouseEnter() {
      return setNotHelpfulHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setNotHelpfulHovered(false);
    },
    className: cx(styles$L.thumb, styles$L.down),
    onClick: function onClick() {
      return handleFeedback(false);
    }
  }, helpful === false || notHelpfulHovered ? /*#__PURE__*/React.createElement("i", {
    className: "cleverstory-dislike-active"
  }) : /*#__PURE__*/React.createElement("i", {
    className: "cleverstory-dislike"
  })));
};
function getColorStyles$g(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }
  var styles = {
    color: color
  };
  return styles;
}
var getQuestionStyle = function getQuestionStyle(fontStyles) {
  var styles = {};
  if (!fontStyles) {
    return styles;
  }
  var colorRgb = _$1.get(fontStyles, "color", null);
  var color = getColorStyles$g(colorRgb);
  styles = _extends({}, styles, color);
  var fontFamily = _$1.get(fontStyles, 'fontFamily');
  if (fontFamily) {
    styles = _extends({}, styles, {
      fontFamily: fontFamily
    });
  }
  var fontSizeString = _$1.get(fontStyles, 'fontSize', '12');
  var fontSize = 'inherit';
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }
  styles['fontSize'] = fontSize;
  return styles;
};
var getAnswerStyle = function getAnswerStyle(fontStyles) {
  var styles = {};
  if (!fontStyles) {
    return styles;
  }
  var colorRgb = _$1.get(fontStyles, "secondaryColor", null);
  var color = getColorStyles$g(colorRgb);
  styles = _extends({}, styles, color);
  var fontFamily = _$1.get(fontStyles, 'fontFamily');
  if (fontFamily) {
    styles = _extends({}, styles, {
      fontFamily: fontFamily
    });
  }
  var fontSizeString = _$1.get(fontStyles, 'fontSize', '12');
  var fontSize = 'inherit';
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }
  styles['fontSize'] = fontSize;
  return styles;
};
var getBackgroundStyles = function getBackgroundStyles(properties) {
  var backgroundColor = _$1.get(properties, 'backgroundColor', null);
  return {
    backgroundColor: colorStyle(backgroundColor)
  };
};
var colorStyle = function colorStyle(color) {
  return "rgba(" + (_$1.get(color, 'r') || 0) + ", " + (_$1.get(color, 'g') || 0) + ", " + (_$1.get(color, 'b') || 0) + ", " + (_$1.get(color, 'a') || 1) + ")";
};

var styles$M = {"popupModal":"_GX8wt","popupModalContent":"_205ln","popupModalDialog":"_1ksMH","mobileContent":"_1tmVR","mobileDialog":"_1SOXv","sliderModal":"_3Io8P","sliderModalDialog":"_2Mz_K"};

var InlineModal = function InlineModal(_ref) {
  var widgetProps = _ref.widgetProps,
    className = _ref.className,
    show = _ref.show,
    onSubmit = _ref.onSubmit,
    breakpoint = _ref.breakpoint,
    handleSuggestionClick = _ref.handleSuggestionClick,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(className)
  }, /*#__PURE__*/React.createElement(SessionContainer, {
    show: show,
    handleSuggestionClick: handleSuggestionClick,
    breakpoint: breakpoint,
    onSubmit: onSubmit,
    widgetProps: widgetProps,
    onClose: onClose
  }));
};
var inlineConatinerEquals = function inlineConatinerEquals(prevProps, nextProps) {
  var paths = ['className', 'widgetProps', 'breakpoint', 'show', 'onChange', 'onSubmit', 'handleSuggestionClick'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var InlineResponse = React.memo(InlineModal, inlineConatinerEquals);
var PopUpModal = function PopUpModal(_ref2) {
  var _cx, _cx2;
  var show = _ref2.show,
    onClose = _ref2.onClose,
    className = _ref2.className,
    breakpoint = _ref2.breakpoint,
    handleSuggestionClick = _ref2.handleSuggestionClick,
    onSubmit = _ref2.onSubmit,
    widgetProps = _ref2.widgetProps;
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: onClose,
    centered: true,
    fullscreen: breakpoint === 'mobile' ? true : false,
    animation: true,
    dialogClassName: cx(styles$M.popupModalDialog, (_cx = {}, _cx[styles$M.mobileDialog] = breakpoint === 'mobile', _cx)),
    contentClassName: cx(styles$M.popupModalContent, (_cx2 = {}, _cx2[styles$M.mobileContent] = breakpoint === 'mobile', _cx2)),
    className: cx(styles$M.popupModal, className),
    "aria-labelledby": "example-custom-modal-styling-title"
  }, /*#__PURE__*/React.createElement(SessionContainer, {
    onSubmit: onSubmit,
    handleSuggestionClick: handleSuggestionClick,
    breakpoint: breakpoint,
    widgetProps: widgetProps,
    onClose: onClose
  }));
};
var popupConatinerEquals = function popupConatinerEquals(prevProps, nextProps) {
  var paths = ['className', 'widgetProps', 'breakpoint', 'show', 'onChange', 'onSubmit', 'handleSuggestionClick'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var PopUpResponse = React.memo(PopUpModal, popupConatinerEquals);
var SliderModal = function SliderModal(_ref3) {
  var show = _ref3.show,
    onClose = _ref3.onClose,
    breakpoint = _ref3.breakpoint,
    handleSuggestionClick = _ref3.handleSuggestionClick,
    onSubmit = _ref3.onSubmit,
    widgetProps = _ref3.widgetProps;
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: onClose,
    backdrop: "static",
    fullscreen: true,
    animation: true,
    dialogClassName: cx(styles$M.sliderModalDialog),
    className: cx(styles$M.sliderModal),
    "aria-labelledby": "example-custom-modal-styling-title"
  }, /*#__PURE__*/React.createElement(SessionContainer, {
    handleSuggestionClick: handleSuggestionClick,
    breakpoint: breakpoint,
    onSubmit: onSubmit,
    widgetProps: widgetProps,
    onClose: onClose
  }));
};
var sliderConatinerEquals = function sliderConatinerEquals(prevProps, nextProps) {
  var paths = ['className', 'widgetProps', 'breakpoint', 'show', 'onChange', 'onSubmit', 'handleSuggestionClick'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var SliderResponse = React.memo(SliderModal, sliderConatinerEquals);

var styles$N = {"inlineContainer":"_1IcDK","preview":"_3PIfM"};

var QuestionComponent = function QuestionComponent(_ref) {
  var widgetProps = _ref.widgetProps,
    className = _ref.className,
    breakpoint = _ref.breakpoint,
    _ref$showChats = _ref.showChats,
    showChats = _ref$showChats === void 0 ? false : _ref$showChats;
  var questionDesign = _$1.get(widgetProps, "properties." + breakpoint + ".questionDesign", {});
  var seekLayoutType = _$1.get(questionDesign, "type", 'bar');
  return /*#__PURE__*/React.createElement(React.Fragment, null, seekLayoutType === 'bar' && /*#__PURE__*/React.createElement(BarLayoutComponent, {
    widgetProps: widgetProps,
    breakpoint: breakpoint,
    className: className,
    showChats: showChats
  }));
};
var BarLayoutComponent = function BarLayoutComponent(_ref2) {
  var widgetProps = _ref2.widgetProps,
    breakpoint = _ref2.breakpoint,
    className = _ref2.className,
    showChats = _ref2.showChats;
  var seekContext = React.useContext(SeekContext);
  var context = React.useContext(WidgetsContext);
  var _useState = useState({
      question: '',
      showChats: showChats
    }),
    state = _useState[0],
    setState = _useState[1];
  var id = _$1.get(widgetProps, 'uid');
  var seekSession = seekContext.seekSession || {};
  var alias = seekContext.alias;
  var seekSessionId = _$1.get(seekSession, id + ".sessionId", null);
  var pageSession = useSelector(function (state) {
    return _$1.get(state, "pages.analytics[" + alias + "].id", null);
  });
  var pageId = useSelector(function (state) {
    return _$1.get(state, 'pages.item.id', null);
  });
  var widgetProperties = _$1.get(widgetProps, 'properties');
  var storyboard = _$1.get(context, 'storyboard.id');
  var seekResponseProps = _$1.get(widgetProperties, breakpoint + ".responseDesign", {});
  var layoutType = _$1.get(seekResponseProps, 'type', breakpoint === 'desktop' ? 'inline' : 'popup');
  var handleSubmit = function handleSubmit(question) {
    var questionLength = question.replace(/\s+/g, '').length;
    if (question && questionLength !== 0) {
      seekContext.seekAnswerForQuestion(id, seekSessionId, question, pageSession, pageId, storyboard);
      setState(function (state) {
        return _extends({}, state, {
          showChats: true,
          question: ''
        });
      });
    }
  };
  var handleSuggestionClick = function handleSuggestionClick(suggestion) {
    if (seekContext.disabled) {
      return;
    }
    seekContext.seekAnswerForQuestion(id, seekSessionId, suggestion, pageSession, pageId, storyboard);
    setState(function (state) {
      return _extends({}, state, {
        showChats: true,
        question: ''
      });
    });
  };
  var handleCloseChat = function handleCloseChat() {
    setState(function (state) {
      return _extends({}, state, {
        showChats: false
      });
    });
    seekContext.invalidateSeekSession(id, seekSessionId);
  };
  switch (layoutType) {
    case 'inline':
      {
        return /*#__PURE__*/React.createElement("div", {
          className: cx(styles$N.inlineContainer, className)
        }, !state.showChats && /*#__PURE__*/React.createElement(SeekSearchBox, {
          widgetProps: widgetProps,
          value: state.question,
          onChange: function onChange(value) {
            setState(function (state) {
              return _extends({}, state, {
                question: value
              });
            });
          },
          className: cx(styles$N.searchInputField),
          breakpoint: breakpoint,
          disabled: seekContext.disabled,
          handleSuggestionClick: handleSuggestionClick,
          onSubmit: handleSubmit
        }), state.showChats && /*#__PURE__*/React.createElement(InlineResponse, {
          widgetProps: widgetProps,
          onClose: handleCloseChat,
          show: state.showChats,
          breakpoint: breakpoint,
          handleSuggestionClick: handleSuggestionClick,
          onSubmit: handleSubmit
        }));
      }
    case 'popup':
      {
        var onSubmit = function onSubmit(question) {
          if (!state.showChats && seekSessionId) {
            seekContext.seekChatHistory(seekSessionId, id, question, handleSubmit);
            setState(function (state) {
              return _extends({}, state, {
                showChats: true,
                question: ''
              });
            });
            return;
          }
          handleSubmit(question);
        };
        var onSuggestionClick = function onSuggestionClick(suggestion) {
          if (!state.showChats && seekSessionId) {
            seekContext.seekChatHistory(seekSessionId, id, suggestion, handleSuggestionClick);
            setState(function (state) {
              return _extends({}, state, {
                showChats: true,
                question: ''
              });
            });
            return;
          }
          handleSuggestionClick(suggestion);
        };
        return /*#__PURE__*/React.createElement("div", {
          className: cx(styles$N.popupConatiner, className)
        }, /*#__PURE__*/React.createElement(SeekSearchBox, {
          widgetProps: widgetProps,
          value: state.question,
          onChange: function onChange(value) {
            setState(function (state) {
              return _extends({}, state, {
                question: value
              });
            });
          },
          className: cx(styles$N.searchInputField),
          breakpoint: breakpoint,
          disabled: seekContext.disabled,
          handleSuggestionClick: onSuggestionClick,
          onSubmit: onSubmit
        }), state.showChats && /*#__PURE__*/React.createElement(PopUpResponse, {
          widgetProps: widgetProps,
          onClose: handleCloseChat,
          show: state.showChats,
          breakpoint: breakpoint,
          handleSuggestionClick: handleSuggestionClick,
          onSubmit: handleSubmit
        }));
      }
    case 'slider':
      {
        var _onSubmit = function _onSubmit(question) {
          if (!state.showChats && seekSessionId) {
            seekContext.seekChatHistory(seekSessionId, id, question, handleSubmit);
            setState(function (state) {
              return _extends({}, state, {
                showChats: true,
                question: ''
              });
            });
            return;
          }
          handleSubmit(question);
        };
        var _onSuggestionClick = function _onSuggestionClick(suggestion) {
          if (!state.showChats && seekSessionId) {
            seekContext.seekChatHistory(seekSessionId, id, suggestion, handleSuggestionClick);
            setState(function (state) {
              return _extends({}, state, {
                showChats: true,
                question: ''
              });
            });
            return;
          }
          handleSuggestionClick(suggestion);
        };
        return /*#__PURE__*/React.createElement("div", {
          className: cx(styles$N.popupConatiner, className)
        }, /*#__PURE__*/React.createElement(SeekSearchBox, {
          widgetProps: widgetProps,
          value: state.question,
          onChange: function onChange(value) {
            setState(function (state) {
              return _extends({}, state, {
                question: value
              });
            });
          },
          className: cx(styles$N.searchInputField),
          breakpoint: breakpoint,
          disabled: seekContext.disabled,
          handleSuggestionClick: _onSuggestionClick,
          onSubmit: _onSubmit
        }), state.showChats && /*#__PURE__*/React.createElement(SliderResponse, {
          widgetProps: widgetProps,
          onClose: handleCloseChat,
          show: state.showChats,
          breakpoint: breakpoint,
          handleSuggestionClick: handleSuggestionClick,
          onSubmit: handleSubmit,
          className: styles$N.previous
        }));
      }
  }
};
var questionConatinerEquals = function questionConatinerEquals(prevProps, nextProps) {
  var paths = ['className', 'widgetProps', 'breakpoint'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var QuestionDesign = React.memo(QuestionComponent, questionConatinerEquals);

var styles$O = {"seekContainer":"_2Orxt"};

var _excluded$7 = ["className", "style", "widgetProps", "breakpoint"];
var SeekWidgetComponent = function SeekWidgetComponent(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var context = useContext(WidgetsContext);
  var seekContainerRef = useRef(null);
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var stretched = _$1.get(widgetProps, 'properties.desktop.stretched', false);
  var questionDesign = _$1.get(widgetProps, "properties." + breakpoint + ".questionDesign", {});
  var seekLayoutType = _$1.get(questionDesign, "type", 'bar');
  var widgetStyle = _extends({}, style, getStyles$j(widgetProps, breakpoint));
  return /*#__PURE__*/React.createElement(AutoGrowLayout, {
    ref: seekContainerRef,
    editorSession: context.session,
    breakpoint: breakpoint,
    widget: widgetProps
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(className, styles$O.seekContainer, (_cx = {}, _cx[styles$O.stretched] = stretched, _cx[styles$O.mobile] = breakpoint === 'mobile', _cx)),
    ref: seekContainerRef,
    style: widgetStyle,
    "data-widget-id": id,
    "data-widget-type": type
  }, /*#__PURE__*/React.createElement(QuestionDesign, {
    widgetProps: widgetProps,
    breakpoint: breakpoint,
    className: styles$O.questionWrapper
  })));
};
function getStyles$j(widgetProps, breakpoint, type) {
  var defaultProperties = _$1.get(widgetProps, "properties.desktop");
  var deviceProperties = _$1.get(widgetProps, "properties." + breakpoint);
  var stretched = _$1.get(defaultProperties, 'stretched', false);
  var margin = _$1.get(defaultProperties, 'margin', 0);
  var padding = _$1.get(deviceProperties, "padding", 0);
  var widgetStyles = {};
  if (breakpoint === 'desktop') {
    widgetStyles = _extends({}, widgetStyles, {
      width: "1200px",
      paddingLeft: "0px",
      marginLeft: "calc((100% - 1200px) * 0.5)",
      paddingRight: "0px"
    });
    if (stretched) {
      widgetStyles = _extends({}, widgetStyles, {
        marginLeft: margin,
        width: "calc(100% - 2 * " + margin + "px)",
        left: "calc((100% - 2 * " + margin + "px))/2)"
      });
    }
  }
  if (breakpoint === 'mobile') {
    widgetStyles = _extends({}, widgetStyles, {
      paddingLeft: "0px",
      paddingRight: "0px"
    });
  }
  return widgetStyles;
}
var seekWidgetEquals = function seekWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var SeekWidget = React.memo(SeekWidgetComponent, seekWidgetEquals);

var styles$P = {"carouselContainer":"_2XXly","carousel":"_2gg0D","cardWrapper":"_2l7rn","stretched":"_Vjr3v","mobile":"_vQDdU","custom-navigation":"_7VxKK","navigationButton":"_3z4uv","navigationDisable":"_2xva6","paginationContainer":"_1ieqd","bulletPoints":"_2VpWQ","paginationIcon":"_1Kn-C"};

var _excluded$8 = ["className", "style", "widgetProps", "breakpoint", "children"];
var CarouselCardContext = React.createContext({
  activecard: null
});
var CarouselWidgetComponent = function CarouselWidgetComponent(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var deviceLayout = _$1.get(widgetProps, "properties." + breakpoint + ".layout");
  var stretched = _$1.get(widgetProps, 'properties.desktop.stretched', false);
  var free = _$1.get(widgetProps, 'properties.desktop.free', false);
  var transition = _$1.get(widgetProps, 'properties.desktop.transition', {});
  var arrowsProperty = _$1.get(widgetProps, "properties." + breakpoint + ".arrows", {});
  var dotsProperty = _$1.get(widgetProps, "properties." + breakpoint + ".dots", {});
  var sliderRef = useRef(null);
  var _useState = useState(0),
    activeIndex = _useState[0],
    setActiveIndex = _useState[1];
  var widgetStyle = _extends({}, style, getStyles$k(widgetProps, breakpoint));
  var _useInView = useInView$1({
      threshold: 0.2,
      triggerOnce: false
    }),
    ref = _useInView.ref,
    inView = _useInView.inView;
  useEffect(function () {
    if (inView && _$1.get(transition, 'autoPlay')) {
      sliderRef.slickPlay();
    } else {
      sliderRef.slickPause();
    }
  }, [inView]);
  var settings = {
    dots: _$1.get(dotsProperty, 'flag'),
    autoplay: inView ? _$1.get(transition, 'autoPlay') : false,
    pauseOnHover: _$1.get(transition, 'pauseOnHover'),
    autoplaySpeed: parseInt(_$1.get(transition, 'visibleDuration')) * 1000,
    appendDots: function appendDots(dots) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          bottom: _$1.get(dotsProperty, 'offset', 10) + "px"
        },
        className: cx('swiper-pagination', styles$P.paginationContainer)
      }, /*#__PURE__*/React.createElement("ul", {
        style: {
          margin: "0px"
        }
      }, " ", dots, " "));
    },
    customPaging: function customPaging(index) {
      return /*#__PURE__*/React.createElement("a", null, /*#__PURE__*/React.createElement("span", {
        key: index
      }, renderDotsIcons(dotsProperty, index, index === activeIndex, _$1.size(children) - 1)));
    },
    swipe: !isDesktop,
    swipeToSlide: true,
    fade: _$1.get(transition, 'style') == 'FADE',
    infinite: _$1.get(transition, 'autoPlay'),
    arrows: _$1.get(arrowsProperty, 'enabled'),
    speed: parseInt(_$1.get(transition, 'speed')) * 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: function beforeChange(index, newIndex) {
      setActiveIndex(newIndex);
    },
    dotsClass: "slick-dots slick-thumb",
    nextArrow: /*#__PURE__*/React.createElement(CustomNavigationButton, {
      arrowsProperty: arrowsProperty,
      breakpoint: breakpoint,
      disable: !_$1.get(transition, 'autoPlay') && activeIndex + 1 == _$1.size(children),
      direction: 'right'
    }),
    prevArrow: /*#__PURE__*/React.createElement(CustomNavigationButton, {
      arrowsProperty: arrowsProperty,
      breakpoint: breakpoint,
      disable: !_$1.get(transition, 'autoPlay') && activeIndex == 0,
      direction: 'left'
    })
  };
  var carouselCardContextValue = React.useMemo(function () {
    return {
      activeIndex: activeIndex
    };
  }, [activeIndex]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$P.carouselContainer, (_cx = {}, _cx[styles$P.stretched] = stretched, _cx[styles$P.mobile] = breakpoint === 'mobile', _cx)),
    ref: ref,
    style: widgetStyle,
    "data-widget-id": id,
    "data-widget-type": type
  }, /*#__PURE__*/React.createElement(CarouselCardContext.Provider, {
    value: carouselCardContextValue
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      height: "100%",
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(Slider, _extends({
    ref: function ref(slider) {
      return sliderRef = slider;
    }
  }, settings, {
    className: styles$P.carousel
  }), React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles$P.cardWrapper
    }, React.cloneElement(child, {
      parentStyle: style,
      index: index,
      stretched: stretched
    }, null));
  })))));
};
var CustomNavigationButton = function CustomNavigationButton(_ref2) {
  var _cx2, _cx3, _cx4;
  var arrowsProperty = _ref2.arrowsProperty,
    disable = _ref2.disable,
    breakpoint = _ref2.breakpoint,
    direction = _ref2.direction,
    onClick = _ref2.onClick;
  var _useState2 = useState({
      buttonState: 'regular',
      buttonStyles: {}
    }),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    updateButtonStyles('regular');
  }, [breakpoint]);
  var updateButtonStyles = function updateButtonStyles(state) {
    var updatedStyles = getNavigationButtonStyles(direction, arrowsProperty, state);
    setState(function (prevstate) {
      return {
        buttonState: state,
        buttonStyles: updatedStyles
      };
    });
  };
  return /*#__PURE__*/React.createElement(Button, {
    variant: "info",
    style: state.buttonStyles,
    onClick: onClick,
    onMouseOver: function onMouseOver() {
      return updateButtonStyles('hover');
    },
    onMouseOut: function onMouseOut() {
      return updateButtonStyles('regular');
    },
    className: cx((_cx2 = {}, _cx2["custom-prev-button"] = direction == 'left', _cx2), (_cx3 = {}, _cx3["custom-next-button"] = direction == 'right', _cx3), (_cx4 = {}, _cx4[styles$P.navigationDisable] = disable, _cx4), styles$P.navigationButton)
  }, renderArrowIcons(_$1.get(arrowsProperty, 'style'), direction, arrowsProperty, state.buttonState));
};
var renderDotsIcons = function renderDotsIcons(data, index, isActive, lastIndex) {
  var lastPagination = lastIndex == index;
  var dotStyles = _$1.get(data, 'flag') ? getPaginationStyles(data, isActive, lastPagination) : {};
  var type = _$1.get(data, 'style') || _$1.get(data, 'type');
  switch (type) {
    case 'DEFAULT':
      return /*#__PURE__*/React.createElement("i", {
        key: index,
        style: dotStyles,
        className: cx('cleverstory-pagination-default', styles$P.paginationIcon)
      });
    case 'STANDARD':
      return /*#__PURE__*/React.createElement("i", {
        key: index,
        style: dotStyles,
        className: cx('cleverstory-pagination-standard', styles$P.paginationIcon)
      });
    default:
      return /*#__PURE__*/React.createElement("i", {
        key: index,
        style: dotStyles,
        className: cx('cleverstory-pagination-standard', styles$P.paginationIcon)
      });
  }
};
function getPaginationStyles(properties, isActive, lastPagination) {
  var dotIconstyles = {};
  if (!properties && !_$1.get(properties, 'flag')) {
    return dotIconstyles;
  }
  var defaultcolor = _$1.get(properties, "defaultColor", null);
  var selectedcolor = _$1.get(properties, "selectedColor", null);
  var color = getColorStyles$h(isActive ? selectedcolor : defaultcolor);
  dotIconstyles = _extends({}, dotIconstyles, color);
  var fontSizeString = _$1.get(properties, 'size', 8);
  var fontSize = 'inherit';
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }
  dotIconstyles['fontSize'] = fontSize;
  var spaceBetween = _$1.get(properties, 'cornerRadius', 8);
  var marginRight = 'inherit';
  if (spaceBetween && !lastPagination) {
    marginRight = parseInt(spaceBetween) + 'px';
  }
  dotIconstyles['marginRight'] = marginRight;
  return dotIconstyles;
}
var renderArrowIcons = function renderArrowIcons(type, direction, properties, buttonState) {
  var _cx5, _cx6, _cx7, _cx8, _cx9, _cx10, _cx11, _cx12;
  if (properties === void 0) {
    properties = null;
  }
  var arrowIconStyles = getArrowStyles(properties, buttonState);
  switch (type) {
    case 'MORDERN':
      return /*#__PURE__*/React.createElement("i", {
        style: arrowIconStyles,
        className: cx((_cx5 = {}, _cx5['cleverstory-drop-down-left'] = direction == 'left', _cx5), (_cx6 = {}, _cx6['cleverstory-drop-down-right'] = direction == 'right', _cx6))
      });
    case 'STANDARD':
      return /*#__PURE__*/React.createElement("i", {
        style: arrowIconStyles,
        className: cx((_cx7 = {}, _cx7['cleverstory-left'] = direction == 'left', _cx7), (_cx8 = {}, _cx8['cleverstory-right'] = direction == 'right', _cx8))
      });
    case 'DEFAULT':
      return /*#__PURE__*/React.createElement("i", {
        style: arrowIconStyles,
        className: cx((_cx9 = {}, _cx9['cleverstory-fill-left'] = direction == 'left', _cx9), (_cx10 = {}, _cx10['cleverstory-fill-right'] = direction == 'right', _cx10))
      });
    default:
      return /*#__PURE__*/React.createElement("i", {
        style: arrowIconStyles,
        className: cx((_cx11 = {}, _cx11['cleverstory-left'] = direction == 'left', _cx11), (_cx12 = {}, _cx12['cleverstory-right'] = direction == 'right', _cx12))
      });
  }
};
function getNavigationButtonStyles(direction, properties, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var backgroundRgb = _$1.get(properties, active + ".backgroundColor", null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = "rgba(" + backgroundRgb.r + ", " + backgroundRgb.g + ", " + backgroundRgb.b + ", " + backgroundRgb.a + ")";
  }
  styles['backgroundColor'] = background;
  var border = _$1.get(properties, 'backgroundCornerRadius', {});
  var borderStyle = getBorderStyles$h(border);
  styles = _extends({}, styles, borderStyle);
  var offset = _$1.get(properties, 'offset');
  if (direction == 'left') {
    styles = _extends({}, styles, {
      left: parseInt(offset) + 'px'
    });
  }
  if (direction == 'right') {
    styles = _extends({}, styles, {
      right: parseInt(offset) + 'px'
    });
  }
  return styles;
}
function getArrowStyles(properties, state) {
  var arrowIconstyles = {};
  if (!properties) {
    return arrowIconstyles;
  }
  var deviceProperties = properties;
  var defaultStyles = _$1.get(deviceProperties, "" + state, {});
  var colorRgb = _$1.get(defaultStyles, "color", null);
  var color = getColorStyles$h(colorRgb);
  arrowIconstyles = _extends({}, arrowIconstyles, color);
  var fontSizeString = _$1.get(deviceProperties, 'size', null);
  var fontSize = 'inherit';
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }
  arrowIconstyles['fontSize'] = fontSize;
  return arrowIconstyles;
}
function getStyles$k(widgetProps, breakpoint) {
  var stretched = _$1.get(widgetProps, 'properties.desktop.stretched', false);
  var free = _$1.get(widgetProps, 'properties.desktop.free', false);
  var margin = _$1.get(widgetProps, 'properties.desktop.margin', 0);
  var padding = _$1.get(widgetProps, "properties." + breakpoint + ".padding", 0);
  var widgetStyles = {
    paddingTop: padding + "px",
    paddingBottom: padding + "px",
    transformOrigin: 'top'
  };
  if (breakpoint === 'desktop' && !free) {
    widgetStyles = _extends({}, widgetStyles, {
      width: "1200px",
      marginLeft: "calc((100% - 1200px) * 0.5)",
      paddingLeft: padding + "px",
      paddingRight: padding + "px"
    });
    if (stretched) {
      widgetStyles = _extends({}, widgetStyles, {
        marginLeft: margin,
        width: "calc(100% - 2 * " + margin + "px)",
        left: "calc((100% - 2 * " + margin + "px))/2)"
      });
    }
  }
  if (breakpoint === 'mobile') {
    widgetStyles = _extends({}, widgetStyles, {
      width: '100%'
    });
  }
  return widgetStyles;
}
function getColorStyles$h(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  var styles = {
    color: color
  };
  return styles;
}
function getBorderStyles$h(value) {
  if (!value) {
    return null;
  }
  var styles = {
    borderRadius: parseInt(value) + 'px'
  };
  return styles;
}
var carouselWidgetEquals = function carouselWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var CarouselWidget = React.memo(CarouselWidgetComponent, carouselWidgetEquals);

var styles$Q = {"carouselCard":"_ftXpP"};

var _excluded$9 = ["className", "style", "widgetProps", "breakpoint", "children", "parentStyle", "index", "stretched"];
var CarouselCardWidgetComponent = function CarouselCardWidgetComponent(_ref) {
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children,
    parentStyle = _ref.parentStyle,
    index = _ref.index,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  var id = _$1.get(widgetProps, 'uid');
  var type = _$1.get(widgetProps, 'type');
  var parentWidget = useContainerSelector(id);
  var isFreeSize = _$1.get(parentWidget, "properties.desktop.free", false);
  var _useState = useState(null),
    windowWidth = _useState[0],
    setWindowWidth = _useState[1];
  var background = _$1.get(widgetProps, 'properties.desktop.background');
  var layout = _$1.get(widgetProps, 'properties.desktop.layout');
  var carouselContext = React.useContext(CarouselCardContext);
  var context = React.useContext(WidgetsContext);
  useEffect(function () {
    if (!windowWidth) {
      handleResize();
    }
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  var handleResize = function handleResize() {
    setWindowWidth(window.innerWidth);
  };
  var widgetStyle = _extends({}, style, {
    transform: 'none'
  }, getStyles(widgetProps, breakpoint));
  function getStyles(widget, breakpoint) {
    var styles = {};
    if (breakpoint === 'desktop') {
      var width = parseFloat(_$1.get(widget, "properties." + breakpoint + ".layout.width", 100));
      styles = _extends({}, styles, {
        maxWidth: "calc(" + width + "% - 0px)",
        height: '100%'
      });
    }
    if (breakpoint === 'mobile') {
      styles = _extends({}, styles, {
        transform: 'none',
        width: _$1.get(parentStyle, 'width'),
        height: _$1.get(parentStyle, 'height')
      });
    }
    return styles;
  }
  if (context.development) {
    return /*#__PURE__*/React.createElement("div", {
      id: id,
      className: cx(className, styles$Q.carouselCard),
      style: widgetStyle,
      "data-widget-id": id,
      "data-widget-type": type,
      "data-free-size": isFreeSize
    }, /*#__PURE__*/React.createElement(BackgroundView, {
      background: background,
      breakpoint: breakpoint
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$Q.inner
    }, children));
  }
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$Q.carouselCard),
    style: widgetStyle,
    "data-widget-id": id,
    "data-widget-type": type,
    "data-free-size": isFreeSize
  }, /*#__PURE__*/React.createElement(BackgroundView, {
    background: background,
    breakpoint: breakpoint
  }), carouselContext.activeIndex == index && /*#__PURE__*/React.createElement("div", {
    className: styles$Q.inner
  }, children));
};
var carouselCardWidgetEquals = function carouselCardWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var CarouselCardWidget = React.memo(CarouselCardWidgetComponent, carouselCardWidgetEquals);

var styles$R = {"asset":"_FXJuO","assetViewer":"_2g8jT","background":"_IMam9"};

var AssetWidgetComponent = function AssetWidgetComponent(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint;
  var assetRef = React.useRef(null);
  var context = React.useContext(WidgetsContext);
  var contentContext = React.useContext(Content.Context);
  var gatingContext = React.useContext(GatingContext);
  var storyboardType = _$1.get(context, 'storyboard.type');
  var asset = _$1.get(widgetProps, 'content');
  var _React$useState = React.useState(false),
    active = _React$useState[0],
    setActive = _React$useState[1];
  var _React$useState2 = React.useState(null),
    analytics = _React$useState2[0],
    setAnalytics = _React$useState2[1];
  var _useState = useState(false),
    loaded = _useState[0],
    setLoaded = _useState[1];
  var _React$useState3 = React.useState(_$1.get(widgetProps, 'content.content.gatingConfigurations', [])),
    gatingConfigurations = _React$useState3[0],
    setGatingConfigurations = _React$useState3[1];
  var handleAssetVisibilityChange = function handleAssetVisibilityChange(visible) {
    setActive(visible);
  };
  var id = _$1.get(widgetProps, 'uid');
  var fullHeight = _$1.get(widgetProps, 'properties.desktop.fullHeight', false);
  var content = _$1.get(widgetProps, 'content', null);
  var background = _$1.get(widgetProps, 'properties.desktop.background');
  var poster = _$1.get(widgetProps, 'properties.desktop.video.poster');
  var animation = !fullHeight ? _$1.get(widgetProps, "properties." + breakpoint + ".animation") : null;
  var activeSession = useSelector(function (state) {
    return _$1.get(state, "content.analytics." + _$1.get(widgetProps, 'content.id', null) + ".item.id");
  });
  var scrollParent = fullHeight ? 'body' : "#asset_scroll_" + id;
  var widgetStyle = _extends({}, style, getStyles$l(widgetProps, breakpoint, loaded, storyboardType));
  useEffect(function () {
    var updatedItems = (gatingConfigurations || []).filter(function (_ref2) {
      var id = _ref2.id;
      return !gatingContext.assetConfigurations.includes(id);
    });
    setGatingConfigurations(updatedItems);
  }, [gatingContext.assetConfigurations]);
  useEffect(function () {
    if (gatingContext.configuration) {
      return;
    }
    if (analytics) {
      setLoaded(true);
      triggerAssetGating(analytics);
    }
  }, [analytics]);
  useEffect(function () {
    if (!gatingContext.gating) {
      setActive(true);
    } else {
      setActive(false);
    }
  }, [gatingContext === null || gatingContext === void 0 ? void 0 : gatingContext.gating]);
  var triggerAssetGating = function triggerAssetGating(_ref3) {
    var duration = _ref3.duration,
      percentageRead = _ref3.percentageRead;
    if (gatingContext.preview) {
      return;
    }
    gatingConfigurations.every(function (item) {
      if (!item.enabled) {
        return true;
      }
      var triggerValue = _$1.get(item, 'trigger.value', 0);
      var limit = duration;
      if (_$1.get(item, 'trigger.type', '') === "PERCENTAGE") {
        limit = percentageRead;
      }
      if (triggerValue <= limit) {
        var gating = _$1.get(item, 'gating.id', null);
        if (gating) {
          context.fetchGating(gating);
          gatingContext.triggerGating(_$1.get(item, 'trigger.type', ''), null, item);
          return false;
        }
      }
      return true;
    });
  };
  return /*#__PURE__*/React.createElement(AutoGrowLayout, {
    ref: assetRef,
    editorSession: context.session,
    breakpoint: breakpoint,
    widget: widgetProps,
    inlineAsset: true
  }, /*#__PURE__*/React.createElement(Waypoint, {
    onEnter: function onEnter() {
      return handleAssetVisibilityChange(true);
    },
    onLeave: function onLeave() {
      return handleAssetVisibilityChange(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    ref: assetRef,
    className: cx(className, styles$R.asset, 'cs_asset_widget'),
    style: widgetStyle,
    "data-widget-id": id,
    "data-asset": _$1.get(asset, 'uid')
  }, /*#__PURE__*/React.createElement(AnimationComponent, animation, /*#__PURE__*/React.createElement("div", {
    id: "asset_scroll_" + id,
    className: styles$R.assetViewer,
    style: getScrollStyles(widgetProps)
  }, /*#__PURE__*/React.createElement(BackgroundView, {
    background: background,
    breakpoint: breakpoint,
    className: cx((_cx = {}, _cx[styles$R.background] = !fullHeight, _cx))
  }), content && !context.development && /*#__PURE__*/React.createElement(AssetContentViewer, {
    asset: widgetProps.content,
    active: active,
    poster: poster,
    inline: true,
    widgetId: id,
    onLoad: function onLoad() {
      setLoaded(true);
    },
    loaded: loaded,
    scrollParent: scrollParent,
    onAnalyticsChange: function onAnalyticsChange(analytics) {
      if (activeSession || active) {
        setAnalytics(analytics);
        if (contentContext.onAnalyticsChange) {
          contentContext.onAnalyticsChange(asset, analytics);
        }
      }
    },
    onDebugAnalytics: function onDebugAnalytics(analytics) {
      if (contentContext.debug) {
        setAnalytics(analytics);
      }
    }
  }))))));
};
function getScrollStyles(widgetProps) {
  var fullHeight = _$1.get(widgetProps, 'properties.desktop.fullHeight', false);
  var widgetStyles = {};
  if (fullHeight) {
    widgetStyles = _extends({}, widgetStyles, {
      overflowY: 'hidden'
    });
  } else {
    widgetStyles = _extends({}, widgetStyles, {
      overflowY: 'auto'
    });
  }
  return widgetStyles;
}
function getStyles$l(widgetProps, breakpoint, loaded, storyboardType) {
  var display = storyboardType === 'SPATIAL' ? 'FREE' : _$1.get(widgetProps, 'properties.desktop.display', 'PAGE');
  var fullHeight = _$1.get(widgetProps, 'properties.desktop.fullHeight', false);
  var margin = _$1.get(widgetProps, 'properties.desktop.margin', 0);
  var height = _$1.get(widgetProps, "properties." + breakpoint + ".layout.height", 'auto');
  var width = _$1.get(widgetProps, "properties." + breakpoint + ".layout.width", '100%');
  var widgetStyles = {};
  if (breakpoint === 'desktop') {
    widgetStyles = _extends({}, widgetStyles, {
      width: width ? width : "1200px"
    });
    if (display === 'STRETCHED') {
      widgetStyles = _extends({}, widgetStyles, {
        marginLeft: margin,
        width: "calc(100% - 2 * " + margin + "px)"
      });
    }
    if (display === 'FREE') {
      widgetStyles = _extends({}, widgetStyles, {
        width: width ? width : "1200px"
      });
    }
  }
  if (breakpoint === 'mobile') {
    widgetStyles = _extends({}, widgetStyles, {
      width: '100%'
    });
  }
  if (fullHeight) {
    widgetStyles = _extends({}, widgetStyles);
    if (loaded) {
      widgetStyles = _extends({}, widgetStyles, {
        height: 'auto'
      });
    } else {
      widgetStyles = _extends({}, widgetStyles, {
        height: height
      });
    }
  } else {
    widgetStyles = _extends({}, widgetStyles);
  }
  return widgetStyles;
}
var assetWidgetEquals = function assetWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var AssetWidget = React.memo(AssetWidgetComponent, assetWidgetEquals);

var styles$S = {"loading":"_3i2f7","loader":"_2YYpE","carousel":"_1LDh7","track":"_1oED4","spatialPage":"_3zU60","spatialPageInner":"_1g7vq","fullscreen":"_S4kLA","highlighted":"_272Mv","spatialPageContainer":"_3h4uK","blurEffect":"_3TElE","mobileOverlay":"_1Wll-","spatialPagePlaceholder":"_1IopH","spatialPagePlaceholderInner":"_Wzlz-","navigation":"_2Drxo","button":"_3zOQF","backgroundOverlay":"_1uRMr","overlay":"_11X_y","customBackground":"_2RZS0","backgroundImage":"_1wzBr","toolbar":"_10TCJ","show":"_31bev","mainMenu":"_2Kx9F","menuItemButton":"_2v0ox","menuItemTitle":"_1luck","slider":"_3y0Av","arrowButton":"_1M7y6","menuIcon":"_3nH1o","exitFullscreen":"_1HoQg","highlight":"_2yjfH","gridMenu":"_2eS5G","menuHeader":"_3Qx_t","menuItems":"_2Bp0L","gridItem":"_2s1o_","glassEffect":"_15i99","menuTitle":"_3Qk9e","menuFooter":"_2VlDl","closeButton":"_1LpX2","scrollingMenu":"_1HhUT","scrollWrapper":"_20gOA","reactHorizontalScrollingMenu":"_3XLxm","loadingMessage":"_3lOde","loadingDot":"_2JRAT","dot":"_3lli3","loading__dot":"_1sb-j"};

var _this = undefined;
var DESKTOP_ASPECT_RATIO = 16 / 9;
var MOBILE_ASPECT_RATIO = 9 / 16;
var DESKTOP_WIDTH_PADDING = 160;
var MOBILE_WIDTH_PADDING = 20;
var DESKTOP_HEIGHT_PADDING = 120;
var MOBILE_HEIGHT_PADDING = 60;
var HIGHLIGHT_WIDTH = 225;
var PAGES_TO_LOAD = 5;
var PAGES_TO_RENDER = 3;
var transition = {
  ease: 'easeOut',
  bounce: 0,
  duration: 0.2
};
var useDesktop = function useDesktop() {
  var desktop = isDesktop;
  if (process.browser) {
    desktop = useMediaQuery({
      query: '(min-width: 992px)'
    });
  }
  return desktop;
};
var useMobilePortrait = function useMobilePortrait() {
  var _useState = useState(false),
    isMobilePortrait = _useState[0],
    setIsMobilePortrait = _useState[1];
  useEffect(function () {
    var handleResize = function handleResize() {
      setIsMobilePortrait(window.innerHeight > window.innerWidth);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return isMobilePortrait;
};
var SpatialContent = React.memo(function (_ref) {
  var _extends2, _cx;
  var breakpoint = _ref.breakpoint,
    initialPage = _ref.initialPage,
    pages = _ref.pages,
    appearance = _ref.appearance,
    onChange = _ref.onChange,
    children = _ref.children,
    onFetchPage = _ref.onFetchPage,
    imageCDN = _ref.imageCDN,
    updatePagesToRender = _ref.updatePagesToRender;
  var containerRef = React.useRef(null);
  var trackRef = useRef(null);
  var spatialPageRef = useRef(null);
  var spatialPageInnerRef = useRef(null);
  var singlePage = pages.length == 1;
  var _useState2 = useState({
      initialized: false,
      dimensions: {
        width: 0,
        height: 0
      },
      visualViewport: '100vh',
      scale: 1,
      menuPosition: {
        x: 0,
        y: 0
      },
      singlePage: false,
      showHighlight: false,
      showMenu: false,
      trackWidth: 0,
      dragConstraints: {
        left: 0,
        right: 0
      },
      fullscreen: false,
      backgroundPosition: 0,
      activePage: {
        id: initialPage,
        fullscreen: singlePage,
        slideIndex: 0
      }
    }),
    state = _useState2[0],
    setState = _useState2[1];
  var x = useMotionValue(0);
  var mobilePotrait = useMobilePortrait();
  var viewportSize = useViewportSize();
  var desktop = useDesktop();
  var aspectRatio = !mobilePotrait ? DESKTOP_ASPECT_RATIO : MOBILE_ASPECT_RATIO;
  var widthPadding = desktop ? DESKTOP_WIDTH_PADDING : MOBILE_WIDTH_PADDING;
  var heightPadding = desktop ? DESKTOP_HEIGHT_PADDING : MOBILE_HEIGHT_PADDING;
  React.useEffect(function () {
    setTimeout(function () {
      setState(function (state) {
        return _extends({}, state, {
          initialized: true
        });
      });
    }, 1000);
    onChange('index', {
      id: state.activePage.id,
      slideIndex: 0
    });
  }, []);
  React.useEffect(function () {
    if (initialPage) {
      setState(function (state) {
        return _extends({}, state, {
          activePage: _extends({}, state.activePage, {
            id: initialPage
          })
        });
      });
    }
  }, [initialPage]);
  React.useEffect(function () {
    handleResize(state.showHighlight);
  }, [viewportSize, state.showHighlight, state.fullscreen]);
  React.useEffect(function () {
    var menuElement = document.getElementById('cs-spatial-menu');
    if (state.dimensions.width === 0 || !spatialPageInnerRef.current || !menuElement) {
      return;
    }
    var menuRect = menuElement.getBoundingClientRect();
    var spatialPageRect = spatialPageRef.current.getBoundingClientRect();
    var spatialPageInnerRect = spatialPageInnerRef.current.getBoundingClientRect();
    var highlightX = spatialPageInnerRect.width + 80;
    var highlightY = spatialPageInnerRect.top;
    var widthDiff = spatialPageRect.width - spatialPageInnerRect.width;
    var spatialPageCenterX = state.showHighlight ? spatialPageInnerRect.width / 2 + 50 : spatialPageInnerRect.width / 2 + widthDiff / 2;
    var menuX = spatialPageCenterX - menuRect.width / 2;
    var menuY = state.fullscreen ? spatialPageInnerRect.bottom - (menuRect.height + 20) : spatialPageInnerRect.bottom - menuRect.height / 2;
    setState(function (state) {
      return _extends({}, state, {
        menuPosition: {
          x: menuX,
          y: menuY
        },
        highlight: _extends({}, state.highlight, {
          x: highlightX,
          y: highlightY
        })
      });
    });
  }, [state.dimensions, spatialPageInnerRef.current, state.initialized]);
  React.useEffect(function () {
    var controls = animate(x, calculateNewX(), transition);
    calculateBackgroundPosition();
    handleLazyLoadPages();
    handleUpdatePagesToRender();
    return function () {
      controls.stop();
    };
  }, [state.activePage.id, state.initialized]);
  var handleLazyLoadPages = function handleLazyLoadPages() {
    var activeIndex = pages.findIndex(function (obj) {
      return obj.id === state.activePage.id;
    });
    if (activeIndex < 0) {
      return;
    }
    var closestIndices = getClosestIndices(pages, activeIndex, PAGES_TO_LOAD);
    closestIndices = [].concat(closestIndices, [activeIndex]);
    var closestPages = closestIndices.map(function (index) {
      return pages[index];
    });
    closestPages.forEach(function (page) {
      if (page.loading || page.loaded) {
        return;
      }
      if (onFetchPage) {
        onFetchPage(page.id);
      }
    });
  };
  var handleUpdatePagesToRender = function handleUpdatePagesToRender() {
    var activeIndex = pages.findIndex(function (obj) {
      return obj.id === state.activePage.id;
    });
    var closestIndices = getClosestIndices(pages, activeIndex, PAGES_TO_RENDER);
    var closestPages = closestIndices.map(function (index) {
      var closestPage = pages[index];
      return closestPage.id;
    });
    var closestPages = [].concat(closestPages, [state.activePage.id]);
    var uniqueClosestPages = _$1.uniq(closestPages);
    updatePagesToRender(uniqueClosestPages);
  };
  var getClosestIndices = function getClosestIndices(pages, index, limit) {
    var result = [];
    var arrLength = pages.length;
    if (arrLength <= limit) {
      return pages.map(function (_, i) {
        return i;
      });
    }
    for (var i = index - 1; i >= 0 && result.length < limit / 2; i--) {
      result.unshift(i);
    }
    for (var _i = index + 1; _i < arrLength && result.length < limit; _i++) {
      result.push(_i);
    }
    for (var _i2 = index - 2; _i2 >= 0 && result.length < limit; _i2--) {
      result.unshift(_i2);
    }
    return result;
  };
  var handleResize = useCallback(function (showHighlight) {
    if (viewportSize && viewportSize.width > 0) {
      var width = viewportSize.width,
        height = viewportSize.height,
        viewportHeight = viewportSize.viewportHeight;
      var calculateAvailableWidth = function calculateAvailableWidth() {
        if (state.fullscreen) {
          return width;
        }
        return showHighlight ? width - (HIGHLIGHT_WIDTH * state.scale + 120) : width - widthPadding;
      };
      var newHeightWidth = height;
      var newWidthHeight = width;
      if (!state.fullscreen) {
        var availableWidth = calculateAvailableWidth();
        var availableHeight = showHighlight || state.fullscreen ? height : height - heightPadding;
        newHeightWidth = availableWidth / aspectRatio;
        newWidthHeight = availableWidth;
        if (newHeightWidth > availableHeight) {
          newWidthHeight = availableHeight * aspectRatio;
          newHeightWidth = availableHeight;
        }
      }
      var scale = newHeightWidth == 1024 ? newHeightWidth / 500 : newHeightWidth / 675;
      setState(function (state) {
        return _extends({}, state, {
          scale: scale,
          showHighlight: showHighlight,
          viewportHeight: viewportHeight,
          dimensions: {
            width: newWidthHeight,
            height: newHeightWidth
          },
          trackWidth: containerRef.current.scrollWidth - containerRef.current.offsetWidth
        });
      });
    }
  }, [viewportSize, state.showHighlight, state.fullscreen]);
  useEffect(function () {
    var updateDragConstraints = function updateDragConstraints() {
      var _containerRef$current;
      var containerWidth = ((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.clientWidth) || 0;
      var activeIndex = pages.findIndex(function (obj) {
        return obj.id === state.activePage.id;
      });
      var constraint = -activeIndex * containerWidth;
      setState(function (state) {
        return _extends({}, state, {
          dragConstraints: {
            left: constraint,
            right: constraint
          }
        });
      });
    };
    updateDragConstraints();
  }, [state.activePage.id, state.dimensions]);
  var toggleGridMenu = function toggleGridMenu() {
    setState(function (state) {
      return _extends({}, state, {
        showMenu: !state.showMenu,
        showHighlight: false
      });
    });
  };
  var navigateToPage = function navigateToPage(id, fullscreen, slideIndex) {
    if (slideIndex === void 0) {
      slideIndex = 0;
    }
    var previousId = state.activePage.id;
    var currentSlideIndex = slideIndex;
    if (previousId != id) {
      currentSlideIndex = 0;
    }
    setState(function (state) {
      return _extends({}, state, {
        fullscreen: fullscreen,
        activePage: _extends({}, state.activePage, {
          id: id,
          fullscreen: fullscreen,
          slideIndex: currentSlideIndex
        })
      });
    });
    if (onChange && previousId !== id) {
      onChange('index', {
        id: id,
        slideIndex: currentSlideIndex
      });
    }
    return Promise.resolve();
  };
  var handleDragEnd = function handleDragEnd(event, info) {
    if (!info || state.fullscreen) {
      return;
    }
    var activeIndex = pages.findIndex(function (obj) {
      return obj.id === state.activePage.id;
    });
    var offset = info.offset;
    if (_$1.gt(offset.x, 0) && activeIndex > 0) {
      var prevPage = pages[activeIndex - 1];
      navigateToPage(_$1.get(prevPage, 'id'), state.fullscreen, 0);
    } else if (_$1.lt(offset.x, 0) && activeIndex < _$1.size(pages) - 1) {
      var nextPage = pages[activeIndex + 1];
      navigateToPage(_$1.get(nextPage, 'id'), state.fullscreen, 0);
    }
  };
  var calculateBackgroundPosition = function calculateBackgroundPosition() {
    var backgroundImage = document.getElementById('cs-spatial-bg');
    if (!backgroundImage) {
      return;
    }
    var backgroundImageRect = backgroundImage.getBoundingClientRect();
    var containerRect = containerRef.current.getBoundingClientRect();
    var activeIndex = pages.findIndex(function (obj) {
      return obj.id === state.activePage.id;
    });
    var position = (backgroundImageRect.width - containerRect.width) / (pages === null || pages === void 0 ? void 0 : pages.length) * activeIndex;
    setState(function (state) {
      return _extends({}, state, {
        backgroundPosition: position
      });
    });
  };
  var calculateNewX = function calculateNewX() {
    var _containerRef$current2;
    var activeIndex = pages.findIndex(function (obj) {
      return obj.id === state.activePage.id;
    });
    var offset = -(activeIndex * ((_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.clientWidth));
    return offset || 0;
  };
  var handleToggleFullscreen = function handleToggleFullscreen() {
    setState(function (state) {
      return _extends({}, state, {
        fullscreen: !state.fullscreen
      });
    });
  };
  return /*#__PURE__*/React.createElement(SpatialContext.Provider, {
    value: _extends({}, state, (_extends2 = {
      breakpoint: breakpoint,
      pages: pages,
      appearance: appearance,
      navigateToPage: navigateToPage,
      onToggleFullscreen: handleToggleFullscreen,
      onChange: onChange
    }, _extends2["pages"] = pages, _extends2))
  }, /*#__PURE__*/React.createElement(KeyManager, null, /*#__PURE__*/React.createElement(motion.div, {
    key: breakpoint,
    ref: containerRef,
    style: {
      height: state.viewportHeight
    },
    className: cx(styles$S.carousel, (_cx = {}, _cx[styles$S.singlePage] = false, _cx))
  }, !state.initialized && /*#__PURE__*/React.createElement("div", {
    className: styles$S.loading
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$S.loader
  }, /*#__PURE__*/React.createElement("video", {
    loop: true,
    autoPlay: true,
    playsInline: true,
    muted: true
  }, /*#__PURE__*/React.createElement("source", {
    src: "/images/shortLoader.mp4",
    type: "video/mp4"
  })), /*#__PURE__*/React.createElement("label", null, "Loading Spatial content..."))), /*#__PURE__*/React.createElement(Menu, {
    showGridMenu: state.showMenu,
    appearance: appearance,
    scale: state.scale,
    menuPosition: state.menuPosition,
    onToggleHighlight: handleResize.bind(_this, !state.showHighlight),
    onToggleGridMenu: toggleGridMenu,
    onToggleFullscreen: handleToggleFullscreen,
    activePage: state.activePage,
    navigateToPage: navigateToPage,
    breakpoint: breakpoint,
    pages: pages,
    fullscreen: state.fullscreen
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$S.backgroundOverlay
  }, _$1.get(appearance, 'background.type', null) == 'color' && /*#__PURE__*/React.createElement(BackgroundViewComponent, {
    background: _$1.get(appearance, 'background', null)
  }), _$1.get(appearance, 'background.type', null) !== 'color' && /*#__PURE__*/React.createElement(BackgroundManager, {
    background: _$1.get(appearance, 'background', null),
    backgroundPosition: state.backgroundPosition,
    imageCDN: imageCDN
  })), /*#__PURE__*/React.createElement(motion.div, {
    className: cx(styles$S.track),
    ref: trackRef,
    style: {
      x: x
    },
    whileTap: {
      cursor: "grabbing"
    },
    initial: false,
    dragConstraints: state.dragConstraints,
    draggable: true,
    drag: breakpoint === 'mobile' ? 'x' : false,
    dragElastic: 0.1,
    onDragEnd: function onDragEnd(event, info) {
      handleDragEnd(event, info);
    }
  }, /*#__PURE__*/React.createElement(ParallaxProvider, null, /*#__PURE__*/React.createElement("div", {
    className: cx(styles$S.spatialPage, styles$S.spatialPagePlaceholder),
    ref: spatialPageRef
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$S.spatialPagePlaceholderInner,
    ref: spatialPageInnerRef,
    style: {
      width: state.dimensions.width,
      height: state.dimensions.height,
      transformOrigin: 'left center'
    }
  })), React.Children.map(children, function (child, i) {
    return React.cloneElement(child);
  }))), /*#__PURE__*/React.createElement(GridMenu, {
    pages: pages,
    show: state.showMenu,
    onClose: toggleGridMenu,
    fullscreen: state.fullscreen,
    onSelect: navigateToPage
  }))));
});
var SpatialContext = React.createContext({
  showMenu: false,
  showHighlight: false,
  fullscreen: false,
  dimensions: {
    width: 0,
    height: 0
  }
});
SpatialContent.SpatialContext = SpatialContent;
var SpatialPage = React.memo(function (_ref2) {
  var _cx2, _cx3;
  var appearance = _ref2.appearance,
    page = _ref2.page,
    children = _ref2.children,
    slideWidgets = _ref2.slideWidgets,
    loading = _ref2.loading;
  var spatialPageRef = React.useRef(null);
  var spatialContext = React.useContext(SpatialContext);
  var slideBackground = _$1.get(appearance, 'slideBackground', {});
  var breakpoint = spatialContext.breakpoint;
  var currentSlideIndexRef = useRef(_$1.get(spatialContext, 'activePage.slideIndex', 0));
  var startYRef = useRef(0);
  var fullscreenRef = useRef(spatialContext.fullscreen);
  var activePageRef = useRef(spatialContext.activePage);
  var slideWidgetsRef = useRef(slideWidgets);
  var isScrolling = false;
  useEffect(function () {
    var carousel = spatialPageRef.current;
    carousel.addEventListener('wheel', handleScroll);
    carousel.addEventListener('touchstart', handleTouchStart);
    carousel.addEventListener('touchmove', handleTouchMove);
    carousel.addEventListener('touchend', handleTouchEnd);
    return function () {
      carousel.removeEventListener('wheel', handleScroll);
      carousel.removeEventListener('touchstart', handleTouchStart);
      carousel.removeEventListener('touchmove', handleTouchMove);
      carousel.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);
  var didMountRef = useRef(false);
  var fullScreenClicked = useRef(false);
  useEffect(function () {
    fullscreenRef.current = spatialContext.fullscreen;
    if (didMountRef.current) {
      fullScreenClicked.current = true;
    } else {
      didMountRef.current = true;
    }
  }, [spatialContext.fullscreen]);
  useEffect(function () {
    var slide = slideWidgetsRef.current[spatialContext.activePage.slideIndex];
    var carousel = spatialPageRef.current;
    if (slide && carousel) {
      var slideElement = document.getElementById(slide.uid);
      if (slideElement) {
        var SlideRect = slideElement.getBoundingClientRect();
        carousel.style.transform = "translateY(" + SlideRect.height * -spatialContext.activePage.slideIndex + "px) translateZ(0)";
      }
    }
  }, [fullscreenRef.current]);
  useEffect(function () {
    slideWidgetsRef.current = slideWidgets;
  }, [slideWidgets]);
  useEffect(function () {
    activePageRef.current = spatialContext.activePage;
    if (fullScreenClicked.current) {
      currentSlideIndexRef.current = 0;
    }
    if (slideWidgetsRef.current.length == 1) {
      spatialContext.onChange('progress', {
        id: activePageRef.current.id,
        progress: 100
      });
    }
    fullScreenClicked.current = false;
  }, [spatialContext.activePage]);
  var scrollToSlide = function scrollToSlide(index) {
    if (index < 0 || index >= slideWidgetsRef.current.length) {
      return;
    }
    var carousel = spatialPageRef.current;
    var slide = slideWidgetsRef.current[index];
    var slideElement = document.getElementById(slide.uid);
    var SlideRect = slideElement.getBoundingClientRect();
    spatialContext.navigateToPage(activePageRef.current.id, fullscreenRef.current, index).then(function () {
      carousel.style.transform = "translateY(" + SlideRect.height * -index + "px)";
      currentSlideIndexRef.current = index;
      var percentage = (index + 1) / slideWidgetsRef.current.length * 100;
      if (spatialContext.onChange) {
        spatialContext.onChange('progress', {
          id: activePageRef.current.id,
          progress: percentage
        });
      }
    });
  };
  var handleTouchStart = function handleTouchStart(event) {
    startYRef.current = event.touches[0].pageY;
  };
  var handleTouchMove = function handleTouchMove(event) {
    event.preventDefault();
    if (isScrolling) return;
    var currentY = event.touches[0].pageY;
    var deltaY = startYRef.current - currentY;
    if (breakpoint === 'mobile' && !fullscreenRef.current && event.deltaY > 0) {
      spatialContext.onToggleFullscreen();
      setTimeout(function () {
        isScrolling = false;
      }, 1000);
      return;
    }
    if (Math.abs(deltaY) > 50) {
      isScrolling = true;
      if (deltaY > 0) {
        scrollToSlide(currentSlideIndexRef.current + 1);
      } else {
        scrollToSlide(currentSlideIndexRef.current - 1);
      }
      setTimeout(function () {
        isScrolling = false;
      }, 1000);
    }
  };
  var handleTouchEnd = function handleTouchEnd() {
    startYRef.current = 0;
  };
  var handleScroll = function handleScroll(event) {
    event.preventDefault();
    if (isScrolling) return;
    var scrollThreshold = 12;
    if (Math.abs(event.deltaY) < scrollThreshold) return;
    isScrolling = true;
    if (event.deltaY > 0) {
      scrollToSlide(currentSlideIndexRef.current + 1);
    } else {
      scrollToSlide(currentSlideIndexRef.current - 1);
    }
    setTimeout(function () {
      isScrolling = false;
    }, 1000);
  };
  var handlePageClick = function handlePageClick(e) {
    e.preventDefault();
    spatialContext.onToggleFullscreen();
  };
  return /*#__PURE__*/React.createElement(motion.div, {
    initial: {
      opacity: 1
    },
    animate: {
      opacity: spatialContext.showMenu ? 0 : 1
    },
    id: page && page.id,
    className: styles$S.spatialPage
  }, /*#__PURE__*/React.createElement("div", {
    id: "cs-spatial-page-" + page.id,
    className: cx(styles$S.spatialPageInner, (_cx2 = {}, _cx2[styles$S.highlighted] = spatialContext.showHighlight, _cx2), (_cx3 = {}, _cx3[styles$S.fullscreen] = spatialContext.fullscreen, _cx3)),
    style: {
      width: spatialContext.dimensions.width + "px",
      height: spatialContext.dimensions.height + "px",
      transformOrigin: 'left center'
    }
  }, loading && /*#__PURE__*/React.createElement(LoadingMessage, null), slideBackground && /*#__PURE__*/React.createElement(BackgroundViewComponent, {
    background: slideBackground
  }), breakpoint === 'mobile' && !spatialContext.fullscreen && /*#__PURE__*/React.createElement("div", {
    onClick: handlePageClick,
    className: styles$S.mobileOverlay
  }), /*#__PURE__*/React.createElement("div", {
    ref: spatialPageRef,
    className: cx(styles$S.spatialPageContainer)
  }, children)));
});
SpatialContent.SpatialPage = SpatialPage;
var LoadingMessage = function LoadingMessage() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$S.loadingMessage
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$S.loadingDot
  }), /*#__PURE__*/React.createElement("span", {
    className: styles$S.loadingDot
  }), /*#__PURE__*/React.createElement("span", {
    className: styles$S.loadingDot
  }));
};
function BackgroundManager(_ref3) {
  var background = _ref3.background,
    imageCDN = _ref3.imageCDN,
    backgroundPosition = _ref3.backgroundPosition;
  var color = _$1.get(background, 'color');
  var blur = _$1.get(background, 'blur', 0);
  var colorOverlay = getColorsConfig(color);
  var opacity = _$1.get(background, 'opacity', 100) / 100;
  if (!background) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        background: '#ffffff'
      },
      className: styles$S.customBackground
    });
  }
  switch (_$1.get(background, 'media.type', null) || background.type) {
    case 'color':
      {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            background: colorToString(background.color)
          },
          className: styles$S.customBackground
        });
      }
    case 'image':
      {
        var media = _$1.get(background, 'media');
        var url = imageCDN + "/" + media.url;
        return /*#__PURE__*/React.createElement("div", {
          className: styles$S.backgroundOverlay
        }, /*#__PURE__*/React.createElement("div", {
          className: cx(styles$S.overlay, styles$S.color),
          style: {
            background: colorOverlay,
            backdropFilter: "blur(" + blur + "px)"
          }
        }), /*#__PURE__*/React.createElement("img", {
          style: {
            transform: "translateX(" + backgroundPosition + "px)",
            opacity: opacity
          },
          id: "cs-spatial-bg",
          className: styles$S.backgroundImage,
          src: url
        }));
      }
    case 'video':
      {
        return /*#__PURE__*/React.createElement("div", {
          className: styles$S.customBackground
        }, /*#__PURE__*/React.createElement("div", {
          className: cx(styles$S.overlay, styles$S.color),
          style: {
            background: colorOverlay,
            backdropFilter: "blur(" + blur + "px)"
          }
        }), /*#__PURE__*/React.createElement(VideoView, {
          background: background,
          imageCDN: imageCDN
        }));
      }
    default:
      return /*#__PURE__*/React.createElement("div", {
        style: {
          background: '#ffffff'
        },
        className: styles$S.customBackground
      });
  }
}
var Menu = React.memo(function (_ref4) {
  var _cx4, _cx5;
  var menuPosition = _ref4.menuPosition,
    onToggleGridMenu = _ref4.onToggleGridMenu,
    appearance = _ref4.appearance,
    onToggleFullscreen = _ref4.onToggleFullscreen,
    fullscreen = _ref4.fullscreen,
    showGridMenu = _ref4.showGridMenu,
    activePage = _ref4.activePage,
    navigateToPage = _ref4.navigateToPage,
    breakpoint = _ref4.breakpoint,
    pages = _ref4.pages;
  var ref = useRef(null);
  var scrollRef = useRef(null);
  var desktop = useDesktop();
  var firstPage = pages[0];
  var menuDesigns = _$1.get(appearance, 'menuDesign');
  var _useState3 = useState({
      show: false,
      menuPosition: menuPosition,
      containerStyle: {},
      buttonStyle: {},
      iconStyle: {}
    }),
    state = _useState3[0],
    setState = _useState3[1];
  useEffect(function () {
    updateContainerStyles('regular');
  }, [breakpoint]);
  var updateContainerStyles = function updateContainerStyles(active) {
    setState(function (state) {
      return _extends({}, state, {
        buttonStyle: getStyles$m(menuDesigns, active),
        containerStyle: getWrapperStyles(menuDesigns),
        iconStyle: getIconStyles$1(menuDesigns)
      });
    });
  };
  useEffect(function () {
    if (menuPosition.y === 0) {
      return;
    }
    setTimeout(function () {
      setState(function (state) {
        return _extends({}, state, {
          show: true
        });
      });
    }, 1000);
  }, [menuPosition]);
  useEffect(function () {
    var pageIndex = pages.findIndex(function (obj) {
      return obj.id === activePage.id;
    });
    if (scrollRef.current && !scrollRef.current.isItemVisible(pageIndex)) {
      var item = scrollRef.current.getItemByIndex(pageIndex);
      scrollRef.current.scrollToItem(item);
    }
  }, [activePage]);
  var y = showGridMenu ? '100vh' : menuPosition.y + "px";
  var style = {
    transform: "translateX(" + (breakpoint === 'mobile' && fullscreen ? 0 : menuPosition.x) + "px) translateY(" + y + ")"
  };
  var handleLeftArrowClick = function handleLeftArrowClick() {
    var previousIndex = findIndex(activePage.id, 'previous');
    if (previousIndex < 0) {
      return;
    }
    var currentPage = pages[previousIndex];
    if (scrollRef.current && !scrollRef.current.isItemVisible(previousIndex)) {
      var item = scrollRef.current.getItemByIndex(previousIndex);
      scrollRef.current.scrollToItem(item);
    }
    navigateToPage(currentPage.id, fullscreen, 0);
  };
  var handleRightArrowClick = function handleRightArrowClick() {
    var nextIndex = findIndex(activePage.id, 'next');
    if (nextIndex >= pages.length) {
      return;
    }
    var currentPage = pages[nextIndex];
    if (scrollRef.current && !scrollRef.current.isItemVisible(nextIndex)) {
      var item = scrollRef.current.getItemByIndex(nextIndex);
      scrollRef.current.scrollToItem(item);
    }
    navigateToPage(currentPage.id, fullscreen, 0);
  };
  var findIndex = function findIndex(currentId, direction) {
    if (direction === void 0) {
      direction = 'next';
    }
    var currentIndex = pages.findIndex(function (obj) {
      return obj.id === currentId;
    });
    if (currentIndex === -1) {
      return -1;
    }
    var newIndex;
    if (direction === 'next') {
      newIndex = currentIndex + 1;
    } else if (direction === 'previous') {
      newIndex = currentIndex - 1;
    } else {
      throw new Error("Invalid direction. Use 'next' or 'previous'.");
    }
    return newIndex;
  };
  var handleHomeClick = function handleHomeClick() {
    navigateToPage(firstPage.id, false, 0);
  };
  var LeftArrow = function LeftArrow() {
    var currentIndex = pages.findIndex(function (obj) {
      return obj.id === activePage.id;
    });
    var _useState4 = useState({}),
      buttonStyle = _useState4[0],
      setButtonStyle = _useState4[1];
    var updateButtonStyles = function updateButtonStyles(state) {
      var updatedStyles = getStyles$m(menuDesigns, state);
      setButtonStyle(updatedStyles);
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "info",
      disabled: currentIndex === 0,
      id: "leftArrow",
      style: buttonStyle,
      onMouseOver: function onMouseOver() {
        return updateButtonStyles('hover');
      },
      onMouseOut: function onMouseOut() {
        return updateButtonStyles('regular');
      },
      className: styles$S.arrowButton,
      onClick: handleLeftArrowClick
    }, /*#__PURE__*/React.createElement("i", {
      style: {
        color: state.iconStyle.color
      },
      className: cx(styles$S.icon, 'cleverstory-drop-down-left')
    })), /*#__PURE__*/React.createElement("style", null, "\n              #leftArrow i::before {\n                color: " + getColorsConfig(state.iconStyle.color) + ";\n              }\n            "));
  };
  var RightArrow = function RightArrow() {
    var currentIndex = pages.findIndex(function (obj) {
      return obj.id === activePage.id;
    });
    var _useState5 = useState({}),
      buttonStyle = _useState5[0],
      setButtonStyle = _useState5[1];
    var updateButtonStyles = function updateButtonStyles(state) {
      var updatedStyles = getStyles$m(menuDesigns, state);
      setButtonStyle(updatedStyles);
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "info",
      id: "rightArrow",
      style: buttonStyle,
      onMouseOver: function onMouseOver() {
        return updateButtonStyles('hover');
      },
      onMouseOut: function onMouseOut() {
        return updateButtonStyles('regular');
      },
      disabled: currentIndex === _$1.size(pages) - 1,
      className: styles$S.arrowButton,
      onClick: handleRightArrowClick
    }, /*#__PURE__*/React.createElement("i", {
      style: {
        color: state.iconStyle.color
      },
      className: cx(styles$S.icon, 'cleverstory-drop-down-right')
    })), /*#__PURE__*/React.createElement("style", null, "\n              #rightArrow i::before {\n                color: " + getColorsConfig(state.iconStyle.color) + ";\n              }\n            "));
  };
  var MenuItem = function MenuItem(_ref5) {
    var title = _ref5.title,
      activePage = _ref5.activePage,
      itemId = _ref5.itemId,
      page = _ref5.page;
    var _useState6 = useState({}),
      buttonStyle = _useState6[0],
      setButtonStyle = _useState6[1];
    useEffect(function () {
      updateButtonStyles('regular');
    }, [breakpoint]);
    var updateButtonStyles = function updateButtonStyles(state) {
      var updatedStyles = getStyles$m(menuDesigns, state);
      setButtonStyle(updatedStyles);
    };
    return /*#__PURE__*/React.createElement("div", {
      role: "menuitem",
      id: page.id,
      tabIndex: 0,
      key: itemId,
      style: activePage.id == page.id ? getStyles$m(menuDesigns, 'hover') : buttonStyle,
      onMouseOver: function onMouseOver() {
        return updateButtonStyles('hover');
      },
      onMouseOut: function onMouseOut() {
        return updateButtonStyles('regular');
      },
      onClick: function onClick() {
        navigateToPage(page.id, false, 0);
      },
      className: cx(styles$S.menuItemButton)
    }, /*#__PURE__*/React.createElement("h3", {
      className: styles$S.menuItemTitle
    }, /*#__PURE__*/React.createElement(TruncatedTextWithTooltip, {
      content: title,
      maxWidth: 150
    })));
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "cs-spatial-menu",
    ref: ref,
    style: style,
    className: cx(styles$S.toolbar, (_cx4 = {}, _cx4[styles$S.show] = state.show, _cx4), (_cx5 = {}, _cx5[styles$S.fullscreen] = fullscreen, _cx5))
  }, !desktop && fullscreen && /*#__PURE__*/React.createElement("div", {
    style: state.containerStyle,
    className: cx(styles$S.mainMenu, styles$S.exitFullscreen)
  }, breakpoint === 'mobile' && /*#__PURE__*/React.createElement("div", {
    id: "fullscreenToggle",
    className: cx(styles$S.menuIcon),
    onClick: onToggleFullscreen
  }, /*#__PURE__*/React.createElement("i", {
    style: {
      color: state.iconStyle.color
    },
    className: cx(styles$S.icon, 'cleverstory-drop-down-left')
  })), /*#__PURE__*/React.createElement("style", null, "\n                #fullscreenToggle i::before {\n                  color: " + getColorsConfig(state.iconStyle.color) + ";\n                }\n              ")), /*#__PURE__*/React.createElement("div", {
    style: state.containerStyle,
    className: styles$S.mainMenu
  }, desktop && /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: '700px',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(ScrollMenu, {
    apiRef: scrollRef,
    scrollContainerClassName: styles$S.scrollingMenu,
    wrapperClassName: styles$S.scrollWrapper,
    LeftArrow: /*#__PURE__*/React.createElement(LeftArrow, null),
    RightArrow: /*#__PURE__*/React.createElement(RightArrow, null)
  }, pages && pages.map(function (page, index) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      itemId: index,
      activePage: activePage,
      key: index,
      page: page,
      title: page.name
    });
  }))), !desktop && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LeftArrow, null), /*#__PURE__*/React.createElement(RightArrow, null))), /*#__PURE__*/React.createElement("div", {
    style: state.containerStyle,
    className: styles$S.mainMenu
  }, desktop && /*#__PURE__*/React.createElement("div", {
    className: styles$S.menuIcon,
    onClick: onToggleGridMenu
  }, /*#__PURE__*/React.createElement("i", {
    style: {
      color: state.iconStyle.color
    },
    className: cx(styles$S.icon, 'cleverstory-grid')
  })), desktop && /*#__PURE__*/React.createElement("div", {
    className: styles$S.menuIcon,
    onClick: onToggleFullscreen
  }, /*#__PURE__*/React.createElement("i", {
    style: {
      color: state.iconStyle.color
    },
    className: cx(styles$S.icon, 'cleverstory-expand-editor')
  })), !desktop && /*#__PURE__*/React.createElement("div", {
    className: cx(styles$S.menuIcon),
    onClick: handleHomeClick
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: state.iconStyle.color
    },
    className: cx(styles$S.icon, 'cleverstory-sptial-home')
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }))), /*#__PURE__*/React.createElement("style", null, "\n                .menuIcon i::before {\n                  color: " + getColorsConfig(state.iconStyle.color) + ";\n                }\n              ")));
});
function getWrapperStyles(properties) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var backgroundRgb = _$1.get(properties, "background", null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = getColorsConfig(backgroundRgb);
  }
  styles['background'] = background;
  var blur = _$1.get(properties, "background.blur", null);
  var blurEffect = 20;
  if (blur) {
    blurEffect = blur;
  }
  styles['-webkit-backdrop-filter'] = "blur(" + blurEffect + "px)";
  styles['backdrop-filter'] = "blur(" + blurEffect + "px)";
  return styles;
}
function getIconStyles$1(properties) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultStyles = _$1.get(properties, "regular", {});
  var colorRgb = _$1.get(defaultStyles, "font.color", null);
  var color = getColorStyles$i(colorRgb);
  styles = _extends({}, styles, color);
  return styles;
}
function getStyles$m(properties, active) {
  var styles = {};
  if (!properties) {
    return styles;
  }
  var defaultStyles = _$1.get(properties, "regular", {});
  var colorRgb = _$1.get(defaultStyles, "font.color", null);
  var color = getColorStyles$i(active == 'regular' ? _extends({}, colorRgb, {
    a: 0.60
  }) : colorRgb);
  styles = _extends({}, styles, color);
  var backgroundRgb = _$1.get(properties, active + ".background", null);
  var background = 'inherit';
  if (backgroundRgb && active == 'hover') {
    background = getColorsConfig(backgroundRgb);
  }
  styles['background'] = background;
  var font = _$1.get(defaultStyles, 'font', {});
  var fontFamily = _$1.get(font, 'fontFamily');
  if (fontFamily) {
    styles = _extends({}, styles, {
      fontFamily: fontFamily
    });
  }
  return styles;
}
function getColorStyles$i(value) {
  if (!value) {
    return null;
  }
  var colorRgb = value;
  var color = 'inherit';
  if (colorRgb) {
    color = "rgba(" + colorRgb.r + ", " + colorRgb.g + ", " + colorRgb.b + ", " + colorRgb.a + ")";
  }
  var styles = {
    color: color
  };
  return styles;
}
var GridMenu = React.memo(function (_ref6) {
  var _cx6;
  var pages = _ref6.pages,
    show = _ref6.show,
    onClose = _ref6.onClose,
    fullscreen = _ref6.fullscreen,
    onSelect = _ref6.onSelect;
  var handleSelect = function handleSelect(id) {
    onSelect(id, fullscreen);
    onClose();
  };
  return /*#__PURE__*/React.createElement(motion.div, {
    className: cx(styles$S.gridMenu, (_cx6 = {}, _cx6[styles$S.open] = show, _cx6)),
    initial: {
      opacity: 0,
      zIndex: -1
    },
    animate: {
      opacity: show ? 1 : 0,
      zIndex: show ? 1 : -1
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$S.menuHeader
  }, /*#__PURE__*/React.createElement("h1", null, "Contents ")), /*#__PURE__*/React.createElement("div", {
    className: styles$S.menuItems
  }, pages.map(function (page, index) {
    return /*#__PURE__*/React.createElement(motion.div, {
      key: index,
      className: styles$S.gridItem,
      onClick: handleSelect.bind(_this, page.id)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$S.menuIcon
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$S.glassEffect
    }), /*#__PURE__*/React.createElement(IKImage, {
      path: _$1.get(page, 'icon.url')
    })), /*#__PURE__*/React.createElement("h3", {
      className: styles$S.menuTitle
    }, /*#__PURE__*/React.createElement(TruncatedTextWithTooltip, {
      content: page.name,
      maxWidth: 250
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$S.menuFooter
  }, /*#__PURE__*/React.createElement("button", {
    className: styles$S.closeButton,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("i", {
    className: cx(styles$S.closeButtonIcon, 'cleverstory-close')
  }))));
});
function KeyManager(_ref7) {
  var children = _ref7.children;
  var containerRef = React.useRef();
  var spatialContext = React.useContext(SpatialContext);
  var pages = spatialContext.pages;
  useEffect(function () {
    if (containerRef.current) {
      containerRef.current.focus();
    }
  }, []);
  var keyMap = {
    MOVE_LEFT: 'left',
    MOVE_RIGHT: 'right',
    MOVE_DOWN: 'down',
    MOVE_UP: 'up',
    ESCAPE: 'esc'
  };
  var navigateNext = React.useCallback(function (e) {
    e.preventDefault();
    var currentIndex = pages.findIndex(function (item) {
      return item.id === spatialContext.activePage.id;
    });
    if (currentIndex >= pages.length - 1) {
      return;
    }
    var nextPage = pages[currentIndex + 1];
    spatialContext.navigateToPage(nextPage.id, spatialContext.fullscreen, 0);
  }, [spatialContext.activePage]);
  var navigatePrevious = React.useCallback(function (e) {
    e.preventDefault();
    var currentIndex = pages.findIndex(function (item) {
      return item.id === spatialContext.activePage.id;
    });
    if (currentIndex <= 0) {
      return;
    }
    var previousPage = pages[currentIndex - 1];
    spatialContext.navigateToPage(previousPage.id, spatialContext.fullscreen, 0);
  }, [spatialContext.activePage]);
  var toggleFullScreen = React.useCallback(function (e) {
  }, [spatialContext.activePage]);
  return /*#__PURE__*/React.createElement(GlobalHotKeys, {
    className: styles$S.keymanager,
    innerRef: containerRef,
    keyMap: keyMap,
    handlers: {
      MOVE_UP: toggleFullScreen,
      MOVE_DOWN: toggleFullScreen,
      MOVE_LEFT: navigatePrevious,
      MOVE_RIGHT: navigateNext,
      ESCAPE: toggleFullScreen
    },
    allowChanges: true
  }, children);
}
function useViewportSize() {
  if (!process.browser) {
    return {
      width: 0,
      height: 0
    };
  }
  var _useState7 = useState({
      width: window.innerWidth,
      height: window.innerHeight,
      viewportHeight: '100vh'
    }),
    viewportSize = _useState7[0],
    setViewportSize = _useState7[1];
  useEffect(function () {
    var handleResize = function handleResize() {
      var vh = (window.visualViewport ? window.visualViewport.height : window.innerHeight) * 0.01;
      document.documentElement.style.setProperty('--vh', vh + "px");
      document.body.style.height = vh * 100 + "px";
      setViewportSize({
        width: window.visualViewport.width,
        height: window.visualViewport.height,
        viewportHeight: vh * 100 + "px"
      });
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return viewportSize;
}

var styles$T = {"slide":"_1JYIk"};

var SlideWidgetComponent = function SlideWidgetComponent(_ref) {
  var _cx;
  var className = _ref.className,
    style = _ref.style,
    widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    children = _ref.children;
  var id = _.get(widgetProps, 'uid');
  var slideRef = useRef(null);
  var slideHeight = _.get(widgetProps, "properties." + breakpoint + ".layout.height");
  var order = _.get(widgetProps, "order");
  var spatialContext = React.useContext(SpatialContext);
  var scale = _.get(spatialContext, 'scale', 1);
  var widgetStyle = _extends({}, style, {
    transform: "scale(" + scale + ")",
    transformOrigin: 'top left',
    marginTop: order == 1 ? '0px' : "calc(" + slideHeight + " * " + (scale - 1) + ")"
  });
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(className, styles$T.slide, 'cs_slide_root', (_cx = {}, _cx[styles$T.mobile] = breakpoint === 'mobile', _cx)),
    ref: slideRef,
    "data-widget-id": id,
    "data-container": true,
    style: widgetStyle
  }, /*#__PURE__*/React.createElement(HotspotRender, {
    breakpoint: breakpoint
  }, children));
};
var slideWidgetEquals = function slideWidgetEquals(prevProps, nextProps) {
  var paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  var next = _.pick(nextProps, paths);
  var previous = _.pick(prevProps, paths);
  var equals = _.isEqual(next, previous);
  return equals;
};
var SlideWidget = React.memo(SlideWidgetComponent, slideWidgetEquals);

var styles$U = {"widget":"_3UqHw"};

var _excluded$a = ["widgetProps", "breakpoint"];
var WidgetsContext = React.createContext({
  selector: null,
  breakpoint: DESKTOP,
  shouldZoom: true,
  domain: null,
  development: false,
  createLiveElementContext: function createLiveElementContext(id) {},
  createGatingContext: function createGatingContext(id) {},
  fetchGating: function fetchGating(id) {},
  onTriggerMixpanelEvent: function onTriggerMixpanelEvent(session, eventName, properties) {}
});
var FormContext = React.createContext({
  useForm: function useForm() {},
  useFormValue: ['', function () {}],
  submitForm: function submitForm() {},
  formSuccess: false
});
var SeekContext = React.createContext({
  disabled: true,
  seekSession: null,
  seekAnswerForQuestion: function seekAnswerForQuestion(widget, id, question, pageSession, pageId, storyboard) {},
  updateSeekHelpful: function updateSeekHelpful(widget, chatId, helpful) {},
  invalidateSeekSession: function invalidateSeekSession(widget, seekSessionId) {},
  seekChatHistory: function seekChatHistory(session, widget, question, callback) {}
});
var GatingContext = React.createContext({
  triggerGating: function triggerGating() {},
  type: null,
  payload: null,
  gating: null,
  configuration: null,
  configurations: [],
  assetConfigurations: []
});
var ModalContext = React.createContext({
  close: function close() {}
});
var EmbedContext = React.createContext({
  embedded: false
});
var WidgetComponent = function WidgetComponent(_ref) {
  var widgetProps = _ref.widgetProps,
    breakpoint = _ref.breakpoint,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  var id = _$1.get(widgetProps, 'uid');
  var container = useContainerSelector(id);
  var widgetChildren = useWidgetChildrenSelector(id);
  var parentContainer = useContainerSelector(container === null || container === void 0 ? void 0 : container.uid);
  var type = _$1.get(widgetProps, 'type');
  var Component = getWidgetComponentFotType$1(type);
  if (!Component) {
    console.warn("Component not found for type " + type);
    return false;
  }
  var layout = _$1.get(widgetProps, "properties." + breakpoint + ".layout");
  var widgetStyle = getStylesForLayout(layout, breakpoint, container, parentContainer);
  var children = widgetChildren.map(function (item) {
    return /*#__PURE__*/React.createElement(Widget, {
      key: item.uid,
      widgetProps: item,
      breakpoint: breakpoint
    });
  });
  return React.createElement(Component, _extends({
    widgetProps: widgetProps,
    className: styles$U.widget,
    key: id,
    breakpoint: breakpoint,
    style: widgetStyle
  }, rest), children);
};
var getWidgetComponentFotType$1 = function getWidgetComponentFotType(type) {
  switch (type) {
    case PAGE:
      return PageWidget;
    case BASIC_TEXT:
      return BasicTextWidget;
    case TEXT:
      return TextWidget;
    case IMAGE:
      return ImageWidget;
    case VIDEO:
      return VideoWidget;
    case BUTTON:
      return ButtonWidget;
    case SHAPE:
      return ShapeWidget;
    case LINE:
      return LineWidget;
    case RECTANGLE:
      return RectangleWidget;
    case IFRAME:
      return IFrameWidget;
    case HTML:
      return HtmlWidget;
    case EXTERNAL_FORM:
      return ExternalFormWidget;
    case FORM:
      return FormWidget;
    case FORM_STEP:
      return FormStepWidget;
    case FORM_FIELD:
      return FormTextWidget;
    case OTP_INPUT:
      return FormOtpInputWidget;
    case FORM_DROPDOWN_LIST:
      return FormDropdownList;
    case FORM_CHECK_LIST:
      return FomrCheckBoxListWidget;
    case FORM_CHECK_BOX:
      return FormCheckBoxField;
    case FORM_NUMBER:
      return FormNumberWidget;
    case FORM_TEXTAREA:
      return FormTextAreaWidget;
    case FORM_SUBMIT:
      return SubmitButtonWidget;
    case OTP_FORM_SUBMIT:
      return OtpSubmitButtonWidget;
    case OTP_RESEND:
      return OtpResendButtonWidget;
    case ANCHOR:
      return AnchorWidget;
    case LIVE_ELEMENT:
      return LiveElementWidget;
    case LIVE_ELEMENT_CONTAINER:
      return LiveElementContainerWidget;
    case SECTION:
      return SectionWidget;
    case SECTION_COLUMN:
      return SectionColumnWidget;
    case CONTENT:
      return ContentWidget;
    case CONTENT_CARD:
      return ContentCardWidget;
    case CONTENT_CARD_TEMPLATE:
      return PlaceholderCardWidget;
    case CONTENT_FILTER:
      return FilterWidget;
    case CONTENT_FILTER_CONTAINER:
      return FilterContainerWidget;
    case CONTENT_SEARCH:
      return SearchContainerWidget;
    case CONTENT_PAGINATION_BUTTON:
      return PaginationButtonWidget;
    case CONTENT_EMPTY_MESSAGE:
      return EmptyMessageWidget;
    case CONTENT_LOADING_MESSAGE:
      return LoadingWidget;
    case GROUP:
      return GroupWidget;
    case MODAL:
      return ModalWidget;
    case MENU:
      return MenuWidget;
    case MENU_CONTAINER:
      return MenuContainerWidget;
    case CAROUSEL:
      return CarouselWidget;
    case CAROUSEL_CARD:
      return CarouselCardWidget;
    case HOTSPOT:
      return HotspotWidget;
    case ASSET:
      return AssetWidget;
    case SEEK:
      return SeekWidget;
    case SLIDE:
      return SlideWidget;
    default:
      return false;
  }
};
var widgetEquals = function widgetEquals(prevProps, nextProps) {
  var paths = ['widgetProps', 'breakpoint'];
  var next = _$1.pick(nextProps, paths);
  var previous = _$1.pick(prevProps, paths);
  var equals = _$1.isEqual(next, previous);
  return equals;
};
var Widget = React.memo(WidgetComponent, widgetEquals);

var styles$V = {"loading":"_GKdGO","loader":"_1iIak","carousel":"_LizR_","customBackground":"_lQwl1","overlay":"_2eaVc","overlayFullScreen":"_2gDFd","lightOverlay":"_ZQPlV","darkOverlay":"_197wA","track":"_1-K-K","arrow":"_GovN4","arrowIcon":"_1Mcuw","left":"_pnAPt","right":"_37elp","bottom":"_r_HHH","disableButton":"_3agxp","singlePage":"_3GeH0","page":"_d8yU1","card":"_2-sVj","close":"_qfnMX","body":"_2a_Bm","content":"_3yqcu","open":"_w7Lc9","fullscreen":"_1JMLt","keymanager":"_3PNsY","noScroll":"_1fk5Z","menuButton":"_Vth9j","menu":"_2Vuuv","show":"_1Ng6h","inner":"_2Fzzx","pageDetails":"_38K_O","title":"_2BvyY","description":"_1meAn","thumbnails":"_ppE_I","thumbnail":"_2vbZR","active":"_2BmOB","pagination":"_1rh9V","scrollbar":"_2D4SR","thumb":"_3xoaY","bar":"_3ea3K","escapeText":"_2LYWe","rightMenu":"_3AlVv","downloadLink":"_33HHx","searchButton":"_1uW_M","fullscreenButton":"_s5Fnz","searchIcon":"_d1908","activePageMenu":"_wSU6-","searchPopover":"_34EzS","findInPage":"_228Dj","fadeInDown":"_17z3T","searchBox":"_2kXvG","searchActions":"_2vHlh","navigationIcon":"_pprAh"};

var ArrowIcon = '/images/interactive/arrow.svg';
var UpArrowIcon = '/images/interactive/up-arrow.svg';
var DownArrowIcon = '/images/interactive/down-arrow.svg';
var transition$1 = {
  ease: 'easeOut',
  bounce: 0,
  duration: 0.2
};
var openSpring = {
  type: 'spring',
  stiffness: 200,
  damping: 30
};
var closeSpring = {
  type: 'spring',
  stiffness: 300,
  damping: 35
};
var TOP_OFFSET = 50;
var LEFT_OFFSET = 60;
var measurements = {
  topOffset: function topOffset(desktop, value) {
    if (!desktop) {
      return 0;
    }
    var ratio = value / TOP_OFFSET;
    return TOP_OFFSET * (1 - ratio);
  },
  leftOffset: function leftOffset(desktop, value) {
    if (!desktop) {
      return 20;
    }
    var ratio = value / TOP_OFFSET;
    return LEFT_OFFSET * (1 - ratio);
  },
  borderRadius: function borderRadius(desktop, value) {
    var radius = desktop ? 30 : 15;
    var ratio = value / TOP_OFFSET;
    return radius * (1 - ratio);
  },
  arrowOffset: function arrowOffset(desktop, value) {
    var ratio = value / TOP_OFFSET;
    var width = 45;
    var offset = LEFT_OFFSET + 0.5 * width;
    return offset * ratio;
  }
};
function memoFunctionEqual(paths) {
  return function (prevProps, nextProps) {
    var next = _$1.pick(nextProps, paths);
    var previous = _$1.pick(prevProps, paths);
    var equals = _$1.isEqual(next, previous);
    return equals;
  };
}
var useDesktop$1 = function useDesktop() {
  var desktop = isDesktop;
  if (process.browser) {
    desktop = useMediaQuery({
      query: '(min-width: 992px)'
    });
  }
  return desktop;
};
var CarouselContext = React.createContext({
  initialised: false,
  navigateToPage: function navigateToPage(index, fullscreen) {},
  navigatePreviousPage: function navigatePreviousPage() {},
  navigateNextPage: function navigateNextPage() {},
  scrollToTop: function scrollToTop() {}
});
var CarouselNavigationContext = React.createContext({
  scrollToTop: function scrollToTop() {},
  scrollToBottom: function scrollToBottom() {},
  scrollToWidget: function scrollToWidget() {}
});
function InteractiveContent(_ref) {
  var children = _ref.children,
    initialPage = _ref.initialPage,
    appearance = _ref.appearance,
    downloadUrl = _ref.downloadUrl,
    onChange = _ref.onChange,
    onDownload = _ref.onDownload;
  var pages = _$1.size(children);
  if (pages <= 0) {
    return false;
  }
  return /*#__PURE__*/React.createElement(Carousel, {
    initialPage: initialPage,
    downloadUrl: downloadUrl,
    appearance: appearance,
    onChange: onChange,
    onDownload: onDownload
  }, children);
}
function Carousel(_ref2) {
  var _cx, _cx2, _cx3, _cx4, _cx5;
  var children = _ref2.children,
    initialPage = _ref2.initialPage,
    appearance = _ref2.appearance,
    downloadUrl = _ref2.downloadUrl,
    onChange = _ref2.onChange,
    onDownload = _ref2.onDownload;
  var containerRef = React.useRef(null);
  var pages = _$1.size(children);
  var singlePage = pages == 1;
  var desktop = useDesktop$1();
  var x = useMotionValue(0);
  var _React$useState = React.useState(singlePage ? TOP_OFFSET : 0),
    y = _React$useState[0],
    setY = _React$useState[1];
  var _React$useState2 = React.useState(singlePage),
    fullScreen = _React$useState2[0],
    setFullScreen = _React$useState2[1];
  var _useState = useState({
      progress: 0,
      scrollTop: 0
    }),
    scrollPage = _useState[0],
    setScrollPage = _useState[1];
  var _React$useState3 = React.useState(false),
    initialised = _React$useState3[0],
    setInitialised = _React$useState3[1];
  var _useState2 = useState(''),
    activeNavigation = _useState2[0],
    setActiveNavigation = _useState2[1];
  var _React$useState4 = React.useState({
      index: initialPage,
      fullscreen: singlePage
    }),
    activePage = _React$useState4[0],
    setActivePage = _React$useState4[1];
  var activePageRef = React.useRef(activePage);
  var _React$useState5 = React.useState([]),
    pagesMetadata = _React$useState5[0],
    setPagesMetadata = _React$useState5[1];
  var _React$useState6 = React.useState(0.9),
    scale = _React$useState6[0],
    setScale = _React$useState6[1];
  var gatingContext = React.useContext(GatingContext);
  var gatingConfigurations = _$1.get(gatingContext, 'configurations', []);
  var embedContext = React.useContext(EmbedContext);
  var actionScrolling = useRef(false);
  var calculateNewX = function calculateNewX() {
    var _containerRef$current;
    if (!desktop) {
      return 0;
    }
    var left = measurements.leftOffset(desktop, y);
    var offset = -activePage.index * (((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.clientWidth) - 105 || 0) - (LEFT_OFFSET - left);
    return offset;
  };
  var _useState3 = useState({
      initialised: initialised,
      activePage: activePage,
      pages: pages,
      navigateToPage: function navigateToPage() {}
    }),
    carouselState = _useState3[0],
    setCarouselState = _useState3[1];
  var _useState4 = useState({
      scrollToTop: function scrollToTop() {},
      scrollToBottom: function scrollToBottom() {},
      scrollToWidget: function scrollToWidget() {}
    }),
    carouselNavigationState = _useState4[0],
    setCarouselNavigationState = _useState4[1];
  React.useEffect(function () {
    activePageRef.current = activePage;
  }, [activePage]);
  React.useEffect(function () {
    setCarouselNavigationState(function (state) {
      return _extends({}, state, {
        scrollToTop: handleScrollTop,
        scrollToBottom: handleScrollBottom,
        scrollToWidget: handleScrollToWidget
      });
    });
    setCarouselState(function (state) {
      return _extends({}, state, {
        navigateToPage: navigateToPage
      });
    });
  }, []);
  React.useEffect(function () {
    setCarouselState(function (state) {
      return _extends({}, state, {
        initialised: initialised,
        activePage: activePage,
        pages: pages
      });
    });
  }, [initialised, activePage, pages]);
  React.useEffect(function () {
    if (initialised && embedContext.embedded) {
      var isInIframe = window.parent !== window;
      if (isInIframe) {
        var parentWindow = window.parent;
        parentWindow.postMessage({
          type: "cleverstory:embed:page:loading",
          payload: {
            id: activePage.index
          }
        }, '*');
      }
    }
  }, [initialised]);
  React.useEffect(function () {
    var offset = desktop ? 120 : 40;
    var scale = (window.innerWidth - offset) / window.innerWidth;
    setScale(scale);
    document.addEventListener('fullscreenchange', exitHandler);
    document.addEventListener('webkitfullscreenchange', exitHandler);
    document.addEventListener('mozfullscreenchange', exitHandler);
    document.addEventListener('MSFullscreenChange', exitHandler);
    document.querySelector("." + styles$V.carousel).addEventListener('touchmove', function (e) {
      e.preventDefault();
    }, false);
    var pagesMetadata = children.map(function (child) {
      var name = _$1.get(child, 'props.widgetProps.name');
      var description = _$1.get(child, 'props.widgetProps.properties.desktop.seo.description');
      var icon = _$1.get(child, 'props.widgetProps.icon.url');
      return {
        name: name,
        description: description,
        icon: icon
      };
    });
    setPagesMetadata(pagesMetadata);
    setTimeout(function () {
      setInitialised(true);
    }, 1000);
  }, []);
  React.useEffect(function () {
    var controls = animate(x, calculateNewX(), transition$1);
    triggerSectionGating();
    return function () {
      controls.stop();
    };
  }, [activePage.index]);
  React.useEffect(function () {
    if (gatingConfigurations.length > 0) {
      triggerSectionGating();
    }
  }, [gatingConfigurations]);
  React.useEffect(function () {
    var controls = animate(x, calculateNewX(), {
      duration: 0
    });
    return function () {
      controls.stop();
    };
  }, [desktop]);
  React.useEffect(function () {
    window.addEventListener('resize', handleWidowResize);
    calculateWindowHeight();
    return function () {
      window.removeEventListener('resize', handleWidowResize);
    };
  }, [desktop, activePage.index]);
  React.useEffect(function () {
    if (!activePage.fullscreen && y > LEFT_OFFSET / 2) {
      setActivePage(function (state) {
        return _extends({}, state, {
          fullscreen: true
        });
      });
    } else if (activePage.fullscreen && y < LEFT_OFFSET / 2) {
      setActivePage(function (state) {
        return _extends({}, state, {
          fullscreen: false
        });
      });
    }
    var controls = animate(x, calculateNewX(), transition$1);
    return controls.stop;
  }, [y]);
  React.useEffect(function () {
    var newY = activePage.fullscreen ? TOP_OFFSET : 0;
    setY(newY);
  }, [activePage.fullscreen]);
  var triggerSectionGating = function triggerSectionGating() {
    if (gatingContext.preview) {
      return;
    }
    var sectionConfigurations = gatingConfigurations.filter(function (item) {
      return _$1.get(item, 'trigger.type', '') === 'INTERACTIVE_SECTION';
    });
    sectionConfigurations.every(function (item) {
      var section = _$1.get(item, 'trigger.value', 0);
      if (section <= activePage.index + 1) {
        var gating = _$1.get(item, 'gating.id', null);
        if (gating) {
          gatingContext.triggerGating('INTERACTIVE_SECTION', null, item);
          return false;
        }
      }
      return true;
    });
  };
  var handleEndDrag = function handleEndDrag(e, dragProps) {
    var _containerRef$current2;
    if (!dragProps) {
      return;
    }
    var clientWidth = ((_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.clientWidth) - 100 || 0;
    var offset = dragProps.offset,
      velocity = dragProps.velocity;
    if (Math.abs(velocity.y) > Math.abs(velocity.x)) {
      animate(x, calculateNewX(), transition$1);
      return;
    }
    if (offset.x > clientWidth / 4) {
      navigateToPage(Math.max(0, activePage.index - 1), false);
    } else if (offset.x < -clientWidth / 4) {
      navigateToPage(Math.min(pages - 1, activePage.index + 1), false);
    } else {
      animate(x, calculateNewX(), transition$1);
    }
  };
  var handleGuesture = function handleGuesture(offset) {
    if (!desktop || singlePage) {
      return;
    }
    if (activePage.fullscreen) {
      var _activePageRef = containerRef.current.querySelector("." + styles$V.page + "." + styles$V.fullscreen);
      if (_activePageRef) {
        var scrollTop = _activePageRef.scrollTop;
        if (scrollTop > 0) {
          return;
        }
      }
    }
    setY(function (y) {
      var newY = y + offset;
      newY = Math.min(newY, TOP_OFFSET);
      newY = Math.max(newY, 0);
      return newY;
    });
  };
  useGesture({
    onDrag: function onDrag(data) {
      var movement = data.movement;
      handleGuesture(-movement[1]);
    },
    onWheel: function onWheel(data) {
      var movement = data.movement;
      handleGuesture(movement[1]);
    }
  }, {
    target: containerRef,
    eventOptions: {
      passive: false
    }
  });
  var navigateToPage = function navigateToPage(index, fullscreen) {
    if (gatingContext.configuration) {
      return;
    }
    var previousIndex = activePageRef.current.index;
    if (index < 0) {
      return;
    }
    if (index >= pages) {
      return;
    }
    if (previousIndex !== index) {
      var pageElement = containerRef.current.querySelector("#page_" + index + ".interactive_content__page");
      if (pageElement) {
        pageElement.scrollTop = 0;
      }
    }
    setActivePage(function (state) {
      return _extends({}, state, {
        index: index,
        fullscreen: pages > 1 ? fullscreen : true
      });
    });
    if (onChange && previousIndex !== index) {
      onChange('index', {
        index: index
      });
    }
    var duration = 300;
    var diff = Math.abs(index - previousIndex);
    if (diff > 0) {
      duration = Math.abs(index - previousIndex) * 500;
    }
    return new Promise(function (resolve) {
      return setTimeout(resolve, duration);
    });
  };
  var handleWidowResize = function handleWidowResize() {
    calculateWindowHeight();
    var offset = desktop || window.innerWidth >= 1024 ? 120 : 40;
    var scale = (window.innerWidth - offset) / window.innerWidth;
    setScale(scale);
    animate(x, calculateNewX(), {
      duration: 0
    });
  };
  var calculateWindowHeight = function calculateWindowHeight() {
    document.documentElement.style.setProperty('--window-height', window.innerHeight + "px");
  };
  var handleLeftArrowClick = useCallback(function () {
    navigateToPage(activePage.index - 1, false);
  }, [activePage.index]);
  var handleRightArrowClick = useCallback(function () {
    navigateToPage(activePage.index + 1, false);
  }, [activePage.index]);
  var handleMenuChanage = function handleMenuChanage(page) {
    navigateToPage(page, false);
  };
  var _handleNavigatePage = function handleNavigatePage() {
    var selector = desktop ? "." + styles$V.fullscreen : "." + styles$V.body;
    var scrollContainer = desktop ? containerRef.current.querySelector(selector) : document.getElementById("page_" + activePageRef.current.index).querySelector(selector);
    if (scrollContainer.scrollTop === 0) {
      navigateToPage(activePageRef.current.index, singlePage);
      scrollContainer.removeEventListener('scroll', _handleNavigatePage);
    }
  };
  var handleScrollTop = function handleScrollTop() {
    var selector = desktop ? "." + styles$V.fullscreen : "." + styles$V.body;
    var scrollContainer = desktop ? containerRef.current.querySelector(selector) : document.getElementById("page_" + activePageRef.current.index).querySelector(selector);
    scrollContainer.addEventListener('scroll', _handleNavigatePage);
    scrollContainer.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };
  var handleScrollBottom = function handleScrollBottom() {
    navigateToPage(activePageRef.current.index, true).then(function () {
      var selector = desktop ? "." + styles$V.fullscreen : "." + styles$V.body;
      var scrollContainer = desktop ? containerRef.current.querySelector(selector) : document.getElementById("page_" + activePageRef.current.index).querySelector(selector);
      var height = scrollContainer.scrollHeight;
      scrollContainer.scroll({
        top: height,
        left: 0,
        behavior: 'smooth'
      });
    });
  };
  var handleScrollDown = function handleScrollDown() {
    navigateToPage(activePageRef.current.index, true).then(function () {
      var scrollContainer = containerRef.current.querySelector("." + styles$V.fullscreen);
      var height = scrollContainer.clientHeight;
      scrollContainer.scroll({
        top: height,
        left: 0,
        behavior: 'smooth'
      });
    });
  };
  var exitHandler = function exitHandler() {
    if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
      setFullScreen(false);
    }
  };
  var handleMouseMove = function handleMouseMove(event) {
    if (typeof window === 'undefined') {
      return;
    }
    switch (true) {
      case event.clientY > 80 / 100 * window.innerHeight && (event.clientX > 50 / 100 * window.innerWidth || event.clientX < 50 / 100 * window.innerWidth):
        if (activeNavigation !== 'bottom') {
          setActiveNavigation('bottom');
        }
        break;
      case event.clientX > 50 / 100 * window.innerWidth:
        if (activeNavigation !== 'right') {
          setActiveNavigation('right');
        }
        break;
      case event.clientX < 50 / 100 * window.innerWidth:
        if (activeNavigation !== 'left') {
          setActiveNavigation('left');
        }
        break;
      default:
        setActiveNavigation('');
        break;
    }
  };
  var handleFullScreen = function handleFullScreen() {
    var viewerContainer = document.getElementsByTagName("body")[0];
    setFullScreen(!fullScreen);
    if (document.fullscreenElement || document.webkitFullscreenElement) {
      document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullscreen();
    }
    if (viewerContainer.requestFullScreen) {
      viewerContainer.requestFullScreen();
    } else if (viewerContainer.mozRequestFullScreen) {
      viewerContainer.mozRequestFullScreen();
    } else if (viewerContainer.webkitRequestFullScreen) {
      viewerContainer.webkitRequestFullScreen();
    }
  };
  var handleScrollToWidget = function handleScrollToWidget(widget) {
    if (!widget) {
      return false;
    }
    var value = widget.value;
    var widgetElement = document.getElementById(value);
    if (!widgetElement) {
      return false;
    }
    var toScrollItem = widgetElement.closest('.interactive_content__page');
    var pageId = toScrollItem.id;
    pageId = pageId.split('_');
    var index = pageId[1];
    index = parseInt(index < 0 ? 0 : index);
    actionScrolling.current = true;
    navigateToPage(index, true).then(function () {
      setTimeout(function () {
        document.querySelector("." + styles$V.carousel).scrollTop = 0;
        actionScrolling.current = false;
      }, 100);
      if (!desktop) {
        widgetElement.scrollIntoView({
          behavior: 'smooth'
        });
        return;
      }
      var selector = desktop ? "." + styles$V.fullscreen : "." + styles$V.body;
      var scrollContainer = desktop ? containerRef.current.querySelector(selector) : document.querySelector(selector);
      var rect = widgetElement.getBoundingClientRect();
      if (scrollContainer) {
        var distanceToTop = rect.top + scrollContainer.scrollTop;
        scrollContainer.scroll({
          top: distanceToTop,
          left: 0,
          behavior: 'smooth'
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement(CarouselContext.Provider, {
    value: carouselState
  }, /*#__PURE__*/React.createElement(CarouselNavigationContext.Provider, {
    value: carouselNavigationState
  }, !initialised && /*#__PURE__*/React.createElement("div", {
    className: styles$V.loading
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$V.loader
  }, /*#__PURE__*/React.createElement("video", {
    loop: true,
    autoPlay: true,
    playsInline: true,
    muted: true
  }, /*#__PURE__*/React.createElement("source", {
    src: "/images/shortLoader.mp4",
    type: "video/mp4"
  })), /*#__PURE__*/React.createElement("label", null, "Loading Interactive content..."))), /*#__PURE__*/React.createElement(motion.div, {
    ref: containerRef,
    className: cx(styles$V.carousel, (_cx = {}, _cx[styles$V.singlePage] = singlePage, _cx))
  }, appearance && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx(styles$V.overlay, (_cx2 = {}, _cx2[styles$V.overlayFullScreen] = activePage.fullscreen, _cx2), (_cx3 = {}, _cx3[styles$V.lightOverlay] = appearance.overlay === 'light', _cx3), (_cx4 = {}, _cx4[styles$V.darkOverlay] = appearance.overlay === 'dark', _cx4))
  }), /*#__PURE__*/React.createElement(BackgroundManager$1, {
    background: appearance.background
  })), /*#__PURE__*/React.createElement(KeyManager$1, null, /*#__PURE__*/React.createElement(Arrow, {
    direction: "left",
    offset: scrollPage.scrollTop,
    activePage: activePage,
    show: activeNavigation == 'left' && scrollPage.scrollTop <= window.innerHeight,
    disabled: activePage.index <= 0 || activeNavigation !== 'left',
    onClick: handleLeftArrowClick
  }), !singlePage && /*#__PURE__*/React.createElement(Menu$1, {
    pages: pagesMetadata,
    offset: y,
    color: _$1.get(appearance, 'iconColor', {}),
    active: activePage.index,
    onChange: handleMenuChanage
  }), /*#__PURE__*/React.createElement("div", {
    className: cx(styles$V.rightMenu, (_cx5 = {}, _cx5[styles$V.activePageMenu] = activePage.fullscreen, _cx5))
  }, appearance.disableDownload === false && downloadUrl && /*#__PURE__*/React.createElement(DownloadButton, {
    iconColor: _$1.get(appearance, 'iconColor', {}),
    onDownload: onDownload
  }), /*#__PURE__*/React.createElement(SearchPopup, {
    iconColor: _$1.get(appearance, 'iconColor', {})
  }), desktop && /*#__PURE__*/React.createElement(FullScreenView, {
    iconColor: _$1.get(appearance, 'iconColor', {}),
    onFullScreen: handleFullScreen,
    fullScreen: fullScreen
  })), /*#__PURE__*/React.createElement(motion.div, {
    className: cx(styles$V.track),
    style: {
      x: x
    },
    initial: false,
    draggable: true,
    drag: false,
    dragElastic: 1,
    onDragEnd: handleEndDrag
  }, children && children.map(function (child, i) {
    var fullscreen = activePage.index === i ? activePage.fullscreen : false;
    return /*#__PURE__*/React.createElement(Page, {
      key: i,
      index: i,
      active: activePage.index === i,
      offset: activePage.index === i ? y : 0,
      scale: scale,
      fullscreen: fullscreen,
      actionScrolling: actionScrolling,
      handleMouseMove: handleMouseMove,
      onDragEnd: handleEndDrag,
      toggleFullScreen: function toggleFullScreen(index, fullscreen) {
        navigateToPage(index, fullscreen);
      },
      onScroll: function onScroll(progress, scrollTop) {
        setScrollPage({
          progress: progress,
          scrollTop: scrollTop
        });
        onChange('progress', {
          index: i,
          progress: progress
        });
      }
    }, React.cloneElement(child));
  })), /*#__PURE__*/React.createElement(Arrow, {
    direction: "bottom",
    offset: y,
    activePage: activePage,
    show: activeNavigation === 'bottom' && !activePage.fullscreen,
    disabled: scrollPage.progress === 100,
    onClick: handleScrollDown
  }), /*#__PURE__*/React.createElement(Arrow, {
    direction: "right",
    offset: scrollPage.scrollTop,
    activePage: activePage,
    show: activeNavigation === 'right' && scrollPage.scrollTop <= window.innerHeight,
    disabled: activePage.index >= children.length - 1 || activeNavigation !== 'right',
    onClick: handleRightArrowClick
  })))));
}
function PageComponent(_ref3) {
  var _cx6;
  var index = _ref3.index,
    offset = _ref3.offset,
    scale = _ref3.scale,
    active = _ref3.active,
    fullscreen = _ref3.fullscreen,
    children = _ref3.children,
    actionScrolling = _ref3.actionScrolling,
    toggleFullScreen = _ref3.toggleFullScreen,
    handleMouseMove = _ref3.handleMouseMove,
    onScroll = _ref3.onScroll;
  var desktop = useDesktop$1();
  var pageRef = React.useRef(null);
  var carouselContext = React.useContext(CarouselContext);
  var _useInView = useInView$1({
      threshold: [0, 1]
    }),
    inViewRef = _useInView[0],
    entry = _useInView[2];
  React.useEffect(function () {
    if (!entry) {
      return;
    }
    if (desktop) {
      return;
    }
    var intersectionRatio = entry.intersectionRatio;
    if (intersectionRatio === 1 && !actionScrolling.current) {
      toggleFullScreen(index, fullscreen);
    }
  }, [entry, desktop, fullscreen, actionScrolling]);
  React.useEffect(function () {
    calculateScrollPosition();
  }, [fullscreen, active, carouselContext.initialised]);
  React.useEffect(function () {
    calculateScrollPosition();
    pageRef.current.addEventListener('scroll', handlePageScroll);
    pageRef.current.addEventListener('touchmove', function (event) {
      event.stopPropagation();
    });
    return function () {
      if (pageRef.current) {
        pageRef.current.removeEventListener('scroll', handlePageScroll);
      }
    };
  }, [pageRef, active, desktop, carouselContext.initialised]);
  var setPageRef = useCallback(function (node) {
    pageRef.current = node;
    inViewRef(node);
  }, [inViewRef]);
  var radius = measurements.borderRadius(desktop, offset);
  var bottomRadius = desktop ? 0 : radius;
  var top = measurements.topOffset(desktop, offset);
  var left = measurements.leftOffset(desktop, offset);
  var width = "calc(100vw - 2 * (" + left + "px))";
  var effectiveScale = fullscreen ? 1 : scale;
  var pageStyle = {
    borderRadius: radius + "px " + radius + "px " + bottomRadius + "px " + bottomRadius + "px",
    width: width
  };
  if (desktop) {
    pageStyle = _extends({}, pageStyle, {
      transform: "translate3D(0, calc(" + top + "px), 0)"
    });
  }
  var contentStyle = {
    transform: "scale(" + effectiveScale + ")"
  };
  var handlePageScroll = function handlePageScroll() {
    calculateScrollPosition();
  };
  var handleMobileScroll = function handleMobileScroll(progress) {
    if (!active) {
      return;
    }
    onScroll(progress);
  };
  var calculateScrollPosition = function calculateScrollPosition() {
    if (!pageRef.current) {
      return;
    }
    if (!active) {
      return;
    }
    if (!desktop) {
      return;
    }
    if (!carouselContext.initialised) {
      return;
    }
    var scrollTop = pageRef.current.scrollTop;
    var clientHeight = pageRef.current.clientHeight;
    var scrollHeight = pageRef.current.scrollHeight;
    var percent = (scrollTop + clientHeight) * 100 / scrollHeight;
    percent = Math.max(0, percent);
    percent = Math.min(100, percent);
    onScroll(percent, scrollTop);
  };
  var handlePageClick = function handlePageClick() {
    if (desktop) {
      return false;
    }
    if (toggleFullScreen) {
      toggleFullScreen(index, true);
    }
  };
  var handleClose = function handleClose() {
    if (desktop) {
      return false;
    }
    if (toggleFullScreen) {
      toggleFullScreen(index, false);
    }
  };
  return /*#__PURE__*/React.createElement(motion.div, {
    ref: setPageRef,
    id: "page_" + index,
    onMouseMove: _$1.debounce(handleMouseMove, 20),
    key: "page_" + index + "_" + (desktop ? 'desktop' : 'mobile'),
    className: cx(styles$V.page, (_cx6 = {}, _cx6[styles$V.fullscreen] = fullscreen, _cx6.interactive_content__page = true, _cx6)),
    transition: transition$1,
    animate: pageStyle,
    onClick: handlePageClick
  }, /*#__PURE__*/React.createElement(CardPopup, {
    active: active,
    desktopPageRef: pageRef.current,
    open: fullscreen,
    onClose: handleClose,
    onScroll: handleMobileScroll
  }, /*#__PURE__*/React.createElement(motion.div, {
    id: index,
    className: styles$V.content,
    transition: transition$1,
    initial: {
      transform: "scale(" + scale + ")"
    },
    animate: contentStyle
  }, children)));
}
var Page = React.memo(PageComponent, memoFunctionEqual(['index', 'offset', 'scale', 'active', 'fullscreen', 'toggleFullScreen', 'onScroll']));
function CardPopupComponent(_ref4) {
  var _cx7;
  var active = _ref4.active,
    open = _ref4.open,
    desktopPageRef = _ref4.desktopPageRef,
    children = _ref4.children,
    onScroll = _ref4.onScroll,
    onClose = _ref4.onClose;
  var pageRef = React.useRef(null);
  var desktop = useDesktop$1();
  var y = useMotionValue(0);
  var carouselContext = React.useContext(CarouselContext);
  React.useEffect(function () {
    if (open) {
      document.querySelector('body').classList.add(styles$V.noScroll);
      if (pageRef.current) {
        pageRef.current.scrollTop = 0;
      }
    } else {
      document.querySelector('body').classList.remove(styles$V.noScroll);
      y.set(0);
    }
    return function () {};
  }, [open]);
  React.useEffect(function () {
    calculateScrollPosition();
  }, [active, open, carouselContext.initialised]);
  React.useEffect(function () {
    pageRef.current.addEventListener('scroll', calculateScrollPosition);
    return function () {
      if (pageRef.current) {
        pageRef.current.removeEventListener('scroll', calculateScrollPosition);
      }
    };
  }, [pageRef, active, carouselContext.initialised]);
  var calculateScrollPosition = function calculateScrollPosition() {
    if (!pageRef.current) {
      return;
    }
    if (desktop) {
      return;
    }
    if (!active) {
      return;
    }
    if (!carouselContext.initialised) {
      return;
    }
    var scrollTop = pageRef.current.scrollTop;
    var clientHeight = pageRef.current.clientHeight;
    var scrollHeight = pageRef.current.scrollHeight;
    var percent = (scrollTop + clientHeight) * 100 / scrollHeight;
    percent = Math.max(0, percent);
    percent = Math.min(100, percent);
    onScroll(percent);
  };
  return /*#__PURE__*/React.createElement(ParallaxProvider, {
    scrollContainer: desktop ? desktopPageRef : pageRef.current
  }, /*#__PURE__*/React.createElement(motion.div, {
    className: cx(styles$V.card, (_cx7 = {}, _cx7[styles$V.open] = !desktop && open, _cx7))
  }, carouselContext.pages > 1 && /*#__PURE__*/React.createElement(motion.div, {
    className: styles$V.close,
    animate: {
      x: open ? 0 : 100
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: styles$V.close,
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (onClose) {
        onClose();
      }
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "cleverstory-close"
  }))), /*#__PURE__*/React.createElement(motion.div, {
    ref: pageRef,
    className: styles$V.body,
    style: {
      y: y
    },
    transition: open ? openSpring : closeSpring
  }, children)));
}
var CardPopup = React.memo(CardPopupComponent, memoFunctionEqual(['active', 'open', 'onScroll', 'onClose']));
var ArrowComponent = function ArrowComponent(_ref5) {
  var direction = _ref5.direction,
    offset = _ref5.offset,
    disabled = _ref5.disabled,
    show = _ref5.show,
    onClick = _ref5.onClick,
    activePage = _ref5.activePage;
  if (typeof window === 'undefined') {
    return null;
  }
  var animationX = direction === 'left' ? {
    x: '50%'
  } : direction === 'bottom' ? {
    y: '-50%'
  } : {
    x: '-50%'
  };
  var defaultNav = activePage.index === 0 && offset <= window.innerHeight && direction === 'right';
  return /*#__PURE__*/React.createElement(AnimatePresence, null, (show || defaultNav) && /*#__PURE__*/React.createElement(motion.div, {
    className: cx(styles$V.arrow, styles$V[direction]),
    transition: transition$1,
    initial: _extends({
      opacity: 0
    }, animationX),
    animate: {
      opacity: disabled && !defaultNav ? 0 : 1,
      x: 0,
      y: 0
    },
    exit: _extends({
      opacity: 0
    }, animationX)
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onClick
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('cleverstory-drop-down', styles$V.arrowIcon)
  }))));
};
var Arrow = React.memo(ArrowComponent, memoFunctionEqual(['direction', 'show', 'offset', 'disabled', 'onClick', 'activePage']));
var MenuComponent = function MenuComponent(_ref6) {
  var _cx8;
  var pages = _ref6.pages,
    offset = _ref6.offset,
    color = _ref6.color,
    active = _ref6.active,
    onChange = _ref6.onChange;
  var containerRef = React.useRef();
  var gatingContext = React.useContext(GatingContext);
  var _React$useState7 = React.useState({
      show: false,
      activePage: 0,
      hoverPage: 0,
      animate: 'hidden'
    }),
    state = _React$useState7[0],
    setState = _React$useState7[1];
  var total = _$1.size(pages);
  var progress = (state.activePage + 1) / Math.max(total, 1) * 100;
  var hasPrevious = state.activePage <= 0;
  var hasNext = state.activePage === total - 1;
  var headingDelay = Math.min(Math.min(total, 5) * 0.3, 0.8);
  var descriptionDelay = headingDelay + 0.2;
  var paginationDelay = descriptionDelay;
  var heading = _$1.get(pages, state.hoverPage + ".name");
  var description = _$1.get(pages, state.hoverPage + ".description");
  var iconUrl = _$1.get(pages, state.hoverPage + ".icon");
  React.useEffect(function () {
    setState(function (state) {
      return _extends({}, state, {
        activePage: active,
        hoverPage: active
      });
    });
  }, [active]);
  React.useEffect(function () {
    if (state.show && containerRef.current) {
      containerRef.current.focus();
    }
    setState(function (state) {
      return _extends({}, state, {
        animate: state.show ? 'show' : 'hidden'
      });
    });
  }, [state.show]);
  var menuVariant = {
    hidden: {
      y: -200,
      opacity: 0
    },
    show: {
      y: 0,
      opacity: 1
    },
    changePage: {
      y: 0,
      opacity: 1
    }
  };
  var hiddenMenuVariant = {
    hidden: {
      y: 0,
      opacity: 1
    },
    show: {
      y: 0,
      opacity: 1
    },
    changePage: {
      y: 0,
      opacity: 1
    }
  };
  var headingVariant = {
    hidden: {
      y: 40,
      opacity: 0
    },
    show: {
      y: 0,
      opacity: 1,
      transition: {
        ease: 'easeOut',
        delay: headingDelay,
        duration: 0.6
      }
    },
    changePage: {
      y: 0,
      opacity: 1,
      transition: {
        ease: 'easeOut',
        delay: 0.1,
        duration: 1
      }
    }
  };
  var descriptionVariant = {
    hidden: {
      y: 40,
      opacity: 0
    },
    show: {
      y: 0,
      opacity: 1,
      transition: {
        ease: 'easeOut',
        delay: descriptionDelay,
        duration: 0.6
      }
    },
    changePage: {
      y: 0,
      opacity: 1,
      transition: {
        ease: 'easeOut',
        delay: 0.5,
        duration: 1
      }
    }
  };
  var paginationVariant = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        ease: 'easeOut',
        delay: paginationDelay
      }
    },
    changePage: {
      opacity: 1
    }
  };
  var handleMenuClick = function handleMenuClick() {
    setState(function (state) {
      return _extends({}, state, {
        show: true,
        animate: 'show'
      });
    });
  };
  var moveToPage = function moveToPage(page) {
    onChange(page);
  };
  var handleNext = function handleNext(e) {
    e.preventDefault();
    moveToPage(state.activePage + 1);
  };
  var handlePrevious = function handlePrevious(e) {
    e.preventDefault();
    moveToPage(state.activePage - 1);
  };
  var handleClick = function handleClick(page) {
    moveToPage(page);
    handleClose();
  };
  var handleMouseOver = function handleMouseOver(page) {
    setState(function (state) {
      return _extends({}, state, {
        hoverPage: page,
        animate: 'changePage'
      });
    });
  };
  var handleMouseOut = function handleMouseOut(page) {
    setState(function (state) {
      return _extends({}, state, {
        hoverPage: state.activePage,
        animate: 'changePage'
      });
    });
  };
  var handleClose = function handleClose(e) {
    if (e) e.preventDefault();
    setState(function (state) {
      return _extends({}, state, {
        show: false
      });
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(motion.div, {
    className: styles$V.menuButton,
    animate: {
      transform: "translate3D(0, -" + offset + "px, 0)"
    },
    transition: transition$1
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleMenuClick
  }, /*#__PURE__*/React.createElement("i", {
    style: {
      color: colorToString$1(color)
    },
    className: cx('cleverstory-menu', styles$V.arrowIcon)
  }))), /*#__PURE__*/React.createElement(HotKeys, {
    innerRef: containerRef,
    className: cx(styles$V.menu, (_cx8 = {}, _cx8[styles$V.show] = state.show, _cx8)),
    keyMap: {
      PREVIOUS: 'left',
      NEXT: 'right',
      CLOSE: ['escape', 'x']
    },
    handlers: {
      PREVIOUS: handlePrevious,
      NEXT: handleNext,
      CLOSE: handleClose
    },
    allowChanges: true
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$V.overlay
  }, iconUrl && /*#__PURE__*/React.createElement(IKImage, {
    path: iconUrl
  })), /*#__PURE__*/React.createElement(motion.div, {
    className: styles$V.inner,
    key: "container_" + (state.show ? 'visible' : 'hidden'),
    initial: "hidden",
    animate: state.animate
  }, /*#__PURE__*/React.createElement(motion.div, {
    className: styles$V.pageDetails,
    key: "heading_" + state.hoverPage,
    variants: headingVariant
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$V.title
  }, /*#__PURE__*/React.createElement("span", null, heading)), /*#__PURE__*/React.createElement(motion.div, {
    className: styles$V.description,
    key: "description_" + state.hoverPage,
    variants: descriptionVariant
  }, /*#__PURE__*/React.createElement("p", null, description))), /*#__PURE__*/React.createElement(motion.div, {
    className: styles$V.thumbnails,
    variants: {
      hidden: {},
      show: {
        transition: {
          staggerChildren: 0.3
        }
      },
      changePage: {}
    },
    initial: {
      x: -state.activePage * 215
    },
    animate: {
      x: -state.activePage * 215
    }
  }, pages.map(function (page, index) {
    var _cx9;
    var isActive = state.activePage === index;
    var hidden = index - state.activePage < -1;
    return /*#__PURE__*/React.createElement(motion.div, {
      key: index,
      className: cx(styles$V.thumbnail, (_cx9 = {}, _cx9[styles$V.active] = isActive, _cx9)),
      variants: hidden ? hiddenMenuVariant : menuVariant,
      transition: {
        ease: 'easeOut',
        bounce: 0,
        duration: 0.6
      },
      onClick: function onClick() {
        return handleClick(index);
      },
      onMouseOver: function onMouseOver() {
        return handleMouseOver(index);
      },
      onMouseOut: function onMouseOut() {
        return handleMouseOut();
      }
    }, page.icon && /*#__PURE__*/React.createElement(IKImage, {
      path: page.icon,
      width: 200,
      height: 130
    }));
  })), /*#__PURE__*/React.createElement(motion.div, {
    className: styles$V.pagination,
    variants: paginationVariant
  }, /*#__PURE__*/React.createElement("button", {
    className: cx(styles$V.arrow, styles$V.left),
    disabled: hasPrevious,
    onClick: handlePrevious
  }, /*#__PURE__*/React.createElement(ReactSVG, {
    src: ArrowIcon,
    style: {
      width: '100%',
      height: '100%'
    }
  })), /*#__PURE__*/React.createElement("button", {
    className: cx(styles$V.arrow, styles$V.right),
    disabled: hasNext,
    onClick: handleNext
  }, /*#__PURE__*/React.createElement(ReactSVG, {
    src: ArrowIcon,
    style: {
      width: '100%',
      height: '100%'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$V.scrollbar
  }, /*#__PURE__*/React.createElement(motion.div, {
    className: styles$V.thumb,
    animate: {
      width: progress + "%"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$V.bar
  })))), /*#__PURE__*/React.createElement(motion.div, {
    className: styles$V.escapeText,
    variants: paginationVariant
  }, "Press ", /*#__PURE__*/React.createElement("span", null, "esc"), " to head back")));
};
var Menu$1 = React.memo(MenuComponent, memoFunctionEqual(['pages', 'offset', 'color', 'active', 'onChange']));
function BackgroundManager$1(_ref7) {
  var background = _ref7.background;
  if (!background) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        background: '#ffffff'
      },
      className: styles$V.customBackground
    });
  }
  switch (background.type) {
    case 'color':
      {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            background: colorToString$1(background.color)
          },
          className: styles$V.customBackground
        });
      }
    case 'image':
      {
        if (_$1.get(background, 'media.type') === 'image') {
          return /*#__PURE__*/React.createElement("div", {
            className: styles$V.customBackground
          }, /*#__PURE__*/React.createElement(ImageView, {
            background: background
          }));
        }
        return /*#__PURE__*/React.createElement("div", {
          className: styles$V.customBackground
        }, /*#__PURE__*/React.createElement(VideoView, {
          background: background
        }));
      }
    default:
      return /*#__PURE__*/React.createElement("div", {
        style: {
          background: '#ffffff'
        },
        className: styles$V.customBackground
      });
  }
}
function KeyManager$1(_ref8) {
  var children = _ref8.children;
  var containerRef = React.useRef();
  var carouselContext = React.useContext(CarouselContext);
  var gatingContext = React.useContext(GatingContext);
  useEffect(function () {
    if (containerRef.current) {
      containerRef.current.focus();
    }
  }, []);
  var keyMap = {
    MOVE_LEFT: 'left',
    MOVE_RIGHT: 'right'
  };
  var navigateNext = React.useCallback(function (e) {
    e.preventDefault();
    if (gatingContext.configuration) {
      return;
    }
    carouselContext.navigateToPage(carouselContext.activePage.index + 1, carouselContext.activePage.fullscreen);
  }, [carouselContext.activePage]);
  var navigatePrevious = React.useCallback(function (e) {
    e.preventDefault();
    if (gatingContext.configuration) {
      return;
    }
    carouselContext.navigateToPage(carouselContext.activePage.index - 1, carouselContext.activePage.fullscreen);
  }, [carouselContext.activePage]);
  var toggleFullScreen = React.useCallback(function (e) {}, [carouselContext.activePage]);
  return /*#__PURE__*/React.createElement(GlobalHotKeys, {
    className: styles$V.keymanager,
    innerRef: containerRef,
    keyMap: keyMap,
    handlers: {
      MOVE_UP: toggleFullScreen,
      MOVE_DOWN: toggleFullScreen,
      MOVE_LEFT: navigatePrevious,
      MOVE_RIGHT: navigateNext
    },
    allowChanges: true
  }, children);
}
function colorToString$1(color) {
  if (!color || !_$1.has(color, 'r')) {
    return 'rgba(0,0,0,1)';
  }
  return "rgba(" + color.r + ", " + color.g + ", " + color.b + ", " + color.a + ")";
}
function SearchKeyManager(_ref9) {
  var children = _ref9.children,
    toggleShowSeach = _ref9.toggleShowSeach;
  var gatingContext = React.useContext(GatingContext);
  var keyMap = {
    SEARCH: ['ctrl+f', 'meta+f'],
    ESC: 'Escape'
  };
  var handleShowSearch = function handleShowSearch(e) {
    e.preventDefault();
    if (gatingContext.configuration) {
      return;
    }
    toggleShowSeach(true);
  };
  var handleHideSearch = function handleHideSearch(e) {
    e.preventDefault();
    if (gatingContext.configuration) {
      return;
    }
    toggleShowSeach(false);
  };
  return /*#__PURE__*/React.createElement(GlobalHotKeys, {
    className: styles$V.keymanager,
    keyMap: keyMap,
    handlers: {
      SEARCH: handleShowSearch,
      ESE: handleHideSearch
    },
    allowChanges: true
  }, children);
}
var DownloadButton = function DownloadButton(_ref10) {
  var iconColor = _ref10.iconColor,
    onDownload = _ref10.onDownload;
  var _useState5 = useState(false),
    animate = _useState5[0],
    setAnimate = _useState5[1];
  var downloadRef = useRef(null);
  var iconsPaths = [];
  var gatingContext = React.useContext(GatingContext);
  var gatingConfigurations = _$1.get(gatingContext, 'configurations', []);
  var configuration = gatingConfigurations.find(function (item) {
    return _$1.get(item, 'trigger.type', '') === 'INTERACTIVE_DOWNLOAD';
  });
  var handleDownloadClick = function handleDownloadClick() {
    if (configuration && !gatingContext.preview) {
      gatingContext.triggerGating('INTERACTIVE_DOWNLOAD', {
        download: downloadPdf
      }, configuration);
      return;
    }
    setAnimate(true);
  };
  var downloadPdf = function downloadPdf() {
    setAnimate(false);
    if (onDownload) {
      onDownload();
    }
  };
  if (downloadRef.current) {
    iconsPaths = downloadRef.current.getElementsByTagName('path');
  }
  useEffect(function () {
    _$1.forEach(iconsPaths, function (element) {
      element.style.stroke = colorToString$1(iconColor);
      element.style.fill = colorToString$1(iconColor);
    });
  }, [iconsPaths.length]);
  return /*#__PURE__*/React.createElement("div", {
    ref: downloadRef,
    className: styles$V.downloadLink,
    onClick: handleDownloadClick
  }, /*#__PURE__*/React.createElement(AfterEffect, {
    url: "/images/interactive/download.json",
    width: 30,
    height: 30,
    loop: false,
    iconColor: iconColor,
    play: animate,
    eventListeners: [{
      eventName: 'complete',
      callback: function callback() {
        downloadPdf();
      }
    }]
  }));
};
var FullScreenView = function FullScreenView(_ref11) {
  var onFullScreen = _ref11.onFullScreen,
    fullScreen = _ref11.fullScreen,
    iconColor = _ref11.iconColor;
  return /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onFullScreen();
    },
    className: styles$V.fullscreenButton
  }, !fullScreen && /*#__PURE__*/React.createElement("i", {
    style: {
      color: colorToString$1(iconColor)
    },
    className: cx(styles$V.searchIcon, 'cleverstory-expand-editor')
  }), fullScreen && /*#__PURE__*/React.createElement("i", {
    style: {
      color: colorToString$1(iconColor)
    },
    className: cx(styles$V.searchIcon, 'cleverstory-minimize-editor')
  }));
};
var SearchPopup = function SearchPopup(_ref12) {
  var iconColor = _ref12.iconColor;
  var carouselContext = React.useContext(CarouselContext);
  var searchInputRef = React.useRef(null);
  var _React$useState8 = React.useState(false),
    showSearch = _React$useState8[0],
    setShowSearch = _React$useState8[1];
  var _useState6 = useState({
      query: '',
      index: 0,
      total: 0,
      processed: false,
      navigating: false,
      markInstance: null
    }),
    searchContext = _useState6[0],
    setSearchContext = _useState6[1];
  React.useEffect(function () {
    if (showSearch && searchInputRef.current) {
      searchInputRef.current.focus();
    }
    if (!showSearch) {
      resetHighlight();
    }
  }, [showSearch]);
  var hasNext = searchContext.processed && !searchContext.navigating && searchContext.total > 0;
  var hasPrevious = searchContext.processed && !searchContext.navigating && searchContext.total > 0;
  var resetHighlight = function resetHighlight() {
    if (searchContext.markInstance) {
      searchContext.markInstance.unmark();
    }
    setShowSearch(false);
    setSearchContext(function (state) {
      return _extends({}, state, {
        query: '',
        index: 0,
        total: 0,
        processed: false,
        navigating: false
      });
    });
  };
  var handleSearch = function handleSearch(e) {
    e.preventDefault();
    if (searchContext.navigating) {
      return;
    }
    if (searchContext.processed) {
      nextClick();
      return;
    }
    var options = {
      separateWordSearch: false,
      exclude: ['label', '.backToTop']
    };
    var markInstance = searchContext.markInstance;
    if (!markInstance) {
      var textInstances = document.querySelectorAll('.cs_text_widget');
      markInstance = new Mark(textInstances);
    }
    markInstance.unmark({
      done: function done() {
        markInstance.mark(searchContext.query, options);
      }
    });
    var results = document.querySelectorAll(".cs_text_widget mark[data-markjs='true']").length;
    setSearchContext(function (state) {
      return _extends({}, state, {
        processed: true,
        navigating: false,
        index: 0,
        total: results,
        markInstance: markInstance
      });
    });
    if (results > 0) {
      navigate(0);
    }
  };
  var previousClick = function previousClick() {
    var previous = searchContext.index - 1;
    if (previous < 0) {
      previous = searchContext.total - 1;
    }
    if (previous > searchContext.total) {
      previous = 0;
    }
    navigate(previous);
  };
  var nextClick = function nextClick() {
    var next = searchContext.index + 1;
    if (next < 0) {
      next = 0;
    }
    if (next >= searchContext.total) {
      next = 0;
    }
    navigate(next);
  };
  var updateNavigationStatus = function updateNavigationStatus(navigating, index) {
    setSearchContext(function (state) {
      return _extends({}, state, {
        navigating: navigating,
        index: index
      });
    });
  };
  var navigate = function navigate(matchIndex) {
    var elements = document.querySelectorAll(".cs_text_widget mark[data-markjs='true']");
    var highlightElement = null;
    if (elements.length > 0) {
      highlightElement = elements[matchIndex];
    }
    document.querySelectorAll('.cs_search__highlight').forEach(function (elem) {
      elem.classList.remove('cs_search__highlight');
    });
    if (highlightElement) {
      highlightElement.classList.add('cs_search__highlight');
      updateNavigationStatus(true, matchIndex);
      var toScrollItem = highlightElement.closest('.interactive_content__page');
      var id = toScrollItem.id;
      id = id.split('_');
      var index = id[1];
      index = parseInt(index < 0 ? 0 : index);
      carouselContext.navigateToPage(index, true).then(function () {
        if (!isSelectionVisible(highlightElement)) {
          highlightElement.scrollIntoView();
          setTimeout(function () {
            document.querySelector("." + styles$V.carousel).scrollTop = 0;
          }, 100);
        }
        updateNavigationStatus(false, matchIndex);
      });
    }
  };
  var isSelectionVisible = function isSelectionVisible(element) {
    var rect = element.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  };
  var popover = /*#__PURE__*/React.createElement(Popover, {
    className: styles$V.searchPopover
  }, /*#__PURE__*/React.createElement(Popover.Body, {
    className: styles$V.searchPopoverBody
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$V.findInPage
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$V.searchBox
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSearch
  }, /*#__PURE__*/React.createElement("input", {
    ref: searchInputRef,
    onChange: function onChange(e) {
      setSearchContext(function (state) {
        return _extends({}, state, {
          query: e.target.value,
          processed: false
        });
      });
    }
  })), searchContext.processed && /*#__PURE__*/React.createElement("span", null, searchContext.total == 0 ? 0 : searchContext.index + 1, "/", searchContext.total)), /*#__PURE__*/React.createElement("div", {
    className: styles$V.searchActions
  }, /*#__PURE__*/React.createElement("button", {
    "data-search": "next",
    disabled: !hasNext,
    onClick: nextClick
  }, /*#__PURE__*/React.createElement(ReactSVG, {
    src: DownArrowIcon,
    style: {
      width: '100%',
      height: '100%'
    }
  })), /*#__PURE__*/React.createElement("button", {
    "data-search": "prev",
    disabled: !hasPrevious,
    onClick: previousClick
  }, /*#__PURE__*/React.createElement(ReactSVG, {
    src: UpArrowIcon,
    style: {
      width: '100%',
      height: '100%'
    }
  })), /*#__PURE__*/React.createElement("button", {
    "data-search": "cancel",
    onClick: function onClick() {
      setShowSearch(false);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: cx(styles$V.navigationIcon, 'cleverstory-close')
  }))))));
  return /*#__PURE__*/React.createElement(SearchKeyManager, {
    toggleShowSeach: setShowSearch
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    overlay: popover,
    show: showSearch
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$V.searchButton,
    onClick: function onClick() {
      setShowSearch(true);
    }
  }, /*#__PURE__*/React.createElement("i", {
    style: {
      color: colorToString$1(iconColor)
    },
    className: cx(styles$V.searchIcon, 'cleverstory-search')
  }))));
};

var styles$W = {};

function LandingPage(_ref) {
  var children = _ref.children,
    onChange = _ref.onChange,
    pageWidgets = _ref.pageWidgets;
  var widgetContext = React.useContext(WidgetsContext);
  var breakpoint = _$1.get(widgetContext, 'breakpoint');
  var selector = widgetContext.selector;
  var pageRef = React.useRef(null);
  var iframeBodyRef = React.useRef(null);
  var _useState = useState({
      pageHeight: 0
    }),
    state = _useState[0],
    setState = _useState[1];
  var pageWidget = useSelector(function (state) {
    var widgets = _$1.get(state, selector + ".widgets") || [];
    var page = widgets.find(function (item) {
      return item.uid == pageWidgets[0].uid;
    });
    return page;
  });
  var pageHeight = _$1.get(pageWidget, "properties." + breakpoint + ".layout.height");
  var container = _$1.get(pageWidget, "properties." + breakpoint + ".container");
  React.useEffect(function () {
    var isInIframe = window.parent !== window;
    if (isInIframe) {
      var parentWindow = window.parent;
      parentWindow.postMessage({
        type: "cleverstory:embed:page:loading",
        payload: {
          pageWidget: pageWidget
        }
      }, '*');
    }
  }, []);
  React.useEffect(function () {
    if (pageWidgets && _$1.size(pageWidgets) > 0) {
      var windowWidth = document.body.clientWidth;
      var zoomValue = 1;
      if (widgetContext.shouldZoom) {
        zoomValue = windowWidth / container.minWidth;
        if (windowWidth > 1200) {
          zoomValue = 1;
        }
      }
      setState(function (state) {
        return _extends({}, state, {
          pageHeight: parseInt(pageHeight) * zoomValue + "px"
        });
      });
    }
  }, [pageWidgets, pageHeight, breakpoint]);
  useEffect(function () {
    if (widgetContext.preview) {
      var _iframe$contentWindow;
      var parentDocument = window.parent.document;
      var iframe = parentDocument.getElementById("cs-preview-iframe");
      var iframeDocument = (iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) || (iframe === null || iframe === void 0 ? void 0 : (_iframe$contentWindow = iframe.contentWindow) === null || _iframe$contentWindow === void 0 ? void 0 : _iframe$contentWindow.document);
      iframeBodyRef.current = iframeDocument === null || iframeDocument === void 0 ? void 0 : iframeDocument.body;
    }
  }, [widgetContext.preview]);
  useEffect(function () {
    if (pageRef && parseInt(state.pageHeight) > 0) {
      document.addEventListener('scroll', calculateScrollPosition);
      var clientHeight = document.body.clientHeight;
      if (clientHeight > parseInt(state.pageHeight)) {
        onChange('progress', {
          index: 0,
          progress: 100
        });
      }
      return function () {
        if (process.browser) {
          document.removeEventListener('scroll', calculateScrollPosition);
        }
      };
    }
  }, [state.pageHeight, pageRef]);
  var calculateScrollPosition = function calculateScrollPosition() {
    var scrollTop = window.scrollY;
    var clientHeight = document.body.clientHeight;
    var scrollHeight = pageRef.current.scrollHeight;
    var percent = (scrollTop + clientHeight) * 100 / scrollHeight;
    percent = Math.max(0, percent);
    percent = Math.min(100, percent);
    onChange('progress', {
      index: 0,
      progress: percent
    });
  };
  var pageStyles = {
    height: state.pageHeight
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles$W.landingPage,
    style: pageStyles,
    ref: pageRef
  }, /*#__PURE__*/React.createElement(ParallaxProvider, {
    scrollContainer: iframeBodyRef.current
  }, children));
}

var GatingManager = React.forwardRef(function (_ref, ref) {
  var configurations = _ref.configurations,
    children = _ref.children,
    resetGating = _ref.resetGating,
    page = _ref.page,
    breakpoint = _ref.breakpoint,
    preview = _ref.preview,
    onGatingClose = _ref.onGatingClose;
  var context = React.useContext(WidgetsContext);
  var _React$useState = React.useState({
      preview: preview,
      disabled: false,
      triggerGating: function triggerGating() {},
      type: null,
      payload: null,
      gating: null,
      configuration: null,
      configurations: [],
      assetConfigurations: []
    }),
    gatingContext = _React$useState[0],
    setGatingContext = _React$useState[1];
  var _React$useState2 = React.useState(_extends({}, context)),
    widgetContextState = _React$useState2[0],
    setWidgetContextState = _React$useState2[1];
  var formSuccess = useFormSuccessSelector(widgetContextState.selector);
  var otpFormSuccess = useOtpFormSuccessSelector(widgetContextState.selector);
  var otpRequired = useOtpRequiredSelector(widgetContextState.selector);
  var duration = usePageDuration(page);
  var assetType = _$1.get(gatingContext, "configuration.target.entityType", "") === 'asset';
  useState(function () {
    setGatingContext(function (gatingContext) {
      return _extends({}, gatingContext, {
        triggerGating: triggerGating
      });
    });
  }, []);
  React.useEffect(function () {
    if (gatingContext.gating) {
      setWidgetContextState(function (widgetContextState) {
        return _extends({}, widgetContextState, context.createGatingContext(gatingContext.gating));
      });
    }
  }, [gatingContext.gating]);
  useEffect(function () {
    initiateGatingForTimeSpent();
  }, [duration]);
  useEffect(function () {
    setGatingContext(function (gatingContext) {
      return _extends({}, gatingContext, {
        configurations: configurations
      });
    });
  }, [configurations]);
  useEffect(function () {
    if (formSuccess && !otpRequired) {
      handleFormSuccess();
    }
  }, [formSuccess]);
  useEffect(function () {
    if (otpFormSuccess && otpRequired) {
      handleFormSuccess();
    }
  }, [otpFormSuccess]);
  useEffect(function () {
    if (context) {
      setWidgetContextState(function (widgetContextState) {
        return _extends({}, context, widgetContextState);
      });
    }
  }, [context]);
  React.useImperativeHandle(ref, function () {
    return {
      triggerGating: triggerGating,
      closeGating: handleClose
    };
  });
  var triggerGating = function triggerGating(type, payload, configuration) {
    if (gatingContext.gating || gatingContext.disabled) {
      return;
    }
    var gating = _$1.get(configuration, 'gating.id');
    setGatingContext(function (gatingContext) {
      return _extends({}, gatingContext, {
        gating: gating,
        type: type,
        payload: payload,
        configuration: configuration
      });
    });
  };
  var initiateGatingForTimeSpent = function initiateGatingForTimeSpent() {
    if (gatingContext.gating || gatingContext.disabled || preview) {
      return;
    }
    var timeConfigurations = gatingContext.configurations.filter(function (item) {
      return _$1.get(item, 'trigger.type', null) === 'TIME';
    });
    timeConfigurations.every(function (item) {
      var triggerDuration = _$1.get(item, 'trigger.value', 0);
      if (triggerDuration <= duration) {
        var gating = _$1.get(item, 'gating.id', null);
        if (gating) {
          setGatingContext(function (gatingContext) {
            return _extends({}, gatingContext, {
              gating: gating,
              type: 'TIME',
              payload: null,
              configuration: item
            });
          });
          return false;
        }
      }
      return true;
    });
  };
  var isFullScreenVideo = function isFullScreenVideo() {
    var fullscreenContainer = document.fullscreenElement;
    var videoElement = fullscreenContainer ? fullscreenContainer.querySelector('video') : null;
    var modalElement = document.getElementsByClassName('ReactModalPortal')[0];
    if (videoElement) {
      fullscreenContainer.removeChild(modalElement);
    }
  };
  var handleFormSuccess = function handleFormSuccess() {
    if (!preview) {
      if (gatingContext.type === 'INTERACTIVE_DOWNLOAD') {
        if (gatingContext.payload.download) {
          gatingContext.payload.download();
        }
      }
    }
    isFullScreenVideo();
    resetGating(page);
    setGatingContext(function (gatingContext) {
      if (preview) {
        return _extends({}, gatingContext, {
          gating: null,
          configuration: null
        });
      }
      return _extends({}, gatingContext, {
        triggerGating: function triggerGating() {},
        type: null,
        payload: null,
        gating: null,
        configuration: null,
        configurations: [],
        disabled: true
      });
    });
  };
  var handleClose = function handleClose(configuration) {
    if (!configuration) {
      return;
    }
    var items = [].concat(gatingContext.assetConfigurations, [configuration.id]);
    setGatingContext(function (gatingContext) {
      return _extends({}, gatingContext, {
        gating: null,
        configuration: null,
        configurations: (gatingContext.configurations || []).filter(function (item) {
          return item.id !== configuration.id;
        }),
        assetConfigurations: items
      });
    });
    isFullScreenVideo();
    resetGating(page);
    if (assetType && !(configuration !== null && configuration !== void 0 && configuration.optional)) {
      onGatingClose();
    }
  };
  return /*#__PURE__*/React.createElement(GatingContext.Provider, {
    ref: ref,
    value: gatingContext
  }, gatingContext.gating && /*#__PURE__*/React.createElement(GatingRender, {
    widgetContext: widgetContextState,
    configuration: gatingContext.configuration,
    gatingId: gatingContext.gating,
    show: gatingContext.gating !== null,
    onClose: handleClose,
    breakpoint: breakpoint,
    assetType: assetType,
    preview: preview
  }), children);
});
var GatingRender = function GatingRender(_ref2) {
  var widgetContext = _ref2.widgetContext,
    configuration = _ref2.configuration,
    gatingId = _ref2.gatingId,
    show = _ref2.show,
    onClose = _ref2.onClose,
    assetType = _ref2.assetType,
    breakpoint = _ref2.breakpoint,
    preview = _ref2.preview;
  var _React$useState3 = React.useState({}),
    modalContext = _React$useState3[0],
    setModalContext = _React$useState3[1];
  var gating = useSelector(function (state) {
    return _$1.get(state, "gatings.gating[" + gatingId + "].item", null);
  });
  var widgets = _$1.get(gating, 'draft.widgets', []);
  if (!preview) {
    widgets = _$1.get(gating, 'content.widgets', []);
    var fonts = _$1.get(gating, "content.fonts") || [];
    Fonts$1.useFont(fonts);
  }
  useEffect(function () {
    if (widgetContext.onTriggerMixpanelEvent) {
      widgetContext.onTriggerMixpanelEvent(widgetContext.session, 'Page Viewed', {
        screen_name: 'Gating Form'
      });
    }
  }, []);
  var modalWidget = widgets.find(function (item) {
    return item.type === MODAL;
  });
  var assetModal = _$1.get(configuration, "target.assetModal", null);
  useEffect(function () {
    if (configuration !== null && configuration !== void 0 && configuration.optional || assetType && assetModal) {
      setModalContext(function (modalContext) {
        return _extends({}, modalContext, {
          close: handleCloseGating
        });
      });
    }
  }, [configuration, assetType, assetModal]);
  var handleCloseGating = function handleCloseGating() {
    if (onClose) {
      onClose(configuration);
    }
  };
  if (!modalWidget) {
    return null;
  }
  return /*#__PURE__*/React.createElement(WidgetsContext.Provider, {
    value: widgetContext
  }, /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: modalContext
  }, /*#__PURE__*/React.createElement(Widget, {
    key: modalWidget.uid,
    widgetProps: modalWidget,
    breakpoint: breakpoint,
    show: show
  })));
};

var shapes = {
  Shape: Shape,
  Line: Line
};
var Components = {
  HtmlView: HtmlView,
  ExternalFormView: ExternalFormView
};
var Widgets = {
  Context: WidgetsContext,
  FormContext: FormContext,
  GatingContext: GatingContext,
  SeekContext: SeekContext,
  Content: Content,
  FilterDropdown: FilterDropdown,
  AssetSearchBox: AssetSearchBox,
  Widget: Widget,
  Shapes: shapes,
  FormDropDownList: FormDropdownList,
  FormNumberWidget: FormNumberWidget,
  FormTextWidget: FormTextWidget,
  FormOtpInputWidget: FormOtpInputWidget,
  FormTextArea: FormTextAreaWidget,
  FormCheckBoxList: FomrCheckBoxListWidget,
  FormCheckBoxField: FormCheckBoxField,
  MenuButton: MenuButton,
  SeekSearchBox: SeekSearchBox,
  AssetViewer: AssetViewer,
  Actions: Actions,
  Components: Components,
  Animation: AnimationComponent,
  ParallaxContext: ParallaxContainer,
  EmbedContext: EmbedContext,
  SessionContainer: SessionContainer
};

export { BrandThemeManager, Fonts, GatingManager, InteractiveContent, LandingPage, SpatialContent, Widgets };
//# sourceMappingURL=index.modern.js.map
